import { openBlock as c, createElementBlock as g, createElementVNode as T, createStaticVNode as Du, defineComponent as U, h as aM, createBlock as k, watch as xM, onUnmounted as QM, Teleport as ru, createVNode as z, Transition as We, withCtx as O, mergeProps as DM, renderSlot as J, createCommentVNode as A, computed as p, Fragment as K, renderList as lM, unref as y, normalizeClass as V, withDirectives as CM, vShow as WM, useAttrs as yM, resolveDynamicComponent as cM, toDisplayString as w, normalizeProps as se, createTextVNode as vM, getCurrentScope as zN, onScopeDispose as mN, ref as E, getCurrentInstance as AN, onMounted as LM, nextTick as zM, watchEffect as VM, createSlots as Pe, pushScopeId as xN, popScopeId as EN, guardReactiveProps as xe, withScopeId as hN, resolveComponent as AM, normalizeStyle as RM, withKeys as CN, createApp as ON, withModifiers as M1, reactive as rt, toHandlers as pN, cloneVNode as wN, inject as YM, provide as fM, shallowRef as YN, toRaw as BM, vModelRadio as SN, vModelText as ZN, toRefs as kN, vModelCheckbox as bN } from "vue";
import Xi from "vuedraggable";
const UN = "data:image/svg+xml;base64,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", QN = "data:image/svg+xml;base64,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", VN = "data:image/svg+xml;base64,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", gu = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgoJCWQ9Ik0xMC4wMDM1IDBDMTQuMTAzNSAwIDE3LjkwMzUgMi45MSAxOS45MjM1IDcuNkMxOS45Nzg1IDcuNzI2MTcgMjAuMDA3IDcuODYyMzQgMjAuMDA3IDhDMjAuMDA3IDguMTM3NjYgMTkuOTc4NSA4LjI3MzgzIDE5LjkyMzUgOC40QzE3LjkwMzUgMTMuMDkgMTQuMTAzNSAxNiAxMC4wMDM1IDE2QzUuOTAzNDggMTYgMi4xMDM0OCAxMy4wOSAwLjA4MzQ4NDggOC40QzAuMDI4NDIxNSA4LjI3MzgzIDAgOC4xMzc2NiAwIDhDMCA3Ljg2MjM0IDAuMDI4NDIxNSA3LjcyNjE3IDAuMDgzNDg0OCA3LjZDMi4xMDM0OCAyLjkxIDUuOTAzNDggMCAxMC4wMDM1IDBaTTcuNzgxMiA0LjY3NDEyQzguNDM5IDQuMjM0NiA5LjIxMjM2IDQgMTAuMDAzNSA0QzExLjA2NDQgNCAxMi4wODE4IDQuNDIxNDMgMTIuODMxOSA1LjE3MTU3QzEzLjU4MjEgNS45MjE3MiAxNC4wMDM1IDYuOTM5MTMgMTQuMDAzNSA4QzE0LjAwMzUgOC43OTExMyAxMy43Njg5IDkuNTY0NDggMTMuMzI5NCAxMC4yMjIzQzEyLjg4OTggMTAuODgwMSAxMi4yNjUxIDExLjM5MjggMTEuNTM0MiAxMS42OTU1QzEwLjgwMzMgMTEuOTk4MyA5Ljk5OTA1IDEyLjA3NzUgOS4yMjMxMiAxMS45MjMxQzguNDQ3MiAxMS43Njg4IDcuNzM0NDcgMTEuMzg3OCA3LjE3NTA2IDEwLjgyODRDNi42MTU2NSAxMC4yNjkgNi4yMzQ2OCA5LjU1NjI4IDYuMDgwMzQgOC43ODAzNkM1LjkyNiA4LjAwNDQ0IDYuMDA1MjIgNy4yMDAxNyA2LjMwNzk3IDYuNDY5MjdDNi42MTA3MiA1LjczODM2IDcuMTIzNDEgNS4xMTM2NSA3Ljc4MTIgNC42NzQxMlpNOC44OTIzNCA5LjY2Mjk0QzkuMjIxMjQgOS44ODI3IDkuNjA3OTIgMTAgMTAuMDAzNSAxMEMxMC41MzM5IDEwIDExLjA0MjYgOS43ODkyOSAxMS40MTc3IDkuNDE0MjFDMTEuNzkyOCA5LjAzOTE0IDEyLjAwMzUgOC41MzA0MyAxMi4wMDM1IDhDMTIuMDAzNSA3LjYwNDQ0IDExLjg4NjIgNy4yMTc3NiAxMS42NjY0IDYuODg4ODZDMTEuNDQ2NyA2LjU1OTk2IDExLjEzNDMgNi4zMDM2MiAxMC43Njg5IDYuMTUyMjRDMTAuNDAzNCA2LjAwMDg3IDEwLjAwMTMgNS45NjEyNiA5LjYxMzMgNi4wMzg0M0M5LjIyNTM0IDYuMTE1NiA4Ljg2ODk4IDYuMzA2MDggOC41ODkyNyA2LjU4NTc5QzguMzA5NTcgNi44NjU0OSA4LjExOTA4IDcuMjIxODYgOC4wNDE5MSA3LjYwOTgyQzcuOTY0NzQgNy45OTc3OCA4LjAwNDM1IDguMzk5OTEgOC4xNTU3MyA4Ljc2NTM3QzguMzA3MSA5LjEzMDgyIDguNTYzNDUgOS40NDMxOCA4Ljg5MjM0IDkuNjYyOTRaIgoJCWZpbGw9IiM2MjEyRTUiIC8+Cjwvc3ZnPgo=", Lu = "data:image/svg+xml;base64,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", Iu = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjMiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCA2MyAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjAwMDE4MzEwNSA2LjY3OTY5VjYuNjc5NjlDMC4wMDAxODMxMDUgMC44OTUyMjkgNy45MDgxNCAtMS45NTQ0OCAxMi41NTE5IDEuNDk0NTRDMTkuMDcwMyA2LjMzNTk0IDI3LjI4OTYgOS45MDE2NiAzNy41MDAyIDkuNjc5NjlDNDUuNTYyMyA5LjUwNDQyIDUyLjU3NSAxMi42NTA1IDU3Ljk2NjEgMTYuOTU2QzY3LjA3ODcgMjQuMjMzNyA1OS41MzIyIDM0LjY3OTcgNDcuODcwMSAzNC42Nzk3SDguMDAwMThDMy41ODE5MSAzNC42Nzk3IDAuMDAwMTgzMTA1IDMxLjA5OCAwLjAwMDE4MzEwNSAyNi42Nzk3VjI2LjY3OTdWNi42Nzk2OVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==", du = "data:image/svg+xml;base64,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", yu = "data:image/svg+xml;base64,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", e1 = "data:image/svg+xml;base64,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", t1 = "data:image/svg+xml;base64,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", zu = "data:image/svg+xml;base64,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", WN = "data:image/svg+xml;base64,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", i1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEwIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjY5OTU0IDAuMjkwNzkyTDMuNDA5NTQgNC41OTA3OUwxLjc1OTU0IDIuOTQwNzlDMS42Njk5IDIuODM2MTEgMS41NTk1OCAyLjc1MTA5IDEuNDM1NTEgMi42OTEwN0MxLjMxMTQ1IDIuNjMxMDQgMS4xNzYzMiAyLjU5NzMxIDEuMDM4NiAyLjU5MTk5QzAuOTAwODc4IDIuNTg2NjcgMC43NjM1NDUgMi42MDk4OCAwLjYzNTIyIDIuNjYwMTZDMC41MDY4OTUgMi43MTA0MyAwLjM5MDM0OCAyLjc4NjY5IDAuMjkyODkzIDIuODg0MTRDMC4xOTU0MzkgMi45ODE2IDAuMTE5MTgxIDMuMDk4MTQgMC4wNjg5MDYyIDMuMjI2NDdDMC4wMTg2MzE2IDMuMzU0OCAtMC4wMDQ1NzQzMSAzLjQ5MjEzIDAuMDAwNzQ1MTc5IDMuNjI5ODVDMC4wMDYwNjQ2NyAzLjc2NzU2IDAuMDM5Nzk0OCAzLjkwMjcgMC4wOTk4MTgxIDQuMDI2NzZDMC4xNTk4NDEgNC4xNTA4MyAwLjI0NDg2MiA0LjI2MTE1IDAuMzQ5NTQzIDQuMzUwNzlMMi42OTk1NCA2LjcxMDc5QzIuNzkyOTggNi44MDM0NyAyLjkwMzggNi44NzY4IDMuMDI1NjQgNi45MjY1NkMzLjE0NzQ3IDYuOTc2MzMgMy4yNzc5NCA3LjAwMTU1IDMuNDA5NTQgNy4wMDA3OUMzLjY3MTg4IDYuOTk5NjkgMy45MjMyOCA2Ljg5NTU0IDQuMTA5NTQgNi43MTA3OUw5LjEwOTU0IDEuNzEwNzlDOS4yMDMyNyAxLjYxNzgzIDkuMjc3NjcgMS41MDcyMyA5LjMyODQ0IDEuMzg1MzdDOS4zNzkyIDEuMjYzNTEgOS40MDUzNCAxLjEzMjggOS40MDUzNCAxLjAwMDc5QzkuNDA1MzQgMC44Njg3ODEgOS4zNzkyIDAuNzM4MDc1IDkuMzI4NDQgMC42MTYyMTZDOS4yNzc2NyAwLjQ5NDM1NiA5LjIwMzI3IDAuMzgzNzU1IDkuMTA5NTQgMC4yOTA3OTJDOC45MjIxOCAwLjEwNDU0MiA4LjY2ODczIDAgOC40MDQ1NCAwQzguMTQwMzYgMCA3Ljg4NjkxIDAuMTA0NTQyIDcuNjk5NTQgMC4yOTA3OTJaIiBmaWxsPSIjMTJERTc0Ii8+Cjwvc3ZnPgo=", mu = "data:image/svg+xml;base64,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", fN = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGgKICAgIGQ9Ik0xMC40MDggOS4wMDAxOUwxNi43MDggMi43MTAxOUMxNi44OTYzIDIuNTIxODggMTcuMDAyMSAyLjI2NjQ5IDE3LjAwMjEgMi4wMDAxOUMxNy4wMDIxIDEuNzMzODggMTYuODk2MyAxLjQ3ODQ5IDE2LjcwOCAxLjI5MDE5QzE2LjUxOTcgMS4xMDE4OCAxNi4yNjQzIDAuOTk2MDk0IDE1Ljk5OCAwLjk5NjA5NEMxNS43MzE3IDAuOTk2MDk0IDE1LjQ3NjMgMS4xMDE4OCAxNS4yODggMS4yOTAxOUw4Ljk5Nzk5IDcuNTkwMTlMMi43MDc5OSAxLjI5MDE5QzIuNTE5NjggMS4xMDE4OCAyLjI2NDI5IDAuOTk2MDk0IDEuOTk3OTkgMC45OTYwOTRDMS43MzE2OCAwLjk5NjA5NCAxLjQ3NjI5IDEuMTAxODggMS4yODc5OSAxLjI5MDE5QzEuMDk5NjggMS40Nzg0OSAwLjk5Mzg5NCAxLjczMzg4IDAuOTkzODk0IDIuMDAwMTlDMC45OTM4OTQgMi4yNjY0OSAxLjA5OTY4IDIuNTIxODggMS4yODc5OSAyLjcxMDE5TDcuNTg3OTkgOS4wMDAxOUwxLjI4Nzk5IDE1LjI5MDJDMS4xOTQyNiAxNS4zODMxIDEuMTE5ODYgMTUuNDkzNyAxLjA2OTA5IDE1LjYxNTZDMS4wMTgzMyAxNS43Mzc1IDAuOTkyMTg4IDE1Ljg2ODIgMC45OTIxODggMTYuMDAwMkMwLjk5MjE4OCAxNi4xMzIyIDEuMDE4MzMgMTYuMjYyOSAxLjA2OTA5IDE2LjM4NDhDMS4xMTk4NiAxNi41MDY2IDEuMTk0MjYgMTYuNjE3MiAxLjI4Nzk5IDE2LjcxMDJDMS4zODA5NSAxNi44MDM5IDEuNDkxNTUgMTYuODc4MyAxLjYxMzQxIDE2LjkyOTFDMS43MzUyNyAxNi45Nzk4IDEuODY1OTcgMTcuMDA2IDEuOTk3OTkgMTcuMDA2QzIuMTMgMTcuMDA2IDIuMjYwNyAxNi45Nzk4IDIuMzgyNTYgMTYuOTI5MUMyLjUwNDQyIDE2Ljg3ODMgMi42MTUwMiAxNi44MDM5IDIuNzA3OTkgMTYuNzEwMkw4Ljk5Nzk5IDEwLjQxMDJMMTUuMjg4IDE2LjcxMDJDMTUuMzgwOSAxNi44MDM5IDE1LjQ5MTUgMTYuODc4MyAxNS42MTM0IDE2LjkyOTFDMTUuNzM1MyAxNi45Nzk4IDE1Ljg2NiAxNy4wMDYgMTUuOTk4IDE3LjAwNkMxNi4xMyAxNy4wMDYgMTYuMjYwNyAxNi45Nzk4IDE2LjM4MjYgMTYuOTI5MUMxNi41MDQ0IDE2Ljg3ODMgMTYuNjE1IDE2LjgwMzkgMTYuNzA4IDE2LjcxMDJDMTYuODAxNyAxNi42MTcyIDE2Ljg3NjEgMTYuNTA2NiAxNi45MjY5IDE2LjM4NDhDMTYuOTc3NiAxNi4yNjI5IDE3LjAwMzggMTYuMTMyMiAxNy4wMDM4IDE2LjAwMDJDMTcuMDAzOCAxNS44NjgyIDE2Ljk3NzYgMTUuNzM3NSAxNi45MjY5IDE1LjYxNTZDMTYuODc2MSAxNS40OTM3IDE2LjgwMTcgMTUuMzgzMSAxNi43MDggMTUuMjkwMkwxMC40MDggOS4wMDAxOVoiIGZpbGw9ImdyYXkiIC8+Cjwvc3ZnPgo=", Ji = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDcgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01Ljk1MDc5IDQuNTI5NjdMMS43MTA3OSAwLjI5NTM5OUMxLjYxNzgzIDAuMjAxNzk3IDEuNTA3MjMgMC4xMjc1MDMgMS4zODUzNyAwLjA3NjgwMjhDMS4yNjM1MSAwLjAyNjEwMjcgMS4xMzI4IDAgMS4wMDA3OSAwQzAuODY4NzgxIDAgMC43MzgwNzUgMC4wMjYxMDI3IDAuNjE2MjE2IDAuMDc2ODAyOEMwLjQ5NDM1NiAwLjEyNzUwMyAwLjM4Mzc1NSAwLjIwMTc5NyAwLjI5MDc5MiAwLjI5NTM5OUMwLjEwNDU0MiAwLjQ4MjUwOCAwIDAuNzM1NjE3IC0xLjE4MTU0ZS0xMCAwLjk5OTQ0NkMtMS40OTM0NGUtMTAgMS4yNjMyNyAwLjEwNDU0MiAxLjUxNjM4IDAuMjkwNzkyIDEuNzAzNDlMMy44MzA3OSA1LjIzODcxTDAuMjkwNzkyIDguNzczOTNDMC4xMDQ1NDIgOC45NjEwMyAtMS4wODkzZS0wOSA5LjIxNDE1IC0xLjEyMDQ5ZS0wOSA5LjQ3Nzk3Qy0xLjE1MTY3ZS0wOSA5Ljc0MTggMC4xMDQ1NDIgOS45OTQ5MSAwLjI5MDc5MiAxMC4xODJDMC4zODQyMzMgMTAuMjc0NiAwLjQ5NTA0OSAxMC4zNDc4IDAuNjE2ODg2IDEwLjM5NzVDMC43Mzg3MjQgMTAuNDQ3MiAwLjg2OTE4NiAxMC40NzI0IDEuMDAwNzkgMTAuNDcxNkMxLjEzMjQgMTAuNDcyNCAxLjI2Mjg2IDEwLjQ0NzIgMS4zODQ3IDEwLjM5NzVDMS41MDY1NCAxMC4zNDc4IDEuNjE3MzUgMTAuMjc0NiAxLjcxMDc5IDEwLjE4Mkw1Ljk1MDc5IDUuOTQ3NzVDNi4wNDQ1MiA1Ljg1NDkxIDYuMTE4OTEgNS43NDQ0NiA2LjE2OTY4IDUuNjIyNzdDNi4yMjA0NSA1LjUwMTA3IDYuMjQ2NTkgNS4zNzA1NCA2LjI0NjU5IDUuMjM4NzFDNi4yNDY1OSA1LjEwNjg4IDYuMjIwNDUgNC45NzYzNSA2LjE2OTY4IDQuODU0NjVDNi4xMTg5MSA0LjczMjk2IDYuMDQ0NTIgNC42MjI1MSA1Ljk1MDc5IDQuNTI5NjdaIiBmaWxsPSIjMTIxMkUwIi8+Cjwvc3ZnPgo=", u1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDcgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjI5NTMwMiA1Ljk0MjAxTDQuNTM1MyAxMC4xNzYzQzQuNjI4MjYgMTAuMjY5OSA0LjczODg3IDEwLjM0NDIgNC44NjA3MiAxMC4zOTQ5QzQuOTgyNTggMTAuNDQ1NiA1LjExMzI5IDEwLjQ3MTcgNS4yNDUzIDEwLjQ3MTdDNS4zNzczMSAxMC40NzE3IDUuNTA4MDIgMTAuNDQ1NiA1LjYyOTg4IDEwLjM5NDlDNS43NTE3NCAxMC4zNDQyIDUuODYyMzQgMTAuMjY5OSA1Ljk1NTMgMTAuMTc2M0M2LjE0MTU1IDkuOTg5MTcgNi4yNDYwOSA5LjczNjA2IDYuMjQ2MDkgOS40NzIyM0M2LjI0NjA5IDkuMjA4NDEgNi4xNDE1NSA4Ljk1NTMgNS45NTUzIDguNzY4MTlMMi40MTUzIDUuMjMyOTdMNS45NTUzIDEuNjk3NzVDNi4xNDE1NSAxLjUxMDY0IDYuMjQ2MDkgMS4yNTc1MyA2LjI0NjA5IDAuOTkzNzA2QzYuMjQ2MDkgMC43Mjk4NzcgNi4xNDE1NSAwLjQ3Njc2OCA1Ljk1NTMgMC4yODk2NTlDNS44NjE4NiAwLjE5NzEwMyA1Ljc1MTA1IDAuMTIzODc3IDUuNjI5MjEgMC4wNzQxNzk2QzUuNTA3MzcgMC4wMjQ0ODE3IDUuMzc2OTEgLTAuMDAwNzA4NjU2IDUuMjQ1MyA1LjE0MTA5ZS0wNUM1LjExMzcgLTAuMDAwNzA4Njc5IDQuOTgzMjMgMC4wMjQ0ODE3IDQuODYxNCAwLjA3NDE3OTVDNC43Mzk1NiAwLjEyMzg3NiA0LjYyODc0IDAuMTk3MTAyIDQuNTM1MyAwLjI4OTY1OEwwLjI5NTMwMiA0LjUyMzkzQzAuMjAxNTczIDQuNjE2NzcgMC4xMjcxOCA0LjcyNzIyIDAuMDc2NDEwOCA0Ljg0ODkxQzAuMDI1NjQxOSA0Ljk3MDYxIC0wLjAwMDQ5NjM5NCA1LjEwMTE0IC0wLjAwMDQ5NjQwNiA1LjIzMjk3Qy0wLjAwMDQ5NjQxNyA1LjM2NDggMC4wMjU2NDE5IDUuNDk1MzMgMC4wNzY0MTA3IDUuNjE3MDNDMC4xMjcxOCA1LjczODcyIDAuMjAxNTczIDUuODQ5MTcgMC4yOTUzMDIgNS45NDIwMVoiIGZpbGw9IiMxMjEyRTAiLz4KPC9zdmc+Cg==", vN = "data:image/svg+xml;base64,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", GN = "data:image/svg+xml;base64,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", RN = "data:image/svg+xml;base64,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", FN = "data:image/svg+xml;base64,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", XN = "data:image/svg+xml;base64,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", JN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoCgkJZD0iTTggMTFIMUMwLjczNDc4NCAxMSAwLjQ4MDQzIDExLjEwNTQgMC4yOTI4OTMgMTEuMjkyOUMwLjEwNTM1NyAxMS40ODA0IDAgMTEuNzM0OCAwIDEyVjE5QzAgMTkuMjY1MiAwLjEwNTM1NyAxOS41MTk2IDAuMjkyODkzIDE5LjcwNzFDMC40ODA0MyAxOS44OTQ2IDAuNzM0Nzg0IDIwIDEgMjBIOEM4LjI2NTIyIDIwIDguNTE5NTcgMTkuODk0NiA4LjcwNzExIDE5LjcwNzFDOC44OTQ2NCAxOS41MTk2IDkgMTkuMjY1MiA5IDE5VjEyQzkgMTEuNzM0OCA4Ljg5NDY0IDExLjQ4MDQgOC43MDcxMSAxMS4yOTI5QzguNTE5NTcgMTEuMTA1NCA4LjI2NTIyIDExIDggMTFaTTcgMThIMlYxM0g3VjE4Wk0xOSAwSDEyQzExLjczNDggMCAxMS40ODA0IDAuMTA1MzU3IDExLjI5MjkgMC4yOTI4OTNDMTEuMTA1NCAwLjQ4MDQzIDExIDAuNzM0Nzg0IDExIDFWOEMxMSA4LjI2NTIyIDExLjEwNTQgOC41MTk1NyAxMS4yOTI5IDguNzA3MTFDMTEuNDgwNCA4Ljg5NDY0IDExLjczNDggOSAxMiA5SDE5QzE5LjI2NTIgOSAxOS41MTk2IDguODk0NjQgMTkuNzA3MSA4LjcwNzExQzE5Ljg5NDYgOC41MTk1NyAyMCA4LjI2NTIyIDIwIDhWMUMyMCAwLjczNDc4NCAxOS44OTQ2IDAuNDgwNDMgMTkuNzA3MSAwLjI5Mjg5M0MxOS41MTk2IDAuMTA1MzU3IDE5LjI2NTIgMCAxOSAwWk0xOCA3SDEzVjJIMThWN1pNMTkgMTFIMTJDMTEuNzM0OCAxMSAxMS40ODA0IDExLjEwNTQgMTEuMjkyOSAxMS4yOTI5QzExLjEwNTQgMTEuNDgwNCAxMSAxMS43MzQ4IDExIDEyVjE5QzExIDE5LjI2NTIgMTEuMTA1NCAxOS41MTk2IDExLjI5MjkgMTkuNzA3MUMxMS40ODA0IDE5Ljg5NDYgMTEuNzM0OCAyMCAxMiAyMEgxOUMxOS4yNjUyIDIwIDE5LjUxOTYgMTkuODk0NiAxOS43MDcxIDE5LjcwNzFDMTkuODk0NiAxOS41MTk2IDIwIDE5LjI2NTIgMjAgMTlWMTJDMjAgMTEuNzM0OCAxOS44OTQ2IDExLjQ4MDQgMTkuNzA3MSAxMS4yOTI5QzE5LjUxOTYgMTEuMTA1NCAxOS4yNjUyIDExIDE5IDExWk0xOCAxOEgxM1YxM0gxOFYxOFpNOCAwSDFDMC43MzQ3ODQgMCAwLjQ4MDQzIDAuMTA1MzU3IDAuMjkyODkzIDAuMjkyODkzQzAuMTA1MzU3IDAuNDgwNDMgMCAwLjczNDc4NCAwIDFWOEMwIDguMjY1MjIgMC4xMDUzNTcgOC41MTk1NyAwLjI5Mjg5MyA4LjcwNzExQzAuNDgwNDMgOC44OTQ2NCAwLjczNDc4NCA5IDEgOUg4QzguMjY1MjIgOSA4LjUxOTU3IDguODk0NjQgOC43MDcxMSA4LjcwNzExQzguODk0NjQgOC41MTk1NyA5IDguMjY1MjIgOSA4VjFDOSAwLjczNDc4NCA4Ljg5NDY0IDAuNDgwNDMgOC43MDcxMSAwLjI5Mjg5M0M4LjUxOTU3IDAuMTA1MzU3IDguMjY1MjIgMCA4IDBaTTcgN0gyVjJIN1Y3WiIKCQlmaWxsPSJ3aGl0ZSIgLz4KPC9zdmc+Cg==", KN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxNiAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoCgkJZD0iTTE1Ljg3NzcgNy42MDAwOUMxNS43OTQ2IDcuNDM1MTggMTUuNjY3NCA3LjI5NjQ5IDE1LjUxMDMgNy4xOTk0MkMxNS4zNTMyIDcuMTAyMzQgMTUuMTcyMyA3LjA1MDY1IDE0Ljk4NzcgNy4wNTAwOUg5Ljk4NzY1VjEuMDUwMDlDOS45OTgzOSAwLjgzMDc3NSA5LjkzNjYzIDAuNjE0MDIzIDkuODExOTMgMC40MzMyOTJDOS42ODcyMyAwLjI1MjU2MSA5LjUwNjUgMC4xMTc4OTkgOS4yOTc2NiAwLjA1MDA5MTlDOS4wOTY4OCAtMC4wMTU5NjQ5IDguODgwMzQgLTAuMDE2NzA3MiA4LjY3OTEyIDAuMDQ3OTcxNUM4LjQ3Nzg5IDAuMTEyNjUgOC4zMDIzNCAwLjIzOTQyMyA4LjE3NzY1IDAuNDEwMDkyTDAuMTc3NjU1IDExLjQxMDFDMC4wNzc0MjAyIDExLjU1NSAwLjAxNzIzMzIgMTEuNzIzNyAwLjAwMzE4NTAzIDExLjg5OTNDLTAuMDEwODYzMSAxMi4wNzQ5IDAuMDIxNzI2NCAxMi4yNTExIDAuMDk3NjU0NiAxMi40MTAxQzAuMTY3NTc2IDEyLjU5MTggMC4yODkwNDMgMTIuNzQ5MiAwLjQ0NzE0NCAxMi44NjI5QzAuNjA1MjQ2IDEyLjk3NjYgMC43OTMxMDIgMTMuMDQxNyAwLjk4NzY1NCAxMy4wNTAxSDUuOTg3NjVWMTkuMDUwMUM1Ljk4NzgxIDE5LjI2MSA2LjA1NDYyIDE5LjQ2NjQgNi4xNzg1NSAxOS42MzdDNi4zMDI0NyAxOS44MDc2IDYuNDc3MTcgMTkuOTM0NyA2LjY3NzY1IDIwLjAwMDFDNi43NzgxMyAyMC4wMzEyIDYuODgyNDkgMjAuMDQ4MSA2Ljk4NzY1IDIwLjA1MDFDNy4xNDU0NCAyMC4wNTA1IDcuMzAxMDggMjAuMDEzNiA3LjQ0MTg2IDE5Ljk0MjNDNy41ODI2NCAxOS44NzExIDcuNzA0NTYgMTkuNzY3NSA3Ljc5NzY1IDE5LjY0MDFMMTUuNzk3NyA4LjY0MDA5QzE1LjkwNTQgOC40OTA4OSAxNS45Njk5IDguMzE0ODUgMTUuOTg0IDguMTMxMzVDMTUuOTk4MSA3Ljk0Nzg1IDE1Ljk2MTMgNy43NjQwMiAxNS44Nzc3IDcuNjAwMDlaTTcuOTg3NjUgMTUuOTcwMVYxMi4wNTAxQzcuOTg3NjUgMTEuNzg0OSA3Ljg4MjMgMTEuNTMwNSA3LjY5NDc2IDExLjM0M0M3LjUwNzIyIDExLjE1NTQgNy4yNTI4NyAxMS4wNTAxIDYuOTg3NjUgMTEuMDUwMUgyLjk4NzY1TDcuOTg3NjUgNC4xMzAwOVY4LjA1MDA5QzcuOTg3NjUgOC4zMTUzMSA4LjA5MzAxIDguNTY5NjYgOC4yODA1NSA4Ljc1NzJDOC40NjgwOCA4Ljk0NDczIDguNzIyNDQgOS4wNTAwOSA4Ljk4NzY1IDkuMDUwMDlIMTIuOTg3N0w3Ljk4NzY1IDE1Ljk3MDFaIgoJCWZpbGw9IndoaXRlIiAvPgo8L3N2Zz4K", BN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDkgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjU2MjU1IDBIMC45MDYwMTVDMC40MDU2MzcgMCAwIDAuNDA2NTg2IDAgMC45MDgxMzZWNS40NjI3MUMwIDUuOTY0MjUgMC40MDU2MzcgNi4zNzA4NCAwLjkwNjAxNSA2LjM3MDg0SDQuNDI1ODZMNC40MjMyOSA5LjI3MTU0QzQuNDIyNjcgOS45OTQ3NCA1LjM2MTc4IDEwLjI3NDYgNS43NTU0OSA5LjY2ODZMOC44NTE3MyA1LjQyNjIyQzkuMjQ0MTggNC44MjIxMiA4LjgxMTY5IDQuMDIyNTQgOC4wOTI0OSA0LjAyMjU0SDYuNDY4NTdWMC45MDgxMzZDNi40Njg1NyAwLjQwNjU4NiA2LjA2MjkzIDAgNS41NjI1NSAwWiIgZmlsbD0iIzEyREU3NCIvPgo8L3N2Zz4K", HN = "data:image/svg+xml;base64,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", PN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoCgkJZD0iTTE5LjczMDkgMTguMzEwOUwxNi4wMjA5IDE0LjYzMDlDMTcuNDYxIDEyLjgzNTMgMTguMTU4NCAxMC41NTYyIDE3Ljk2OTcgOC4yNjIyQzE3Ljc4MSA1Ljk2ODIgMTYuNzIwNiAzLjgzMzY4IDE1LjAwNjQgMi4yOTc1NEMxMy4yOTIzIDAuNzYxNDA3IDExLjA1NDcgLTAuMDU5NTg5NCA4Ljc1MzgyIDAuMDAzMzcwOTZDNi40NTI5NCAwLjA2NjMzMTQgNC4yNjM2MiAxLjAwODQ2IDIuNjM2MDQgMi42MzYwNEMxLjAwODQ2IDQuMjYzNjIgMC4wNjYzMzE0IDYuNDUyOTQgMC4wMDMzNzA5NiA4Ljc1MzgyQy0wLjA1OTU4OTQgMTEuMDU0NyAwLjc2MTQwNyAxMy4yOTIzIDIuMjk3NTQgMTUuMDA2NEMzLjgzMzY4IDE2LjcyMDYgNS45NjgyIDE3Ljc4MSA4LjI2MjIgMTcuOTY5N0MxMC41NTYyIDE4LjE1ODQgMTIuODM1MyAxNy40NjEgMTQuNjMwOSAxNi4wMjA5TDE4LjMxMDkgMTkuNzAwOUMxOC40MDM5IDE5Ljc5NDYgMTguNTE0NSAxOS44NjkgMTguNjM2MyAxOS45MTk4QzE4Ljc1ODIgMTkuOTcwNiAxOC44ODg5IDE5Ljk5NjcgMTkuMDIwOSAxOS45OTY3QzE5LjE1MjkgMTkuOTk2NyAxOS4yODM2IDE5Ljk3MDYgMTkuNDA1NSAxOS45MTk4QzE5LjUyNzMgMTkuODY5IDE5LjYzNzkgMTkuNzk0NiAxOS43MzA5IDE5LjcwMDlDMTkuOTExMSAxOS41MTQ0IDIwLjAxMTkgMTkuMjY1MiAyMC4wMTE5IDE5LjAwNTlDMjAuMDExOSAxOC43NDY2IDE5LjkxMTEgMTguNDk3NCAxOS43MzA5IDE4LjMxMDlaTTkuMDIwOSAxNi4wMjA5QzcuNjM2NDMgMTYuMDIwOSA2LjI4MzA1IDE1LjYxMDQgNS4xMzE5MSAxNC44NDEyQzMuOTgwNzYgMTQuMDcyIDMuMDgzNTYgMTIuOTc4OCAyLjU1Mzc0IDExLjY5OTdDMi4wMjM5MyAxMC40MjA2IDEuODg1MzEgOS4wMTMxNCAyLjE1NTQgNy42NTUyN0MyLjQyNTUgNi4yOTc0IDMuMDkyMTkgNS4wNTAxMiA0LjA3MTE1IDQuMDcxMTVDNS4wNTAxMiAzLjA5MjE5IDYuMjk3NCAyLjQyNTUgNy42NTUyNyAyLjE1NTRDOS4wMTMxNCAxLjg4NTMxIDEwLjQyMDYgMi4wMjM5MyAxMS42OTk3IDIuNTUzNzRDMTIuOTc4OCAzLjA4MzU2IDE0LjA3MiAzLjk4MDc2IDE0Ljg0MTIgNS4xMzE5MUMxNS42MTA0IDYuMjgzMDUgMTYuMDIwOSA3LjYzNjQzIDE2LjAyMDkgOS4wMjA5QzE2LjAyMDkgMTAuODc3NCAxNS4yODM0IDEyLjY1NzkgMTMuOTcwNiAxMy45NzA2QzEyLjY1NzkgMTUuMjgzNCAxMC44Nzc0IDE2LjAyMDkgOS4wMjA5IDE2LjAyMDlaIgoJCWZpbGw9IiNCQkM0Q0QiIC8+Cjwvc3ZnPgo=", _N = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgoJCWQ9Ik0zMC45NjkyIDUuMDMwNzdDMzAuOTY5MiAzLjM3MzkyIDI5LjYyNjEgMi4wMzA3NyAyNy45NjkyIDIuMDMwNzdINS4wMzA3N0MzLjM3MzkyIDIuMDMwNzcgMi4wMzA3NyAzLjM3MzkxIDIuMDMwNzcgNS4wMzA3N1YyNy45NjkyQzIuMDMwNzcgMjkuNjI2MSAzLjM3MzkxIDMwLjk2OTIgNS4wMzA3NyAzMC45NjkySDI3Ljk2OTJDMjkuNjI2MSAzMC45NjkyIDMwLjk2OTIgMjkuNjI2MSAzMC45NjkyIDI3Ljk2OTJWNS4wMzA3N1pNMCAwVjMzSDMzVjBIMFoiCgkJZmlsbD0id2hpdGUiIC8+Cgk8cGF0aAoJCWQ9Ik0xOC40Mjc4IDkuNjQ2MTVIMTEuNTI2QzEwLjc2ODIgOS42NDYxNSAxMC4xNTM4IDEwLjI3MTYgMTAuMTUzOCAxMS4wNDMxVjE3Ljg5NzZDMTAuMTUzOCAxOC42NjkxIDEwLjc2ODIgMTkuMjk0NSAxMS41MjYgMTkuMjk0NUgxNi43NTM4TDE2Ljc0OTkgMjMuNzU2NEMxNi43NDkgMjQuODY4OCAxOC4xNzEzIDI1LjI5OTQgMTguNzY3NiAyNC4zNjcyTDIzLjUxIDE3Ljg5NzZDMjQuMTA0NCAxNi45Njg0IDIzLjQ0OTQgMTUuNzM4NSAyMi4zNjAyIDE1LjczODVIMTkuOFYxMS4wNDMxQzE5LjggMTAuMjcxNiAxOS4xODU2IDkuNjQ2MTUgMTguNDI3OCA5LjY0NjE1WiIKCQlmaWxsPSJ3aGl0ZSIgLz4KPC9zdmc+Cg==", $N = "data:image/svg+xml;base64,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", qN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCA0MSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMDA0MjYxMzQgMC44MTgxODJIMi4yNjEzNkw1LjI4NDA5IDguMTk2MDJINS40MDM0MUw4LjQyNjE0IDAuODE4MTgySDEwLjY4MzJWMTFIOC45MTMzNVY0LjAwNDk3SDguODE4ODlMNi4wMDQ5NyAxMC45NzAySDQuNjgyNTNMMS44Njg2MSAzLjk5MDA2SDEuNzc0MTVWMTFIMC4wMDQyNjEzNFYwLjgxODE4MlpNMTIuNjkxOCAxMVYwLjgxODE4MkgxOS4zMTM5VjIuMzY0MzVIMTQuNTM2MlY1LjEyODU1SDE4Ljk3MDlWNi42NzQ3MkgxNC41MzYyVjkuNDUzODRIMTkuMzUzN1YxMUgxMi42OTE4Wk0yMS4xOTU3IDAuODE4MTgySDIzLjQ1MjhMMjYuNDc1NSA4LjE5NjAySDI2LjU5NDhMMjkuNjE3NSAwLjgxODE4MkgzMS44NzQ2VjExSDMwLjEwNDhWNC4wMDQ5N0gzMC4wMTAzTDI3LjE5NjQgMTAuOTcwMkgyNS44NzM5TDIzLjA2IDMuOTkwMDZIMjIuOTY1NlYxMUgyMS4xOTU3VjAuODE4MTgyWk0zMy44ODMyIDExVjAuODE4MTgySDQwLjUwNTNWMi4zNjQzNUgzNS43Mjc2VjUuMTI4NTVINDAuMTYyM1Y2LjY3NDcySDM1LjcyNzZWOS40NTM4NEg0MC41NDUxVjExSDMzLjg4MzJaIiBmaWxsPSIjM0Y0QTU1Ii8+Cjwvc3ZnPgo=", Ml = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTQuNDQ5NDQgMC42NjEzOTJDNC42MjUxIDAuMTMxMzE5IDUuMzc0OSAwLjEzMTMxOCA1LjU1MDU2IDAuNjYxMzkxTDYuNDAxNzkgMy4yMzAxQzYuNDU5NDQgMy40MDQwNyA2LjU5NTkzIDMuNTQwNTYgNi43Njk5IDMuNTk4MjFMOS4zMzg2MSA0LjQ0OTQ0QzkuODY4NjggNC42MjUxIDkuODY4NjggNS4zNzQ5IDkuMzM4NjEgNS41NTA1Nkw2Ljc2OTkgNi40MDE3OUM2LjU5NTkzIDYuNDU5NDQgNi40NTk0NCA2LjU5NTkzIDYuNDAxNzkgNi43Njk5TDUuNTUwNTYgOS4zMzg2MUM1LjM3NDkgOS44Njg2OCA0LjYyNTEgOS44Njg2OCA0LjQ0OTQ0IDkuMzM4NjFMMy41OTgyMSA2Ljc2OTlDMy41NDA1NiA2LjU5NTkzIDMuNDA0MDcgNi40NTk0NCAzLjIzMDEgNi40MDE3OUwwLjY2MTM5MiA1LjU1MDU2QzAuMTMxMzE5IDUuMzc0OSAwLjEzMTMxOCA0LjYyNTEgMC42NjEzOTEgNC40NDk0NEwzLjIzMDEgMy41OTgyMUMzLjQwNDA3IDMuNTQwNTYgMy41NDA1NiAzLjQwNDA3IDMuNTk4MjEgMy4yMzAxTDQuNDQ5NDQgMC42NjEzOTJaIgogICAgZmlsbD0iIzEyMTJFMCIgLz4KPC9zdmc+Cg==", el = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzYgMzUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGgKICAgIGQ9Ik0xNy41MzY1IDEuODEzNDVDMTcuNzA1IDEuMzk2NzIgMTguMjk1IDEuMzk2NzIgMTguNDYzNSAxLjgxMzQ1TDIyLjE3NzYgMTAuOTk3M0MyMi41MzU3IDExLjg4MjkgMjMuMzY3MiAxMi40ODY5IDI0LjMyIDEyLjU1MzlMMzQuMjAyMSAxMy4yNDgyQzM0LjY1MDYgMTMuMjc5NyAzNC44MzI5IDEzLjg0MDggMzQuNDg4NiAxNC4xMjk5TDI2LjkwMTkgMjAuNTAwMkMyNi4xNzA0IDIxLjExNDQgMjUuODUyOCAyMi4wOTE4IDI2LjA4MzYgMjMuMDE4OEwyOC40NzcgMzIuNjMxOEMyOC41ODU2IDMzLjA2OCAyOC4xMDgzIDMzLjQxNDcgMjcuNzI3IDMzLjE3NjdMMTkuMzI0MSAyNy45Mjk4QzE4LjUxMzkgMjcuNDIzOSAxNy40ODYxIDI3LjQyMzkgMTYuNjc1OSAyNy45Mjk4TDguMjczIDMzLjE3NjdDNy44OTE3MiAzMy40MTQ3IDcuNDE0MzkgMzMuMDY4IDcuNTIyOTkgMzIuNjMxOEw5LjkxNjM5IDIzLjAxODhDMTAuMTQ3MiAyMi4wOTE4IDkuODI5NTkgMjEuMTE0NCA5LjA5ODA1IDIwLjUwMDJMMS41MTEzOCAxNC4xMjk5QzEuMTY3MTMgMTMuODQwOSAxLjM0OTQ1IDEzLjI3OTcgMS43OTc4NSAxMy4yNDgyTDExLjY4IDEyLjU1MzlDMTIuNjMyOCAxMi40ODY5IDEzLjQ2NDMgMTEuODgyOSAxMy44MjI0IDEwLjk5NzNMMTcuNTM2NSAxLjgxMzQ1WiIKICAgIHN0cm9rZT0iIzEyMTJFMCIgLz4KPC9zdmc+Cg==", tl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNSAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNjU3NjcgMTJIMC40MDc2N0w0LjUwNDI2IDAuMzYzNjM2SDcuMTA2NTNMMTEuMjA4OCAxMkg4Ljk1ODgxTDUuODUwODUgMi43NUg1Ljc1OTk0TDIuNjU3NjcgMTJaTTIuNzMxNTMgNy40Mzc1SDguODY3OVY5LjEzMDY4SDIuNzMxNTNWNy40Mzc1Wk0xNC44NDk0IDAuMzYzNjM2VjEySDEyLjc0MTVWMC4zNjM2MzZIMTQuODQ5NFoiIGZpbGw9IiMzRjRBNTUiLz4KPC9zdmc+Cg==", il = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyMCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNCAxQzE0IDAuNzM0Nzg0IDEzLjg5NDYgMC40ODA0MyAxMy43MDcxIDAuMjkyODkzQzEzLjUxOTYgMC4xMDUzNTcgMTMuMjY1MiAwIDEzIDBIMUMwLjczNDc4NCAwIDAuNDgwNDMgMC4xMDUzNTcgMC4yOTI4OTMgMC4yOTI4OTNDMC4xMDUzNTcgMC40ODA0MyAwIDAuNzM0Nzg0IDAgMUMwIDEuMjY1MjIgMC4xMDUzNTcgMS41MTk1NyAwLjI5Mjg5MyAxLjcwNzExQzAuNDgwNDMgMS44OTQ2NCAwLjczNDc4NCAyIDEgMkg2VjEzQzYgMTMuMjY1MiA2LjEwNTM2IDEzLjUxOTYgNi4yOTI4OSAxMy43MDcxQzYuNDgwNDMgMTMuODk0NiA2LjczNDc4IDE0IDcgMTRDNy4yNjUyMiAxNCA3LjUxOTU3IDEzLjg5NDYgNy43MDcxMSAxMy43MDcxQzcuODk0NjQgMTMuNTE5NiA4IDEzLjI2NTIgOCAxM1YySDEzQzEzLjI2NTIgMiAxMy41MTk2IDEuODk0NjQgMTMuNzA3MSAxLjcwNzExQzEzLjg5NDYgMS41MTk1NyAxNCAxLjI2NTIyIDE0IDFaTTE5IDZIMTNDMTIuNzM0OCA2IDEyLjQ4MDQgNi4xMDUzNiAxMi4yOTI5IDYuMjkyODlDMTIuMTA1NCA2LjQ4MDQzIDEyIDYuNzM0NzggMTIgN0MxMiA3LjI2NTIyIDEyLjEwNTQgNy41MTk1NyAxMi4yOTI5IDcuNzA3MTFDMTIuNDgwNCA3Ljg5NDY0IDEyLjczNDggOCAxMyA4SDE1VjEzQzE1IDEzLjI2NTIgMTUuMTA1NCAxMy41MTk2IDE1LjI5MjkgMTMuNzA3MUMxNS40ODA0IDEzLjg5NDYgMTUuNzM0OCAxNCAxNiAxNEMxNi4yNjUyIDE0IDE2LjUxOTYgMTMuODk0NiAxNi43MDcxIDEzLjcwNzFDMTYuODk0NiAxMy41MTk2IDE3IDEzLjI2NTIgMTcgMTNWOEgxOUMxOS4yNjUyIDggMTkuNTE5NiA3Ljg5NDY0IDE5LjcwNzEgNy43MDcxMUMxOS44OTQ2IDcuNTE5NTcgMjAgNy4yNjUyMiAyMCA3QzIwIDYuNzM0NzggMTkuODk0NiA2LjQ4MDQzIDE5LjcwNzEgNi4yOTI4OUMxOS41MTk2IDYuMTA1MzYgMTkuMjY1MiA2IDE5IDZaIiBmaWxsPSIjM0Y0QTU1Ii8+Cjwvc3ZnPgo=", ul = "data:image/svg+xml;base64,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", Nl = "data:image/svg+xml;base64,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", ll = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDE4IDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMyAxSDE2VjNIM1YxWiIgZmlsbD0iIzNGNEE1NSIvPgogICAgPHBhdGggZD0iTTkgMEM4LjYwNDQ0IDAgOC4yMTc3NiAwLjExNzI5OCA3Ljg4ODg2IDAuMzM3MDYxQzcuNTU5OTYgMC41NTY4MjQgNy4zMDM2MiAwLjg2OTE4MSA3LjE1MjI0IDEuMjM0NjNDNy4wMDA4NyAxLjYwMDA5IDYuOTYxMjYgMi4wMDIyMiA3LjAzODQzIDIuMzkwMThDNy4xMTU2IDIuNzc4MTQgNy4zMDYwOCAzLjEzNDUxIDcuNTg1NzkgMy40MTQyMUM3Ljg2NTQ5IDMuNjkzOTIgOC4yMjE4NiAzLjg4NDQgOC42MDk4MiAzLjk2MTU3QzguOTk3NzggNC4wMzg3NCA5LjM5OTkyIDMuOTk5MTMgOS43NjUzNyAzLjg0Nzc2QzEwLjEzMDggMy42OTYzOCAxMC40NDMyIDMuNDQwMDQgMTAuNjYyOSAzLjExMTE0QzEwLjg4MjcgMi43ODIyNCAxMSAyLjM5NTU2IDExIDJDMTEgMS40Njk1NyAxMC43ODkzIDAuOTYwODYgMTAuNDE0MiAwLjU4NTc4N0MxMC4wMzkxIDAuMjEwNzE0IDkuNTMwNDMgMCA5IDBaTTIgMEMxLjYwNDQ0IDAgMS4yMTc3NiAwLjExNzI5OCAwLjg4ODg2IDAuMzM3MDYxQzAuNTU5OTYyIDAuNTU2ODI0IDAuMzAzNjE3IDAuODY5MTgxIDAuMTUyMjQyIDEuMjM0NjNDMC4wMDA4NjY1NjIgMS42MDAwOSAtMC4wMzg3NDAxIDIuMDAyMjIgMC4wMzg0MzAzIDIuMzkwMThDMC4xMTU2MDEgMi43NzgxNCAwLjMwNjA4MiAzLjEzNDUxIDAuNTg1Nzg3IDMuNDE0MjFDMC44NjU0OTIgMy42OTM5MiAxLjIyMTg2IDMuODg0NCAxLjYwOTgyIDMuOTYxNTdDMS45OTc3OCA0LjAzODc0IDIuMzk5OTIgMy45OTkxMyAyLjc2NTM3IDMuODQ3NzZDMy4xMzA4MiAzLjY5NjM4IDMuNDQzMTggMy40NDAwNCAzLjY2Mjk0IDMuMTExMTRDMy44ODI3IDIuNzgyMjQgNCAyLjM5NTU2IDQgMkM0IDEuNDY5NTcgMy43ODkyOSAwLjk2MDg2IDMuNDE0MjEgMC41ODU3ODdDMy4wMzkxNCAwLjIxMDcxNCAyLjUzMDQzIDAgMiAwWk0xNiAwQzE1LjYwNDQgMCAxNS4yMTc4IDAuMTE3Mjk4IDE0Ljg4ODkgMC4zMzcwNjFDMTQuNTYgMC41NTY4MjQgMTQuMzAzNiAwLjg2OTE4MSAxNC4xNTIyIDEuMjM0NjNDMTQuMDAwOSAxLjYwMDA5IDEzLjk2MTMgMi4wMDIyMiAxNC4wMzg0IDIuMzkwMThDMTQuMTE1NiAyLjc3ODE0IDE0LjMwNjEgMy4xMzQ1MSAxNC41ODU4IDMuNDE0MjFDMTQuODY1NSAzLjY5MzkyIDE1LjIyMTkgMy44ODQ0IDE1LjYwOTggMy45NjE1N0MxNS45OTc4IDQuMDM4NzQgMTYuMzk5OSAzLjk5OTEzIDE2Ljc2NTQgMy44NDc3NkMxNy4xMzA4IDMuNjk2MzggMTcuNDQzMiAzLjQ0MDA0IDE3LjY2MjkgMy4xMTExNEMxNy44ODI3IDIuNzgyMjQgMTggMi4zOTU1NiAxOCAyQzE4IDEuNDY5NTcgMTcuNzg5MyAwLjk2MDg2IDE3LjQxNDIgMC41ODU3ODdDMTcuMDM5MSAwLjIxMDcxNCAxNi41MzA0IDAgMTYgMFoiIGZpbGw9IiMzRjRBNTUiLz4KPC9zdmc+Cg==", nl = "data:image/svg+xml;base64,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", sl = "data:image/svg+xml;base64,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", ol = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik05LjcwODU4IDlMOS43MTIzMSA4Ljk5OTk1TDkuNzQ0MjEgOC45OTkzM0M5Ljc3NDc4IDguOTk4NTggOS44MjM1NiA4Ljk5Njk3IDkuODg4NjkgOC45OTM1NkMxMC4wMTkxIDguOTg2NzYgMTAuMjE0MyA4Ljk3MjgyIDEwLjQ1OTYgOC45NDQzMkMxMC45NTE2IDguODg3MTcgMTEuNjM2OCA4Ljc3MjQgMTIuNDAwNCA4LjU0MzMzQzEzLjkzNzEgOC4wODIyOSAxNS43MTM2IDcuMTgzMSAxNi45Mjc1IDUuNDM4MTdDMTcuMDIwNiA1LjMwNDI5IDE3LjAyOCA1LjExNTg3IDE2LjkyNjQgNC45NjA4OEMxNS4zNTQxIDIuNTYxNDMgMTIuNzAyOCAxIDkuNzA5MjYgMUM0LjkyNjkxIDEgMSA1LjAwMTQyIDEgMTBDMSAxNC45OTg2IDQuOTI2OTEgMTkgOS43MDkyNiAxOUMxMi41NTY5IDE5IDE1LjA5MzkgMTcuNTg3NSAxNi42ODg0IDE1LjM4NDZDMTYuOTQ5NiAxNS4wMjM3IDE2LjkzNjggMTQuNTU0OCAxNi42ODQ0IDE0LjIzMjhDMTUuNDQzMyAxMi42NDk0IDEzLjcyMTkgMTEuODMyMSAxMi4yNTM1IDExLjQxMzdDMTEuNTI0NCAxMS4yMDYgMTAuODc2IDExLjEwMiAxMC40MTI2IDExLjA1MDNDMTAuMTgxNiAxMS4wMjQ1IDkuOTk4MzIgMTEuMDExOSA5Ljg3NjI2IDExLjAwNThDOS44MTUyOCAxMS4wMDI3IDkuNzY5NzQgMTEuMDAxMyA5Ljc0MTMgMTEuMDAwNkw5LjcxMTc2IDExTDkuNzA5MjYgMTFDOS43MDkwNCAxMSA5LjcwODgyIDExIDkuNzA4NiAxMU05LjcwODU4IDlMOS43MDkyNiAxMEM5LjcwOTI2IDExIDkuNzA4OTIgMTEgOS43MDg2IDExTTkuNzA4NTggOUM5LjcwODQ5IDkgOS43MDg0MSA5IDkuNzA4MzIgOUM5LjcwNzk0IDkgOS43MDc1NSA5IDkuNzA3MTYgOUM5LjE1NTg0IDkuMDAxMTMgOC43MDkyNiA5LjQ0ODQxIDguNzA5MjYgMTBDOC43MDkyNiAxMC41NTIxIDkuMTU2NjIgMTAuOTk5NiA5LjcwODYgMTFNOS43MDg1OCA5TDkuNzA4NiAxMSIgc3Ryb2tlPSIjM0Y0QTU1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", N1 = "data:image/svg+xml;base64,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", l1 = "data:image/svg+xml;base64,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", n1 = "data:image/svg+xml;base64,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", al = "data:image/svg+xml;base64,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", jl = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoCiAgICBkPSJNMC40OTk4MjcgNy45OTk5OUgyLjYxOTA2QzIuNjg0ODQgOC4wMDAzNyAyLjc1MDA0IDcuOTg3NzYgMi44MTA5NCA3Ljk2Mjg5QzIuODcxODQgNy45MzgwMiAyLjkyNzIyIDcuOTAxMzcgMi45NzM5MyA3Ljg1NTA0TDYuNDMyNjcgNC4zOTEzTDcuODUyMTUgMy4wMDE4MUM3Ljg5OSAyLjk1NTM0IDcuOTM2MTkgMi45MDAwNiA3Ljk2MTU2IDIuODM5MTZDNy45ODY5NCAyLjc3ODI1IDggMi43MTI5MiA4IDIuNjQ2OTRDOCAyLjU4MDk2IDcuOTg2OTQgMi41MTU2MyA3Ljk2MTU2IDIuNDU0NzJDNy45MzYxOSAyLjM5MzgxIDcuODk5IDIuMzM4NTMgNy44NTIxNSAyLjI5MjA3TDUuNzMyOTIgMC4xNDc4NDVDNS42ODY0NiAwLjEwMDk5OCA1LjYzMTE4IDAuMDYzODE0NiA1LjU3MDI3IDAuMDM4NDM5NUM1LjUwOTM3IDAuMDEzMDY0NCA1LjQ0NDA0IDAgNS4zNzgwNSAwQzUuMzEyMDcgMCA1LjI0Njc0IDAuMDEzMDY0NCA1LjE4NTg0IDAuMDM4NDM5NUM1LjEyNDkzIDAuMDYzODE0NiA1LjA2OTY1IDAuMTAwOTk4IDUuMDIzMTggMC4xNDc4NDVMMy42MTM2OSAxLjU2MjMzTDAuMTQ0OTU2IDUuMDI2MDdDMC4wOTg2MzE4IDUuMDcyNzggMC4wNjE5ODI1IDUuMTI4MTYgMC4wMzcxMDkyIDUuMTg5MDZDMC4wMTIyMzYgNS4yNDk5NiAtMC4wMDAzNzE5NTQgNS4zMTUxNiA4LjM1NDExZS0wNiA1LjM4MDk0VjcuNTAwMTdDOC4zNTQxMWUtMDYgNy42MzI3MyAwLjA1MjY2NzcgNy43NTk4NiAwLjE0NjQwMiA3Ljg1MzZDMC4yNDAxMzYgNy45NDczMyAwLjM2NzI2NyA3Ljk5OTk5IDAuNDk5ODI3IDcuOTk5OTlaTTUuMzc4MDUgMS4yMDc0Nkw2Ljc5MjU0IDIuNjIxOTVMNi4wODI4IDMuMzMxNjlMNC42NjgzMSAxLjkxNzJMNS4zNzgwNSAxLjIwNzQ2Wk0wLjk5OTY0NSA1LjU4NTg3TDMuOTYzNTcgMi42MjE5NUw1LjM3ODA1IDQuMDM2NDNMMi40MTQxMyA3LjAwMDM1SDAuOTk5NjQ1VjUuNTg1ODdaIiBmaWxsPSJncmF5IiAvPgo8L3N2Zz4K", Tl = "data:image/svg+xml;base64,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", cl = "data:image/svg+xml;base64,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", Dl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSI3LjI1IiB5PSIwLjI1IiB3aWR0aD0iMC41IiBoZWlnaHQ9IjE0LjUiIHN0cm9rZT0iI0RCREJGOSIgc3Ryb2tlLXdpZHRoPSIwLjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8cmVjdCB4PSIwLjI1IiB5PSI3Ljc1IiB3aWR0aD0iMC41IiBoZWlnaHQ9IjE0LjUiIHRyYW5zZm9ybT0icm90YXRlKC05MCAwLjI1IDcuNzUpIiBzdHJva2U9IiNEQkRCRjkiIHN0cm9rZS13aWR0aD0iMC41IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", rl = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGgKICAgIGQ9Ik0xLjAwMTA4IDcuMDA1NjdMOC41OTEwOCA3LjAwNTY3TDUuMjkxMDggMTAuMjk1N0M1LjEwMjc4IDEwLjQ4NCA0Ljk5Njk5IDEwLjczOTQgNC45OTY5OSAxMS4wMDU3QzQuOTk2OTkgMTEuMjcyIDUuMTAyNzggMTEuNTI3NCA1LjI5MTA4IDExLjcxNTdDNS40NzkzOCAxMS45MDQgNS43MzQ3OCAxMi4wMDk4IDYuMDAxMDggMTIuMDA5OEM2LjI2NzM4IDEyLjAwOTggNi41MjI3OCAxMS45MDQgNi43MTEwOCAxMS43MTU3TDExLjcxMTEgNi43MTU2N0MxMS44MDIxIDYuNjIwNTcgMTEuODczNSA2LjUwODQzIDExLjkyMTEgNi4zODU2N0MxMi4wMjExIDYuMTQyMjEgMTIuMDIxMSA1Ljg2OTEzIDExLjkyMTEgNS42MjU2N0MxMS44NzM1IDUuNTAyOTIgMTEuODAyMSA1LjM5MDc4IDExLjcxMTEgNS4yOTU2N0w2LjcxMTA4IDAuMjk1Njc1QzYuNjE4MTIgMC4yMDE5NDcgNi41MDc1MiAwLjEyNzU1MSA2LjM4NTY2IDAuMDc2NzgxN0M2LjI2MzggMC4wMjYwMTI5IDYuMTMzMDkgLTAuMDAwMTI0NDkgNi4wMDEwOCAtMC4wMDAxMjQ1MDJDNS44NjkwNyAtMC4wMDAxMjQ1MTMgNS43MzgzNiAwLjAyNjAxMjggNS42MTY1IDAuMDc2NzgxN0M1LjQ5NDY1IDAuMTI3NTUxIDUuMzg0MDQgMC4yMDE5NDcgNS4yOTEwOCAwLjI5NTY3NUM1LjE5NzM1IDAuMzg4NjM4IDUuMTIyOTYgMC40OTkyMzcgNS4wNzIxOSAwLjYyMTA5N0M1LjAyMTQyIDAuNzQyOTU3IDQuOTk1MjggMC44NzM2NjIgNC45OTUyOCAxLjAwNTY3QzQuOTk1MjggMS4xMzc2OSA1LjAyMTQyIDEuMjY4MzkgNS4wNzIxOSAxLjM5MDI1QzUuMTIyOTYgMS41MTIxMSA1LjE5NzM1IDEuNjIyNzEgNS4yOTEwOCAxLjcxNTY3TDguNTkxMDggNS4wMDU2N0wxLjAwMTA4IDUuMDA1NjdDMC43MzU4NjQgNS4wMDU2NyAwLjQ4MTUxIDUuMTExMDMgMC4yOTM5NzQgNS4yOTg1N0MwLjEwNjQzNyA1LjQ4NjEgMC4wMDEwODEwNiA1Ljc0MDQ2IDAuMDAxMDgxMDQgNi4wMDU2N0MwLjAwMTA4MTAxIDYuMjcwODkgMC4xMDY0MzcgNi41MjUyNCAwLjI5Mzk3MyA2LjcxMjc4QzAuNDgxNTEgNi45MDAzMiAwLjczNTg2NCA3LjAwNTY3IDEuMDAxMDggNy4wMDU2N1oiCiAgICBmaWxsPSIjMTIxMkUwIiAvPgo8L3N2Zz4K", gl = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTQuNzEwMTkgNC4yODk5QzQuNjE1MDggNC4xOTg4NiA0LjUwMjk0IDQuMTI3NDkgNC4zODAxOSA0LjA3OTlDNC4xMzY3MiAzLjk3OTg4IDMuODYzNjUgMy45Nzk4OCAzLjYyMDE4IDQuMDc5OUMzLjQ5NzQzIDQuMTI3NDkgMy4zODUyOSA0LjE5ODg2IDMuMjkwMTggNC4yODk5TDAuNzkwMTg1IDYuNzg5OUMwLjYwMTg4MSA2Ljk3ODIgMC40OTYwOTQgNy4yMzM1OSAwLjQ5NjA5NCA3LjQ5OTlDMC40OTYwOTQgNy43NjYyIDAuNjAxODgxIDguMDIxNTkgMC43OTAxODUgOC4yMDk5QzAuOTc4NDg5IDguMzk4MiAxLjIzMzg4IDguNTAzOTkgMS41MDAxOSA4LjUwMzk5QzEuNzY2NDkgOC41MDM5OSAyLjAyMTg4IDguMzk4MiAyLjIxMDE5IDguMjA5OUwzLjAwMDE5IDcuNDA5OVYxNC45OTk5QzMuMDAwMTkgMTUuMjY1MSAzLjEwNTU0IDE1LjUxOTUgMy4yOTMwOCAxNS43MDdDMy40ODA2MSAxNS44OTQ1IDMuNzM0OTcgMTUuOTk5OSA0LjAwMDE5IDE1Ljk5OTlDNC4yNjU0IDE1Ljk5OTkgNC41MTk3NiAxNS44OTQ1IDQuNzA3MjkgMTUuNzA3QzQuODk0ODMgMTUuNTE5NSA1LjAwMDE5IDE1LjI2NTEgNS4wMDAxOSAxNC45OTk5VjcuNDA5OUw1Ljc5MDE4IDguMjA5OUM1Ljg4MzE1IDguMzAzNjIgNS45OTM3NSA4LjM3ODAyIDYuMTE1NjEgOC40Mjg3OUM2LjIzNzQ3IDguNDc5NTYgNi4zNjgxNyA4LjUwNTY5IDYuNTAwMTkgOC41MDU2OUM2LjYzMjIgOC41MDU2OSA2Ljc2MjkgOC40Nzk1NiA2Ljg4NDc2IDguNDI4NzlDNy4wMDY2MiA4LjM3ODAyIDcuMTE3MjIgOC4zMDM2MiA3LjIxMDE5IDguMjA5OUM3LjMwMzkxIDguMTE2OTMgNy4zNzgzMSA4LjAwNjMzIDcuNDI5MDggNy44ODQ0N0M3LjQ3OTg0IDcuNzYyNjEgNy41MDU5OCA3LjYzMTkxIDcuNTA1OTggNy40OTk5QzcuNTA1OTggNy4zNjc4OCA3LjQ3OTg0IDcuMjM3MTggNy40MjkwOCA3LjExNTMyQzcuMzc4MzEgNi45OTM0NiA3LjMwMzkxIDYuODgyODYgNy4yMTAxOSA2Ljc4OTlMNC43MTAxOSA0LjI4OTlaIgogICAgZmlsbD0iI0JCQzRDRCIgLz4KICA8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iI0JCQzRDRCIgLz4KPC9zdmc+", Ll = "data:image/svg+xml;base64,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", Il = "data:image/svg+xml;base64,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", dl = "data:image/svg+xml;base64,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", yl = "data:image/svg+xml;base64,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", zl = "data:image/svg+xml;base64,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", ml = "data:image/svg+xml;base64,ICA8c3ZnIHZpZXdCb3g9IjAgMCA3ODAgNzgwIiBmaWxsPSJncmF5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGgKICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgIGQ9Ik03MzIgNDhINDhWNzMySDczMlY0OFpNMCAwVjc4MEg3ODBWMEgwWiIKICAgIC8+CiAgICA8cGF0aAogICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgICAgZD0iTTczMiA4NEM3MzIgNjQuMTE3OCA3MTUuODgyIDQ4IDY5NiA0OEg4NEM2NC4xMTc4IDQ4IDQ4IDY0LjExNzcgNDggODRWNjk2QzQ4IDcxNS44ODIgNjQuMTE3NyA3MzIgODQgNzMySDY5NkM3MTUuODgyIDczMiA3MzIgNzE1Ljg4MiA3MzIgNjk2Vjg0Wk0wIDBWNzgwSDc4MFYwSDBaIgogICAgLz4KICAgIDxwYXRoCiAgICAgIGQ9Ik0yNzYgMzkwQzI3NiAzNjYuODA0IDI5NC44MDQgMzQ4IDMxOCAzNDhINDYyQzQ4NS4xOTYgMzQ4IDUwNCAzNjYuODA0IDUwNCAzOTBDNTA0IDQxMy4xOTYgNDg1LjE5NiA0MzIgNDYyIDQzMkgzMThDMjk0LjgwNCA0MzIgMjc2IDQxMy4xOTYgMjc2IDM5MFoiCiAgICAvPgogICAgPHBhdGgKICAgICAgZD0iTTI3NiA0OThDMjc2IDQ3NC44MDQgMjk0LjgwNCA0NTYgMzE4IDQ1NkMzNDEuMTk2IDQ1NiAzNjAgNDc0LjgwNCAzNjAgNDk4QzM2MCA1MjEuMTk2IDM0MS4xOTYgNTQwIDMxOCA1NDBDMjk0LjgwNCA1NDAgMjc2IDUyMS4xOTYgMjc2IDQ5OFoiCiAgICAvPgogICAgPHBhdGgKICAgICAgZD0iTTI3NiAyNTJDMjc2IDI0NS4zNzMgMjgxLjM3MyAyNDAgMjg4IDI0MEg0OTJDNDk4LjYyNyAyNDAgNTA0IDI0NS4zNzMgNTA0IDI1MkM1MDQgMjkxLjc2NCA0NzEuNzY0IDMyNCA0MzIgMzI0SDM0OEMzMDguMjM2IDMyNCAyNzYgMjkxLjc2NCAyNzYgMjUyWiIKICAgIC8+Cjwvc3ZnPg==", Al = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzMgMzMiIGZpbGw9ImdyYXkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgICAgZD0iTTMwLjk2OTIgNS4wMzA3N0MzMC45NjkyIDMuMzczOTIgMjkuNjI2MSAyLjAzMDc3IDI3Ljk2OTIgMi4wMzA3N0g1LjAzMDc3QzMuMzczOTIgMi4wMzA3NyAyLjAzMDc3IDMuMzczOTEgMi4wMzA3NyA1LjAzMDc3VjI3Ljk2OTJDMi4wMzA3NyAyOS42MjYxIDMuMzczOTEgMzAuOTY5MiA1LjAzMDc3IDMwLjk2OTJIMjcuOTY5MkMyOS42MjYxIDMwLjk2OTIgMzAuOTY5MiAyOS42MjYxIDMwLjk2OTIgMjcuOTY5MlY1LjAzMDc3Wk0wIDBWMzNIMzNWMEgwWiIKICAgIC8+CiAgICA8cGF0aAogICAgICBkPSJNMTguNDI3OCA5LjY0NjE1SDExLjUyNkMxMC43NjgyIDkuNjQ2MTUgMTAuMTUzOCAxMC4yNzE2IDEwLjE1MzggMTEuMDQzMVYxNy44OTc2QzEwLjE1MzggMTguNjY5MSAxMC43NjgyIDE5LjI5NDUgMTEuNTI2IDE5LjI5NDVIMTYuNzUzOEwxNi43NDk5IDIzLjc1NjRDMTYuNzQ5IDI0Ljg2ODggMTguMTcxMyAyNS4yOTk0IDE4Ljc2NzYgMjQuMzY3MkwyMy41MSAxNy44OTc2QzI0LjEwNDQgMTYuOTY4NCAyMy40NDk0IDE1LjczODUgMjIuMzYwMiAxNS43Mzg1SDE5LjhWMTEuMDQzMUMxOS44IDEwLjI3MTYgMTkuMTg1NiA5LjY0NjE1IDE4LjQyNzggOS42NDYxNVoiCiAgICAvPgo8L3N2Zz4=", xl = "data:image/svg+xml;base64,ICA8c3ZnIHZpZXdCb3g9IjAgMCA3ODAgNzgwIiBmaWxsPSJncmF5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGgKICAgICAgZD0iTTMwNiAyMTZDMzA2IDIwOS4zNzMgMzExLjM3MyAyMDQgMzE4IDIwNEg0MjBDNDMyLjczMSAyMDQgNDQ0Ljg4MyAyMDYuNDc4IDQ1NiAyMTAuOTc4QzQ5MS4xODIgMjI1LjIxOSA1MTYgMjU5LjcxMSA1MTYgMzAwQzUxNiAzNDAuMjg5IDQ5MS4xODIgMzc0Ljc4MSA0NTYgMzg5LjAyMkM0NDQuODgzIDM5My41MjIgNDMyLjczMSAzOTYgNDIwIDM5NkgzNjZDMzU5LjM3MyAzOTYgMzU0IDQwMS4zNzMgMzU0IDQwOEMzNTQgNDE0LjYyNyAzNTkuMzczIDQyMCAzNjYgNDIwSDQwOEM0MzEuMTk2IDQyMCA0NTAgNDM4LjgwNCA0NTAgNDYyQzQ1MCA0ODUuMTk2IDQzMS4xOTYgNTA0IDQwOCA1MDRIMzYwQzM0Ny4yNjkgNTA0IDMzNS4xMTcgNTAxLjUyMiAzMjQgNDk3LjAyMkMyODguODE4IDQ4Mi43ODEgMjY0IDQ0OC4yODkgMjY0IDQwOEMyNjQgMzY3LjcxMSAyODguODE4IDMzMy4yMTkgMzI0IDMxOC45NzhDMzM1LjExNyAzMTQuNDc4IDM0Ny4yNjkgMzEyIDM2MCAzMTJINDIwQzQyNi42MjcgMzEyIDQzMiAzMDYuNjI3IDQzMiAzMDBDNDMyIDI5My4zNzMgNDI2LjYyNyAyODggNDIwIDI4OEgzNzJWMjg3Ljc1NEMzMzUuMDQzIDI4NC43MDUgMzA2IDI1My43NDQgMzA2IDIxNloiCiAgICAvPgogICAgPHBhdGgKICAgICAgZD0iTTM1NCA1NzBDMzU0IDU1My40MzEgMzY3LjQzMSA1NDAgMzg0IDU0MEM0MDAuNTY5IDU0MCA0MTQgNTUzLjQzMSA0MTQgNTcwQzQxNCA1ODYuNTY5IDQwMC41NjkgNjAwIDM4NCA2MDBDMzY3LjQzMSA2MDAgMzU0IDU4Ni41NjkgMzU0IDU3MFoiCiAgICAvPgogICAgPHBhdGgKICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgIGQ9Ik0wIDc4MFYwSDc4MFY3ODBIMFpNNzMyIDg0QzczMiA2NC4xMTc4IDcxNS44ODIgNDggNjk2IDQ4SDg0QzY0LjExNzggNDggNDggNjQuMTE3NyA0OCA4NFY2OTZDNDggNzE1Ljg4MiA2NC4xMTc3IDczMiA4NCA3MzJINjk2QzcxNS44ODIgNzMyIDczMiA3MTUuODgyIDczMiA2OTZWODRaIgogICAgLz4KICA8L3N2Zz4=", El = "data:image/svg+xml;base64,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", hl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzgwIiBoZWlnaHQ9IjUwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNzgwIDUwMCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNzgwIDUwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNDAgMWUtM2g3MDBjMjIuMDkyIDAgNDAgMTcuOTA5IDQwIDQwdjQyMGMwIDIyLjA5Mi0xNy45MDggNDAtNDAgNDBoLTcwMGMtMjIuMDkxIDAtNDAtMTcuOTA4LTQwLTQwdi00MjBjMC0yMi4wOTEgMTcuOTA5LTQwIDQwLTQweiIgZmlsbD0iIzI1NTdENiIvPjxwYXRoIGQ9Im0wLjI1MyAyMzUuNjloMzcuNDQxbDguNDQyLTE5LjUxaDE4LjlsOC40MiAxOS41MWg3My42Njh2LTE0LjkxNWw2LjU3NiAxNC45OGgzOC4yNDNsNi41NzYtMTUuMjAydjE1LjEzOGgxODMuMDhsLTAuMDg1LTMyLjAyNmgzLjU0MmMyLjQ3OSAwLjA4MyAzLjIwNCAwLjMwMiAzLjIwNCA0LjIyNnYyNy44aDk0LjY4OXYtNy40NTVjNy42MzkgMy45MiAxOS41MTggNy40NTUgMzUuMTQ4IDcuNDU1aDM5LjgzNmw4LjUyNS0xOS41MWgxOC45bDguMzM3IDE5LjUxaDc2Ljc2NXYtMTguNTMybDExLjYyNiAxOC41MzJoNjEuNTE1di0xMjIuNTFoLTYwLjg4djE0LjQ2OGwtOC41MjItMTQuNDY4aC02Mi40NzF2MTQuNDY4bC03LjgyOC0xNC40NjhoLTg0LjM4Yy0xNC4xMjMgMC0yNi41MzkgMS44ODktMzYuNTY5IDcuMTUzdi03LjE1M2gtNTguMjI5djcuMTUzYy02LjM4My01LjQyNi0xNS4wNzktNy4xNTMtMjQuNzUtNy4xNTNoLTIxMi43NGwtMTQuMjc0IDMxLjY0MS0xNC42NTktMzEuNjQxaC02Ny4wMDV2MTQuNDY4bC03LjM2Mi0xNC40NjhoLTU3LjE0NWwtMjYuNTM5IDU4LjI0NnY2NC4yNjFoM2UtM3ptMjM2LjM0LTE3LjY3aC0yMi40NjRsLTAuMDgzLTY4Ljc5NC0zMS43NzUgNjguNzkzaC0xOS4yNGwtMzEuODU4LTY4Ljg1NHY2OC44NTRoLTQ0LjU3bC04LjQyLTE5LjU5MmgtNDUuNjI3bC04LjUwNSAxOS41OTJoLTIzLjgwMWwzOS4yNDEtODcuODM3aDMyLjU1OWwzNy4yNjkgODMuMTY0di04My4xNjRoMzUuNzY2bDI4LjY3OCA1OS41ODcgMjYuMzQ0LTU5LjU4N2gzNi40ODVsMWUtMyA4Ny44Mzh6bS0xNjUuOS0zNy44MjNsLTE0Ljk5OC0zNS4wMTctMTQuOTE1IDM1LjAxN2gyOS45MTN6bTI1NS4zIDM3LjgyMWgtNzMuMjAzdi04Ny44MzdoNzMuMjAzdjE4LjI5MWgtNTEuMjg5djE1LjgzM2g1MC4wNnYxOC4wMDVoLTUwLjA2MXYxNy41NDJoNTEuMjg5bDFlLTMgMTguMTY2em0xMDMuMTYtNjQuMThjMCAxNC4wMDQtOS43NTUgMjEuMjQtMTUuNDM5IDIzLjQxMiA0Ljc5NCAxLjc0OCA4Ljg5MSA0LjgzOCAxMC44NCA3LjM5NyAzLjA5NCA0LjM2OSAzLjYyOCA4LjI3MSAzLjYyOCAxNi4xMTZ2MTcuMjU1aC0yMi4xMDRsLTAuMDgzLTExLjA3N2MwLTUuMjg1IDAuNTI4LTEyLjg4Ni0zLjQ1OC0xNy4xMTItMy4yMDItMy4wOS04LjA4My0zLjc2LTE1Ljk3My0zLjc2aC0yMy41MjN2MzEuOTVoLTIxLjkxNHYtODcuODM4aDUwLjQwMWMxMS4xOTkgMCAxOS40NTEgMC4yODMgMjYuNTM1IDQuMjA3IDYuOTMzIDMuOTI0IDExLjA5IDkuNjUyIDExLjA5IDE5LjQ1em0tMjcuNjk5IDEzLjA0MmMtMy4wMTMgMS43NTItNi41NzMgMS44MS0xMC44NDEgMS44MWgtMjYuNjJ2LTE5LjUxaDI2Ljk4MmMzLjgxOCAwIDcuODA0IDAuMTY0IDEwLjM5MyAxLjU4NCAyLjg0MiAxLjI4IDQuNjAxIDQuMDAzIDQuNjAxIDcuNzY1IDAgMy44NC0xLjY3NCA2LjkyOS00LjUxNSA4LjM1MXptNjIuODQ0IDUxLjEzOGgtMjIuMzU4di04Ny44MzdoMjIuMzU4djg3LjgzN3ptMjU5LjU2IDBoLTMxLjA1M2wtNDEuNTM1LTY1LjkyN3Y2NS45MjdoLTQ0LjYyOGwtOC41MjctMTkuNTkyaC00NS41MjFsLTguMjcxIDE5LjU5MmgtMjUuNjQ4Yy0xMC42NDkgMC0yNC4xMzgtMi4yNTctMzEuNzczLTkuNzE1LTcuNzAxLTcuNDU4LTExLjcwOC0xNy41Ni0xMS43MDgtMzMuNTMzIDAtMTMuMDI3IDIuMzk1LTI0LjkzNiAxMS44MTItMzQuMzQ3IDcuMDg1LTcuMDEgMTguMTgtMTAuMjQyIDMzLjI4LTEwLjI0MmgyMS4yMTV2MTguODIxaC0yMC43NzFjLTcuOTk3IDAtMTIuNTE0IDEuMTQtMTYuODYyIDUuMjAzLTMuNzM1IDMuNjk5LTYuMjk4IDEwLjY5LTYuMjk4IDE5Ljg5NyAwIDkuNDEgMS45NTEgMTYuMTk2IDYuMDIzIDIwLjYyOCAzLjM3MyAzLjQ3NiA5LjUwNiA0LjUzIDE1LjI3MiA0LjUzaDkuODQybDMwLjg4NC02OS4wNzZoMzIuODM1bDM3LjEwMiA4My4wODF2LTgzLjA4aDMzLjM2NmwzOC41MTkgNjEuMTc0di02MS4xNzRoMjIuNDQ1djg3LjgzM3ptLTEzMy4yLTM3LjgybC0xNS4xNjUtMzUuMDE3LTE1LjA4MSAzNS4wMTdoMzAuMjQ2em0xODkuMDQgMTc4LjA4Yy01LjMyMiA3LjQ1Ny0xNS42OTQgMTEuMjM4LTI5LjczNiAxMS4yMzhoLTQyLjMxOXYtMTguODRoNDIuMTQ3YzQuMTgxIDAgNy4xMDYtMC41MjcgOC44NjgtMi4xNzUgMS42NjUtMS40NzQgMi42MDUtMy41NTQgMi41OTEtNS43MjkgMC0yLjU2MS0xLjA2NC00LjU5My0yLjY3Ny01LjgxMS0xLjU5LTEuMzQyLTMuOTA0LTEuOTUtNy43MjItMS45NS0yMC41NzQtMC42Ny00Ni4yNDQgMC42MDgtNDYuMjQ0LTI3LjE5NCAwLTEyLjc0MiA4LjQ0My0yNi4xNTYgMzEuNDM5LTI2LjE1Nmg0My42NDl2LTE3LjQ3OWgtNDAuNTU3Yy0xMi4yMzcgMC0yMS4xMjkgMi44MS0yNy40MjUgNy4xNzR2LTcuMTc1aC01OS45ODVjLTkuNTk1IDAtMjAuODU0IDIuMjc5LTI2LjE3OSA3LjE3NXYtNy4xNzVoLTEwNy4xMnY3LjE3NWMtOC41MjQtNS44OTItMjIuOTA4LTcuMTc1LTI5LjU0OS03LjE3NWgtNzAuNjU2djcuMTc1Yy02Ljc0NS02LjI1OC0yMS43NDItNy4xNzUtMzAuODg2LTcuMTc1aC03OS4wNzdsLTE4LjA5NCAxOC43NjQtMTYuOTQ5LTE4Ljc2NGgtMTE4LjEzdjEyMi41OWgxMTUuOWwxOC42NDYtMTkuMDYyIDE3LjU2NSAxOS4wNjIgNzEuNDQyIDAuMDYxdi0yOC44MzhoNy4wMjFjOS40NzkgMC4xNCAyMC42Ni0wLjIyOCAzMC41MjMtNC4zMTJ2MzMuMDg1aDU4LjkyOHYtMzEuOTUyaDIuODQyYzMuNjI4IDAgMy45ODUgMC4xNDQgMy45ODUgMy42MTV2MjguMzMzaDE3OS4wMWMxMS4zNjQgMCAyMy4yNDQtMi43ODYgMjkuODI0LTcuODQ1djcuODQ1aDU2Ljc4YzExLjgxNSAwIDIzLjM1NC0xLjU4NyAzMi4xMzQtNS42NDlsMmUtMyAtMjIuODR6bS0zNTQuOTQtNDcuMTU1YzAgMjQuNDA2LTE5LjAwNSAyOS40NDUtMzguMTU5IDI5LjQ0NWgtMjcuMzQzdjI5LjQ2OWgtNDIuNTkxbC0yNi45ODQtMjkuMDg2LTI4LjA0MiAyOS4wODZoLTg2LjgwMnYtODcuODU5aDg4LjEzNWwyNi45NjEgMjguNzk5IDI3Ljg3NS0yOC43OTloNzAuMDIxYzE3LjM4OSAwIDM2LjkyOSA0LjYxMyAzNi45MjkgMjguOTQ1em0tMTc0LjIyIDQwLjQzNGgtNTMuODc4di0xNy40OGg0OC4xMXYtMTcuOTI2aC00OC4xMXYtMTUuOTc0aDU0LjkzOWwyMy45NjkgMjUuNjA0LTI1LjAzIDI1Ljc3NnptODYuODEgMTAuMDZsLTMzLjY0NC0zNS43ODkgMzMuNjQ0LTM0LjY1djcwLjQzOXptNDkuNzU3LTM5LjA2NmgtMjguMzE4di0yMi4zNzRoMjguNTcyYzcuOTEyIDAgMTMuNDA0IDMuMDkgMTMuNDA0IDEwLjc3MiAwIDcuNTk5LTUuMjM4IDExLjYwMi0xMy42NTggMTEuNjAyem0xNDguMzYtNDAuMzczaDczLjEzOHYxOC4xN2gtNTEuMzE1djE1Ljk3M2g1MC4wNjJ2MTcuOTI2aC01MC4wNjJ2MTcuNDhsNTEuMzE0IDAuMDh2MTguMjNoLTczLjEzOWwyZS0zIC04Ny44NTl6bS0yOC4xMTkgNDcuMDI5YzQuODc4IDEuNzI1IDguODY1IDQuODE2IDEwLjczNCA3LjM3NSAzLjA5NSA0LjI5MSAzLjU0MiA4LjI5NCAzLjYzMSAxNi4wMzd2MTcuNDE4aC0yMi4wMDJ2LTEwLjk5MmMwLTUuMjg2IDAuNTMxLTEzLjExMi0zLjU0Mi0xNy4xOTgtMy4yMDEtMy4xNDctOC4wODMtMy44OTktMTYuMDc2LTMuODk5aC0yMy40MnYzMi4wOWgtMjIuMDJ2LTg3Ljg1OWg1MC41OTRjMTEuMDkzIDAgMTkuMTczIDAuNDcgMjYuMzY2IDQuMTQ2IDYuOTE1IDQuMDA0IDExLjI2NiA5LjQ4NyAxMS4yNjYgMTkuNTExLTFlLTMgMTQuMDIyLTkuNzY0IDIxLjE3OC0xNS41MzEgMjMuMzcxem0tMTIuMzg1LTExLjEwN2MtMi45MzIgMS42NjctNi41NTYgMS44MTEtMTAuODE4IDEuODExaC0yNi42MjJ2LTE5LjczMmgyNi45ODJjMy45MDIgMCA3LjgwNyAwLjA4IDEwLjQ1OCAxLjU4NyAyLjg0IDEuNDIzIDQuNTM4IDQuMTQ2IDQuNTM4IDcuOTAzIDAgMy43NTgtMS42OTkgNi43ODYtNC41MzggOC40MzF6bTE5Ny44MiA1LjU5N2M0LjI3IDQuMjI5IDYuNTU0IDkuNTcxIDYuNTU0IDE4LjYxMyAwIDE4LjktMTIuMzIyIDI3LjcyMy0zNC40MjUgMjcuNzIzaC00Mi42OHYtMTguODRoNDIuNTFjNC4xNTcgMCA3LjEwNC0wLjUyNSA4Ljk1LTIuMTc1IDEuNTA4LTEuMzU4IDIuNTg5LTMuMzMzIDIuNTg5LTUuNzI5IDAtMi41NjEtMS4xNy00LjU5Mi0yLjY3NS01LjgxMS0xLjY3NS0xLjM0LTMuOTg2LTEuOTQ5LTcuODAzLTEuOTQ5LTIwLjQ5My0wLjY3LTQ2LjE1NyAwLjYwOS00Ni4xNTctMjcuMTkyIDAtMTIuNzQ0IDguMzU1LTI2LjE1OCAzMS4zMy0yNi4xNThoNDMuOTMydjE4LjdoLTQwLjE5OGMtMy45ODQgMC02LjU3NSAwLjE0NS04Ljc3OSAxLjU4Ny0yLjQgMS40MjItMy4yOSAzLjUzNC0zLjI5IDYuMzE5IDAgMy4zMTQgMi4wMzcgNS41NyA0Ljc5NSA2LjU0NiAyLjMxMSAwLjc3IDQuNzk1IDAuOTk1IDguNTI2IDAuOTk1bDExLjc5NyAwLjMwNmMxMS44OTUgMC4yNzYgMjAuMDYxIDIuMjQ4IDI1LjAyNCA3LjA2NXptODYuOTU1LTIzLjUyaC0zOS45MzhjLTMuOTg2IDAtNi42MzggMC4xNDQtOC44NjcgMS41ODctMi4zMTIgMS40MjMtMy4yMDIgMy41MzQtMy4yMDIgNi4zMjIgMCAzLjMxNCAxLjk1MSA1LjU2OCA0Ljc5MSA2LjU0NCAyLjMxMiAwLjc3MSA0Ljc5NSAwLjk5NiA4LjQ0NCAwLjk5NmwxMS44NzggMC4zMDRjMTEuOTgzIDAuMjg0IDE5Ljk4MiAyLjI1OCAyNC44NiA3LjA3MiAwLjg5MSAwLjY3IDEuNDIyIDEuNDIyIDIuMDMzIDIuMTc1di0yNWgxZS0zeiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg0K", Cl = "data:image/svg+xml;base64,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", Ol = "data:image/svg+xml;base64,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", pl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzgwIiBoZWlnaHQ9IjUwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNzgwIDUwMCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNzgwIDUwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNDAsMGg3MDBjMjIuMDkyLDAsNDAsMTcuOTA5LDQwLDQwdjQyMGMwLDIyLjA5Mi0xNy45MDgsNDAtNDAsNDBINDBjLTIyLjA5MSwwLTQwLTE3LjkwOC00MC00MFY0MCAgIEMwLDE3LjkwOSwxNy45MDksMCw0MCwweiIgZmlsbD0iIzAwNzlCRSIvPjxwYXRoIGQ9Im01OTkuOTMgMjUxLjQ1YzAtOTkuNDE1LTgyLjk4LTE2OC4xMy0xNzMuOS0xNjguMWgtNzguMjQyYy05Mi4wMDMtMC4wMzMtMTY3LjczIDY4LjcwNS0xNjcuNzMgMTY4LjEgMCA5MC45MyA3NS43MjcgMTY1LjY0IDE2Ny43MyAxNjUuMmg3OC4yNDJjOTAuOTE0IDAuNDM2IDE3My45LTc0LjI5NCAxNzMuOS0xNjUuMnoiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJtMzQ4LjI4IDk3LjQzYy04NC4wNyAwLjAyNy0xNTIuMTkgNjguMzA4LTE1Mi4yMSAxNTIuNTggMC4wMiA4NC4yNTggNjguMTQ0IDE1Mi41MyAxNTIuMjEgMTUyLjU2IDg0LjA5LTAuMDI3IDE1Mi4yMy02OC4zMDMgMTUyLjI0LTE1Mi41Ni0wLjAxMS04NC4yNzItNjguMTQ5LTE1Mi41NS0xNTIuMjQtMTUyLjU4eiIgZmlsbD0iIzAwNzlCRSIvPjxwYXRoIGQ9Im0yNTIuMDcgMjQ5LjZjMC4wOC00MS4xODEgMjUuNzQ2LTc2LjI5NyA2MS45NC05MC4yNXYxODAuNDhjLTM2LjE5NC0xMy45NDgtNjEuODYxLTQ5LjA0NS02MS45NC05MC4yM3ptMTMxIDkwLjI3NHYtMTgwLjUzYzM2LjIwNyAxMy45MiA2MS45MTQgNDkuMDU3IDYxLjk3OSA5MC4yNTctMC4wNjUgNDEuMjEyLTI1Ljc3MiA3Ni4zMjItNjEuOTc5IDkwLjI2OXoiIGZpbGw9IiNmZmYiLz48L3N2Zz4NCg==", wl = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI3ODAiIGhlaWdodD0iNTAwIiB2aWV3Qm94PSIwIDAgNzgwIDUwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik01NC45OTIgMEMyNC42MjcgMCAwIDI0LjYzIDAgNTUuMDA0djM5MC45OTJDMCA0NzYuMzc2IDI0LjYxOSA1MDEgNTQuOTkyIDUwMWg2NzAuMDE2Qzc1NS4zNzMgNTAxIDc4MCA0NzYuMzcgNzgwIDQ0NS45OTZWNTUuMDA0Qzc4MCAyNC42MjQgNzU1LjM4MSAwIDcyNS4wMDggMEg1NC45OTJ6IiBmaWxsPSIjNEQ0RDREIi8+PHBhdGggZD0iTTMyNy4xNTIgMTYxLjg5M2M4LjgzNyAwIDE2LjI0OCAxLjc4NCAyNS4yNjggNi4wOXYyMi43NTFjLTguNTQ0LTcuODYzLTE1Ljk1NS0xMS4xNTQtMjUuNzU2LTExLjE1NC0xOS4yNjQgMC0zNC40MTQgMTUuMDE1LTM0LjQxNCAzNC4wNSAwIDIwLjA3NSAxNC42ODEgMzQuMTk2IDM1LjM3IDM0LjE5NiA5LjMxMiAwIDE2LjU4Ni0zLjEyIDI0LjgtMTAuODU3djIyLjc2M2MtOS4zNDEgNC4xNC0xNi45MTEgNS43NzYtMjUuNzU2IDUuNzc2LTMxLjI3OCAwLTU1LjU4Mi0yMi41OTYtNTUuNTgyLTUxLjczNyAwLTI4LjgyNiAyNC45NTEtNTEuODc4IDU2LjA3LTUxLjg3OHptLTk3LjExMy42MjdjMTEuNTQ2IDAgMjIuMTEgMy43MiAzMC45NDMgMTAuOTk0bC0xMC43NDggMTMuMjQ4Yy01LjM1LTUuNjQ2LTEwLjQxLTguMDI4LTE2LjU2NC04LjAyOC04Ljg1MyAwLTE1LjMgNC43NDUtMTUuMyAxMC45ODkgMCA1LjM1NCAzLjYxOSA4LjE4OCAxNS45NDQgMTIuNDgyIDIzLjM2NSA4LjA0NCAzMC4yOSAxNS4xNzYgMzAuMjkgMzAuOTI2IDAgMTkuMTkzLTE0Ljk3NiAzMi41NTMtMzYuMzIgMzIuNTUzLTE1LjYzIDAtMjYuOTk0LTUuNzk1LTM2LjQ1OC0xOC44NzJsMTMuMjY4LTEyLjAzYzQuNzMgOC42MSAxMi42MjIgMTMuMjIyIDIyLjQyIDEzLjIyMiA5LjE2MyAwIDE1Ljk0Ny01Ljk1MiAxNS45NDctMTMuOTg0IDAtNC4xNjQtMi4wNTUtNy43MzQtNi4xNTgtMTAuMjU4LTIuMDY2LTEuMTk1LTYuMTU4LTIuOTc3LTE0LjItNS42NDctMTkuMjkxLTYuNTM4LTI1LjkxLTEzLjUyNy0yNS45MS0yNy4xODUgMC0xNi4yMjUgMTQuMjE0LTI4LjQxIDMyLjg0Ni0yOC40MXptMjM0LjcyMyAxLjcyOGgyMi40MzdsMjguMDg0IDY2LjU5MiAyOC40NDYtNjYuNTkyaDIyLjI2N2wtNDUuNDk0IDEwMS42ODZoLTExLjA1M2wtNDQuNjg3LTEwMS42ODZ6bS0zOTcuMzQ4LjE1MmgzMC4xNWMzMy4zMTIgMCA1Ni41MzQgMjAuMzgyIDU2LjUzNCA0OS42NDEgMCAxNC41OS03LjEwNCAyOC42OTYtMTkuMTE4IDM4LjA1Ny0xMC4xMDggNy45MDEtMjEuNjI2IDExLjQ0NS0zNy41NzQgMTEuNDQ1SDY3LjQxNFYxNjQuNHptOTYuMTM1IDBoMjAuNTR2OTkuMTQzaC0yMC41NFYxNjQuNHptNDExLjczNCAwaDU4LjI1MnYxNi44SDU5NS44MXYyMi4wMDVoMzYuMzM2djE2Ljc5MWgtMzYuMzM2djI2Ljc2MmgzNy43MjZ2MTYuNzg1aC01OC4yNTJWMTY0LjR6bTcxLjg1OCAwaDMwLjQ1NWMyMy42OSAwIDM3LjI2NSAxMC43MSAzNy4yNjUgMjkuMjcyIDAgMTUuMTgtOC41MTQgMjUuMTQtMjMuOTg2IDI4LjEwNWwzMy4xNDggNDEuNzY2aC0yNS4yNmwtMjguNDI5LTM5LjgyOGgtMi42Nzh2MzkuODI4aC0yMC41MTVWMTY0LjR6bTIwLjUxNSAxNS42MTZ2MzAuMDI1aDYuMDAyYzEzLjExNyAwIDIwLjA2OS01LjM2MiAyMC4wNjktMTUuMzI4IDAtOS42NDgtNi45NTQtMTQuNjk3LTE5Ljc0NS0xNC42OTdoLTYuMzI2ek04Ny45NCAxODEuMTk5djY1LjU1OWg1LjUxMmMxMy4yNzMgMCAyMS42NTYtMi4zOTQgMjguMTEtNy44OCA3LjEwMy01Ljk1NSAxMS4zNzYtMTUuNDY1IDExLjM3Ni0yNC45OCAwLTkuNDk5LTQuMjczLTE4LjcyNS0xMS4zNzYtMjQuNjgxLTYuNzg1LTUuNzgtMTQuODM3LTguMDE4LTI4LjExLTguMDE4SDg3Ljk0eiIgZmlsbD0iI0ZGRiIvPjxwYXRoIGQ9Im00MTUuMTMgMTYxLjIxYzMwLjk0MSAwIDU2LjAyMiAyMy41OCA1Ni4wMjIgNTIuNzA5djAuMDMzYzAgMjkuMTMtMjUuMDgxIDUyLjc0Mi01Ni4wMjEgNTIuNzQycy01Ni4wMjItMjMuNjEzLTU2LjAyMi01Mi43NDJ2LTAuMDMzYzAtMjkuMTMgMjUuMDgyLTUyLjcxIDU2LjAyMi01Mi43MXptMzY0Ljg1IDEyNy4xNWMtMjYuMDUgMTguMzMtMjIxLjA4IDE0OS4zNC01NTguNzUgMjEyLjYyaDUwMy43NmMzMC4zNjUgMCA1NC45OTItMjQuNjMgNTQuOTkyLTU1LjAwNHYtMTU3LjYyeiIgZmlsbD0iI0Y0NzIxNiIvPjwvZz48L3N2Zz4K", Yl = "data:image/svg+xml;base64,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", Sl = "data:image/svg+xml;base64,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", Zl = "data:image/svg+xml;base64,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", kl = "data:image/svg+xml;base64,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", bl = "data:image/svg+xml;base64,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", Ul = "data:image/svg+xml;base64,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", Ql = "data:image/svg+xml;base64,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", Vl = "data:image/svg+xml;base64,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", Wl = "data:image/svg+xml;base64,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", fl = "data:image/svg+xml;base64,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", vl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzgwIiBoZWlnaHQ9IjUwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNzgwIDUwMCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNzgwIDUwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNDAsMGg3MDBjMjIuMDkyLDAsNDAsMTcuOTA5LDQwLDQwdjQyMGMwLDIyLjA5Mi0xNy45MDgsNDAtNDAsNDBINDBjLTIyLjA5MSwwLTQwLTE3LjkwOC00MC00MFY0MCAgIEMwLDE3LjkwOSwxNy45MDksMCw0MCwweiIgZmlsbD0iIzBFNDU5NSIvPjxwYXRoIGQ9Im0yOTMuMiAzNDguNzNsMzMuMzYxLTE5NS43Nmg1My4zNmwtMzMuMzg1IDE5NS43NmgtNTMuMzM2em0yNDYuMTEtMTkxLjU0Yy0xMC41Ny0zLjk2Ni0yNy4xMzctOC4yMjItNDcuODIyLTguMjIyLTUyLjcyNSAwLTg5Ljg2NSAyNi41NS05MC4xOCA2NC42MDMtMC4yOTkgMjguMTMgMjYuNTE0IDQzLjgyMiA0Ni43NTIgNTMuMTg2IDIwLjc3MSA5LjU5NSAyNy43NTIgMTUuNzE0IDI3LjY1NCAyNC4yODMtMC4xMzEgMTMuMTIxLTE2LjU4NiAxOS4xMTYtMzEuOTIyIDE5LjExNi0yMS4zNTcgMC0zMi43MDMtMi45NjctNTAuMjI3LTEwLjI3NmwtNi44NzYtMy4xMS03LjQ4OSA0My44MjNjMTIuNDYzIDUuNDY0IDM1LjUxIDEwLjE5OCA1OS40MzggMTAuNDQzIDU2LjA5IDAgOTIuNS0yNi4yNDYgOTIuOTE2LTY2Ljg4MiAwLjE5OS0yMi4yNjktMTQuMDE2LTM5LjIxNi00NC44MDEtNTMuMTg4LTE4LjY1LTkuMDU1LTMwLjA3Mi0xNS4wOTktMjkuOTUxLTI0LjI2OCAwLTguMTM3IDkuNjY4LTE2LjgzOSAzMC41NTctMTYuODM5IDE3LjQ0OS0wLjI3IDMwLjA5IDMuNTM1IDM5LjkzOCA3LjVsNC43ODEgMi4yNiA3LjIzMi00Mi40MjltMTM3LjMxLTQuMjIzaC00MS4yMzJjLTEyLjc3MyAwLTIyLjMzMiAzLjQ4Ny0yNy45NDEgMTYuMjM0bC03OS4yNDQgMTc5LjRoNTYuMDMxczkuMTYtMjQuMTIzIDExLjIzMi0yOS40MThjNi4xMjUgMCA2MC41NTUgMC4wODQgNjguMzM4IDAuMDg0IDEuNTk2IDYuODUzIDYuNDkgMjkuMzM0IDYuNDkgMjkuMzM0aDQ5LjUxNGwtNDMuMTg4LTE5NS42NHptLTY1LjQxOCAxMjYuNDFjNC40MTItMTEuMjc5IDIxLjI2LTU0LjcyMyAyMS4yNi01NC43MjMtMC4zMTYgMC41MjIgNC4zNzktMTEuMzM0IDcuMDc0LTE4LjY4NGwzLjYwNSAxNi44NzlzMTAuMjE5IDQ2LjcyOSAxMi4zNTQgNTYuNTI4aC00NC4yOTN6bS0zNjMuMy0xMjYuNDFsLTUyLjI0IDEzMy41LTUuNTY3LTI3LjEzYy05LjcyNS0zMS4yNzMtNDAuMDI1LTY1LjE1NS03My44OTgtODIuMTE4bDQ3Ljc2NiAxNzEuMiA1Ni40NTYtMC4wNjQgODQuMDA0LTE5NS4zOWgtNTYuNTIxIiBmaWxsPSIjZmZmIi8+PHBhdGggZD0ibTE0Ni45MiAxNTIuOTZoLTg2LjA0MWwtMC42ODEgNC4wNzNjNjYuOTM4IDE2LjIwNCAxMTEuMjMgNTUuMzYzIDEyOS42MiAxMDIuNDFsLTE4LjcxLTg5Ljk2Yy0zLjIzLTEyLjM5NS0xMi41OTctMTYuMDk0LTI0LjE4Ni0xNi41MjciIGZpbGw9IiNGMkFFMTQiLz48L3N2Zz4NCg==", Gl = "data:image/svg+xml;base64,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", Rl = "data:image/svg+xml;base64,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", WA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddImageIcon: e1,
  AiIcon: tl,
  Alipay: El,
  Amex: hl,
  ArrowRightIcon: rl,
  ArrowTriangle: Il,
  ArrowsExchangeIcon: t1,
  BillIcon: Rl,
  ChainIcon: vN,
  ChartIcon: HN,
  ChatBubbleIcon: nl,
  CheckCircleIcon: yu,
  CheckIcon: i1,
  ChevronLeftIcon: u1,
  ChevronRightIcon: Ji,
  Code: Ol,
  CodeFront: Cl,
  CopyIcon: al,
  CrossIcon: mu,
  CrossLightIcon: fN,
  DashboardIcon: JN,
  Diners: pl,
  Discover: wl,
  DocumentExportIcon: dl,
  Elo: Yl,
  ExitIcon: FN,
  Eye2Icon: Lu,
  EyeIcon: gu,
  FeedBeoLogo: ml,
  FlashBoldIcon: BN,
  FlashIcon: KN,
  FunnyEmojiIcon: sl,
  GearIcon: XN,
  Generic: Sl,
  GifIcon: UN,
  GiftIcon: Nl,
  Hiper: Zl,
  HiperCard: kl,
  InfoIcon: Tl,
  Jcb: bl,
  KudoLogo: Al,
  LineAndArrowIcon: gl,
  LinearScaleIcon: ll,
  Logo: _N,
  Maestro: Ul,
  MagnifierIcon: PN,
  Mastercard: Ql,
  MemeIcon: qN,
  Mir: Vl,
  MultimediaIcon: QN,
  MultipleLinesIcon: ul,
  NumberScaleIcon: l1,
  PacManIcon: ol,
  PartyEmojiIcon: n1,
  Paypal: Wl,
  PencilIcon: jl,
  PeopleIcon: RN,
  PersonCheckIcon: Gl,
  PersonIcon: GN,
  PhotoIcon: WN,
  PlusCircleIcon: cl,
  PlusIcon: Dl,
  RefreshIcon: Ll,
  Star2Icon: el,
  StarIcon: Ml,
  StarScaleIcon: N1,
  SurveyLogo: xl,
  TextIcon: VN,
  ThumbUpIcon: zl,
  TrashBinIcon: zu,
  TtTextIcon: il,
  Unionpay: fl,
  Visa: vl,
  WordCloudIcon: yl,
  XCircleIcon: du,
  YtIcon: $N,
  iconPasswordBlob: Iu
}, Symbol.toStringTag, { value: "Module" }));
async function s1(M, e) {
  const t = new Image();
  return new Promise((i, u) => {
    t.onload = function() {
      const N = document.createElement("canvas");
      N.width = t.width, N.height = t.height, t.width > e && (N.width = e, N.height = t.height * (e / t.width));
      const l = N.getContext("2d");
      l.imageSmoothingEnabled = !1, l.drawImage(t, 0, 0, N.width, N.height), i(N.toDataURL("image/webp", 90));
    }, t.src = M;
  });
}
const fA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  resizeImage: s1
}, Symbol.toStringTag, { value: "Module" }));
const Fl = {
  viewBox: "0 0 21 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Xl = /* @__PURE__ */ T("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.0035 0C14.1035 0 17.9035 2.91 19.9235 7.6C19.9785 7.72617 20.007 7.86234 20.007 8C20.007 8.13766 19.9785 8.27383 19.9235 8.4C17.9035 13.09 14.1035 16 10.0035 16C5.90348 16 2.10348 13.09 0.0834848 8.4C0.0284215 8.27383 0 8.13766 0 8C0 7.86234 0.0284215 7.72617 0.0834848 7.6C2.10348 2.91 5.90348 0 10.0035 0ZM7.7812 4.67412C8.439 4.2346 9.21236 4 10.0035 4C11.0644 4 12.0818 4.42143 12.8319 5.17157C13.5821 5.92172 14.0035 6.93913 14.0035 8C14.0035 8.79113 13.7689 9.56448 13.3294 10.2223C12.8898 10.8801 12.2651 11.3928 11.5342 11.6955C10.8033 11.9983 9.99905 12.0775 9.22312 11.9231C8.4472 11.7688 7.73447 11.3878 7.17506 10.8284C6.61565 10.269 6.23468 9.55628 6.08034 8.78036C5.926 8.00444 6.00522 7.20017 6.30797 6.46927C6.61072 5.73836 7.12341 5.11365 7.7812 4.67412ZM8.89234 9.66294C9.22124 9.8827 9.60792 10 10.0035 10C10.5339 10 11.0426 9.78929 11.4177 9.41421C11.7928 9.03914 12.0035 8.53043 12.0035 8C12.0035 7.60444 11.8862 7.21776 11.6664 6.88886C11.4467 6.55996 11.1343 6.30362 10.7689 6.15224C10.4034 6.00087 10.0013 5.96126 9.6133 6.03843C9.22534 6.1156 8.86898 6.30608 8.58927 6.58579C8.30957 6.86549 8.11908 7.22186 8.04191 7.60982C7.96474 7.99778 8.00435 8.39991 8.15573 8.76537C8.3071 9.13082 8.56345 9.44318 8.89234 9.66294Z"
}, null, -1), Jl = [
  Xl
];
function Kl(M, e) {
  return c(), g("svg", Fl, [...Jl]);
}
const Bl = { render: Kl }, Hl = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Pl = /* @__PURE__ */ T("path", { d: "M19 10C18.7348 10 18.4804 10.1054 18.2929 10.2929C18.1054 10.4804 18 10.7348 18 11V14.38L16.52 12.9C15.9974 12.3815 15.2911 12.0906 14.555 12.0906C13.8189 12.0906 13.1126 12.3815 12.59 12.9L11.89 13.61L9.41 11.12C8.88742 10.6015 8.18113 10.3106 7.445 10.3106C6.70887 10.3106 6.00258 10.6015 5.48 11.12L4 12.61V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H13C13.2652 6 13.5196 5.89464 13.7071 5.70711C13.8946 5.51957 14 5.26522 14 5C14 4.73478 13.8946 4.48043 13.7071 4.29289C13.5196 4.10536 13.2652 4 13 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19.22C2.00264 19.9565 2.29637 20.6621 2.81715 21.1828C3.33794 21.7036 4.04351 21.9974 4.78 22H17.22C17.491 21.9978 17.7603 21.9574 18.02 21.88C18.5974 21.718 19.1058 21.3711 19.4671 20.8924C19.8283 20.4137 20.0226 19.8297 20.02 19.23V11C20.02 10.867 19.9935 10.7353 19.942 10.6126C19.8905 10.49 19.8151 10.3789 19.7201 10.2857C19.6251 10.1926 19.5125 10.1194 19.3888 10.0703C19.2652 10.0212 19.133 9.99734 19 10ZM5 20C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V15.43L6.89 12.54C7.03615 12.3947 7.23389 12.3131 7.44 12.3131C7.64611 12.3131 7.84385 12.3947 7.99 12.54L15.46 20H5ZM18 19C17.9936 19.1936 17.931 19.3812 17.82 19.54L13.3 15L14.01 14.3C14.0817 14.2268 14.1673 14.1687 14.2617 14.129C14.3561 14.0893 14.4576 14.0689 14.56 14.0689C14.6624 14.0689 14.7639 14.0893 14.8583 14.129C14.9527 14.1687 15.0383 14.2268 15.11 14.3L18 17.21V19ZM21 4H20V3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2C18.7348 2 18.4804 2.10536 18.2929 2.29289C18.1054 2.48043 18 2.73478 18 3V4H17C16.7348 4 16.4804 4.10536 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5C16 5.26522 16.1054 5.51957 16.2929 5.70711C16.4804 5.89464 16.7348 6 17 6H18V7C18 7.26522 18.1054 7.51957 18.2929 7.70711C18.4804 7.89464 18.7348 8 19 8C19.2652 8 19.5196 7.89464 19.7071 7.70711C19.8946 7.51957 20 7.26522 20 7V6H21C21.2652 6 21.5196 5.89464 21.7071 5.70711C21.8946 5.51957 22 5.26522 22 5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10536 21.2652 4 21 4Z" }, null, -1), _l = [
  Pl
];
function $l(M, e) {
  return c(), g("svg", Hl, [..._l]);
}
const o1 = { render: $l }, ql = {
  viewBox: "0 0 8 8",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Mn = /* @__PURE__ */ T("path", { d: "M0.499827 7.99999H2.61906C2.68484 8.00037 2.75004 7.98776 2.81094 7.96289C2.87184 7.93802 2.92722 7.90137 2.97393 7.85504L6.43267 4.3913L7.85215 3.00181C7.899 2.95534 7.93619 2.90006 7.96156 2.83916C7.98694 2.77825 8 2.71292 8 2.64694C8 2.58096 7.98694 2.51563 7.96156 2.45472C7.93619 2.39381 7.899 2.33853 7.85215 2.29207L5.73292 0.147845C5.68646 0.100998 5.63118 0.0638146 5.57027 0.0384395C5.50937 0.0130644 5.44404 0 5.37805 0C5.31207 0 5.24674 0.0130644 5.18584 0.0384395C5.12493 0.0638146 5.06965 0.100998 5.02318 0.147845L3.61369 1.56233L0.144956 5.02607C0.0986318 5.07278 0.0619825 5.12816 0.0371092 5.18906C0.012236 5.24996 -0.000371954 5.31516 8.35411e-06 5.38094V7.50017C8.35411e-06 7.63273 0.0526677 7.75986 0.146402 7.8536C0.240136 7.94733 0.367267 7.99999 0.499827 7.99999ZM5.37805 1.20746L6.79254 2.62195L6.0828 3.33169L4.66831 1.9172L5.37805 1.20746ZM0.999645 5.58587L3.96357 2.62195L5.37805 4.03643L2.41413 7.00035H0.999645V5.58587Z" }, null, -1), en = [
  Mn
];
function tn(M, e) {
  return c(), g("svg", ql, [...en]);
}
const un = { render: tn }, Nn = {
  viewBox: "0 0 9 10",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, ln = /* @__PURE__ */ T("path", { d: "M9 3.47C8.99479 3.42407 8.98474 3.37882 8.97 3.335V3.29C8.94596 3.23859 8.91389 3.19133 8.875 3.15L5.875 0.15C5.83367 0.111108 5.78641 0.0790405 5.735 0.0549999C5.72008 0.05288 5.70493 0.05288 5.69 0.0549999C5.63921 0.0258706 5.58311 0.0071721 5.525 0H3.5C3.10218 0 2.72064 0.158035 2.43934 0.43934C2.15804 0.720644 2 1.10218 2 1.5V2H1.5C1.10218 2 0.720644 2.15804 0.43934 2.43934C0.158035 2.72064 0 3.10218 0 3.5V8.5C0 8.89782 0.158035 9.27936 0.43934 9.56066C0.720644 9.84196 1.10218 10 1.5 10H5.5C5.89782 10 6.27936 9.84196 6.56066 9.56066C6.84196 9.27936 7 8.89782 7 8.5V8H7.5C7.89782 8 8.27936 7.84196 8.56066 7.56066C8.84196 7.27936 9 6.89782 9 6.5V3.5C9 3.5 9 3.5 9 3.47ZM6 1.705L7.295 3H6.5C6.36739 3 6.24021 2.94732 6.14645 2.85355C6.05268 2.75979 6 2.63261 6 2.5V1.705ZM6 8.5C6 8.63261 5.94732 8.75979 5.85355 8.85355C5.75979 8.94732 5.63261 9 5.5 9H1.5C1.36739 9 1.24021 8.94732 1.14645 8.85355C1.05268 8.75979 1 8.63261 1 8.5V3.5C1 3.36739 1.05268 3.24021 1.14645 3.14645C1.24021 3.05268 1.36739 3 1.5 3H2V6.5C2 6.89782 2.15804 7.27936 2.43934 7.56066C2.72064 7.84196 3.10218 8 3.5 8H6V8.5ZM8 6.5C8 6.63261 7.94732 6.75979 7.85355 6.85355C7.75979 6.94732 7.63261 7 7.5 7H3.5C3.36739 7 3.24021 6.94732 3.14645 6.85355C3.05268 6.75979 3 6.63261 3 6.5V1.5C3 1.36739 3.05268 1.24021 3.14645 1.14645C3.24021 1.05268 3.36739 1 3.5 1H5V2.5C5 2.89782 5.15804 3.27936 5.43934 3.56066C5.72064 3.84196 6.10218 4 6.5 4H8V6.5Z" }, null, -1), nn = [
  ln
];
function sn(M, e) {
  return c(), g("svg", Nn, [...nn]);
}
const a1 = { render: sn }, on = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, an = /* @__PURE__ */ T("path", { d: "M10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19ZM14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18Z" }, null, -1), jn = [
  an
];
function Tn(M, e) {
  return c(), g("svg", on, [...jn]);
}
const Au = { render: Tn }, cn = {
  viewBox: "0 0 34 34",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Dn = /* @__PURE__ */ Du('<path d="M0.899657 15.9888C1.38607 15.9888 1.78599 15.611 1.84504 15.1284C2.18664 12.3369 3.28252 9.77838 4.92278 7.66253C5.2197 7.27952 5.20292 6.73206 4.86011 6.38946C4.48348 6.01305 3.86516 6.03104 3.53622 6.44972C1.63832 8.8654 0.377287 11.8045 0.00585214 15.0146C-0.0551391 15.5417 0.36872 15.9888 0.899657 15.9888Z"></path><path d="M26.3432 29.0699C26.7264 28.7731 27.2742 28.7899 27.617 29.1325C27.9937 29.5089 27.9757 30.1268 27.5567 30.4556C25.1153 32.3714 22.1394 33.6379 18.8896 33.9947C18.364 34.0524 17.9198 33.6297 17.9198 33.1012C17.9198 32.6131 18.301 32.2125 18.7861 32.1561C21.613 31.8269 24.2042 30.726 26.3432 29.0699Z"></path><path d="M29.0589 27.7135C29.4334 28.0877 30.0476 28.0722 30.378 27.6586C32.3237 25.2227 33.6171 22.2436 33.9941 18.9854C34.0551 18.4583 33.6313 18.0112 33.1003 18.0112C32.6139 18.0112 32.214 18.3891 32.155 18.8716C31.8081 21.706 30.6836 24.3002 29.0012 26.4347C28.6995 26.8175 28.7141 27.3689 29.0589 27.7135Z"></path><path d="M6.27999 4.94848C6.62478 5.29305 7.17652 5.30762 7.55956 5.00609C9.67359 3.34186 12.2383 2.22388 15.0407 1.86512C15.5212 1.8036 15.8962 1.4048 15.8962 0.920652C15.8962 0.387915 15.4455 -0.0365018 14.9163 0.0277131C11.6941 0.418729 8.74811 1.70499 6.33492 3.63017C5.92099 3.96039 5.90549 4.5742 6.27999 4.94848Z"></path><path d="M0.899656 18.0112C0.36872 18.0112 -0.0551393 18.4583 0.00585187 18.9854C0.377287 22.1955 1.63833 25.1346 3.53623 27.5503C3.86517 27.969 4.48348 27.987 4.86012 27.6105C5.20293 27.268 5.2197 26.7205 4.92278 26.3375C3.28253 24.2216 2.18664 21.6631 1.84504 18.8716C1.78599 18.389 1.38607 18.0112 0.899656 18.0112Z"></path><path d="M33.1003 15.9888C32.6139 15.9888 32.214 15.6109 32.155 15.1284C31.8081 12.2941 30.6836 9.69982 29.0012 7.56532C28.6995 7.18252 28.7141 6.63111 29.0589 6.28654C29.4334 5.91226 30.0476 5.92776 30.378 6.34143C32.3237 8.77733 33.6171 11.7564 33.9941 15.0146C34.0551 15.5417 33.6313 15.9888 33.1003 15.9888Z"></path><path d="M6.33493 30.3698C5.921 30.0396 5.90549 29.4258 6.28 29.0515C6.62479 28.707 7.17653 28.6924 7.55957 28.9939C9.6736 30.6581 12.2383 31.7761 15.0407 32.1349C15.5212 32.1964 15.8962 32.5952 15.8962 33.0793C15.8962 33.6121 15.4455 34.0365 14.9163 33.9723C11.6941 33.5813 8.74811 32.295 6.33493 30.3698Z"></path><path d="M27.5567 3.54444C27.9757 3.87318 27.9937 4.49112 27.617 4.86752C27.2742 5.21012 26.7264 5.22689 26.3432 4.93015C24.2042 3.27396 21.613 2.17311 18.7861 1.84394C18.301 1.78746 17.9198 1.38692 17.9198 0.898835C17.9198 0.370339 18.364 -0.052436 18.8896 0.00528454C22.1394 0.362133 25.1153 1.62862 27.5567 3.54444Z"></path><path d="M12.1596 21.9087C13.1898 21.9087 14.1427 21.6127 14.9282 21.1237C15.1343 20.995 15.3274 20.7762 15.3274 20.4288V17.7005C15.3274 17.25 15.0055 16.9154 14.5548 16.9154H12.4429C11.9922 16.9154 11.6574 17.2372 11.6574 17.6876C11.6574 18.138 11.9922 18.4598 12.4429 18.4598H13.6534V20.1328C13.2413 20.2743 12.6232 20.3644 12.1596 20.3644C10.4856 20.3644 9.1335 18.9617 9.1335 17.2758C9.1335 15.577 10.4856 14.1871 12.1596 14.1871C12.6876 14.1871 13.1769 14.303 13.6019 14.4831C13.7435 14.5475 13.8852 14.5861 14.0268 14.5861C14.4518 14.5861 14.7608 14.2 14.7608 13.7882C14.7608 13.5437 14.6321 13.2992 14.3745 13.1576C13.7435 12.8101 12.958 12.6428 12.1596 12.6428C9.55845 12.6428 7.45947 14.7148 7.45947 17.2758C7.45947 19.8368 9.55845 21.9087 12.1596 21.9087Z"></path><path d="M18.4861 13.5565C18.4861 13.1061 18.1126 12.7715 17.7006 12.7715C17.2112 12.7715 16.8764 13.1061 16.8764 13.5565V20.995C16.8764 21.4454 17.1983 21.78 17.6748 21.78C18.0997 21.78 18.4861 21.4454 18.4861 20.995V13.5565Z"></path><path d="M22.0323 20.995C22.0323 21.4454 21.6589 21.78 21.2339 21.78C20.7446 21.78 20.4227 21.4454 20.4227 20.995V13.5565C20.4227 13.1061 20.7575 12.7715 21.2082 12.7715H25.3933C25.844 12.7715 26.1788 13.0804 26.1788 13.5308C26.1788 13.904 25.844 14.2515 25.3933 14.2515H22.0323V16.5165H24.8138C25.2645 16.5165 25.5993 16.8254 25.5993 17.2758C25.5993 17.649 25.2645 17.9965 24.8138 17.9965H22.0323V20.995Z"></path>', 11), rn = [
  Dn
];
function gn(M, e) {
  return c(), g("svg", cn, [...rn]);
}
const Ln = { render: gn }, In = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, dn = /* @__PURE__ */ T("path", { d: "M19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.1645 21.9977 19.3284 21.981 19.49 21.95L19.79 21.88H19.86H19.91L20.28 21.74L20.41 21.67C20.51 21.61 20.62 21.56 20.72 21.49C20.8535 21.3918 20.9805 21.2849 21.1 21.17L21.17 21.08C21.2682 20.9805 21.3585 20.8735 21.44 20.76L21.53 20.63C21.5998 20.5187 21.6601 20.4016 21.71 20.28C21.7374 20.232 21.7609 20.1818 21.78 20.13C21.83 20.01 21.86 19.88 21.9 19.75V19.6C21.9567 19.4046 21.9903 19.2032 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM5 20C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V14.69L7.29 11.39C7.38296 11.2963 7.49356 11.2219 7.61542 11.1711C7.73728 11.1203 7.86799 11.0942 8 11.0942C8.13201 11.0942 8.26272 11.1203 8.38458 11.1711C8.50644 11.2219 8.61704 11.2963 8.71 11.39L17.31 20H5ZM20 19C19.9991 19.1233 19.9753 19.2453 19.93 19.36C19.9071 19.4087 19.8804 19.4556 19.85 19.5C19.8232 19.5423 19.7931 19.5825 19.76 19.62L14.41 14.27L15.29 13.39C15.383 13.2963 15.4936 13.2219 15.6154 13.1711C15.7373 13.1203 15.868 13.0942 16 13.0942C16.132 13.0942 16.2627 13.1203 16.3846 13.1711C16.5064 13.2219 16.617 13.2963 16.71 13.39L20 16.69V19ZM20 13.86L18.12 12C17.5477 11.457 16.7889 11.1543 16 11.1543C15.2111 11.1543 14.4523 11.457 13.88 12L13 12.88L10.12 10C9.54772 9.45699 8.7889 9.15428 8 9.15428C7.2111 9.15428 6.45228 9.45699 5.88 10L4 11.86V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V13.86ZM13.5 6C13.2033 6 12.9133 6.08797 12.6666 6.2528C12.42 6.41762 12.2277 6.65189 12.1142 6.92597C12.0006 7.20006 11.9709 7.50166 12.0288 7.79264C12.0867 8.08361 12.2296 8.35088 12.4393 8.56066C12.6491 8.77044 12.9164 8.9133 13.2074 8.97118C13.4983 9.02906 13.7999 8.99935 14.074 8.88582C14.3481 8.77229 14.5824 8.58003 14.7472 8.33335C14.912 8.08668 15 7.79667 15 7.5C15 7.10218 14.842 6.72064 14.5607 6.43934C14.2794 6.15804 13.8978 6 13.5 6Z" }, null, -1), yn = [
  dn
];
function zn(M, e) {
  return c(), g("svg", In, [...yn]);
}
const xu = { render: zn }, mn = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, An = /* @__PURE__ */ T("path", { d: "M18.9571 7.96875C17.0245 7.96875 15.2976 9.09656 14.5579 10.8422C14.388 11.2357 14.5706 11.6922 14.9648 11.8602L15.4257 12.0565C15.8209 12.2248 16.2779 12.042 16.4479 11.6475C16.8651 10.6631 17.8499 10.028 18.9571 10.028C20.5766 10.028 21.6646 11.1187 21.6646 12.7425C21.6646 12.8025 21.6169 12.8516 21.5569 12.8533C20.5423 12.8828 19.3461 12.9509 18.277 13.0772C15.7213 13.3786 14.196 14.7755 14.196 16.8141C14.196 17.8997 14.6048 18.8766 15.3473 19.5605C16.0443 20.2031 16.9945 20.5312 18.0238 20.5312C19.184 20.5312 20.217 20.3102 21.0683 19.8525C21.3246 19.7146 21.6646 19.8882 21.6646 20.1792C21.6646 20.3736 21.8222 20.5312 22.0167 20.5312H22.7187C23.271 20.5312 23.7187 20.0835 23.7187 19.5312V12.7425C23.7187 9.97641 21.7162 7.96875 18.9571 7.96875ZM18.0238 18.5189C17.2054 18.5189 16.2496 18.0577 16.2496 16.8141C16.2496 16.3148 16.4287 15.9652 16.8299 15.6802C17.2209 15.4027 17.8199 15.2044 18.5174 15.1223C19.1811 15.044 19.8992 14.9893 20.587 14.9532C21.1658 14.9229 21.6519 15.4074 21.526 15.9732C21.1472 17.6751 19.9919 18.5189 18.0238 18.5189Z" }, null, -1), xn = /* @__PURE__ */ T("path", { d: "M4.12734 15.923C4.27399 15.5332 4.64684 15.2752 5.06328 15.2752H9.56172C9.97816 15.2752 10.351 15.5332 10.4977 15.923L11.9878 19.8834C12.1345 20.2732 12.5073 20.5312 12.9237 20.5312H12.971C13.6756 20.5312 14.1593 19.822 13.9019 19.166L8.20268 4.63857C7.86984 3.79016 6.66827 3.79283 6.33921 4.64272L0.714474 19.1702C0.460746 19.8255 0.944288 20.5312 1.64702 20.5312H1.70125C2.11769 20.5312 2.49054 20.2732 2.63719 19.8834L4.12734 15.923ZM6.37813 9.98366C6.7054 9.12539 7.9196 9.12539 8.24687 9.98366L8.96329 11.8625C9.21289 12.517 8.72947 13.2188 8.02892 13.2188H6.59608C5.89553 13.2188 5.41211 12.517 5.66171 11.8625L6.37813 9.98366Z" }, null, -1), En = [
  An,
  xn
];
function hn(M, e) {
  return c(), g("svg", mn, [...En]);
}
const Cn = { render: hn }, On = {
  viewBox: "0 0 16 17",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, pn = /* @__PURE__ */ T("path", { d: "M11.3 8.72C11.8336 8.25813 12.2616 7.68688 12.5549 7.04502C12.8482 6.40316 13 5.70571 13 5C13 3.67392 12.4732 2.40215 11.5355 1.46447C10.5979 0.526784 9.32608 0 8 0C6.67392 0 5.40215 0.526784 4.46447 1.46447C3.52678 2.40215 3 3.67392 3 5C2.99999 5.70571 3.1518 6.40316 3.44513 7.04502C3.73845 7.68688 4.16642 8.25813 4.7 8.72C3.30014 9.35388 2.11247 10.3775 1.27898 11.6685C0.445495 12.9596 0.00147185 14.4633 0 16C0 16.2652 0.105357 16.5196 0.292893 16.7071C0.48043 16.8946 0.734784 17 1 17C1.26522 17 1.51957 16.8946 1.70711 16.7071C1.89464 16.5196 2 16.2652 2 16C2 14.4087 2.63214 12.8826 3.75736 11.7574C4.88258 10.6321 6.4087 10 8 10C9.5913 10 11.1174 10.6321 12.2426 11.7574C13.3679 12.8826 14 14.4087 14 16C14 16.2652 14.1054 16.5196 14.2929 16.7071C14.4804 16.8946 14.7348 17 15 17C15.2652 17 15.5196 16.8946 15.7071 16.7071C15.8946 16.5196 16 16.2652 16 16C15.9985 14.4633 15.5545 12.9596 14.721 11.6685C13.8875 10.3775 12.6999 9.35388 11.3 8.72ZM8 8C7.40666 8 6.82664 7.82405 6.33329 7.49441C5.83994 7.16476 5.45542 6.69623 5.22836 6.14805C5.0013 5.59987 4.94189 4.99667 5.05764 4.41473C5.1734 3.83279 5.45912 3.29824 5.87868 2.87868C6.29824 2.45912 6.83279 2.1734 7.41473 2.05764C7.99667 1.94189 8.59987 2.0013 9.14805 2.22836C9.69623 2.45542 10.1648 2.83994 10.4944 3.33329C10.8241 3.82664 11 4.40666 11 5C11 5.79565 10.6839 6.55871 10.1213 7.12132C9.55871 7.68393 8.79565 8 8 8Z" }, null, -1), wn = [
  pn
];
function Yn(M, e) {
  return c(), g("svg", On, [...wn]);
}
const j1 = { render: Yn }, Sn = {
  viewBox: "0 0 22 17",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Zn = /* @__PURE__ */ T("path", { d: "M11.3 8.72C11.8336 8.25813 12.2616 7.68688 12.5549 7.04502C12.8482 6.40316 13 5.70571 13 5C13 3.67392 12.4732 2.40215 11.5355 1.46447C10.5979 0.526784 9.32608 1.78911e-07 8 1.78911e-07C6.67392 1.78911e-07 5.40215 0.526784 4.46447 1.46447C3.52678 2.40215 3 3.67392 3 5C2.99999 5.70571 3.1518 6.40316 3.44513 7.04502C3.73845 7.68688 4.16642 8.25813 4.7 8.72C3.30014 9.35388 2.11247 10.3775 1.27898 11.6685C0.445495 12.9596 0.00147185 14.4633 0 16C0 16.2652 0.105357 16.5196 0.292893 16.7071C0.48043 16.8946 0.734784 17 1 17C1.26522 17 1.51957 16.8946 1.70711 16.7071C1.89464 16.5196 2 16.2652 2 16C2 14.4087 2.63214 12.8826 3.75736 11.7574C4.88258 10.6321 6.4087 10 8 10C9.5913 10 11.1174 10.6321 12.2426 11.7574C13.3679 12.8826 14 14.4087 14 16C14 16.2652 14.1054 16.5196 14.2929 16.7071C14.4804 16.8946 14.7348 17 15 17C15.2652 17 15.5196 16.8946 15.7071 16.7071C15.8946 16.5196 16 16.2652 16 16C15.9985 14.4633 15.5545 12.9596 14.721 11.6685C13.8875 10.3775 12.6999 9.35388 11.3 8.72V8.72ZM8 8C7.40666 8 6.82664 7.82405 6.33329 7.49441C5.83994 7.16476 5.45542 6.69623 5.22836 6.14805C5.0013 5.59987 4.94189 4.99667 5.05764 4.41473C5.1734 3.83279 5.45912 3.29824 5.87868 2.87868C6.29824 2.45912 6.83279 2.1734 7.41473 2.05764C7.99667 1.94189 8.59987 2.0013 9.14805 2.22836C9.69623 2.45542 10.1648 2.83994 10.4944 3.33329C10.8241 3.82664 11 4.40666 11 5C11 5.79565 10.6839 6.55871 10.1213 7.12132C9.55871 7.68393 8.79565 8 8 8ZM17.74 8.32C18.38 7.59933 18.798 6.70905 18.9438 5.75634C19.0896 4.80362 18.9569 3.82907 18.5618 2.95C18.1666 2.07093 17.5258 1.3248 16.7165 0.801423C15.9071 0.27805 14.9638 -0.0002576 14 1.78911e-07C13.7348 1.78911e-07 13.4804 0.105357 13.2929 0.292893C13.1054 0.48043 13 0.734784 13 1C13 1.26522 13.1054 1.51957 13.2929 1.70711C13.4804 1.89464 13.7348 2 14 2C14.7956 2 15.5587 2.31607 16.1213 2.87868C16.6839 3.44129 17 4.20435 17 5C16.9986 5.52524 16.8593 6.0409 16.5961 6.49542C16.3328 6.94994 15.9549 7.32738 15.5 7.59C15.3517 7.67552 15.2279 7.79766 15.1404 7.94474C15.0528 8.09182 15.0045 8.2589 15 8.43C14.9958 8.59976 15.0349 8.7678 15.1137 8.91826C15.1924 9.06872 15.3081 9.19665 15.45 9.29L15.84 9.55L15.97 9.62C17.1754 10.1917 18.1923 11.096 18.901 12.2263C19.6096 13.3566 19.9805 14.6659 19.97 16C19.97 16.2652 20.0754 16.5196 20.2629 16.7071C20.4504 16.8946 20.7048 17 20.97 17C21.2352 17 21.4896 16.8946 21.6771 16.7071C21.8646 16.5196 21.97 16.2652 21.97 16C21.9782 14.4654 21.5938 12.9543 20.8535 11.6101C20.1131 10.2659 19.0413 9.13331 17.74 8.32V8.32Z" }, null, -1), kn = [
  Zn
];
function bn(M, e) {
  return c(), g("svg", Sn, [...kn]);
}
const Un = { render: bn }, Qn = {
  viewBox: "0 0 16 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Vn = /* @__PURE__ */ T("path", { d: "M0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H8.59L6.29 13.29C6.19627 13.383 6.12188 13.4936 6.07111 13.6154C6.02034 13.7373 5.9942 13.868 5.9942 14C5.9942 14.132 6.02034 14.2627 6.07111 14.3846C6.12188 14.5064 6.19627 14.617 6.29 14.71C6.38296 14.8037 6.49356 14.8781 6.61542 14.9289C6.73728 14.9797 6.86799 15.0058 7 15.0058C7.13201 15.0058 7.26272 14.9797 7.38458 14.9289C7.50644 14.8781 7.61704 14.8037 7.71 14.71L11.71 10.71C11.801 10.6149 11.8724 10.5028 11.92 10.38C12.02 10.1365 12.02 9.86346 11.92 9.62C11.8724 9.49725 11.801 9.3851 11.71 9.29L7.71 5.29C7.61676 5.19676 7.50607 5.1228 7.38425 5.07234C7.26243 5.02188 7.13186 4.99591 7 4.99591C6.86814 4.99591 6.73757 5.02188 6.61575 5.07234C6.49393 5.1228 6.38324 5.19676 6.29 5.29C6.19676 5.38324 6.1228 5.49393 6.07234 5.61575C6.02188 5.73757 5.99591 5.86814 5.99591 6C5.99591 6.13186 6.02188 6.26243 6.07234 6.38425C6.1228 6.50607 6.19676 6.61676 6.29 6.71L8.59 9H1C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 0 9.73478 0 10ZM13 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7C1.26522 7 1.51957 6.89464 1.70711 6.70711C1.89464 6.51957 2 6.26522 2 6V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H13C13.2652 2 13.5196 2.10536 13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V14C2 13.7348 1.89464 13.4804 1.70711 13.2929C1.51957 13.1054 1.26522 13 1 13C0.734784 13 0.48043 13.1054 0.292893 13.2929C0.105357 13.4804 0 13.7348 0 14V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0Z" }, null, -1), Wn = [
  Vn
];
function fn(M, e) {
  return c(), g("svg", Qn, [...Wn]);
}
const vn = { render: fn }, Gn = {
  viewBox: "0 0 21 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Rn = /* @__PURE__ */ T("path", { d: "M19.7309 18.3109L16.0209 14.6309C17.461 12.8353 18.1584 10.5562 17.9697 8.2622C17.781 5.9682 16.7206 3.83368 15.0064 2.29754C13.2923 0.761407 11.0547 -0.0595894 8.75382 0.00337096C6.45294 0.0663314 4.26362 1.00846 2.63604 2.63604C1.00846 4.26362 0.0663314 6.45294 0.00337096 8.75382C-0.0595894 11.0547 0.761407 13.2923 2.29754 15.0064C3.83368 16.7206 5.9682 17.781 8.2622 17.9697C10.5562 18.1584 12.8353 17.461 14.6309 16.0209L18.3109 19.7009C18.4039 19.7946 18.5145 19.869 18.6363 19.9198C18.7582 19.9706 18.8889 19.9967 19.0209 19.9967C19.1529 19.9967 19.2836 19.9706 19.4055 19.9198C19.5273 19.869 19.6379 19.7946 19.7309 19.7009C19.9111 19.5144 20.0119 19.2652 20.0119 19.0059C20.0119 18.7466 19.9111 18.4974 19.7309 18.3109ZM9.0209 16.0209C7.63643 16.0209 6.28305 15.6104 5.13191 14.8412C3.98076 14.072 3.08356 12.9788 2.55374 11.6997C2.02393 10.4206 1.88531 9.01314 2.1554 7.65527C2.4255 6.2974 3.09219 5.05012 4.07115 4.07115C5.05012 3.09219 6.2974 2.4255 7.65527 2.1554C9.01314 1.88531 10.4206 2.02393 11.6997 2.55374C12.9788 3.08356 14.072 3.98076 14.8412 5.13191C15.6104 6.28305 16.0209 7.63643 16.0209 9.0209C16.0209 10.8774 15.2834 12.6579 13.9706 13.9706C12.6579 15.2834 10.8774 16.0209 9.0209 16.0209Z" }, null, -1), Fn = [
  Rn
];
function Xn(M, e) {
  return c(), g("svg", Gn, [...Fn]);
}
const Eu = { render: Xn }, Jn = {
  viewBox: "0 0 10 7",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Kn = /* @__PURE__ */ T("path", { d: "M7.69954 0.290792L3.40954 4.59079L1.75954 2.94079C1.6699 2.83611 1.55958 2.75109 1.43551 2.69107C1.31145 2.63104 1.17632 2.59731 1.0386 2.59199C0.900878 2.58667 0.763545 2.60988 0.63522 2.66016C0.506895 2.71043 0.390348 2.78669 0.292893 2.88414C0.195439 2.9816 0.119181 3.09814 0.0689062 3.22647C0.0186316 3.3548 -0.00457431 3.49213 0.000745179 3.62985C0.00606467 3.76756 0.0397948 3.9027 0.0998181 4.02676C0.159841 4.15083 0.244862 4.26115 0.349543 4.35079L2.69954 6.71079C2.79298 6.80347 2.9038 6.8768 3.02564 6.92656C3.14747 6.97633 3.27794 7.00155 3.40954 7.00079C3.67188 6.99969 3.92328 6.89554 4.10954 6.71079L9.10954 1.71079C9.20327 1.61783 9.27767 1.50723 9.32844 1.38537C9.3792 1.26351 9.40534 1.1328 9.40534 1.00079C9.40534 0.868781 9.3792 0.738075 9.32844 0.616216C9.27767 0.494356 9.20327 0.383755 9.10954 0.290792C8.92218 0.104542 8.66873 0 8.40454 0C8.14036 0 7.88691 0.104542 7.69954 0.290792Z" }, null, -1), Bn = [
  Kn
];
function Hn(M, e) {
  return c(), g("svg", Jn, [...Bn]);
}
const Mi = { render: Hn }, Pn = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, _n = /* @__PURE__ */ T("path", { d: "M12.72 6.79L8.43001 11.09L6.78 9.44C6.69036 9.33532 6.58004 9.2503 6.45597 9.19027C6.33191 9.13025 6.19678 9.09652 6.05906 9.0912C5.92134 9.08588 5.78401 9.10909 5.65568 9.15936C5.52736 9.20964 5.41081 9.28589 5.31335 9.38335C5.2159 9.4808 5.13964 9.59735 5.08937 9.72568C5.03909 9.854 5.01589 9.99133 5.02121 10.1291C5.02653 10.2668 5.06026 10.4019 5.12028 10.526C5.1803 10.65 5.26532 10.7604 5.37 10.85L7.72 13.21C7.81344 13.3027 7.92426 13.376 8.0461 13.4258C8.16794 13.4755 8.2984 13.5008 8.43001 13.5C8.69234 13.4989 8.94374 13.3947 9.13 13.21L14.13 8.21C14.2237 8.11704 14.2981 8.00644 14.3489 7.88458C14.3997 7.76272 14.4258 7.63201 14.4258 7.5C14.4258 7.36799 14.3997 7.23728 14.3489 7.11542C14.2981 6.99356 14.2237 6.88296 14.13 6.79C13.9426 6.60375 13.6892 6.49921 13.425 6.49921C13.1608 6.49921 12.9074 6.60375 12.72 6.79ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z" }, null, -1), $n = [
  _n
];
function qn(M, e) {
  return c(), g("svg", Pn, [...$n]);
}
const T1 = { render: qn }, Ms = {
  viewBox: "0 0 9 9",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, es = /* @__PURE__ */ T("path", { d: "M7.7158 0.295798C7.62284 0.20207 7.51223 0.127676 7.39038 0.0769072C7.26852 0.0261385 7.13781 0 7.0058 0C6.87379 0 6.74308 0.0261385 6.62122 0.0769072C6.49936 0.127676 6.38876 0.20207 6.2958 0.295798L4.0058 2.5958L1.7158 0.295798C1.52749 0.107495 1.2721 0.00170659 1.0058 0.0017066C0.739497 0.00170661 0.484102 0.107495 0.295798 0.295798C0.107495 0.484102 0.00170661 0.739497 0.0017066 1.0058C0.00170659 1.2721 0.107495 1.52749 0.295798 1.7158L2.5958 4.0058L0.295798 6.2958C0.20207 6.38876 0.127676 6.49936 0.0769072 6.62122C0.0261385 6.74308 0 6.87379 0 7.0058C0 7.13781 0.0261385 7.26852 0.0769072 7.39038C0.127676 7.51223 0.20207 7.62284 0.295798 7.7158C0.388761 7.80953 0.499362 7.88392 0.621222 7.93469C0.743081 7.98546 0.873786 8.0116 1.0058 8.0116C1.13781 8.0116 1.26852 7.98546 1.39038 7.93469C1.51223 7.88392 1.62284 7.80953 1.7158 7.7158L4.0058 5.4158L6.2958 7.7158C6.38876 7.80953 6.49936 7.88392 6.62122 7.93469C6.74308 7.98546 6.87379 8.0116 7.0058 8.0116C7.13781 8.0116 7.26852 7.98546 7.39038 7.93469C7.51223 7.88392 7.62284 7.80953 7.7158 7.7158C7.80953 7.62284 7.88392 7.51223 7.93469 7.39038C7.98546 7.26852 8.0116 7.13781 8.0116 7.0058C8.0116 6.87379 7.98546 6.74308 7.93469 6.62122C7.88392 6.49936 7.80953 6.38876 7.7158 6.2958L5.4158 4.0058L7.7158 1.7158C7.80953 1.62284 7.88392 1.51223 7.93469 1.39038C7.98546 1.26852 8.0116 1.13781 8.0116 1.0058C8.0116 0.873786 7.98546 0.743081 7.93469 0.621222C7.88392 0.499362 7.80953 0.388761 7.7158 0.295798Z" }, null, -1), ts = [
  es
];
function is(M, e) {
  return c(), g("svg", Ms, [...ts]);
}
const c1 = { render: is }, us = {
  viewBox: "0 0 21 21",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Ns = /* @__PURE__ */ T("path", { d: "M13.8329 6.41288C13.7399 6.31915 13.6293 6.24476 13.5075 6.19399C13.3856 6.14322 13.2549 6.11708 13.1229 6.11708C12.9909 6.11708 12.8602 6.14322 12.7383 6.19399C12.6164 6.24476 12.5058 6.31915 12.4129 6.41288L10.1229 8.71288L7.83288 6.41288C7.64458 6.22458 7.38918 6.11879 7.12288 6.11879C6.85658 6.11879 6.60119 6.22458 6.41288 6.41288C6.22458 6.60119 6.11879 6.85658 6.11879 7.12288C6.11879 7.38918 6.22458 7.64458 6.41288 7.83288L8.71288 10.1229L6.41288 12.4129C6.31915 12.5058 6.24476 12.6164 6.19399 12.7383C6.14322 12.8602 6.11708 12.9909 6.11708 13.1229C6.11708 13.2549 6.14322 13.3856 6.19399 13.5075C6.24476 13.6293 6.31915 13.7399 6.41288 13.8329C6.50585 13.9266 6.61645 14.001 6.73831 14.0518C6.86016 14.1025 6.99087 14.1287 7.12288 14.1287C7.25489 14.1287 7.3856 14.1025 7.50746 14.0518C7.62932 14.001 7.73992 13.9266 7.83288 13.8329L10.1229 11.5329L12.4129 13.8329C12.5058 13.9266 12.6164 14.001 12.7383 14.0518C12.8602 14.1025 12.9909 14.1287 13.1229 14.1287C13.2549 14.1287 13.3856 14.1025 13.5075 14.0518C13.6293 14.001 13.7399 13.9266 13.8329 13.8329C13.9266 13.7399 14.001 13.6293 14.0518 13.5075C14.1025 13.3856 14.1287 13.2549 14.1287 13.1229C14.1287 12.9909 14.1025 12.8602 14.0518 12.7383C14.001 12.6164 13.9266 12.5058 13.8329 12.4129L11.5329 10.1229L13.8329 7.83288C13.9266 7.73992 14.001 7.62932 14.0518 7.50746C14.1025 7.3856 14.1287 7.25489 14.1287 7.12288C14.1287 6.99087 14.1025 6.86016 14.0518 6.73831C14.001 6.61645 13.9266 6.50585 13.8329 6.41288ZM17.1929 3.05288C16.2704 2.09778 15.167 1.33596 13.9469 0.811868C12.7269 0.287778 11.4147 0.0119157 10.0869 0.000377568C8.7591 -0.0111606 7.44231 0.241856 6.21334 0.744665C4.98438 1.24747 3.86786 1.99001 2.92893 2.92893C1.99001 3.86786 1.24747 4.98438 0.744665 6.21334C0.241856 7.44231 -0.0111606 8.7591 0.000377568 10.0869C0.0119157 11.4147 0.287778 12.7269 0.811868 13.9469C1.33596 15.167 2.09778 16.2704 3.05288 17.1929C3.97535 18.148 5.0788 18.9098 6.29884 19.4339C7.51888 19.958 8.83108 20.2339 10.1589 20.2454C11.4867 20.2569 12.8035 20.0039 14.0324 19.5011C15.2614 18.9983 16.3779 18.2558 17.3168 17.3168C18.2558 16.3779 18.9983 15.2614 19.5011 14.0324C20.0039 12.8035 20.2569 11.4867 20.2454 10.1589C20.2339 8.83108 19.958 7.51888 19.4339 6.29884C18.9098 5.0788 18.148 3.97535 17.1929 3.05288ZM15.7829 15.7829C14.4749 17.0923 12.7534 17.9077 10.9117 18.0902C9.06993 18.2727 7.22189 17.8109 5.6824 16.7837C4.14292 15.7564 3.00724 14.2271 2.46886 12.4564C1.93047 10.6856 2.02269 8.78302 2.7298 7.07267C3.4369 5.36231 4.71516 3.95003 6.34677 3.07644C7.97839 2.20286 9.86242 1.92201 11.6779 2.28176C13.4934 2.6415 15.1279 3.61957 16.3031 5.04934C17.4783 6.47911 18.1214 8.27212 18.1229 10.1229C18.1265 11.1742 17.9215 12.2157 17.5198 13.1873C17.1182 14.1588 16.5278 15.041 15.7829 15.7829Z" }, null, -1), ls = [
  Ns
];
function ns(M, e) {
  return c(), g("svg", us, [...ls]);
}
const ss = { render: ns }, os = {
  viewBox: "0 0 18 18",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, as = /* @__PURE__ */ T("path", { d: "M10.408 9.00019L16.708 2.71019C16.8963 2.52188 17.0021 2.26649 17.0021 2.00019C17.0021 1.73388 16.8963 1.47849 16.708 1.29019C16.5197 1.10188 16.2643 0.996094 15.998 0.996094C15.7317 0.996094 15.4763 1.10188 15.288 1.29019L8.99799 7.59019L2.70799 1.29019C2.51968 1.10188 2.26429 0.996094 1.99799 0.996094C1.73168 0.996094 1.47629 1.10188 1.28799 1.29019C1.09968 1.47849 0.993894 1.73388 0.993894 2.00019C0.993894 2.26649 1.09968 2.52188 1.28799 2.71019L7.58799 9.00019L1.28799 15.2902C1.19426 15.3831 1.11986 15.4937 1.06909 15.6156C1.01833 15.7375 0.992188 15.8682 0.992188 16.0002C0.992188 16.1322 1.01833 16.2629 1.06909 16.3848C1.11986 16.5066 1.19426 16.6172 1.28799 16.7102C1.38095 16.8039 1.49155 16.8783 1.61341 16.9291C1.73527 16.9798 1.86597 17.006 1.99799 17.006C2.13 17.006 2.2607 16.9798 2.38256 16.9291C2.50442 16.8783 2.61502 16.8039 2.70799 16.7102L8.99799 10.4102L15.288 16.7102C15.3809 16.8039 15.4915 16.8783 15.6134 16.9291C15.7353 16.9798 15.866 17.006 15.998 17.006C16.13 17.006 16.2607 16.9798 16.3826 16.9291C16.5044 16.8783 16.615 16.8039 16.708 16.7102C16.8017 16.6172 16.8761 16.5066 16.9269 16.3848C16.9776 16.2629 17.0038 16.1322 17.0038 16.0002C17.0038 15.8682 16.9776 15.7375 16.9269 15.6156C16.8761 15.4937 16.8017 15.3831 16.708 15.2902L10.408 9.00019Z" }, null, -1), js = [
  as
];
function Ts(M, e) {
  return c(), g("svg", os, [...js]);
}
const D1 = { render: Ts }, cs = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Ds = /* @__PURE__ */ T("path", { d: "M7.87093 15.5452L6.10093 17.2652C5.6368 17.7293 5.00731 17.9901 4.35093 17.9901C3.69455 17.9901 3.06506 17.7293 2.60093 17.2652C2.1368 16.8011 1.87606 16.1716 1.87606 15.5152C1.87606 14.8588 2.1368 14.2293 2.60093 13.7652L7.14093 9.21521C7.58654 8.76815 8.18695 8.50949 8.81794 8.49274C9.44894 8.47599 10.0622 8.70243 10.5309 9.12521L10.6509 9.22521C10.8406 9.41086 11.0962 9.51358 11.3615 9.51077C11.6269 9.50795 11.8803 9.39984 12.0659 9.21021C12.2516 9.02058 12.3543 8.76497 12.3515 8.49961C12.3487 8.23424 12.2406 7.98086 12.0509 7.79521C11.9945 7.72224 11.9344 7.65215 11.8709 7.58521C11.0173 6.84253 9.91326 6.45206 8.7825 6.49291C7.65173 6.53376 6.57876 7.00287 5.78093 7.80521L1.18093 12.3552C0.399287 13.206 -0.0234493 14.3259 0.00100474 15.481C0.0254587 16.636 0.495212 17.737 1.31216 18.554C2.12911 19.3709 3.23009 19.8407 4.38518 19.8651C5.54026 19.8896 6.66014 19.4669 7.51093 18.6852L9.24093 16.9952C9.41175 16.8089 9.50565 16.5647 9.50374 16.3119C9.50183 16.0592 9.40425 15.8165 9.23064 15.6327C9.05703 15.449 8.82027 15.3378 8.568 15.3216C8.31573 15.3053 8.06666 15.3852 7.87093 15.5452ZM18.5609 1.30521C17.7197 0.469219 16.5819 0 15.3959 0C14.21 0 13.0722 0.469219 12.2309 1.30521L10.5009 2.99521C10.3301 3.18156 10.2362 3.42569 10.2381 3.67848C10.24 3.93126 10.3376 4.17395 10.5112 4.3577C10.6848 4.54145 10.9216 4.65263 11.1739 4.66886C11.4261 4.6851 11.6752 4.60519 11.8709 4.44521L13.6009 2.72521C14.0651 2.26108 14.6946 2.00034 15.3509 2.00034C16.0073 2.00034 16.6368 2.26108 17.1009 2.72521C17.5651 3.18934 17.8258 3.81883 17.8258 4.47521C17.8258 5.13159 17.5651 5.76108 17.1009 6.22521L12.5609 10.7752C12.1153 11.2223 11.5149 11.4809 10.8839 11.4977C10.2529 11.5144 9.63964 11.288 9.17093 10.8652L9.05093 10.7652C8.8613 10.5796 8.60569 10.4768 8.34032 10.4797C8.07496 10.4825 7.82158 10.5906 7.63593 10.7802C7.45028 10.9698 7.34756 11.2255 7.35037 11.4908C7.35319 11.7562 7.4613 12.0096 7.65093 12.1952C7.72357 12.2695 7.80036 12.3396 7.88093 12.4052C8.73561 13.1457 9.83916 13.5347 10.9692 13.4938C12.0993 13.453 13.1719 12.9854 13.9709 12.1852L18.5209 7.63521C19.3623 6.79929 19.8387 5.66444 19.8462 4.47846C19.8537 3.29248 19.3916 2.1517 18.5609 1.30521Z" }, null, -1), rs = [
  Ds
];
function gs(M, e) {
  return c(), g("svg", cs, [...rs]);
}
const Ls = { render: gs }, Is = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, ds = /* @__PURE__ */ T("path", { d: "M19.32 7.55L17.43 6.92L18.32 5.14C18.4102 4.95369 18.4404 4.74397 18.4064 4.53978C18.3723 4.33558 18.2758 4.14699 18.13 4L16 1.87C15.8522 1.72209 15.6618 1.62421 15.4555 1.59013C15.2493 1.55605 15.0375 1.58748 14.85 1.68L13.07 2.57L12.44 0.680003C12.3735 0.482996 12.2472 0.311629 12.0787 0.189751C11.9102 0.0678737 11.7079 0.00154767 11.5 3.33354e-06H8.5C8.29036 -0.000537828 8.08585 0.0648223 7.91537 0.186845C7.7449 0.308868 7.61709 0.481382 7.55 0.680003L6.92 2.57L5.14 1.68C4.95369 1.58978 4.74397 1.55961 4.53978 1.59364C4.33558 1.62767 4.14699 1.72423 4 1.87L1.87 4C1.72209 4.14777 1.62421 4.33818 1.59013 4.54446C1.55605 4.75074 1.58748 4.96251 1.68 5.15L2.57 6.93L0.680003 7.56C0.482996 7.62654 0.311629 7.75283 0.189751 7.92131C0.0678737 8.08979 0.00154767 8.29207 3.33354e-06 8.5V11.5C-0.000537828 11.7096 0.0648223 11.9142 0.186845 12.0846C0.308868 12.2551 0.481382 12.3829 0.680003 12.45L2.57 13.08L1.68 14.86C1.58978 15.0463 1.55961 15.256 1.59364 15.4602C1.62767 15.6644 1.72423 15.853 1.87 16L4 18.13C4.14777 18.2779 4.33818 18.3758 4.54446 18.4099C4.75074 18.444 4.96251 18.4125 5.15 18.32L6.93 17.43L7.56 19.32C7.62709 19.5186 7.7549 19.6911 7.92537 19.8132C8.09585 19.9352 8.30036 20.0005 8.51 20H11.51C11.7196 20.0005 11.9242 19.9352 12.0946 19.8132C12.2651 19.6911 12.3929 19.5186 12.46 19.32L13.09 17.43L14.87 18.32C15.0551 18.4079 15.2628 18.4369 15.4649 18.4029C15.667 18.3689 15.8538 18.2737 16 18.13L18.13 16C18.2779 15.8522 18.3758 15.6618 18.4099 15.4555C18.444 15.2493 18.4125 15.0375 18.32 14.85L17.43 13.07L19.32 12.44C19.517 12.3735 19.6884 12.2472 19.8103 12.0787C19.9321 11.9102 19.9985 11.7079 20 11.5V8.5C20.0005 8.29036 19.9352 8.08585 19.8132 7.91537C19.6911 7.7449 19.5186 7.61709 19.32 7.55ZM18 10.78L16.8 11.18C16.5241 11.2695 16.2709 11.418 16.0581 11.6151C15.8452 11.8122 15.6778 12.0533 15.5675 12.3216C15.4571 12.5899 15.4064 12.879 15.419 13.1688C15.4315 13.4586 15.5069 13.7422 15.64 14L16.21 15.14L15.11 16.24L14 15.64C13.7436 15.5122 13.4627 15.4411 13.1763 15.4313C12.89 15.4215 12.6049 15.4734 12.3403 15.5834C12.0758 15.6934 11.8379 15.8589 11.6429 16.0688C11.4479 16.2787 11.3003 16.5281 11.21 16.8L10.81 18H9.22L8.82 16.8C8.73049 16.5241 8.58203 16.2709 8.3849 16.0581C8.18778 15.8452 7.94671 15.6778 7.67842 15.5675C7.41014 15.4571 7.12105 15.4064 6.83123 15.419C6.5414 15.4315 6.25777 15.5069 6 15.64L4.86 16.21L3.76 15.11L4.36 14C4.4931 13.7422 4.56852 13.4586 4.58105 13.1688C4.59358 12.879 4.5429 12.5899 4.43254 12.3216C4.32218 12.0533 4.15478 11.8122 3.94195 11.6151C3.72912 11.418 3.47595 11.2695 3.2 11.18L2 10.78V9.22L3.2 8.82C3.47595 8.73049 3.72912 8.58203 3.94195 8.3849C4.15478 8.18778 4.32218 7.94671 4.43254 7.67842C4.5429 7.41014 4.59358 7.12105 4.58105 6.83123C4.56852 6.5414 4.4931 6.25777 4.36 6L3.79 4.89L4.89 3.79L6 4.36C6.25777 4.4931 6.5414 4.56852 6.83123 4.58105C7.12105 4.59358 7.41014 4.5429 7.67842 4.43254C7.94671 4.32218 8.18778 4.15478 8.3849 3.94195C8.58203 3.72912 8.73049 3.47595 8.82 3.2L9.22 2H10.78L11.18 3.2C11.2695 3.47595 11.418 3.72912 11.6151 3.94195C11.8122 4.15478 12.0533 4.32218 12.3216 4.43254C12.5899 4.5429 12.879 4.59358 13.1688 4.58105C13.4586 4.56852 13.7422 4.4931 14 4.36L15.14 3.79L16.24 4.89L15.64 6C15.5122 6.25645 15.4411 6.53735 15.4313 6.82369C15.4215 7.11003 15.4734 7.39513 15.5834 7.65969C15.6934 7.92424 15.8589 8.16207 16.0688 8.35708C16.2787 8.5521 16.5281 8.69973 16.8 8.79L18 9.19V10.78ZM10 6C9.20888 6 8.43552 6.2346 7.77772 6.67413C7.11993 7.11365 6.60724 7.73836 6.30448 8.46927C6.00173 9.20017 5.92252 10.0044 6.07686 10.7804C6.2312 11.5563 6.61217 12.269 7.17158 12.8284C7.73099 13.3878 8.44372 13.7688 9.21964 13.9231C9.99557 14.0775 10.7998 13.9983 11.5307 13.6955C12.2616 13.3928 12.8864 12.8801 13.3259 12.2223C13.7654 11.5645 14 10.7911 14 10C14 8.93914 13.5786 7.92172 12.8284 7.17158C12.0783 6.42143 11.0609 6 10 6ZM10 12C9.60444 12 9.21776 11.8827 8.88886 11.6629C8.55996 11.4432 8.30362 11.1308 8.15224 10.7654C8.00087 10.3999 7.96126 9.99778 8.03843 9.60982C8.1156 9.22186 8.30608 8.86549 8.58579 8.58579C8.86549 8.30608 9.22186 8.1156 9.60982 8.03843C9.99778 7.96126 10.3999 8.00087 10.7654 8.15224C11.1308 8.30362 11.4432 8.55996 11.6629 8.88886C11.8827 9.21776 12 9.60444 12 10C12 10.5304 11.7893 11.0391 11.4142 11.4142C11.0391 11.7893 10.5304 12 10 12Z" }, null, -1), ys = [
  ds
];
function zs(M, e) {
  return c(), g("svg", Is, [...ys]);
}
const ms = { render: zs }, As = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, xs = /* @__PURE__ */ T("path", { d: "M8 11H1C0.734784 11 0.48043 11.1054 0.292893 11.2929C0.105357 11.4804 0 11.7348 0 12V19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20H8C8.26522 20 8.51957 19.8946 8.70711 19.7071C8.89464 19.5196 9 19.2652 9 19V12C9 11.7348 8.89464 11.4804 8.70711 11.2929C8.51957 11.1054 8.26522 11 8 11ZM7 18H2V13H7V18ZM19 0H12C11.7348 0 11.4804 0.105357 11.2929 0.292893C11.1054 0.48043 11 0.734784 11 1V8C11 8.26522 11.1054 8.51957 11.2929 8.70711C11.4804 8.89464 11.7348 9 12 9H19C19.2652 9 19.5196 8.89464 19.7071 8.70711C19.8946 8.51957 20 8.26522 20 8V1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0ZM18 7H13V2H18V7ZM19 11H12C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11ZM18 18H13V13H18V18ZM8 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V8C0 8.26522 0.105357 8.51957 0.292893 8.70711C0.48043 8.89464 0.734784 9 1 9H8C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8V1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0ZM7 7H2V2H7V7Z" }, null, -1), Es = [
  xs
];
function hs(M, e) {
  return c(), g("svg", As, [...Es]);
}
const Cs = { render: hs }, Os = {
  viewBox: "0 0 16 21",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, ps = /* @__PURE__ */ T("path", { d: "M15.8777 7.60009C15.7946 7.43518 15.6674 7.29649 15.5103 7.19942C15.3532 7.10234 15.1723 7.05065 14.9877 7.05009H9.98765V1.05009C9.99839 0.830775 9.93663 0.614023 9.81193 0.433292C9.68723 0.252561 9.5065 0.117899 9.29766 0.0500919C9.09688 -0.0159649 8.88034 -0.0167072 8.67912 0.0479715C8.47789 0.11265 8.30234 0.239423 8.17765 0.410092L0.177655 11.4101C0.0774202 11.555 0.0172332 11.7237 0.00318503 11.8993C-0.0108631 12.0749 0.0217264 12.2511 0.0976546 12.4101C0.167576 12.5918 0.289043 12.7492 0.447144 12.8629C0.605246 12.9766 0.793102 13.0417 0.987654 13.0501H5.98765V19.0501C5.98781 19.261 6.05462 19.4664 6.17855 19.637C6.30247 19.8076 6.47717 19.9347 6.67765 20.0001C6.77813 20.0312 6.88249 20.0481 6.98765 20.0501C7.14544 20.0505 7.30108 20.0136 7.44186 19.9423C7.58264 19.8711 7.70456 19.7675 7.79765 19.6401L15.7977 8.64009C15.9054 8.49089 15.9699 8.31485 15.984 8.13135C15.9981 7.94785 15.9613 7.76402 15.8777 7.60009ZM7.98765 15.9701V12.0501C7.98765 11.7849 7.8823 11.5305 7.69476 11.343C7.50722 11.1554 7.25287 11.0501 6.98765 11.0501H2.98765L7.98765 4.13009V8.05009C7.98765 8.31531 8.09301 8.56966 8.28055 8.7572C8.46808 8.94473 8.72244 9.05009 8.98765 9.05009H12.9877L7.98765 15.9701Z" }, null, -1), ws = [
  ps
];
function Ys(M, e) {
  return c(), g("svg", Os, [...ws]);
}
const r1 = { render: Ys }, Ss = {
  viewBox: "0 0 9 10",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Zs = /* @__PURE__ */ T("path", { d: "M5.56255 0H0.906015C0.405637 0 0 0.406586 0 0.908136V5.46271C0 5.96425 0.405637 6.37084 0.906015 6.37084H4.42586L4.42329 9.27154C4.42267 9.99474 5.36178 10.2746 5.75549 9.6686L8.85173 5.42622C9.24418 4.82212 8.81169 4.02254 8.09249 4.02254H6.46857V0.908136C6.46857 0.406586 6.06293 0 5.56255 0Z" }, null, -1), ks = [
  Zs
];
function bs(M, e) {
  return c(), g("svg", Ss, [...ks]);
}
const g1 = { render: bs }, Us = {
  viewBox: "0 0 21 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Qs = /* @__PURE__ */ T("path", { d: "M6 14C6.39782 14 6.77936 13.842 7.06066 13.5607C7.34196 13.2794 7.5 12.8978 7.5 12.5C7.50488 12.4501 7.50488 12.3999 7.5 12.35L10.29 9.56H10.52H10.75L12.36 11.17C12.36 11.17 12.36 11.22 12.36 11.25C12.36 11.6478 12.518 12.0294 12.7993 12.3107C13.0806 12.592 13.4622 12.75 13.86 12.75C14.2578 12.75 14.6394 12.592 14.9207 12.3107C15.202 12.0294 15.36 11.6478 15.36 11.25V11.17L19 7.5C19.2967 7.5 19.5867 7.41203 19.8334 7.2472C20.08 7.08238 20.2723 6.84811 20.3858 6.57403C20.4993 6.29994 20.5291 5.99834 20.4712 5.70736C20.4133 5.41639 20.2704 5.14912 20.0607 4.93934C19.8509 4.72956 19.5836 4.5867 19.2926 4.52882C19.0017 4.47094 18.7001 4.50065 18.426 4.61418C18.1519 4.72771 17.9176 4.91997 17.7528 5.16664C17.588 5.41332 17.5 5.70333 17.5 6C17.4951 6.04988 17.4951 6.10012 17.5 6.15L13.89 9.76H13.73L12 8C12 7.60218 11.842 7.22064 11.5607 6.93934C11.2794 6.65804 10.8978 6.5 10.5 6.5C10.1022 6.5 9.72064 6.65804 9.43934 6.93934C9.15804 7.22064 9 7.60218 9 8L6 11C5.60218 11 5.22064 11.158 4.93934 11.4393C4.65804 11.7206 4.5 12.1022 4.5 12.5C4.5 12.8978 4.65804 13.2794 4.93934 13.5607C5.22064 13.842 5.60218 14 6 14ZM19.5 18H2.5V1C2.5 0.734784 2.39464 0.48043 2.20711 0.292893C2.01957 0.105357 1.76522 0 1.5 0C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1V19C0.5 19.2652 0.605357 19.5196 0.792893 19.7071C0.98043 19.8946 1.23478 20 1.5 20H19.5C19.7652 20 20.0196 19.8946 20.2071 19.7071C20.3946 19.5196 20.5 19.2652 20.5 19C20.5 18.7348 20.3946 18.4804 20.2071 18.2929C20.0196 18.1054 19.7652 18 19.5 18Z" }, null, -1), Vs = [
  Qs
];
function Ws(M, e) {
  return c(), g("svg", Us, [...Vs]);
}
const fs = { render: Ws }, vs = {
  viewBox: "0 0 20 17",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Gs = /* @__PURE__ */ T("path", { d: "M13.4 8.15956L8.5 4.99956C8.34798 4.91179 8.17554 4.86559 8 4.86559C7.82446 4.86559 7.65202 4.91179 7.5 4.99956C7.35174 5.08508 7.22791 5.20723 7.14036 5.3543C7.05282 5.50138 7.00449 5.66846 7 5.83956V12.1596C7.0013 12.3378 7.05019 12.5124 7.14161 12.6653C7.23303 12.8183 7.36367 12.944 7.52 13.0296C7.66543 13.1152 7.83123 13.1601 8 13.1596C8.17714 13.1474 8.34869 13.0925 8.5 12.9996L13.4 9.83956C13.5403 9.74891 13.6557 9.62453 13.7356 9.47779C13.8155 9.33106 13.8574 9.16664 13.8574 8.99956C13.8574 8.83248 13.8155 8.66806 13.7356 8.52133C13.6557 8.37459 13.5403 8.25022 13.4 8.15956ZM9 10.3196V7.67956L11 8.99956L9 10.3196ZM17.38 1.50956L15.83 1.30956C11.991 0.839521 8.109 0.839521 4.27 1.30956L2.72 1.50956C1.97471 1.59067 1.2854 1.94343 0.783675 2.50049C0.281954 3.05755 0.0029736 3.77988 0 4.52956V13.4696C0.00635666 14.2081 0.280506 14.9193 0.771546 15.471C1.26259 16.0228 1.93715 16.3776 2.67 16.4696L4.22 16.6596C6.13776 16.8926 8.06815 17.0061 10 16.9996C11.9323 16.9995 13.8627 16.8793 15.78 16.6396L17.33 16.4496C18.0628 16.3576 18.7374 16.0028 19.2285 15.451C19.7195 14.8993 19.9936 14.1881 20 13.4496V4.52956C19.9985 3.78754 19.7265 3.07152 19.235 2.5156C18.7435 1.95969 18.0662 1.60201 17.33 1.50956H17.38ZM18.05 13.5096C18.0508 13.7615 17.9565 14.0044 17.7859 14.1898C17.6154 14.3752 17.3811 14.4894 17.13 14.5096L15.58 14.6996C11.9077 15.1596 8.19232 15.1596 4.52 14.6996L2.97 14.5096C2.71889 14.4894 2.48463 14.3752 2.31406 14.1898C2.1435 14.0044 2.04919 13.7615 2.05 13.5096V4.52956C2.06192 4.28151 2.16055 4.04552 2.32869 3.86276C2.49683 3.68 2.7238 3.56207 2.97 3.52956L4.47 3.29956C8.14273 2.84621 11.8573 2.84621 15.53 3.29956L17.08 3.48956C17.3262 3.52207 17.5532 3.64 17.7213 3.82276C17.8894 4.00552 17.9881 4.24151 18 4.48956L18.05 13.5096Z" }, null, -1), Rs = [
  Gs
];
function Fs(M, e) {
  return c(), g("svg", vs, [...Rs]);
}
const Xs = { render: Fs }, Js = {
  viewBox: "0 0 10 10",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Ks = /* @__PURE__ */ T("path", { d: "M4.44944 0.661392C4.6251 0.131319 5.3749 0.131318 5.55056 0.661391L6.40179 3.2301C6.45944 3.40407 6.59593 3.54056 6.7699 3.59821L9.33861 4.44944C9.86868 4.6251 9.86868 5.3749 9.33861 5.55056L6.7699 6.40179C6.59593 6.45944 6.45944 6.59593 6.40179 6.7699L5.55056 9.33861C5.3749 9.86868 4.6251 9.86868 4.44944 9.33861L3.59821 6.7699C3.54056 6.59593 3.40407 6.45944 3.2301 6.40179L0.661392 5.55056C0.131319 5.3749 0.131318 4.6251 0.661391 4.44944L3.2301 3.59821C3.40407 3.54056 3.54056 3.40407 3.59821 3.2301L4.44944 0.661392Z" }, null, -1), Bs = [
  Ks
];
function Hs(M, e) {
  return c(), g("svg", Js, [...Bs]);
}
const Ps = { render: Hs }, _s = {
  viewBox: "0 0 36 35",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, $s = /* @__PURE__ */ T("path", { d: "M17.5365 1.81345C17.705 1.39672 18.295 1.39672 18.4635 1.81345L22.1776 10.9973C22.5357 11.8829 23.3672 12.4869 24.32 12.5539L34.2021 13.2482C34.6506 13.2797 34.8329 13.8408 34.4886 14.1299L26.9019 20.5002C26.1704 21.1144 25.8528 22.0918 26.0836 23.0188L28.477 32.6318C28.5856 33.068 28.1083 33.4147 27.727 33.1767L19.3241 27.9298C18.5139 27.4239 17.4861 27.4239 16.6759 27.9298L8.273 33.1767C7.89172 33.4147 7.41439 33.068 7.52299 32.6318L9.91639 23.0188C10.1472 22.0918 9.82959 21.1144 9.09805 20.5002L1.51138 14.1299C1.16713 13.8409 1.34945 13.2797 1.79785 13.2482L11.68 12.5539C12.6328 12.4869 13.4643 11.8829 13.8224 10.9973L17.5365 1.81345Z" }, null, -1), qs = [
  $s
];
function Mo(M, e) {
  return c(), g("svg", _s, [...qs]);
}
const L1 = { render: Mo }, eo = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, to = /* @__PURE__ */ T("path", { d: "M10 8.96086C9.73479 8.96086 9.48043 9.06576 9.2929 9.25248C9.10536 9.4392 9 9.69245 9 9.95651V13.9391C9 14.2032 9.10536 14.4564 9.2929 14.6431C9.48043 14.8299 9.73479 14.9348 10 14.9348C10.2652 14.9348 10.5196 14.8299 10.7071 14.6431C10.8946 14.4564 11 14.2032 11 13.9391V9.95651C11 9.69245 10.8946 9.4392 10.7071 9.25248C10.5196 9.06576 10.2652 8.96086 10 8.96086ZM10.38 5.05791C10.1365 4.95832 9.86347 4.95832 9.62 5.05791C9.49725 5.1053 9.38511 5.17635 9.29 5.26699C9.20167 5.36377 9.13065 5.4749 9.08 5.59556C9.02402 5.71372 8.99662 5.8433 9 5.97391C8.99924 6.10494 9.02447 6.23484 9.07423 6.35614C9.124 6.47745 9.19732 6.58779 9.29 6.68082C9.38721 6.76877 9.49882 6.83948 9.62 6.88991C9.7715 6.95188 9.93597 6.97585 10.099 6.95971C10.2619 6.94358 10.4184 6.88784 10.5547 6.79738C10.691 6.70692 10.8029 6.58452 10.8805 6.44094C10.9582 6.29735 10.9992 6.13698 11 5.97391C10.9963 5.71029 10.8927 5.45779 10.71 5.26699C10.6149 5.17635 10.5028 5.1053 10.38 5.05791ZM10 0C8.02219 0 6.08879 0.583939 4.4443 1.67797C2.79981 2.77201 1.51809 4.327 0.761209 6.14632C0.00433284 7.96563 -0.193701 9.96756 0.192152 11.8989C0.578004 13.8303 1.53041 15.6044 2.92894 16.9968C4.32746 18.3893 6.10929 19.3375 8.0491 19.7217C9.98891 20.1059 11.9996 19.9087 13.8268 19.1551C15.6541 18.4015 17.2159 17.1254 18.3147 15.4881C19.4135 13.8507 20 11.9257 20 9.95651C20 8.649 19.7413 7.3543 19.2388 6.14632C18.7363 4.93834 17.9997 3.84074 17.0711 2.91619C16.1425 1.99165 15.0401 1.25826 13.8268 0.757894C12.6136 0.257533 11.3132 0 10 0ZM10 17.9217C8.41775 17.9217 6.87104 17.4546 5.55544 16.5793C4.23985 15.7041 3.21447 14.4601 2.60897 13.0047C2.00347 11.5492 1.84504 9.94768 2.15372 8.40258C2.4624 6.85748 3.22433 5.43821 4.34315 4.32426C5.46197 3.2103 6.88743 2.45169 8.43928 2.14435C9.99113 1.83701 11.5997 1.99475 13.0615 2.59762C14.5233 3.20049 15.7727 4.22141 16.6518 5.53128C17.5308 6.84115 18 8.38114 18 9.95651C18 12.069 17.1572 14.095 15.6569 15.5888C14.1566 17.0825 12.1217 17.9217 10 17.9217Z" }, null, -1), io = [
  to
];
function uo(M, e) {
  return c(), g("svg", eo, [...io]);
}
const Ee = { render: uo }, No = {
  viewBox: "0 0 15 15",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, lo = /* @__PURE__ */ T("rect", {
  x: "7.25",
  y: "0.25",
  width: "0.5",
  height: "14.5",
  "stroke-width": "0.5",
  "stroke-linejoin": "round"
}, null, -1), no = /* @__PURE__ */ T("rect", {
  x: "0.25",
  y: "7.75",
  width: "0.5",
  height: "14.5",
  transform: "rotate(-90 0.25 7.75)",
  "stroke-width": "0.5",
  "stroke-linejoin": "round"
}, null, -1), so = [
  lo,
  no
];
function oo(M, e) {
  return c(), g("svg", No, [...so]);
}
const ao = { render: oo }, jo = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, To = /* @__PURE__ */ T("path", { d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM14 9H11V6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5C9.73479 5 9.48043 5.10536 9.2929 5.29289C9.10536 5.48043 9 5.73478 9 6V9H6C5.73479 9 5.48043 9.10536 5.2929 9.29289C5.10536 9.48043 5 9.73478 5 10C5 10.2652 5.10536 10.5196 5.2929 10.7071C5.48043 10.8946 5.73479 11 6 11H9V14C9 14.2652 9.10536 14.5196 9.2929 14.7071C9.48043 14.8946 9.73479 15 10 15C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14V11H14C14.2652 11 14.5196 10.8946 14.7071 10.7071C14.8946 10.5196 15 10.2652 15 10C15 9.73478 14.8946 9.48043 14.7071 9.29289C14.5196 9.10536 14.2652 9 14 9Z" }, null, -1), co = [
  To
];
function Do(M, e) {
  return c(), g("svg", jo, [...co]);
}
const I1 = { render: Do }, ro = {
  viewBox: "0 0 12 13",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, go = /* @__PURE__ */ T("path", { d: "M1.00108 7.00567L8.59108 7.00567L5.29108 10.2957C5.10278 10.484 4.99699 10.7394 4.99699 11.0057C4.99699 11.272 5.10278 11.5274 5.29108 11.7157C5.47938 11.904 5.73478 12.0098 6.00108 12.0098C6.26738 12.0098 6.52278 11.904 6.71108 11.7157L11.7111 6.71567C11.8021 6.62057 11.8735 6.50843 11.9211 6.38567C12.0211 6.14221 12.0211 5.86913 11.9211 5.62567C11.8735 5.50292 11.8021 5.39078 11.7111 5.29567L6.71108 0.295675C6.61812 0.201947 6.50752 0.127551 6.38566 0.0767817C6.2638 0.0260129 6.13309 -0.00012449 6.00108 -0.000124502C5.86907 -0.000124513 5.73836 0.0260128 5.6165 0.0767817C5.49465 0.127551 5.38404 0.201947 5.29108 0.295675C5.19735 0.388638 5.12296 0.499237 5.07219 0.621097C5.02142 0.742957 4.99528 0.873662 4.99528 1.00567C4.99528 1.13769 5.02142 1.26839 5.07219 1.39025C5.12296 1.51211 5.19735 1.62271 5.29108 1.71567L8.59108 5.00567L1.00108 5.00567C0.735864 5.00567 0.48151 5.11103 0.293974 5.29857C0.106437 5.4861 0.00108106 5.74046 0.00108104 6.00567C0.00108101 6.27089 0.106437 6.52524 0.293973 6.71278C0.48151 6.90032 0.735864 7.00567 1.00108 7.00567Z" }, null, -1), Lo = [
  go
];
function Io(M, e) {
  return c(), g("svg", ro, [...Lo]);
}
const yo = { render: Io }, zo = {
  viewBox: "0 0 20 12",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, mo = /* @__PURE__ */ T("path", { d: "M1.71023 10.29C1.61513 10.199 1.50298 10.1276 1.38023 10.08C1.13677 9.97998 0.863694 9.97998 0.620232 10.08C0.497481 10.1276 0.385336 10.199 0.290233 10.29C0.199192 10.3851 0.127827 10.4972 0.0802325 10.62C0.00365307 10.8021 -0.0172696 11.0028 0.0201045 11.1968C0.0574787 11.3908 0.151475 11.5694 0.290233 11.71C0.387433 11.7983 0.499048 11.8694 0.620232 11.92C0.739933 11.9729 0.869362 12.0002 1.00023 12.0002C1.1311 12.0002 1.26053 11.9729 1.38023 11.92C1.50142 11.8694 1.61303 11.7983 1.71023 11.71C1.84899 11.5694 1.94299 11.3908 1.98036 11.1968C2.01773 11.0028 1.99681 10.8021 1.92023 10.62C1.87264 10.4972 1.80127 10.3851 1.71023 10.29ZM5.00023 2H19.0002C19.2654 2 19.5198 1.89464 19.7073 1.70711C19.8949 1.51957 20.0002 1.26522 20.0002 1C20.0002 0.734784 19.8949 0.48043 19.7073 0.292893C19.5198 0.105357 19.2654 0 19.0002 0H5.00023C4.73502 0 4.48066 0.105357 4.29313 0.292893C4.10559 0.48043 4.00023 0.734784 4.00023 1C4.00023 1.26522 4.10559 1.51957 4.29313 1.70711C4.48066 1.89464 4.73502 2 5.00023 2ZM1.71023 5.29C1.56961 5.15124 1.39104 5.05725 1.19705 5.01987C1.00306 4.9825 0.802343 5.00342 0.620232 5.08C0.499048 5.13064 0.387433 5.20167 0.290233 5.29C0.199192 5.3851 0.127827 5.49725 0.0802325 5.62C0.0273273 5.7397 0 5.86913 0 6C0 6.13087 0.0273273 6.2603 0.0802325 6.38C0.130874 6.50118 0.201902 6.6128 0.290233 6.71C0.387433 6.79833 0.499048 6.86936 0.620232 6.92C0.739933 6.97291 0.869362 7.00023 1.00023 7.00023C1.1311 7.00023 1.26053 6.97291 1.38023 6.92C1.50142 6.86936 1.61303 6.79833 1.71023 6.71C1.79856 6.6128 1.86959 6.50118 1.92023 6.38C1.97314 6.2603 2.00047 6.13087 2.00047 6C2.00047 5.86913 1.97314 5.7397 1.92023 5.62C1.87264 5.49725 1.80127 5.3851 1.71023 5.29ZM19.0002 5H5.00023C4.73502 5 4.48066 5.10536 4.29313 5.29289C4.10559 5.48043 4.00023 5.73478 4.00023 6C4.00023 6.26522 4.10559 6.51957 4.29313 6.70711C4.48066 6.89464 4.73502 7 5.00023 7H19.0002C19.2654 7 19.5198 6.89464 19.7073 6.70711C19.8949 6.51957 20.0002 6.26522 20.0002 6C20.0002 5.73478 19.8949 5.48043 19.7073 5.29289C19.5198 5.10536 19.2654 5 19.0002 5ZM1.71023 0.29C1.61513 0.198959 1.50298 0.127594 1.38023 0.0799999C1.19812 0.00342049 0.997409 -0.0175019 0.803419 0.0198722C0.609429 0.0572463 0.430856 0.151242 0.290233 0.29C0.201902 0.387201 0.130874 0.498815 0.0802325 0.62C0.0273273 0.7397 0 0.869129 0 1C0 1.13087 0.0273273 1.2603 0.0802325 1.38C0.130874 1.50119 0.201902 1.6128 0.290233 1.71C0.387433 1.79833 0.499048 1.86936 0.620232 1.92C0.802343 1.99658 1.00306 2.0175 1.19705 1.98013C1.39104 1.94275 1.56961 1.84876 1.71023 1.71C1.79856 1.6128 1.86959 1.50119 1.92023 1.38C1.97314 1.2603 2.00047 1.13087 2.00047 1C2.00047 0.869129 1.97314 0.7397 1.92023 0.62C1.86959 0.498815 1.79856 0.387201 1.71023 0.29ZM19.0002 10H5.00023C4.73502 10 4.48066 10.1054 4.29313 10.2929C4.10559 10.4804 4.00023 10.7348 4.00023 11C4.00023 11.2652 4.10559 11.5196 4.29313 11.7071C4.48066 11.8946 4.73502 12 5.00023 12H19.0002C19.2654 12 19.5198 11.8946 19.7073 11.7071C19.8949 11.5196 20.0002 11.2652 20.0002 11C20.0002 10.7348 19.8949 10.4804 19.7073 10.2929C19.5198 10.1054 19.2654 10 19.0002 10Z" }, null, -1), Ao = [
  mo
];
function xo(M, e) {
  return c(), g("svg", zo, [...Ao]);
}
const Eo = { render: xo }, ho = {
  viewBox: "0 0 18 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Co = /* @__PURE__ */ T("path", {
  d: "M9.70858 9L9.71231 8.99995L9.74421 8.99933C9.77478 8.99858 9.82356 8.99697 9.88869 8.99356C10.0191 8.98676 10.2143 8.97282 10.4596 8.94432C10.9516 8.88717 11.6368 8.7724 12.4004 8.54333C13.9371 8.08229 15.7136 7.1831 16.9275 5.43817C17.0206 5.30429 17.028 5.11587 16.9264 4.96088C15.3541 2.56143 12.7028 1 9.70926 1C4.92691 1 1 5.00142 1 10C1 14.9986 4.92691 19 9.70926 19C12.5569 19 15.0939 17.5875 16.6884 15.3846C16.9496 15.0237 16.9368 14.5548 16.6844 14.2328C15.4433 12.6494 13.7219 11.8321 12.2535 11.4137C11.5244 11.206 10.876 11.102 10.4126 11.0503C10.1816 11.0245 9.99832 11.0119 9.87626 11.0058C9.81528 11.0027 9.76974 11.0013 9.7413 11.0006L9.71176 11L9.70926 11C9.70904 11 9.70882 11 9.7086 11M9.70858 9L9.70926 10C9.70926 11 9.70892 11 9.7086 11M9.70858 9C9.70849 9 9.70841 9 9.70832 9C9.70794 9 9.70755 9 9.70716 9C9.15584 9.00113 8.70926 9.44841 8.70926 10C8.70926 10.5521 9.15662 10.9996 9.7086 11M9.70858 9L9.7086 11",
  "stroke-width": "2",
  "stroke-linejoin": "round"
}, null, -1), Oo = [
  Co
];
function po(M, e) {
  return c(), g("svg", ho, [...Oo]);
}
const d1 = { render: po }, wo = {
  viewBox: "0 0 8 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Yo = /* @__PURE__ */ T("path", { d: "M4.71019 4.2899C4.61508 4.19886 4.50294 4.12749 4.38019 4.0799C4.13672 3.97988 3.86365 3.97988 3.62018 4.0799C3.49743 4.12749 3.38529 4.19886 3.29018 4.2899L0.790185 6.7899C0.601881 6.9782 0.496094 7.23359 0.496094 7.4999C0.496094 7.7662 0.601881 8.02159 0.790185 8.2099C0.978489 8.3982 1.23388 8.50399 1.50019 8.50399C1.76649 8.50399 2.02188 8.3982 2.21019 8.2099L3.00019 7.4099V14.9999C3.00019 15.2651 3.10554 15.5195 3.29308 15.707C3.48061 15.8945 3.73497 15.9999 4.00019 15.9999C4.2654 15.9999 4.51976 15.8945 4.70729 15.707C4.89483 15.5195 5.00019 15.2651 5.00019 14.9999V7.4099L5.79018 8.2099C5.88315 8.30362 5.99375 8.37802 6.11561 8.42879C6.23747 8.47956 6.36817 8.50569 6.50019 8.50569C6.6322 8.50569 6.7629 8.47956 6.88476 8.42879C7.00662 8.37802 7.11722 8.30362 7.21019 8.2099C7.30391 8.11693 7.37831 8.00633 7.42908 7.88447C7.47984 7.76261 7.50598 7.63191 7.50598 7.4999C7.50598 7.36788 7.47984 7.23718 7.42908 7.11532C7.37831 6.99346 7.30391 6.88286 7.21019 6.7899L4.71019 4.2899Z" }, null, -1), So = /* @__PURE__ */ T("rect", {
  width: "8",
  height: "2",
  rx: "1"
}, null, -1), Zo = [
  Yo,
  So
];
function ko(M, e) {
  return c(), g("svg", wo, [...Zo]);
}
const bo = { render: ko }, Uo = {
  viewBox: "0 0 18 4",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Qo = /* @__PURE__ */ T("path", { d: "M3 1H16V3H3V1Z" }, null, -1), Vo = /* @__PURE__ */ T("path", { d: "M9 0C8.60444 0 8.21776 0.117298 7.88886 0.337061C7.55996 0.556824 7.30362 0.869181 7.15224 1.23463C7.00087 1.60009 6.96126 2.00222 7.03843 2.39018C7.1156 2.77814 7.30608 3.13451 7.58579 3.41421C7.86549 3.69392 8.22186 3.8844 8.60982 3.96157C8.99778 4.03874 9.39992 3.99913 9.76537 3.84776C10.1308 3.69638 10.4432 3.44004 10.6629 3.11114C10.8827 2.78224 11 2.39556 11 2C11 1.46957 10.7893 0.96086 10.4142 0.585787C10.0391 0.210714 9.53043 0 9 0ZM2 0C1.60444 0 1.21776 0.117298 0.88886 0.337061C0.559962 0.556824 0.303617 0.869181 0.152242 1.23463C0.000866562 1.60009 -0.0387401 2.00222 0.0384303 2.39018C0.115601 2.77814 0.306082 3.13451 0.585787 3.41421C0.865492 3.69392 1.22186 3.8844 1.60982 3.96157C1.99778 4.03874 2.39992 3.99913 2.76537 3.84776C3.13082 3.69638 3.44318 3.44004 3.66294 3.11114C3.8827 2.78224 4 2.39556 4 2C4 1.46957 3.78929 0.96086 3.41421 0.585787C3.03914 0.210714 2.53043 0 2 0ZM16 0C15.6044 0 15.2178 0.117298 14.8889 0.337061C14.56 0.556824 14.3036 0.869181 14.1522 1.23463C14.0009 1.60009 13.9613 2.00222 14.0384 2.39018C14.1156 2.77814 14.3061 3.13451 14.5858 3.41421C14.8655 3.69392 15.2219 3.8844 15.6098 3.96157C15.9978 4.03874 16.3999 3.99913 16.7654 3.84776C17.1308 3.69638 17.4432 3.44004 17.6629 3.11114C17.8827 2.78224 18 2.39556 18 2C18 1.46957 17.7893 0.96086 17.4142 0.585787C17.0391 0.210714 16.5304 0 16 0Z" }, null, -1), Wo = [
  Qo,
  Vo
];
function fo(M, e) {
  return c(), g("svg", Uo, [...Wo]);
}
const vo = { render: fo }, Go = {
  viewBox: "0 0 21 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Ro = /* @__PURE__ */ T("path", { d: "M15.0282 7H5.02819C4.76297 7 4.50862 7.10536 4.32108 7.29289C4.13354 7.48043 4.02819 7.73478 4.02819 8C4.02819 8.26522 4.13354 8.51957 4.32108 8.70711C4.50862 8.89464 4.76297 9 5.02819 9H15.0282C15.2934 9 15.5478 8.89464 15.7353 8.70711C15.9228 8.51957 16.0282 8.26522 16.0282 8C16.0282 7.73478 15.9228 7.48043 15.7353 7.29289C15.5478 7.10536 15.2934 7 15.0282 7ZM11.0282 11H5.02819C4.76297 11 4.50862 11.1054 4.32108 11.2929C4.13354 11.4804 4.02819 11.7348 4.02819 12C4.02819 12.2652 4.13354 12.5196 4.32108 12.7071C4.50862 12.8946 4.76297 13 5.02819 13H11.0282C11.2934 13 11.5478 12.8946 11.7353 12.7071C11.9228 12.5196 12.0282 12.2652 12.0282 12C12.0282 11.7348 11.9228 11.4804 11.7353 11.2929C11.5478 11.1054 11.2934 11 11.0282 11ZM10.0282 0C8.71497 0 7.41461 0.258658 6.20135 0.761205C4.9881 1.26375 3.8857 2.00035 2.95712 2.92893C1.08175 4.8043 0.0281864 7.34784 0.0281864 10C0.0194442 12.3091 0.818979 14.5485 2.28819 16.33L0.288186 18.33C0.149429 18.4706 0.0554325 18.6492 0.0180584 18.8432C-0.0193158 19.0372 0.0016069 19.2379 0.0781863 19.42C0.161244 19.5999 0.29589 19.7511 0.465033 19.8544C0.634176 19.9577 0.830187 20.0083 1.02819 20H10.0282C12.6804 20 15.2239 18.9464 17.0993 17.0711C18.9746 15.1957 20.0282 12.6522 20.0282 10C20.0282 7.34784 18.9746 4.8043 17.0993 2.92893C15.2239 1.05357 12.6804 0 10.0282 0ZM10.0282 18H3.43819L4.36819 17.07C4.55444 16.8826 4.65898 16.6292 4.65898 16.365C4.65898 16.1008 4.55444 15.8474 4.36819 15.66C3.05877 14.352 2.24336 12.6305 2.06088 10.7888C1.87839 8.94705 2.34013 7.09901 3.36741 5.55952C4.3947 4.02004 5.92398 2.88436 7.6947 2.34597C9.46543 1.80759 11.368 1.8998 13.0784 2.60691C14.7888 3.31402 16.201 4.59227 17.0746 6.22389C17.9482 7.85551 18.2291 9.73954 17.8693 11.555C17.5096 13.3705 16.5315 15.005 15.1017 16.1802C13.672 17.3554 11.8789 17.9985 10.0282 18Z" }, null, -1), Fo = [
  Ro
];
function Xo(M, e) {
  return c(), g("svg", Go, [...Fo]);
}
const Jo = { render: Xo }, Ko = {
  viewBox: "0 0 20 14",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Bo = /* @__PURE__ */ T("path", { d: "M14 1C14 0.734784 13.8946 0.48043 13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H6V13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14C7.26522 14 7.51957 13.8946 7.70711 13.7071C7.89464 13.5196 8 13.2652 8 13V2H13C13.2652 2 13.5196 1.89464 13.7071 1.70711C13.8946 1.51957 14 1.26522 14 1ZM19 6H13C12.7348 6 12.4804 6.10536 12.2929 6.29289C12.1054 6.48043 12 6.73478 12 7C12 7.26522 12.1054 7.51957 12.2929 7.70711C12.4804 7.89464 12.7348 8 13 8H15V13C15 13.2652 15.1054 13.5196 15.2929 13.7071C15.4804 13.8946 15.7348 14 16 14C16.2652 14 16.5196 13.8946 16.7071 13.7071C16.8946 13.5196 17 13.2652 17 13V8H19C19.2652 8 19.5196 7.89464 19.7071 7.70711C19.8946 7.51957 20 7.26522 20 7C20 6.73478 19.8946 6.48043 19.7071 6.29289C19.5196 6.10536 19.2652 6 19 6Z" }, null, -1), Ho = [
  Bo
];
function Po(M, e) {
  return c(), g("svg", Ko, [...Ho]);
}
const _o = { render: Po }, $o = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, qo = /* @__PURE__ */ T("path", { d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM15.62 7.13C15.0477 6.58699 14.2889 6.28428 13.5 6.28428C12.7111 6.28428 11.9523 6.58699 11.38 7.13C11.2162 7.3213 11.1306 7.56738 11.1403 7.81905C11.15 8.07073 11.2543 8.30947 11.4324 8.48756C11.6105 8.66566 11.8493 8.76999 12.101 8.77971C12.3526 8.78943 12.5987 8.70383 12.79 8.54C12.883 8.44627 12.9936 8.37188 13.1154 8.32111C13.2373 8.27034 13.368 8.2442 13.5 8.2442C13.632 8.2442 13.7627 8.27034 13.8846 8.32111C14.0064 8.37188 14.117 8.44627 14.21 8.54C14.3974 8.72625 14.6508 8.83079 14.915 8.83079C15.1792 8.83079 15.4326 8.72625 15.62 8.54C15.8063 8.35264 15.9108 8.09919 15.9108 7.835C15.9108 7.57081 15.8063 7.31736 15.62 7.13ZM7 9C7.19779 9 7.39113 8.94135 7.55557 8.83147C7.72002 8.72159 7.8482 8.56541 7.92388 8.38268C7.99957 8.19996 8.01937 7.99889 7.98079 7.80491C7.9422 7.61093 7.84696 7.43275 7.70711 7.29289C7.56726 7.15304 7.38908 7.0578 7.19509 7.01921C7.00111 6.98063 6.80005 7.00043 6.61732 7.07612C6.43459 7.15181 6.27842 7.27998 6.16853 7.44443C6.05865 7.60888 6 7.80222 6 8C6 8.26522 6.10536 8.51957 6.2929 8.70711C6.48043 8.89464 6.73479 9 7 9ZM13 11H7C6.73479 11 6.48043 11.1054 6.2929 11.2929C6.10536 11.4804 6 11.7348 6 12C6 12.2652 6.10536 12.5196 6.2929 12.7071C6.48043 12.8946 6.73479 13 7 13C7 13.7956 7.31607 14.5587 7.87868 15.1213C8.44129 15.6839 9.20436 16 10 16C10.7957 16 11.5587 15.6839 12.1213 15.1213C12.6839 14.5587 13 13.7956 13 13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12C14 11.7348 13.8946 11.4804 13.7071 11.2929C13.5196 11.1054 13.2652 11 13 11ZM10 14C9.73479 14 9.48043 13.8946 9.2929 13.7071C9.10536 13.5196 9 13.2652 9 13H11C11 13.2652 10.8946 13.5196 10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14Z" }, null, -1), Ma = [
  qo
];
function ea(M, e) {
  return c(), g("svg", $o, [...Ma]);
}
const ta = { render: ea }, ia = {
  viewBox: "0 0 18 21",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, ua = /* @__PURE__ */ T("path", { d: "M15 6.00028H14.65C14.8782 5.53305 14.9979 5.02027 15 4.50028C15.003 3.80361 14.7975 3.12197 14.4098 2.54311C14.0221 1.96425 13.4701 1.51467 12.8247 1.25222C12.1794 0.989775 11.4703 0.926484 10.7886 1.07049C10.107 1.2145 9.48405 1.55922 9 2.06028C8.51595 1.55922 7.89302 1.2145 7.21138 1.07049C6.52975 0.926484 5.82061 0.989775 5.17525 1.25222C4.5299 1.51467 3.97786 1.96425 3.59019 2.54311C3.20252 3.12197 2.99697 3.80361 3 4.50028C3.00213 5.02027 3.12178 5.53305 3.35 6.00028H3C2.20435 6.00028 1.44129 6.31635 0.87868 6.87896C0.316071 7.44157 0 8.20463 0 9.00028V11.0003C0 11.2655 0.105357 11.5199 0.292893 11.7074C0.48043 11.8949 0.734784 12.0003 1 12.0003H2V18.0003C2 18.7959 2.31607 19.559 2.87868 20.1216C3.44129 20.6842 4.20435 21.0003 5 21.0003H13C13.7956 21.0003 14.5587 20.6842 15.1213 20.1216C15.6839 19.559 16 18.7959 16 18.0003V12.0003H17C17.2652 12.0003 17.5196 11.8949 17.7071 11.7074C17.8946 11.5199 18 11.2655 18 11.0003V9.00028C18 8.20463 17.6839 7.44157 17.1213 6.87896C16.5587 6.31635 15.7956 6.00028 15 6.00028ZM8 19.0003H5C4.73478 19.0003 4.48043 18.8949 4.29289 18.7074C4.10536 18.5199 4 18.2655 4 18.0003V12.0003H8V19.0003ZM8 10.0003H2V9.00028C2 8.73506 2.10536 8.48071 2.29289 8.29318C2.48043 8.10564 2.73478 8.00028 3 8.00028H8V10.0003ZM8 6.00028H6.5C6.20333 6.00028 5.91332 5.91231 5.66665 5.74749C5.41997 5.58266 5.22771 5.3484 5.11418 5.07431C5.00065 4.80022 4.97094 4.49862 5.02882 4.20765C5.0867 3.91667 5.22956 3.6494 5.43934 3.43962C5.64912 3.22984 5.91639 3.08698 6.20736 3.0291C6.49834 2.97123 6.79994 3.00093 7.07403 3.11446C7.34811 3.22799 7.58238 3.42025 7.7472 3.66693C7.91203 3.9136 8 4.20361 8 4.50028V6.00028ZM10 4.50028C10 4.20361 10.088 3.9136 10.2528 3.66693C10.4176 3.42025 10.6519 3.22799 10.926 3.11446C11.2001 3.00093 11.5017 2.97123 11.7926 3.0291C12.0836 3.08698 12.3509 3.22984 12.5607 3.43962C12.7704 3.6494 12.9133 3.91667 12.9712 4.20765C13.0291 4.49862 12.9994 4.80022 12.8858 5.07431C12.7723 5.3484 12.58 5.58266 12.3334 5.74749C12.0867 5.91231 11.7967 6.00028 11.5 6.00028H10V4.50028ZM14 18.0003C14 18.2655 13.8946 18.5199 13.7071 18.7074C13.5196 18.8949 13.2652 19.0003 13 19.0003H10V12.0003H14V18.0003ZM16 10.0003H10V8.00028H15C15.2652 8.00028 15.5196 8.10564 15.7071 8.29318C15.8946 8.48071 16 8.73506 16 9.00028V10.0003Z" }, null, -1), Na = [
  ua
];
function la(M, e) {
  return c(), g("svg", ia, [...Na]);
}
const na = { render: la }, sa = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, oa = /* @__PURE__ */ T("path", { d: "M19 9.00146C18.7348 9.00146 18.4804 9.10682 18.2929 9.29436C18.1054 9.48189 18 9.73625 18 10.0015C18.0119 11.8745 17.3703 13.693 16.1857 15.1439C15.001 16.5948 13.3475 17.5871 11.51 17.9501C9.67239 18.313 7.76578 18.0238 6.11851 17.1322C4.47123 16.2407 3.18641 14.8026 2.48533 13.0657C1.78425 11.3288 1.71079 9.40178 2.27762 7.61654C2.84445 5.8313 4.01607 4.2996 5.5907 3.28524C7.16533 2.27089 9.0444 1.83738 10.9043 2.05938C12.7641 2.28137 14.4884 3.14498 15.78 4.50146H13.38C13.1148 4.50146 12.8604 4.60682 12.6729 4.79436C12.4854 4.98189 12.38 5.23625 12.38 5.50146C12.38 5.76668 12.4854 6.02103 12.6729 6.20857C12.8604 6.39611 13.1148 6.50146 13.38 6.50146H17.91C18.1752 6.50146 18.4296 6.39611 18.6171 6.20857C18.8046 6.02103 18.91 5.76668 18.91 5.50146V1.00146C18.91 0.736248 18.8046 0.481894 18.6171 0.294358C18.4296 0.106821 18.1752 0.00146455 17.91 0.00146455C17.6448 0.00146455 17.3904 0.106821 17.2029 0.294358C17.0154 0.481894 16.91 0.736248 16.91 1.00146V2.77146C15.2447 1.17952 13.0808 0.211417 10.784 0.0307936C8.48729 -0.14983 6.19863 0.468109 4.30492 1.78015C2.41121 3.0922 1.02861 5.01787 0.390831 7.23165C-0.246949 9.44544 -0.100787 11.8115 0.804611 13.93C1.71001 16.0484 3.31911 17.7893 5.3599 18.8583C7.40069 19.9273 9.748 20.2589 12.005 19.7969C14.2621 19.335 16.2904 18.1079 17.7471 16.3231C19.2039 14.5383 19.9997 12.3053 20 10.0015C20 9.73625 19.8946 9.48189 19.7071 9.29436C19.5196 9.10682 19.2652 9.00146 19 9.00146Z" }, null, -1), aa = [
  oa
];
function ja(M, e) {
  return c(), g("svg", sa, [...aa]);
}
const y1 = { render: ja }, Ta = {
  viewBox: "0 0 33 33",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, ca = /* @__PURE__ */ T("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M30.9692 5.03077C30.9692 3.37392 29.6261 2.03077 27.9692 2.03077H5.03077C3.37392 2.03077 2.03077 3.37391 2.03077 5.03077V27.9692C2.03077 29.6261 3.37391 30.9692 5.03077 30.9692H27.9692C29.6261 30.9692 30.9692 29.6261 30.9692 27.9692V5.03077ZM0 0V33H33V0H0Z"
}, null, -1), Da = /* @__PURE__ */ T("path", { d: "M18.4278 9.64615H11.526C10.7682 9.64615 10.1538 10.2716 10.1538 11.0431V17.8976C10.1538 18.6691 10.7682 19.2945 11.526 19.2945H16.7538L16.7499 23.7564C16.749 24.8688 18.1713 25.2994 18.7676 24.3672L23.51 17.8976C24.1044 16.9684 23.4494 15.7385 22.3602 15.7385H19.8V11.0431C19.8 10.2716 19.1856 9.64615 18.4278 9.64615Z" }, null, -1), ra = [
  ca,
  Da
];
function ga(M, e) {
  return c(), g("svg", Ta, [...ra]);
}
const z1 = { render: ga }, La = {
  viewBox: "0 0 780 780",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Ia = /* @__PURE__ */ T("path", { d: "M306 216C306 209.373 311.373 204 318 204H420C432.731 204 444.883 206.478 456 210.978C491.182 225.219 516 259.711 516 300C516 340.289 491.182 374.781 456 389.022C444.883 393.522 432.731 396 420 396H366C359.373 396 354 401.373 354 408C354 414.627 359.373 420 366 420H408C431.196 420 450 438.804 450 462C450 485.196 431.196 504 408 504H360C347.269 504 335.117 501.522 324 497.022C288.818 482.781 264 448.289 264 408C264 367.711 288.818 333.219 324 318.978C335.117 314.478 347.269 312 360 312H420C426.627 312 432 306.627 432 300C432 293.373 426.627 288 420 288H372V287.754C335.043 284.705 306 253.744 306 216Z" }, null, -1), da = /* @__PURE__ */ T("path", { d: "M354 570C354 553.431 367.431 540 384 540C400.569 540 414 553.431 414 570C414 586.569 400.569 600 384 600C367.431 600 354 586.569 354 570Z" }, null, -1), ya = /* @__PURE__ */ T("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0 780V0H780V780H0ZM732 84C732 64.1178 715.882 48 696 48H84C64.1178 48 48 64.1177 48 84V696C48 715.882 64.1177 732 84 732H696C715.882 732 732 715.882 732 696V84Z"
}, null, -1), za = [
  Ia,
  da,
  ya
];
function ma(M, e) {
  return c(), g("svg", La, [...za]);
}
const Aa = { render: ma }, xa = {
  viewBox: "0 0 780 780",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Ea = /* @__PURE__ */ Du('<path fill-rule="evenodd" clip-rule="evenodd" d="M732 48H48V732H732V48ZM0 0V780H780V0H0Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M732 84C732 64.1178 715.882 48 696 48H84C64.1178 48 48 64.1177 48 84V696C48 715.882 64.1177 732 84 732H696C715.882 732 732 715.882 732 696V84ZM0 0V780H780V0H0Z"></path><path d="M276 390C276 366.804 294.804 348 318 348H462C485.196 348 504 366.804 504 390C504 413.196 485.196 432 462 432H318C294.804 432 276 413.196 276 390Z"></path><path d="M276 498C276 474.804 294.804 456 318 456C341.196 456 360 474.804 360 498C360 521.196 341.196 540 318 540C294.804 540 276 521.196 276 498Z"></path><path d="M276 252C276 245.373 281.373 240 288 240H492C498.627 240 504 245.373 504 252C504 291.764 471.764 324 432 324H348C308.236 324 276 291.764 276 252Z"></path>', 5), ha = [
  Ea
];
function Ca(M, e) {
  return c(), g("svg", xa, [...ha]);
}
const Oa = { render: Ca }, pa = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, wa = /* @__PURE__ */ T("path", { d: "M18.3393 7.32013L4.33927 0.320128C3.78676 0.0451374 3.16289 -0.0527612 2.55271 0.03978C1.94252 0.132321 1.37573 0.410798 0.929602 0.837244C0.483474 1.26369 0.179724 1.81735 0.0597636 2.42274C-0.0601964 3.02813 0.00947219 3.65578 0.259271 4.22013L2.65927 9.59013C2.71373 9.71996 2.74177 9.85934 2.74177 10.0001C2.74177 10.1409 2.71373 10.2803 2.65927 10.4101L0.259271 15.7801C0.055971 16.2368 -0.0299735 16.7371 0.00924794 17.2355C0.0484693 17.7339 0.211613 18.2145 0.483853 18.6338C0.756092 19.0531 1.1288 19.3977 1.56809 19.6363C2.00739 19.875 2.49935 20 2.99927 20.0001C3.4675 19.9955 3.92876 19.8861 4.34927 19.6801L18.3493 12.6801C18.8459 12.4303 19.2633 12.0474 19.555 11.5742C19.8466 11.101 20.0011 10.556 20.0011 10.0001C20.0011 9.44424 19.8466 8.89928 19.555 8.42605C19.2633 7.95282 18.8459 7.56994 18.3493 7.32013H18.3393ZM17.4493 10.8901L3.44927 17.8901C3.26543 17.9784 3.059 18.0084 2.85766 17.976C2.65631 17.9436 2.46968 17.8504 2.32278 17.709C2.17589 17.5675 2.07575 17.3845 2.0358 17.1846C1.99585 16.9846 2.018 16.7772 2.09927 16.5901L4.48927 11.2201C4.52021 11.1484 4.54692 11.075 4.56927 11.0001H11.4593C11.7245 11.0001 11.9788 10.8948 12.1664 10.7072C12.3539 10.5197 12.4593 10.2653 12.4593 10.0001C12.4593 9.73491 12.3539 9.48056 12.1664 9.29302C11.9788 9.10549 11.7245 9.00013 11.4593 9.00013H4.56927C4.54692 8.9253 4.52021 8.85184 4.48927 8.78013L2.09927 3.41013C2.018 3.22309 1.99585 3.01568 2.0358 2.8157C2.07575 2.61572 2.17589 2.43273 2.32278 2.29128C2.46968 2.14982 2.65631 2.05666 2.85766 2.02428C3.059 1.9919 3.26543 2.02186 3.44927 2.11013L17.4493 9.11013C17.6131 9.19405 17.7505 9.32154 17.8465 9.47857C17.9425 9.63561 17.9933 9.81608 17.9933 10.0001C17.9933 10.1842 17.9425 10.3647 17.8465 10.5217C17.7505 10.6787 17.6131 10.8062 17.4493 10.8901Z" }, null, -1), Ya = [
  wa
];
function Sa(M, e) {
  return c(), g("svg", pa, [...Ya]);
}
const Za = { render: Sa }, ka = {
  viewBox: "0 0 19 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, ba = /* @__PURE__ */ T("path", { d: "M5 6C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8H6C6.26522 8 6.51957 7.89464 6.70711 7.70711C6.89464 7.51957 7 7.26522 7 7C7 6.73478 6.89464 6.48043 6.70711 6.29289C6.51957 6.10536 6.26522 6 6 6H5ZM10 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H14V10C14 10.2652 14.1054 10.5196 14.2929 10.7071C14.4804 10.8946 14.7348 11 15 11C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10V7C16 7 16 7 16 6.94C15.9896 6.84813 15.9695 6.75763 15.94 6.67V6.58C15.8919 6.47718 15.8278 6.38267 15.75 6.3L9.75 0.3C9.66734 0.222216 9.57282 0.158081 9.47 0.11C9.43692 0.104209 9.40308 0.104209 9.37 0.11C9.27276 0.058003 9.16826 0.020922 9.06 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H10C10.2652 20 10.5196 19.8946 10.7071 19.7071C10.8946 19.5196 11 19.2652 11 19C11 18.7348 10.8946 18.4804 10.7071 18.2929C10.5196 18.1054 10.2652 18 10 18ZM10 3.41L12.59 6H11C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41ZM11 10H5C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10ZM17.71 16.29C17.617 16.1963 17.5064 16.1219 17.3846 16.0711C17.2627 16.0203 17.132 15.9942 17 15.9942C16.868 15.9942 16.7373 16.0203 16.6154 16.0711C16.4936 16.1219 16.383 16.1963 16.29 16.29L16 16.59V14C16 13.7348 15.8946 13.4804 15.7071 13.2929C15.5196 13.1054 15.2652 13 15 13C14.7348 13 14.4804 13.1054 14.2929 13.2929C14.1054 13.4804 14 13.7348 14 14V16.59L13.71 16.29C13.5217 16.1017 13.2663 15.9959 13 15.9959C12.7337 15.9959 12.4783 16.1017 12.29 16.29C12.1017 16.4783 11.9959 16.7337 11.9959 17C11.9959 17.2663 12.1017 17.5217 12.29 17.71L14.29 19.71C14.3851 19.801 14.4972 19.8724 14.62 19.92C14.7397 19.9729 14.8691 20.0002 15 20.0002C15.1309 20.0002 15.2603 19.9729 15.38 19.92C15.5028 19.8724 15.6149 19.801 15.71 19.71L17.71 17.71C17.8037 17.617 17.8781 17.5064 17.9289 17.3846C17.9797 17.2627 18.0058 17.132 18.0058 17C18.0058 16.868 17.9797 16.7373 17.9289 16.6154C17.8781 16.4936 17.8037 16.383 17.71 16.29ZM9 16C9.26522 16 9.51957 15.8946 9.70711 15.7071C9.89464 15.5196 10 15.2652 10 15C10 14.7348 9.89464 14.4804 9.70711 14.2929C9.51957 14.1054 9.26522 14 9 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929C4.10536 14.4804 4 14.7348 4 15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H9Z" }, null, -1), Ua = [
  ba
];
function Qa(M, e) {
  return c(), g("svg", ka, [...Ua]);
}
const Va = { render: Qa }, Wa = {
  viewBox: "0 0 20 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, fa = /* @__PURE__ */ T("path", { d: "M16.4284 4.20671C15.8174 2.80272 14.7629 1.63779 13.4265 0.890438C12.0901 0.143088 10.5455 -0.145456 9.0294 0.0690207C7.51331 0.283498 6.10936 0.989165 5.03269 2.07789C3.95602 3.16661 3.26602 4.57833 3.06844 6.09671C2.11502 6.32503 1.27866 6.89555 0.718173 7.6999C0.157689 8.50426 -0.0878807 9.48644 0.0280989 10.4599C0.144078 11.4334 0.61353 12.3304 1.3473 12.9806C2.08107 13.6307 3.02806 13.9888 4.00844 13.9867H6.00844C6.27365 13.9867 6.52801 13.8814 6.71554 13.6938C6.90308 13.5063 7.00844 13.2519 7.00844 12.9867C7.00844 12.7215 6.90308 12.4671 6.71554 12.2796C6.52801 12.0921 6.27365 11.9867 6.00844 11.9867H4.00844C3.478 11.9867 2.96929 11.776 2.59422 11.4009C2.21915 11.0259 2.00844 10.5171 2.00844 9.98671C2.00844 9.45628 2.21915 8.94757 2.59422 8.5725C2.96929 8.19743 3.478 7.98671 4.00844 7.98671C4.27365 7.98671 4.52801 7.88135 4.71554 7.69382C4.90308 7.50628 5.00844 7.25193 5.00844 6.98671C5.01099 5.80399 5.43272 4.66046 6.1987 3.75929C6.96469 2.85813 8.02533 2.25766 9.19218 2.06459C10.359 1.87151 11.5566 2.09832 12.572 2.70472C13.5874 3.31112 14.355 4.25785 14.7384 5.37671C14.7956 5.54855 14.8983 5.70164 15.0357 5.81964C15.1731 5.93765 15.3399 6.01613 15.5184 6.04671C16.2126 6.16645 16.8425 6.52664 17.2978 7.06418C17.753 7.60171 18.0046 8.2823 18.0084 8.98671C18.0084 9.78236 17.6924 10.5454 17.1298 11.108C16.5671 11.6706 15.8041 11.9867 15.0084 11.9867C14.7432 11.9867 14.4889 12.0921 14.3013 12.2796C14.1138 12.4671 14.0084 12.7215 14.0084 12.9867C14.0084 13.2519 14.1138 13.5063 14.3013 13.6938C14.4889 13.8814 14.7432 13.9867 15.0084 13.9867C16.2021 13.9757 17.3523 13.538 18.2514 12.7528C19.1504 11.9676 19.7389 10.8866 19.9104 9.70536C20.0819 8.52408 19.8252 7.32041 19.1866 6.31194C18.548 5.30346 17.5696 4.55673 16.4284 4.20671ZM10.9284 14.6067C10.9085 14.5453 10.878 14.4878 10.8384 14.4367L10.7184 14.2767C10.6212 14.1884 10.5096 14.1174 10.3884 14.0667C10.2063 13.9901 10.0056 13.9692 9.81162 14.0066C9.61763 14.044 9.43906 14.138 9.29844 14.2767L9.17844 14.4367C9.13885 14.4878 9.10841 14.5453 9.08844 14.6067C9.0596 14.6634 9.03938 14.7241 9.02844 14.7867C9.02399 14.8533 9.02399 14.9201 9.02844 14.9867C9.02354 15.0499 9.02354 15.1135 9.02844 15.1767C9.03771 15.2429 9.05799 15.3072 9.08844 15.3667C9.10841 15.4281 9.13885 15.4857 9.17844 15.5367L9.29844 15.6967C9.49007 15.8794 9.74367 15.983 10.0084 15.9867C10.1391 15.9851 10.2682 15.958 10.3884 15.9067C10.5096 15.8561 10.6212 15.785 10.7184 15.6967L10.8384 15.5367C10.878 15.4857 10.9085 15.4281 10.9284 15.3667C10.9589 15.3072 10.9792 15.2429 10.9884 15.1767C11 15.114 11.0067 15.0505 11.0084 14.9867C11.0129 14.9201 11.0129 14.8533 11.0084 14.7867C10.9912 14.7229 10.9642 14.6622 10.9284 14.6067ZM10.0084 6.98671C9.4815 6.98637 8.96377 7.12483 8.50734 7.38815C8.05092 7.65148 7.6719 8.03037 7.40843 8.48671C7.34232 8.60085 7.29943 8.72693 7.28225 8.85771C7.26506 8.98849 7.27392 9.12138 7.30831 9.24872C7.3427 9.37606 7.40195 9.49533 7.48263 9.59968C7.56332 9.70403 7.66385 9.79138 7.77844 9.85671C8.00805 9.98708 8.27991 10.0213 8.5347 9.95203C8.78949 9.88272 9.00652 9.71544 9.13844 9.48671C9.22654 9.33411 9.3534 9.20749 9.50618 9.11969C9.65896 9.03189 9.83222 8.98601 10.0084 8.98671C10.2737 8.98671 10.528 9.09207 10.7155 9.2796C10.9031 9.46714 11.0084 9.72149 11.0084 9.98671C11.0084 10.2519 10.9031 10.5063 10.7155 10.6938C10.528 10.8814 10.2737 10.9867 10.0084 10.9867C9.74322 10.9867 9.48886 11.0921 9.30133 11.2796C9.11379 11.4671 9.00844 11.7215 9.00844 11.9867C9.00844 12.2519 9.11379 12.5063 9.30133 12.6938C9.48886 12.8814 9.74322 12.9867 10.0084 12.9867C10.8041 12.9867 11.5671 12.6706 12.1298 12.108C12.6924 11.5454 13.0084 10.7824 13.0084 9.98671C13.0084 9.19106 12.6924 8.428 12.1298 7.86539C11.5671 7.30278 10.8041 6.98671 10.0084 6.98671Z" }, null, -1), va = [
  fa
];
function Ga(M, e) {
  return c(), g("svg", Wa, [...va]);
}
const Ra = { render: Ga }, Fa = {
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Xa = /* @__PURE__ */ T("path", { d: "M19.2998 8.08003C19.0188 7.74268 18.6672 7.47111 18.2698 7.2845C17.8724 7.09789 17.4389 7.00078 16.9998 7.00003H12.4399L12.9999 5.57003C13.2328 4.94392 13.3104 4.27064 13.2259 3.60796C13.1415 2.94527 12.8976 2.31297 12.5151 1.76527C12.1326 1.21757 11.6229 0.770839 11.0298 0.463387C10.4367 0.155934 9.77793 -0.00305942 9.1099 4.45911e-05C8.91754 0.000445952 8.72938 0.0563197 8.56798 0.160967C8.40658 0.265614 8.27878 0.414594 8.19991 0.590043L5.34994 7.00003H2.99997C2.20433 7.00003 1.44127 7.3161 0.87867 7.87871C0.316067 8.44131 0 9.20438 0 10V17C0 17.7957 0.316067 18.5587 0.87867 19.1213C1.44127 19.6839 2.20433 20 2.99997 20H15.7298C16.4316 19.9998 17.1111 19.7535 17.6501 19.304C18.1891 18.8546 18.5535 18.2304 18.6798 17.54L19.9498 10.54C20.0283 10.1074 20.0108 9.6628 19.8985 9.2377C19.7862 8.8126 19.5818 8.41738 19.2998 8.08003ZM4.99995 18H2.99997C2.73475 18 2.4804 17.8946 2.29287 17.7071C2.10533 17.5196 1.99998 17.2652 1.99998 17V10C1.99998 9.73481 2.10533 9.48045 2.29287 9.29292C2.4804 9.10538 2.73475 9.00002 2.99997 9.00002H4.99995V18ZM17.9998 10.18L16.7298 17.18C16.6872 17.413 16.5633 17.6232 16.3802 17.7734C16.1971 17.9236 15.9666 18.0039 15.7298 18H6.99993V8.21003L9.7199 2.09004C9.99988 2.17167 10.2599 2.31045 10.4835 2.49762C10.7072 2.6848 10.8896 2.91631 11.0193 3.17753C11.149 3.43876 11.2231 3.72403 11.2369 4.01534C11.2508 4.30665 11.2041 4.59767 11.0999 4.87003L10.5699 6.30003C10.457 6.60229 10.4188 6.92738 10.4588 7.24756C10.4987 7.56774 10.6155 7.87351 10.7992 8.13877C10.9829 8.40402 11.2281 8.62089 11.5138 8.77086C11.7995 8.92084 12.1172 8.99946 12.4399 9.00002H16.9998C17.1467 8.99979 17.2919 9.03192 17.425 9.09414C17.5581 9.15636 17.6758 9.24714 17.7698 9.36002C17.8661 9.47135 17.9367 9.60257 17.9765 9.74431C18.0162 9.88606 18.0242 10.0348 17.9998 10.18Z" }, null, -1), Ja = [
  Xa
];
function Ka(M, e) {
  return c(), g("svg", Fa, [...Ja]);
}
const Ba = { render: Ka }, Ha = {
  viewBox: "0 0 23 17",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Pa = /* @__PURE__ */ T("path", { d: "M11.3001 8.72C11.8337 8.25813 12.2616 7.68688 12.555 7.04502C12.8483 6.40316 13.0001 5.70571 13.0001 5C13.0001 3.67392 12.4733 2.40215 11.5356 1.46447C10.5979 0.526784 9.32615 0 8.00005 0C6.67396 0 5.40218 0.526784 4.4645 1.46447C3.52681 2.40215 3.00002 3.67392 3.00002 5C3.00001 5.70571 3.15182 6.40316 3.44515 7.04502C3.73847 7.68688 4.16645 8.25813 4.70003 8.72C3.30016 9.35388 2.11248 10.3775 1.27899 11.6685C0.445498 12.9596 0.00147186 14.4633 0 16C0 16.2652 0.105358 16.5196 0.292895 16.7071C0.480433 16.8946 0.734788 17 1.00001 17C1.26523 17 1.51958 16.8946 1.70712 16.7071C1.89466 16.5196 2.00001 16.2652 2.00001 16C2.00001 14.4087 2.63216 12.8826 3.75739 11.7574C4.88261 10.6321 6.40874 10 8.00005 10C9.59136 10 11.1175 10.6321 12.2427 11.7574C13.3679 12.8826 14.0001 14.4087 14.0001 16C14.0001 16.2652 14.1055 16.5196 14.293 16.7071C14.4805 16.8946 14.7349 17 15.0001 17C15.2653 17 15.5197 16.8946 15.7072 16.7071C15.8948 16.5196 16.0001 16.2652 16.0001 16C15.9986 14.4633 15.5546 12.9596 14.7211 11.6685C13.8876 10.3775 12.6999 9.35388 11.3001 8.72ZM8.00005 8C7.40671 8 6.82668 7.82405 6.33333 7.49441C5.83998 7.16476 5.45546 6.69623 5.2284 6.14805C5.00133 5.59987 4.94192 4.99667 5.05768 4.41473C5.17344 3.83279 5.45916 3.29824 5.87872 2.87868C6.29828 2.45912 6.83283 2.1734 7.41478 2.05764C7.99673 1.94189 8.59993 2.0013 9.14811 2.22836C9.69629 2.45542 10.1648 2.83994 10.4945 3.33329C10.8241 3.82664 11.0001 4.40666 11.0001 5C11.0001 5.79565 10.684 6.55871 10.1214 7.12132C9.55878 7.68393 8.79571 8 8.00005 8ZM21.7101 5.63C21.6172 5.53627 21.5066 5.46188 21.3847 5.41111C21.2629 5.36034 21.1322 5.3342 21.0001 5.3342C20.8681 5.3342 20.7374 5.36034 20.6156 5.41111C20.4937 5.46188 20.3831 5.53627 20.2901 5.63L18.2901 7.63L17.6701 7C17.5772 6.90627 17.4666 6.83188 17.3447 6.78111C17.2228 6.73034 17.0921 6.7042 16.9601 6.7042C16.8281 6.7042 16.6974 6.73034 16.5755 6.78111C16.4537 6.83188 16.3431 6.90627 16.2501 7C16.0639 7.18736 15.9593 7.44081 15.9593 7.705C15.9593 7.96919 16.0639 8.22264 16.2501 8.41L17.5901 9.75C17.7775 9.93625 18.0309 10.0408 18.2951 10.0408C18.5593 10.0408 18.8128 9.93625 19.0001 9.75L21.6701 7.08C21.7711 6.98932 21.8526 6.87904 21.9095 6.75588C21.9665 6.63272 21.9978 6.49924 22.0016 6.36359C22.0053 6.22794 21.9814 6.09294 21.9313 5.96682C21.8812 5.84071 21.806 5.72611 21.7101 5.63Z" }, null, -1), _a = [
  Pa
];
function $a(M, e) {
  return c(), g("svg", Ha, [..._a]);
}
const qa = { render: $a }, Mj = {
  viewBox: "0 0 7 11",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, ej = /* @__PURE__ */ T("path", { d: "M5.95079 4.52967L1.71079 0.295399C1.61783 0.201797 1.50723 0.127503 1.38537 0.0768028C1.26351 0.0261027 1.1328 0 1.00079 0C0.868781 0 0.738075 0.0261027 0.616216 0.0768028C0.494356 0.127503 0.383755 0.201797 0.290792 0.295399C0.104542 0.482508 0 0.735617 -1.18154e-10 0.999446C-1.49344e-10 1.26327 0.104542 1.51638 0.290792 1.70349L3.83079 5.23871L0.290792 8.77393C0.104542 8.96103 -1.0893e-09 9.21415 -1.12049e-09 9.47797C-1.15167e-09 9.7418 0.104542 9.99491 0.290792 10.182C0.384233 10.2746 0.495049 10.3478 0.616886 10.3975C0.738724 10.4472 0.869186 10.4724 1.00079 10.4716C1.1324 10.4724 1.26286 10.4472 1.3847 10.3975C1.50654 10.3478 1.61735 10.2746 1.71079 10.182L5.95079 5.94775C6.04452 5.85491 6.11891 5.74446 6.16968 5.62277C6.22045 5.50107 6.24659 5.37054 6.24659 5.23871C6.24659 5.10688 6.22045 4.97635 6.16968 4.85465C6.11891 4.73296 6.04452 4.62251 5.95079 4.52967Z" }, null, -1), tj = [
  ej
];
function ij(M, e) {
  return c(), g("svg", Mj, [...tj]);
}
const hu = { render: ij }, uj = {
  viewBox: "0 0 20 21",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, Nj = /* @__PURE__ */ T("path", { d: "M7.50001 8.50397H10C10.2652 8.50397 10.5196 8.39862 10.7071 8.21108C10.8947 8.02355 11 7.76919 11 7.50397C11 7.23876 10.8947 6.9844 10.7071 6.79687C10.5196 6.60933 10.2652 6.50397 10 6.50397H9.00001V6.00397C9.00001 5.73876 8.89465 5.4844 8.70711 5.29687C8.51958 5.10933 8.26522 5.00397 8.00001 5.00397C7.73479 5.00397 7.48044 5.10933 7.2929 5.29687C7.10537 5.4844 7.00001 5.73876 7.00001 6.00397V6.55397C6.39243 6.67735 5.85237 7.02208 5.48466 7.52124C5.11696 8.0204 4.94785 8.63839 5.01015 9.25522C5.07246 9.87206 5.36174 10.4437 5.82184 10.8593C6.28194 11.2748 6.88003 11.5046 7.50001 11.504H8.50001C8.63262 11.504 8.75979 11.5567 8.85356 11.6504C8.94733 11.7442 9.00001 11.8714 9.00001 12.004C9.00001 12.1366 8.94733 12.2638 8.85356 12.3575C8.75979 12.4513 8.63262 12.504 8.50001 12.504H6.00001C5.73479 12.504 5.48044 12.6093 5.2929 12.7969C5.10537 12.9844 5.00001 13.2388 5.00001 13.504C5.00001 13.7692 5.10537 14.0235 5.2929 14.2111C5.48044 14.3986 5.73479 14.504 6.00001 14.504H7.00001V15.004C7.00001 15.2692 7.10537 15.5235 7.2929 15.7111C7.48044 15.8986 7.73479 16.004 8.00001 16.004C8.26522 16.004 8.51958 15.8986 8.70711 15.7111C8.89465 15.5235 9.00001 15.2692 9.00001 15.004V14.454C9.60758 14.3306 10.1476 13.9859 10.5154 13.4867C10.8831 12.9875 11.0522 12.3696 10.9899 11.7527C10.9276 11.1359 10.6383 10.5642 10.1782 10.1487C9.71807 9.73312 9.11998 9.50335 8.50001 9.50397H7.50001C7.3674 9.50397 7.24022 9.4513 7.14645 9.35753C7.05269 9.26376 7.00001 9.13658 7.00001 9.00397C7.00001 8.87137 7.05269 8.74419 7.14645 8.65042C7.24022 8.55665 7.3674 8.50397 7.50001 8.50397ZM19 10.004H16V1.00397C16.0007 0.827765 15.9548 0.654498 15.867 0.501721C15.7792 0.348943 15.6526 0.222079 15.5 0.133975C15.348 0.0462063 15.1755 0 15 0C14.8245 0 14.652 0.0462063 14.5 0.133975L11.5 1.85397L8.50001 0.133975C8.34799 0.0462063 8.17554 0 8.00001 0C7.82447 0 7.65203 0.0462063 7.50001 0.133975L4.50001 1.85397L1.50001 0.133975C1.34799 0.0462063 1.17554 0 1.00001 0C0.824471 0 0.652027 0.0462063 0.500008 0.133975C0.347404 0.222079 0.220789 0.348943 0.132986 0.501721C0.0451828 0.654498 -0.000691685 0.827765 7.88288e-06 1.00397V17.004C7.88288e-06 17.7996 0.316078 18.5627 0.878688 19.1253C1.4413 19.6879 2.20436 20.004 3.00001 20.004H17C17.7957 20.004 18.5587 19.6879 19.1213 19.1253C19.6839 18.5627 20 17.7996 20 17.004V11.004C20 10.7388 19.8947 10.4844 19.7071 10.2969C19.5196 10.1093 19.2652 10.004 19 10.004ZM3.00001 18.004C2.73479 18.004 2.48044 17.8986 2.2929 17.7111C2.10536 17.5235 2.00001 17.2692 2.00001 17.004V2.73397L4.00001 3.87397C4.15435 3.95459 4.32589 3.99669 4.50001 3.99669C4.67413 3.99669 4.84567 3.95459 5.00001 3.87397L8.00001 2.15397L11 3.87397C11.1543 3.95459 11.3259 3.99669 11.5 3.99669C11.6741 3.99669 11.8457 3.95459 12 3.87397L14 2.73397V17.004C14.0027 17.3451 14.0636 17.6833 14.18 18.004H3.00001ZM18 17.004C18 17.2692 17.8947 17.5235 17.7071 17.7111C17.5196 17.8986 17.2652 18.004 17 18.004C16.7348 18.004 16.4804 17.8986 16.2929 17.7111C16.1054 17.5235 16 17.2692 16 17.004V12.004H18V17.004Z" }, null, -1), lj = [
  Nj
];
function nj(M, e) {
  return c(), g("svg", uj, [...lj]);
}
const sj = { render: nj }, oj = {
  viewBox: "0 0 15 12",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, aj = /* @__PURE__ */ T("path", { d: "M2.65767 12H0.40767L4.50426 0.363636H7.10653L11.2088 12H8.95881L5.85085 2.75H5.75994L2.65767 12ZM2.73153 7.4375H8.8679V9.13068H2.73153V7.4375ZM14.8494 0.363636V12H12.7415V0.363636H14.8494Z" }, null, -1), jj = [
  aj
];
function Tj(M, e) {
  return c(), g("svg", oj, [...jj]);
}
const cj = { render: Tj }, Cu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddImageIcon: o1,
  AiIcon: cj,
  ArrowRightIcon: yo,
  ArrowTriangle: Za,
  BillIcon: sj,
  ChainIcon: Ls,
  ChartIcon: fs,
  ChatBubbleIcon: Jo,
  CheckCircleIcon: T1,
  CheckIcon: Mi,
  ChevronRightIcon: hu,
  CopyIcon: a1,
  CrossIcon: c1,
  CrossLightIcon: D1,
  DashboardIcon: Cs,
  DocumentExportIcon: Va,
  ExitIcon: vn,
  EyeIcon: Bl,
  FeedBeoLogo: Oa,
  FlashBoldIcon: g1,
  FlashIcon: r1,
  FunnyEmojiIcon: ta,
  GearIcon: ms,
  GifIcon: Ln,
  GiftIcon: na,
  InfoIcon: Ee,
  KudoLogo: z1,
  LineAndArrowIcon: bo,
  LinearScaleIcon: vo,
  MagnifierIcon: Eu,
  MultimediaIcon: xu,
  MultipleLinesIcon: Eo,
  PacmanIcon: d1,
  PencilIcon: un,
  PeopleIcon: Un,
  PersonCheckIcon: qa,
  PersonIcon: j1,
  PlusCircleIcon: I1,
  PlusIcon: ao,
  RefreshIcon: y1,
  Star2Icon: L1,
  StarIcon: Ps,
  SurveyLogo: Aa,
  TextIcon: Cn,
  ThumbUpIcon: Ba,
  TrashIcon: Au,
  TtTextIcon: _o,
  WordCloudIcon: Ra,
  XCircleIcon: ss,
  YtIcon: Xs
}, Symbol.toStringTag, { value: "Module" })), ei = U({
  props: {
    icon: {
      type: String,
      required: !0
    },
    bg: {
      type: String,
      required: !1,
      default: "bg-white"
    },
    fill: {
      type: String,
      required: !1,
      default: "fill-gray-900"
    }
  },
  setup(M) {
    return () => aM(
      "div",
      {
        class: `w-9 aspect-square ${M.bg} rounded-xl flex items-center justify-center cursor-pointer`
      },
      // @ts-ignore
      aM(Cu[M.icon], {
        class: `${M.fill} h-2.5`
      })
    );
  }
}), vA = /* @__PURE__ */ U({
  __name: "ActionIconButtonCopy",
  setup(M) {
    return (e, t) => (c(), k(ei, {
      icon: "CopyIcon",
      title: "Edit",
      bg: "bg-[#DEF4FC] text-[#12ABE3] hover:bg-[#ACE7FC] hover:text-[#12ABE3] transition-color duration-300",
      fill: "fill-current"
    }));
  }
}), Ku = /* @__PURE__ */ U({
  __name: "ActionIconButtonDelete",
  setup(M) {
    return (e, t) => (c(), k(ei, {
      icon: "TrashIcon",
      title: "delete",
      bg: "bg-[#FCDEEA] text-[#E31266] hover:bg-[#FCACCC] hover:text-[#E31266] transition-color duration-300",
      fill: "fill-current"
    }));
  }
}), GA = /* @__PURE__ */ U({
  __name: "ActionIconButtonEdit",
  setup(M) {
    return (e, t) => (c(), k(ei, {
      icon: "PencilIcon",
      title: "Edit",
      bg: "bg-[#FEEFDF] text-[#E58312] hover:bg-[#FFD9AD] hover:text-[#E58312] transition-color duration-300",
      fill: "fill-current"
    }));
  }
}), RA = /* @__PURE__ */ U({
  __name: "ActionIconButtonPreview",
  setup(M) {
    return (e, t) => (c(), k(ei, {
      icon: "EyeIcon",
      title: "Preview",
      bg: "bg-[#DBDBF9] text-[#1212E0] hover:bg-[#C3C3FA] hover:text-[#1212E0] transition-color duration-300",
      fill: "fill-current"
    }));
  }
}), Ou = (M, e) => {
  const t = M.__vccOpts || M;
  for (const [i, u] of e)
    t[i] = u;
  return t;
}, Dj = {}, rj = { class: "close-button" }, gj = /* @__PURE__ */ T("div", { class: "w-[2px] h-4 bg-[#3F4A55] absolute -rotate-45 rounded-sm" }, null, -1), Lj = /* @__PURE__ */ T("div", { class: "w-[2px] h-4 bg-[#3F4A55] absolute rotate-45 rounded-sm" }, null, -1), Ij = [
  gj,
  Lj
];
function dj(M, e) {
  return c(), g("div", rj, Ij);
}
const m1 = /* @__PURE__ */ Ou(Dj, [["render", dj]]), yj = {
  inheritAttrs: !1,
  components: { CloseButton: m1 }
}, zj = /* @__PURE__ */ U({
  ...yj,
  __name: "BackdropModal",
  props: {
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(M, { emit: e }) {
    const t = M, i = e;
    return xM(
      () => t.show,
      function(N) {
        N ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden");
      }
    ), QM(() => document.body.classList.remove("overflow-hidden")), (u, N) => (c(), k(ru, { to: "body" }, [
      z(We, { name: "fade" }, {
        default: O(() => [
          u.show ? (c(), g("div", DM({ key: 0 }, u.$attrs, { class: "backdrop-modal backdrop fixed inset-0 overflow-auto bg-[rgba(248,249,255,0.95)] z-40 overscroll-contain p-4 md:p-20" }), [
            J(u.$slots, "closeButton", {}, () => [
              z(m1, {
                class: "absolute right-4 md:right-20 z-50",
                onClick: N[0] || (N[0] = (l) => i("close"))
              })
            ]),
            J(u.$slots, "default")
          ], 16)) : A("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), mj = {}, Aj = { class: "relative" }, xj = /* @__PURE__ */ T("svg", {
  viewBox: "0 0 160 160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "[filter:drop-shadow(0_42px_25px_rgba(177,195,213,0.08))_drop-shadow(0_19px_19px_rgba(177,195,213,0.14))_drop-shadow(0_5px_10px_rgba(177,195,213,0.17))_drop-shadow(0_0_20px_rgba(177,195,213,0.17))]"
}, [
  /* @__PURE__ */ T("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 95.2005 4.23937 109.411 11.6003 121.513C12.5393 123.057 13.2363 124.74 13.5744 126.516V126.516C14.5163 131.461 14.5163 136.539 13.5744 141.484L13.4113 142.341C13.2148 143.372 14.1255 144.275 15.1554 144.069V144.069C20.3338 143.033 25.6662 143.033 30.8446 144.069V144.069C31.9613 144.292 33.0116 144.763 33.9422 145.42C46.9649 154.605 62.8524 160 80 160Z",
    fill: "white"
  })
], -1), Ej = { class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" };
function hj(M, e) {
  return c(), g("div", null, [
    T("div", Aj, [
      xj,
      T("div", Ej, [
        J(M.$slots, "default")
      ])
    ])
  ]);
}
const Cj = /* @__PURE__ */ Ou(mj, [["render", hj]]);
function Oj(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5 12.75l6 6 9-13.5"
    })
  ]);
}
function Ii(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
    })
  ]);
}
function A1(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 5.25v13.5m-7.5-13.5v13.5"
    })
  ]);
}
function x1(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
    })
  ]);
}
const pj = { class: "flex gap-2" }, wj = ["onClick"], fe = [
  "white",
  "green",
  "blue",
  "red",
  "yellow",
  "purple"
], te = /* @__PURE__ */ new Map([
  ["white", ["bg-white", "border-gray-200", "stroke-[#3F4A55]"]],
  ["green", ["bg-green-100", "border-green-200", "stroke-green-300"]],
  ["blue", ["bg-blue-100", "border-blue-200", "stroke-blue-300"]],
  ["red", ["bg-red-100", "border-red-200", "stroke-red-300"]],
  ["yellow", ["bg-yellow-100", "border-yellow-200", "stroke-yellow-300"]],
  ["purple", ["bg-purple-100", "border-purple-200", "stroke-purple-300"]]
]), FA = /* @__PURE__ */ U({
  __name: "ColorPalette",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = p(
      () => te.get(t.modelValue)[2]
    );
    return (N, l) => (c(), g("ul", pj, [
      (c(!0), g(K, null, lM(y(te).keys(), (n) => (c(), g("li", {
        key: n,
        class: V(["grow-0 shrink-0 w-16 aspect-square border-2 rounded-full flex items-center justify-center cursor-pointer", y(te).get(n)]),
        onClick: (s) => i("update:modelValue", n)
      }, [
        z(We, { name: "fade" }, {
          default: O(() => [
            CM(z(y(Oj), {
              class: V(["h-6 stroke-2", u.value])
            }, null, 8, ["class"]), [
              [WM, N.modelValue === n]
            ])
          ]),
          _: 2
        }, 1024)
      ], 10, wj))), 128))
    ]));
  }
});
function Yj(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 01.75.75v16.19l6.22-6.22a.75.75 0 111.06 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 111.06-1.06l6.22 6.22V3a.75.75 0 01.75-.75z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Sj(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06l-6.22-6.22V21a.75.75 0 01-1.5 0V4.81l-6.22 6.22a.75.75 0 11-1.06-1.06l7.5-7.5z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Zj(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "fill-rule": "evenodd",
      d: "M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
      "clip-rule": "evenodd"
    })
  ]);
}
function E1(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "fill-rule": "evenodd",
      d: "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
      "clip-rule": "evenodd"
    })
  ]);
}
function kj() {
  for (var M = 0, e, t, i = ""; M < arguments.length; )
    (e = arguments[M++]) && (t = h1(e)) && (i && (i += " "), i += t);
  return i;
}
function h1(M) {
  if (typeof M == "string")
    return M;
  for (var e, t = "", i = 0; i < M.length; i++)
    M[i] && (e = h1(M[i])) && (t && (t += " "), t += e);
  return t;
}
var pu = "-";
function bj(M) {
  var e = Qj(M), t = M.conflictingClassGroups, i = M.conflictingClassGroupModifiers, u = i === void 0 ? {} : i;
  function N(n) {
    var s = n.split(pu);
    return s[0] === "" && s.length !== 1 && s.shift(), C1(s, e) || Uj(n);
  }
  function l(n, s) {
    var a = t[n] || [];
    return s && u[n] ? [].concat(a, u[n]) : a;
  }
  return {
    getClassGroupId: N,
    getConflictingClassGroupIds: l
  };
}
function C1(M, e) {
  var l;
  if (M.length === 0)
    return e.classGroupId;
  var t = M[0], i = e.nextPart.get(t), u = i ? C1(M.slice(1), i) : void 0;
  if (u)
    return u;
  if (e.validators.length !== 0) {
    var N = M.join(pu);
    return (l = e.validators.find(function(n) {
      var s = n.validator;
      return s(N);
    })) == null ? void 0 : l.classGroupId;
  }
}
var Bu = /^\[(.+)\]$/;
function Uj(M) {
  if (Bu.test(M)) {
    var e = Bu.exec(M)[1], t = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}
function Qj(M) {
  var e = M.theme, t = M.prefix, i = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, u = Wj(Object.entries(M.classGroups), t);
  return u.forEach(function(N) {
    var l = N[0], n = N[1];
    Ki(n, i, l, e);
  }), i;
}
function Ki(M, e, t, i) {
  M.forEach(function(u) {
    if (typeof u == "string") {
      var N = u === "" ? e : Hu(e, u);
      N.classGroupId = t;
      return;
    }
    if (typeof u == "function") {
      if (Vj(u)) {
        Ki(u(i), e, t, i);
        return;
      }
      e.validators.push({
        validator: u,
        classGroupId: t
      });
      return;
    }
    Object.entries(u).forEach(function(l) {
      var n = l[0], s = l[1];
      Ki(s, Hu(e, n), t, i);
    });
  });
}
function Hu(M, e) {
  var t = M;
  return e.split(pu).forEach(function(i) {
    t.nextPart.has(i) || t.nextPart.set(i, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(i);
  }), t;
}
function Vj(M) {
  return M.isThemeGetter;
}
function Wj(M, e) {
  return e ? M.map(function(t) {
    var i = t[0], u = t[1], N = u.map(function(l) {
      return typeof l == "string" ? e + l : typeof l == "object" ? Object.fromEntries(Object.entries(l).map(function(n) {
        var s = n[0], a = n[1];
        return [e + s, a];
      })) : l;
    });
    return [i, N];
  }) : M;
}
function fj(M) {
  if (M < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  function u(N, l) {
    t.set(N, l), e++, e > M && (e = 0, i = t, t = /* @__PURE__ */ new Map());
  }
  return {
    get: function(l) {
      var n = t.get(l);
      if (n !== void 0)
        return n;
      if ((n = i.get(l)) !== void 0)
        return u(l, n), n;
    },
    set: function(l, n) {
      t.has(l) ? t.set(l, n) : u(l, n);
    }
  };
}
var O1 = "!";
function vj(M) {
  var e = M.separator || ":", t = e.length === 1, i = e[0], u = e.length;
  return function(l) {
    for (var n = [], s = 0, a = 0, o, j = 0; j < l.length; j++) {
      var D = l[j];
      if (s === 0) {
        if (D === i && (t || l.slice(j, j + u) === e)) {
          n.push(l.slice(a, j)), a = j + u;
          continue;
        }
        if (D === "/") {
          o = j;
          continue;
        }
      }
      D === "[" ? s++ : D === "]" && s--;
    }
    var r = n.length === 0 ? l : l.substring(a), I = r.startsWith(O1), L = I ? r.substring(1) : r, d = o && o > a ? o - a : void 0;
    return {
      modifiers: n,
      hasImportantModifier: I,
      baseClassName: L,
      maybePostfixModifierPosition: d
    };
  };
}
function Gj(M) {
  if (M.length <= 1)
    return M;
  var e = [], t = [];
  return M.forEach(function(i) {
    var u = i[0] === "[";
    u ? (e.push.apply(e, t.sort().concat([i])), t = []) : t.push(i);
  }), e.push.apply(e, t.sort()), e;
}
function Rj(M) {
  return {
    cache: fj(M.cacheSize),
    splitModifiers: vj(M),
    ...bj(M)
  };
}
var Fj = /\s+/;
function Xj(M, e) {
  var t = e.splitModifiers, i = e.getClassGroupId, u = e.getConflictingClassGroupIds, N = /* @__PURE__ */ new Set();
  return M.trim().split(Fj).map(function(l) {
    var n = t(l), s = n.modifiers, a = n.hasImportantModifier, o = n.baseClassName, j = n.maybePostfixModifierPosition, D = i(j ? o.substring(0, j) : o), r = !!j;
    if (!D) {
      if (!j)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      if (D = i(o), !D)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      r = !1;
    }
    var I = Gj(s).join(":"), L = a ? I + O1 : I;
    return {
      isTailwindClass: !0,
      modifierId: L,
      classGroupId: D,
      originalClassName: l,
      hasPostfixModifier: r
    };
  }).reverse().filter(function(l) {
    if (!l.isTailwindClass)
      return !0;
    var n = l.modifierId, s = l.classGroupId, a = l.hasPostfixModifier, o = n + s;
    return N.has(o) ? !1 : (N.add(o), u(s, a).forEach(function(j) {
      return N.add(n + j);
    }), !0);
  }).reverse().map(function(l) {
    return l.originalClassName;
  }).join(" ");
}
function Jj() {
  for (var M = arguments.length, e = new Array(M), t = 0; t < M; t++)
    e[t] = arguments[t];
  var i, u, N, l = n;
  function n(a) {
    var o = e[0], j = e.slice(1), D = j.reduce(function(r, I) {
      return I(r);
    }, o());
    return i = Rj(D), u = i.cache.get, N = i.cache.set, l = s, s(a);
  }
  function s(a) {
    var o = u(a);
    if (o)
      return o;
    var j = Xj(a, i);
    return N(a, j), j;
  }
  return function() {
    return l(kj.apply(null, arguments));
  };
}
function IM(M) {
  var e = function(i) {
    return i[M] || [];
  };
  return e.isThemeGetter = !0, e;
}
var p1 = /^\[(?:([a-z-]+):)?(.+)\]$/i, Kj = /^\d+\/\d+$/, Bj = /* @__PURE__ */ new Set(["px", "full", "screen"]), Hj = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Pj = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, _j = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function KM(M) {
  return Se(M) || Bj.has(M) || Kj.test(M) || Bi(M);
}
function Bi(M) {
  return ve(M, "length", iT);
}
function $j(M) {
  return ve(M, "size", w1);
}
function qj(M) {
  return ve(M, "position", w1);
}
function MT(M) {
  return ve(M, "url", uT);
}
function Yt(M) {
  return ve(M, "number", Se);
}
function Se(M) {
  return !Number.isNaN(Number(M));
}
function eT(M) {
  return M.endsWith("%") && Se(M.slice(0, -1));
}
function it(M) {
  return Pu(M) || ve(M, "number", Pu);
}
function sM(M) {
  return p1.test(M);
}
function ut() {
  return !0;
}
function De(M) {
  return Hj.test(M);
}
function tT(M) {
  return ve(M, "", NT);
}
function ve(M, e, t) {
  var i = p1.exec(M);
  return i ? i[1] ? i[1] === e : t(i[2]) : !1;
}
function iT(M) {
  return Pj.test(M);
}
function w1() {
  return !1;
}
function uT(M) {
  return M.startsWith("url(");
}
function Pu(M) {
  return Number.isInteger(Number(M));
}
function NT(M) {
  return _j.test(M);
}
function lT() {
  var M = IM("colors"), e = IM("spacing"), t = IM("blur"), i = IM("brightness"), u = IM("borderColor"), N = IM("borderRadius"), l = IM("borderSpacing"), n = IM("borderWidth"), s = IM("contrast"), a = IM("grayscale"), o = IM("hueRotate"), j = IM("invert"), D = IM("gap"), r = IM("gradientColorStops"), I = IM("gradientColorStopPositions"), L = IM("inset"), d = IM("margin"), m = IM("opacity"), x = IM("padding"), C = IM("saturate"), Q = IM("scale"), S = IM("sepia"), h = IM("skew"), W = IM("space"), eM = IM("translate"), NM = function() {
    return ["auto", "contain", "none"];
  }, v = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, H = function() {
    return ["auto", sM, e];
  }, F = function() {
    return [sM, e];
  }, $ = function() {
    return ["", KM];
  }, X = function() {
    return ["auto", Se, sM];
  }, P = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, q = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, R = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, tM = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, b = function() {
    return ["", "0", sM];
  }, Z = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, G = function() {
    return [Se, Yt];
  }, Y = function() {
    return [Se, sM];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [ut],
      spacing: [KM],
      blur: ["none", "", De, sM],
      brightness: G(),
      borderColor: [M],
      borderRadius: ["none", "", "full", De, sM],
      borderSpacing: F(),
      borderWidth: $(),
      contrast: G(),
      grayscale: b(),
      hueRotate: Y(),
      invert: b(),
      gap: F(),
      gradientColorStops: [M],
      gradientColorStopPositions: [eT, Bi],
      inset: H(),
      margin: H(),
      opacity: G(),
      padding: F(),
      saturate: G(),
      scale: G(),
      sepia: b(),
      skew: Y(),
      space: F(),
      translate: F()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", sM]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [De]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": Z()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": Z()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(P(), [sM])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: v()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": v()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": v()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: NM()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": NM()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": NM()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [L]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [L]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [L]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [L]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [L]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [L]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [L]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [L]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [L]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", it]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: H()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", sM]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: b()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: b()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", it]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [ut]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", it]
        }, sM]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": X()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": X()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [ut]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [it]
        }, sM]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": X()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": X()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", sM]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", sM]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [D]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [D]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [D]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(tM())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(tM(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(tM(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [d]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [d]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [d]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [d]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [d]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [d]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [d]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [d]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [d]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [W]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [W]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", sM, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", sM, KM]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [De]
        }, De, sM]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [sM, e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", sM, KM]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [sM, e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", De, Bi]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Yt]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ut]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", sM]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Se, Yt]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", sM, KM]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", sM]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", sM]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [M]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [m]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [M]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [m]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(q(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", KM]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", sM, KM]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [M]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: F()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", sM]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", sM]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [m]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(P(), [qj])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", $j]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, MT]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [M]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [I]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [I]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [I]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [r]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [r]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [r]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [N]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [N]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [N]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [N]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [N]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [N]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [N]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [N]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [N]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [N]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [N]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [N]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [N]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [N]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [N]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [n]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [n]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [n]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [n]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [n]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [n]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [n]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [n]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [n]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [m]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(q(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [n]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [n]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [m]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: q()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [u]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [u]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [u]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [u]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [u]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [u]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [u]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [u]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(q())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [sM, KM]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [KM]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [M]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: $()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [M]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [m]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [KM]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [M]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", De, tT]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [ut]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [m]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": R()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": R()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [i]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [s]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", De, sM]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [a]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [o]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [j]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [i]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [s]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [a]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [o]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [j]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [m]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [l]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [l]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [l]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", sM]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Y()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", sM]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Y()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", sM]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [Q]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [Q]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [Q]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [it, sM]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [eM]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [eM]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [h]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [h]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", sM]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", M]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", sM]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [M]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": F()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": F()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": F()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": F()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": F()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": F()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": F()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": F()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": F()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": F()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": F()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": F()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": F()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": F()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": F()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": F()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": F()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": F()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", sM]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [M, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [KM, Yt]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [M, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var iM = /* @__PURE__ */ Jj(lT);
const nT = { class: "w-full" }, XA = /* @__PURE__ */ U({
  __name: "DataTable",
  props: {
    value: {},
    idColumnName: {},
    headers: {},
    order: {}
  },
  emits: ["update:order"],
  setup(M, { emit: e }) {
    const t = M, i = e, { thClass: u, ...N } = yM(), l = p(
      () => t.headers ? t.headers : t.value.length ? Object.keys(t.value[0]).reduce((s, a) => (s[a] = a, s), {}) : {}
    );
    function n(s) {
      const a = t.order && t.order.by === s ? t.order.direction === "asc" ? "desc" : "asc" : "desc";
      i("update:order", { by: s, direction: a });
    }
    return (s, a) => (c(), g("div", null, [
      T("table", nT, [
        T("thead", null, [
          T("tr", null, [
            (c(!0), g(K, null, lM(Object.entries(l.value), ([o, j]) => (c(), g("th", {
              key: o,
              class: V(y(iM)("text-left pb-6 px-2 uppercase text-[#8C96A1] text-sm", y(u)))
            }, [
              typeof j == "function" ? (c(), k(cM(j), { key: 0 })) : (c(), g(K, { key: 1 }, [
                T("span", null, w(j), 1),
                z(y(E1), {
                  class: V(["h-4 inline-block ml-4 cursor-pointer transition-transform ease-in-out duration-200", {
                    "fill-[#ff2f78]": s.order && o === s.order.by,
                    "rotate-180": s.order && o === s.order.by && s.order.direction === "asc"
                  }]),
                  onClick: (D) => n(o)
                }, null, 8, ["onClick", "class"])
              ], 64))
            ], 2))), 128))
          ])
        ]),
        T("tbody", null, [
          (c(!0), g(K, null, lM(s.value, (o) => (c(), g("tr", {
            key: o[s.idColumnName]
          }, [
            (c(!0), g(K, null, lM(Object.keys(l.value), (j) => (c(), g("td", {
              key: j,
              class: "py-3 px-2 text-sm"
            }, [
              typeof o[j] == "function" || typeof o[j] == "object" ? (c(), k(cM(o[j]), se(DM({ key: 0 }, o)), null, 16)) : (c(), g(K, { key: 1 }, [
                vM(w(o[j]), 1)
              ], 64))
            ]))), 128))
          ]))), 128))
        ])
      ])
    ]));
  }
});
var _u;
const wu = typeof window < "u", sT = (M) => typeof M == "string", Hi = (M, e, t) => Math.min(t, Math.max(e, M)), gt = () => {
};
wu && ((_u = window == null ? void 0 : window.navigator) != null && _u.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function Lt(M) {
  return typeof M == "function" ? M() : y(M);
}
function oT(M, e) {
  function t(...i) {
    return new Promise((u, N) => {
      Promise.resolve(M(() => e.apply(this, i), { fn: e, thisArg: this, args: i })).then(u).catch(N);
    });
  }
  return t;
}
const aT = (M) => M();
function jT(M, e = {}) {
  let t, i, u = gt;
  const N = (n) => {
    clearTimeout(n), u(), u = gt;
  };
  return (n) => {
    const s = Lt(M), a = Lt(e.maxWait);
    return t && N(t), s <= 0 || a !== void 0 && a <= 0 ? (i && (N(i), i = null), Promise.resolve(n())) : new Promise((o, j) => {
      u = e.rejectOnCancel ? j : o, a && !i && (i = setTimeout(() => {
        t && N(t), i = null, o(n());
      }, a)), t = setTimeout(() => {
        i && N(i), i = null, o(n());
      }, s);
    });
  };
}
function TT(M, e = !0, t = !0, i = !1) {
  let u = 0, N, l = !0, n = gt, s;
  const a = () => {
    N && (clearTimeout(N), N = void 0, n(), n = gt);
  };
  return (j) => {
    const D = Lt(M), r = Date.now() - u, I = () => s = j();
    return a(), D <= 0 ? (u = Date.now(), I()) : (r > D && (t || !l) ? (u = Date.now(), I()) : e && (s = new Promise((L, d) => {
      n = i ? d : L, N = setTimeout(() => {
        u = Date.now(), l = !0, L(I()), a();
      }, Math.max(0, D - r));
    })), !t && !N && (N = setTimeout(() => l = !0, D)), l = !1, s);
  };
}
function cT(M) {
  return M;
}
function DT(M, e) {
  var t;
  if (typeof M == "number")
    return M + e;
  const i = ((t = M.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : t[0]) || "", u = M.slice(i.length), N = parseFloat(i) + e;
  return Number.isNaN(N) ? M : N + u;
}
function Yu(M) {
  return zN() ? (mN(M), !0) : !1;
}
function rT(M) {
  return typeof M == "function" ? p(M) : E(M);
}
function gT(M, e = !0) {
  AN() ? LM(M) : e ? M() : zM(M);
}
var $u = Object.getOwnPropertySymbols, LT = Object.prototype.hasOwnProperty, IT = Object.prototype.propertyIsEnumerable, dT = (M, e) => {
  var t = {};
  for (var i in M)
    LT.call(M, i) && e.indexOf(i) < 0 && (t[i] = M[i]);
  if (M != null && $u)
    for (var i of $u(M))
      e.indexOf(i) < 0 && IT.call(M, i) && (t[i] = M[i]);
  return t;
};
function yT(M, e, t = {}) {
  const i = t, {
    eventFilter: u = aT
  } = i, N = dT(i, [
    "eventFilter"
  ]);
  return xM(M, oT(u, e), N);
}
var zT = Object.defineProperty, mT = Object.defineProperties, AT = Object.getOwnPropertyDescriptors, Ft = Object.getOwnPropertySymbols, Y1 = Object.prototype.hasOwnProperty, S1 = Object.prototype.propertyIsEnumerable, qu = (M, e, t) => e in M ? zT(M, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : M[e] = t, xT = (M, e) => {
  for (var t in e || (e = {}))
    Y1.call(e, t) && qu(M, t, e[t]);
  if (Ft)
    for (var t of Ft(e))
      S1.call(e, t) && qu(M, t, e[t]);
  return M;
}, ET = (M, e) => mT(M, AT(e)), hT = (M, e) => {
  var t = {};
  for (var i in M)
    Y1.call(M, i) && e.indexOf(i) < 0 && (t[i] = M[i]);
  if (M != null && Ft)
    for (var i of Ft(M))
      e.indexOf(i) < 0 && S1.call(M, i) && (t[i] = M[i]);
  return t;
};
function CT(M, e, t = {}) {
  const i = t, {
    debounce: u = 0,
    maxWait: N = void 0
  } = i, l = hT(i, [
    "debounce",
    "maxWait"
  ]);
  return yT(M, e, ET(xT({}, l), {
    eventFilter: jT(u, { maxWait: N })
  }));
}
function Ke(M) {
  var e;
  const t = Lt(M);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
const Ge = wu ? window : void 0;
function qM(...M) {
  let e, t, i, u;
  if (sT(M[0]) || Array.isArray(M[0]) ? ([t, i, u] = M, e = Ge) : [e, t, i, u] = M, !e)
    return gt;
  Array.isArray(t) || (t = [t]), Array.isArray(i) || (i = [i]);
  const N = [], l = () => {
    N.forEach((o) => o()), N.length = 0;
  }, n = (o, j, D, r) => (o.addEventListener(j, D, r), () => o.removeEventListener(j, D, r)), s = xM(() => [Ke(e), Lt(u)], ([o, j]) => {
    l(), o && N.push(...t.flatMap((D) => i.map((r) => n(o, D, r, j))));
  }, { immediate: !0, flush: "post" }), a = () => {
    s(), l();
  };
  return Yu(a), a;
}
function Z1(M, e = !1) {
  const t = E(), i = () => t.value = !!M();
  return i(), gT(i, e), t;
}
function Je(M, e = {}) {
  const { window: t = Ge } = e, i = Z1(() => t && "matchMedia" in t && typeof t.matchMedia == "function");
  let u;
  const N = E(!1), l = () => {
    u && ("removeEventListener" in u ? u.removeEventListener("change", n) : u.removeListener(n));
  }, n = () => {
    i.value && (l(), u = t.matchMedia(rT(M).value), N.value = u.matches, "addEventListener" in u ? u.addEventListener("change", n) : u.addListener(n));
  };
  return VM(n), Yu(() => l()), N;
}
const OT = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};
var pT = Object.defineProperty, M0 = Object.getOwnPropertySymbols, wT = Object.prototype.hasOwnProperty, YT = Object.prototype.propertyIsEnumerable, e0 = (M, e, t) => e in M ? pT(M, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : M[e] = t, ST = (M, e) => {
  for (var t in e || (e = {}))
    wT.call(e, t) && e0(M, t, e[t]);
  if (M0)
    for (var t of M0(e))
      YT.call(e, t) && e0(M, t, e[t]);
  return M;
};
function ZT(M, e = {}) {
  function t(n, s) {
    let a = M[n];
    return s != null && (a = DT(a, s)), typeof a == "number" && (a = `${a}px`), a;
  }
  const { window: i = Ge } = e;
  function u(n) {
    return i ? i.matchMedia(n).matches : !1;
  }
  const N = (n) => Je(`(min-width: ${t(n)})`, e), l = Object.keys(M).reduce((n, s) => (Object.defineProperty(n, s, {
    get: () => N(s),
    enumerable: !0,
    configurable: !0
  }), n), {});
  return ST({
    greater(n) {
      return Je(`(min-width: ${t(n, 0.1)})`, e);
    },
    greaterOrEqual: N,
    smaller(n) {
      return Je(`(max-width: ${t(n, -0.1)})`, e);
    },
    smallerOrEqual(n) {
      return Je(`(max-width: ${t(n)})`, e);
    },
    between(n, s) {
      return Je(`(min-width: ${t(n)}) and (max-width: ${t(s, -0.1)})`, e);
    },
    isGreater(n) {
      return u(`(min-width: ${t(n, 0.1)})`);
    },
    isGreaterOrEqual(n) {
      return u(`(min-width: ${t(n)})`);
    },
    isSmaller(n) {
      return u(`(max-width: ${t(n, -0.1)})`);
    },
    isSmallerOrEqual(n) {
      return u(`(max-width: ${t(n)})`);
    },
    isInBetween(n, s) {
      return u(`(min-width: ${t(n)}) and (max-width: ${t(s, -0.1)})`);
    }
  }, l);
}
const t0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, i0 = "__vueuse_ssr_handlers__";
t0[i0] = t0[i0] || {};
function kT(M, e) {
  const t = E(!1);
  let i = 0;
  return wu && (qM(M, "dragenter", (u) => {
    u.preventDefault(), i += 1, t.value = !0;
  }), qM(M, "dragover", (u) => {
    u.preventDefault();
  }), qM(M, "dragleave", (u) => {
    u.preventDefault(), i -= 1, i === 0 && (t.value = !1);
  }), qM(M, "drop", (u) => {
    var N, l;
    u.preventDefault(), i = 0, t.value = !1;
    const n = Array.from((l = (N = u.dataTransfer) == null ? void 0 : N.files) != null ? l : []);
    e == null || e(n.length === 0 ? null : n);
  })), {
    isOverDropZone: t
  };
}
var u0 = Object.getOwnPropertySymbols, bT = Object.prototype.hasOwnProperty, UT = Object.prototype.propertyIsEnumerable, QT = (M, e) => {
  var t = {};
  for (var i in M)
    bT.call(M, i) && e.indexOf(i) < 0 && (t[i] = M[i]);
  if (M != null && u0)
    for (var i of u0(M))
      e.indexOf(i) < 0 && UT.call(M, i) && (t[i] = M[i]);
  return t;
};
function VT(M, e, t = {}) {
  const i = t, { window: u = Ge } = i, N = QT(i, ["window"]);
  let l;
  const n = Z1(() => u && "ResizeObserver" in u), s = () => {
    l && (l.disconnect(), l = void 0);
  }, a = xM(() => Ke(M), (j) => {
    s(), n.value && u && j && (l = new ResizeObserver(e), l.observe(j, N));
  }, { immediate: !0, flush: "post" }), o = () => {
    s(), a();
  };
  return Yu(o), {
    isSupported: n,
    stop: o
  };
}
function WT(M, e = { width: 0, height: 0 }, t = {}) {
  const { window: i = Ge, box: u = "content-box" } = t, N = p(() => {
    var s, a;
    return (a = (s = Ke(M)) == null ? void 0 : s.namespaceURI) == null ? void 0 : a.includes("svg");
  }), l = E(e.width), n = E(e.height);
  return VT(M, ([s]) => {
    const a = u === "border-box" ? s.borderBoxSize : u === "content-box" ? s.contentBoxSize : s.devicePixelContentBoxSize;
    if (i && N.value) {
      const o = Ke(M);
      if (o) {
        const j = i.getComputedStyle(o);
        l.value = parseFloat(j.width), n.value = parseFloat(j.height);
      }
    } else if (a) {
      const o = Array.isArray(a) ? a : [a];
      l.value = o.reduce((j, { inlineSize: D }) => j + D, 0), n.value = o.reduce((j, { blockSize: D }) => j + D, 0);
    } else
      l.value = s.contentRect.width, n.value = s.contentRect.height;
  }, t), xM(() => Ke(M), (s) => {
    l.value = s ? e.width : 0, n.value = s ? e.height : 0;
  }), {
    width: l,
    height: n
  };
}
function k1(M = {}) {
  const {
    type: e = "page",
    touch: t = !0,
    resetOnTouchEnds: i = !1,
    initialValue: u = { x: 0, y: 0 },
    window: N = Ge,
    eventFilter: l
  } = M, n = E(u.x), s = E(u.y), a = E(null), o = (L) => {
    e === "page" ? (n.value = L.pageX, s.value = L.pageY) : e === "client" ? (n.value = L.clientX, s.value = L.clientY) : e === "movement" && (n.value = L.movementX, s.value = L.movementY), a.value = "mouse";
  }, j = () => {
    n.value = u.x, s.value = u.y;
  }, D = (L) => {
    if (L.touches.length > 0) {
      const d = L.touches[0];
      e === "page" ? (n.value = d.pageX, s.value = d.pageY) : e === "client" && (n.value = d.clientX, s.value = d.clientY), a.value = "touch";
    }
  }, r = (L) => l === void 0 ? o(L) : l(() => o(L), {}), I = (L) => l === void 0 ? D(L) : l(() => D(L), {});
  return N && (qM(N, "mousemove", r, { passive: !0 }), qM(N, "dragover", r, { passive: !0 }), t && e !== "movement" && (qM(N, "touchstart", I, { passive: !0 }), qM(N, "touchmove", I, { passive: !0 }), i && qM(N, "touchend", j, { passive: !0 }))), {
    x: n,
    y: s,
    sourceType: a
  };
}
function b1(M, e = {}) {
  const {
    handleOutside: t = !0,
    window: i = Ge
  } = e, { x: u, y: N, sourceType: l } = k1(e), n = E(M ?? (i == null ? void 0 : i.document.body)), s = E(0), a = E(0), o = E(0), j = E(0), D = E(0), r = E(0), I = E(!0);
  let L = () => {
  };
  return i && (L = xM([n, u, N], () => {
    const d = Ke(n);
    if (!d)
      return;
    const {
      left: m,
      top: x,
      width: C,
      height: Q
    } = d.getBoundingClientRect();
    o.value = m + i.pageXOffset, j.value = x + i.pageYOffset, D.value = Q, r.value = C;
    const S = u.value - o.value, h = N.value - j.value;
    I.value = C === 0 || Q === 0 || S < 0 || h < 0 || S > C || h > Q, (t || !I.value) && (s.value = S, a.value = h);
  }, { immediate: !0 }), qM(document, "mouseleave", () => {
    I.value = !0;
  })), {
    x: u,
    y: N,
    sourceType: l,
    elementX: s,
    elementY: a,
    elementPositionX: o,
    elementPositionY: j,
    elementHeight: D,
    elementWidth: r,
    isOutside: I,
    stop: L
  };
}
var N0;
(function(M) {
  M.UP = "UP", M.RIGHT = "RIGHT", M.DOWN = "DOWN", M.LEFT = "LEFT", M.NONE = "NONE";
})(N0 || (N0 = {}));
var fT = Object.defineProperty, l0 = Object.getOwnPropertySymbols, vT = Object.prototype.hasOwnProperty, GT = Object.prototype.propertyIsEnumerable, n0 = (M, e, t) => e in M ? fT(M, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : M[e] = t, RT = (M, e) => {
  for (var t in e || (e = {}))
    vT.call(e, t) && n0(M, t, e[t]);
  if (l0)
    for (var t of l0(e))
      GT.call(e, t) && n0(M, t, e[t]);
  return M;
};
const FT = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
RT({
  linear: cT
}, FT);
const XT = {
  key: 0,
  class: "actions absolute top-5 right-5 z-10"
}, JT = {
  key: 1,
  class: "card__footer bg-inherit py-[36px] px-9 -mb-12 -mx-12"
}, UM = /* @__PURE__ */ U({
  __name: "KudoCard",
  setup(M, { expose: e }) {
    const { class: t } = yM(), i = E(null);
    return e({ $el: i }), (u, N) => (c(), g("div", {
      ref_key: "$el",
      ref: i,
      class: V(y(iM)("card relative overflow-hidden flex flex-col justify-between py-12 px-6 md:px-12 rounded-[40px] bg-white [box-shadow:0_-2px_10px_rgba(177,195,213,0.17),0_19px_19px_rgba(177,195,213,0.14),0_42px_25px_rgba(177,195,213,0.08)]", y(t)))
    }, [
      u.$slots.actions ? (c(), g("div", XT, [
        J(u.$slots, "actions")
      ])) : A("", !0),
      J(u.$slots, "default"),
      u.$slots.footer ? (c(), g("div", JT, [
        J(u.$slots, "footer")
      ])) : A("", !0)
    ], 2));
  }
}), KT = ["src"], BT = {
  key: 0,
  class: "mt-5 text-center text-lg text-[#3F4A55] font-serif overflow-y-auto"
}, HT = { class: "text-center relative text-sm text-[#8C96A1]" }, Xt = /* @__PURE__ */ U({
  __name: "ImageKudo",
  props: {
    message: {},
    imgUrl: {},
    senderName: {}
  },
  setup(M) {
    return (e, t) => (c(), k(UM, { class: "kudo-card" }, Pe({
      default: O(() => [
        T("div", {
          class: V(["-mx-12 -mt-12 rounded-[2.5rem] overflow-hidden shrink-0", { "-mb-12": !e.message && !e.senderName }])
        }, [
          T("img", {
            class: "w-full h-auto object-cover",
            src: e.imgUrl
          }, null, 8, KT)
        ], 2),
        e.message ? (c(), g("p", BT, w(e.message), 1)) : A("", !0)
      ]),
      _: 2
    }, [
      e.$slots.actions ? {
        name: "actions",
        fn: O(() => [
          J(e.$slots, "actions")
        ]),
        key: "0"
      } : void 0,
      e.senderName ? {
        name: "footer",
        fn: O(() => [
          T("div", HT, w(e.senderName), 1)
        ]),
        key: "1"
      } : void 0
    ]), 1024));
  }
}), Et = /* @__PURE__ */ U({
  __name: "CharacterCounter",
  props: {
    characterLimit: {},
    message: {}
  },
  setup(M, { expose: e }) {
    const t = M;
    e({
      shake: N
    });
    const i = E(!1), u = p(
      () => t.characterLimit - t.message.length
    );
    function N() {
      i.value = !0, setTimeout(() => i.value = !1, 1500);
    }
    return (l, n) => (c(), g("div", {
      class: V(["text-sm transition-opacity", [
        u.value <= 10 ? "opacity-100" : "opacity-0",
        u.value > 0 ? "text-[#FFCE21]" : "text-[#E31266]",
        i.value && "animate-shake"
      ]])
    }, w(u.value) + "/" + w(l.characterLimit), 3));
  }
}), PT = { class: "text-[#E31266] pt-[21px]" }, Te = /* @__PURE__ */ U({
  __name: "InputError",
  props: {
    errors: {}
  },
  setup(M) {
    return (e, t) => CM((c(), g("ul", PT, [
      (c(!0), g(K, null, lM(e.errors, (i) => (c(), g("li", {
        key: i,
        class: "flex"
      }, w(i), 1))), 128))
    ], 512)), [
      [WM, !!e.errors]
    ]);
  }
}), _T = { class: "grow block" }, $T = {
  key: 0,
  class: "input-label"
}, qT = { class: "relative" }, Mc = ["type", "value"], ec = ["src"], tc = {
  inheritAttrs: !1
}, nM = /* @__PURE__ */ U({
  ...tc,
  __name: "TextInput",
  props: {
    errors: {
      type: Array,
      required: !1
    },
    modelValue: {
      type: String,
      required: !1
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      required: !1
    }
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = e, { class: i, inputClass: u, ...N } = yM();
    return (l, n) => (c(), g("div", {
      class: V(y(i))
    }, [
      T("label", _T, [
        J(l.$slots, "label"),
        M.label && !l.$slots.label ? (c(), g("div", $T, w(M.label), 1)) : A("", !0),
        T("div", qT, [
          T("input", DM({
            type: M.type,
            value: M.modelValue
          }, N, {
            onInput: n[0] || (n[0] = (s) => t(
              "update:modelValue",
              s.target.value
            )),
            class: [M.errors ? "input--error" : null, y(iM)("input w-full", y(u))]
          }), null, 16, Mc),
          CM(T("img", {
            class: "absolute right-4 top-1/2 -translate-y-1/2 bg-white",
            src: y(mu),
            alt: "error icon"
          }, null, 8, ec), [
            [WM, !!M.errors]
          ])
        ])
      ]),
      M.errors ? (c(), k(Te, {
        key: 0,
        errors: M.errors
      }, null, 8, ["errors"])) : A("", !0)
    ], 2));
  }
}), ic = { class: "grow" }, uc = {
  key: 0,
  class: "input-label"
}, Nc = ["value"], lc = {
  inheritAttrs: !1
}, me = /* @__PURE__ */ U({
  ...lc,
  __name: "TextAreaInput",
  props: {
    errors: {},
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = e, { class: i, inputClass: u, ...N } = yM();
    return (l, n) => (c(), g("div", {
      class: V(y(i))
    }, [
      T("label", ic, [
        l.label ? (c(), g("div", uc, w(l.label), 1)) : A("", !0),
        T("textarea", DM({
          class: y(iM)("input w-full", y(u))
        }, N, {
          onInput: n[0] || (n[0] = (s) => t("update:modelValue", s.target.value)),
          value: l.modelValue
        }), `
      `, 16, Nc)
      ]),
      l.errors ? (c(), k(Te, {
        key: 0,
        errors: l.errors
      }, null, 8, ["errors"])) : A("", !0)
    ], 2));
  }
}), nc = ["top", "right", "bottom", "left"], s0 = ["start", "end"], o0 = /* @__PURE__ */ nc.reduce((M, e) => M.concat(e, e + "-" + s0[0], e + "-" + s0[1]), []), It = Math.min, we = Math.max, sc = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oc = {
  start: "end",
  end: "start"
};
function Pi(M, e, t) {
  return we(M, It(e, t));
}
function Re(M, e) {
  return typeof M == "function" ? M(e) : M;
}
function Ne(M) {
  return M.split("-")[0];
}
function PM(M) {
  return M.split("-")[1];
}
function U1(M) {
  return M === "x" ? "y" : "x";
}
function Su(M) {
  return M === "y" ? "height" : "width";
}
function ht(M) {
  return ["top", "bottom"].includes(Ne(M)) ? "y" : "x";
}
function Zu(M) {
  return U1(ht(M));
}
function Q1(M, e, t) {
  t === void 0 && (t = !1);
  const i = PM(M), u = Zu(M), N = Su(u);
  let l = u === "x" ? i === (t ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[N] > e.floating[N] && (l = Kt(l)), [l, Kt(l)];
}
function ac(M) {
  const e = Kt(M);
  return [Jt(M), e, Jt(e)];
}
function Jt(M) {
  return M.replace(/start|end/g, (e) => oc[e]);
}
function jc(M, e, t) {
  const i = ["left", "right"], u = ["right", "left"], N = ["top", "bottom"], l = ["bottom", "top"];
  switch (M) {
    case "top":
    case "bottom":
      return t ? e ? u : i : e ? i : u;
    case "left":
    case "right":
      return e ? N : l;
    default:
      return [];
  }
}
function Tc(M, e, t, i) {
  const u = PM(M);
  let N = jc(Ne(M), t === "start", i);
  return u && (N = N.map((l) => l + "-" + u), e && (N = N.concat(N.map(Jt)))), N;
}
function Kt(M) {
  return M.replace(/left|right|bottom|top/g, (e) => sc[e]);
}
function cc(M) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...M
  };
}
function V1(M) {
  return typeof M != "number" ? cc(M) : {
    top: M,
    right: M,
    bottom: M,
    left: M
  };
}
function ot(M) {
  return {
    ...M,
    top: M.y,
    left: M.x,
    right: M.x + M.width,
    bottom: M.y + M.height
  };
}
function a0(M, e, t) {
  let {
    reference: i,
    floating: u
  } = M;
  const N = ht(e), l = Zu(e), n = Su(l), s = Ne(e), a = N === "y", o = i.x + i.width / 2 - u.width / 2, j = i.y + i.height / 2 - u.height / 2, D = i[n] / 2 - u[n] / 2;
  let r;
  switch (s) {
    case "top":
      r = {
        x: o,
        y: i.y - u.height
      };
      break;
    case "bottom":
      r = {
        x: o,
        y: i.y + i.height
      };
      break;
    case "right":
      r = {
        x: i.x + i.width,
        y: j
      };
      break;
    case "left":
      r = {
        x: i.x - u.width,
        y: j
      };
      break;
    default:
      r = {
        x: i.x,
        y: i.y
      };
  }
  switch (PM(e)) {
    case "start":
      r[l] -= D * (t && a ? -1 : 1);
      break;
    case "end":
      r[l] += D * (t && a ? -1 : 1);
      break;
  }
  return r;
}
const Dc = async (M, e, t) => {
  const {
    placement: i = "bottom",
    strategy: u = "absolute",
    middleware: N = [],
    platform: l
  } = t, n = N.filter(Boolean), s = await (l.isRTL == null ? void 0 : l.isRTL(e));
  let a = await l.getElementRects({
    reference: M,
    floating: e,
    strategy: u
  }), {
    x: o,
    y: j
  } = a0(a, i, s), D = i, r = {}, I = 0;
  for (let L = 0; L < n.length; L++) {
    const {
      name: d,
      fn: m
    } = n[L], {
      x,
      y: C,
      data: Q,
      reset: S
    } = await m({
      x: o,
      y: j,
      initialPlacement: i,
      placement: D,
      strategy: u,
      middlewareData: r,
      rects: a,
      platform: l,
      elements: {
        reference: M,
        floating: e
      }
    });
    if (o = x ?? o, j = C ?? j, r = {
      ...r,
      [d]: {
        ...r[d],
        ...Q
      }
    }, S && I <= 50) {
      I++, typeof S == "object" && (S.placement && (D = S.placement), S.rects && (a = S.rects === !0 ? await l.getElementRects({
        reference: M,
        floating: e,
        strategy: u
      }) : S.rects), {
        x: o,
        y: j
      } = a0(a, D, s)), L = -1;
      continue;
    }
  }
  return {
    x: o,
    y: j,
    placement: D,
    strategy: u,
    middlewareData: r
  };
};
async function ti(M, e) {
  var t;
  e === void 0 && (e = {});
  const {
    x: i,
    y: u,
    platform: N,
    rects: l,
    elements: n,
    strategy: s
  } = M, {
    boundary: a = "clippingAncestors",
    rootBoundary: o = "viewport",
    elementContext: j = "floating",
    altBoundary: D = !1,
    padding: r = 0
  } = Re(e, M), I = V1(r), d = n[D ? j === "floating" ? "reference" : "floating" : j], m = ot(await N.getClippingRect({
    element: (t = await (N.isElement == null ? void 0 : N.isElement(d))) == null || t ? d : d.contextElement || await (N.getDocumentElement == null ? void 0 : N.getDocumentElement(n.floating)),
    boundary: a,
    rootBoundary: o,
    strategy: s
  })), x = j === "floating" ? {
    ...l.floating,
    x: i,
    y: u
  } : l.reference, C = await (N.getOffsetParent == null ? void 0 : N.getOffsetParent(n.floating)), Q = await (N.isElement == null ? void 0 : N.isElement(C)) ? await (N.getScale == null ? void 0 : N.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = ot(N.convertOffsetParentRelativeRectToViewportRelativeRect ? await N.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: x,
    offsetParent: C,
    strategy: s
  }) : x);
  return {
    top: (m.top - S.top + I.top) / Q.y,
    bottom: (S.bottom - m.bottom + I.bottom) / Q.y,
    left: (m.left - S.left + I.left) / Q.x,
    right: (S.right - m.right + I.right) / Q.x
  };
}
const rc = (M) => ({
  name: "arrow",
  options: M,
  async fn(e) {
    const {
      x: t,
      y: i,
      placement: u,
      rects: N,
      platform: l,
      elements: n,
      middlewareData: s
    } = e, {
      element: a,
      padding: o = 0
    } = Re(M, e) || {};
    if (a == null)
      return {};
    const j = V1(o), D = {
      x: t,
      y: i
    }, r = Zu(u), I = Su(r), L = await l.getDimensions(a), d = r === "y", m = d ? "top" : "left", x = d ? "bottom" : "right", C = d ? "clientHeight" : "clientWidth", Q = N.reference[I] + N.reference[r] - D[r] - N.floating[I], S = D[r] - N.reference[r], h = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(a));
    let W = h ? h[C] : 0;
    (!W || !await (l.isElement == null ? void 0 : l.isElement(h))) && (W = n.floating[C] || N.floating[I]);
    const eM = Q / 2 - S / 2, NM = W / 2 - L[I] / 2 - 1, v = It(j[m], NM), H = It(j[x], NM), F = v, $ = W - L[I] - H, X = W / 2 - L[I] / 2 + eM, P = Pi(F, X, $), q = !s.arrow && PM(u) != null && X != P && N.reference[I] / 2 - (X < F ? v : H) - L[I] / 2 < 0, R = q ? X < F ? X - F : X - $ : 0;
    return {
      [r]: D[r] + R,
      data: {
        [r]: P,
        centerOffset: X - P - R,
        ...q && {
          alignmentOffset: R
        }
      },
      reset: q
    };
  }
});
function gc(M, e, t) {
  return (M ? [...t.filter((u) => PM(u) === M), ...t.filter((u) => PM(u) !== M)] : t.filter((u) => Ne(u) === u)).filter((u) => M ? PM(u) === M || (e ? Jt(u) !== u : !1) : !0);
}
const Lc = function(M) {
  return M === void 0 && (M = {}), {
    name: "autoPlacement",
    options: M,
    async fn(e) {
      var t, i, u;
      const {
        rects: N,
        middlewareData: l,
        placement: n,
        platform: s,
        elements: a
      } = e, {
        crossAxis: o = !1,
        alignment: j,
        allowedPlacements: D = o0,
        autoAlignment: r = !0,
        ...I
      } = Re(M, e), L = j !== void 0 || D === o0 ? gc(j || null, r, D) : D, d = await ti(e, I), m = ((t = l.autoPlacement) == null ? void 0 : t.index) || 0, x = L[m];
      if (x == null)
        return {};
      const C = Q1(x, N, await (s.isRTL == null ? void 0 : s.isRTL(a.floating)));
      if (n !== x)
        return {
          reset: {
            placement: L[0]
          }
        };
      const Q = [d[Ne(x)], d[C[0]], d[C[1]]], S = [...((i = l.autoPlacement) == null ? void 0 : i.overflows) || [], {
        placement: x,
        overflows: Q
      }], h = L[m + 1];
      if (h)
        return {
          data: {
            index: m + 1,
            overflows: S
          },
          reset: {
            placement: h
          }
        };
      const W = S.map((v) => {
        const H = PM(v.placement);
        return [v.placement, H && o ? (
          // Check along the mainAxis and main crossAxis side.
          v.overflows.slice(0, 2).reduce((F, $) => F + $, 0)
        ) : (
          // Check only the mainAxis.
          v.overflows[0]
        ), v.overflows];
      }).sort((v, H) => v[1] - H[1]), NM = ((u = W.filter((v) => v[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        PM(v[0]) ? 2 : 3
      ).every((H) => H <= 0))[0]) == null ? void 0 : u[0]) || W[0][0];
      return NM !== n ? {
        data: {
          index: m + 1,
          overflows: S
        },
        reset: {
          placement: NM
        }
      } : {};
    }
  };
}, Ic = function(M) {
  return M === void 0 && (M = {}), {
    name: "flip",
    options: M,
    async fn(e) {
      var t, i;
      const {
        placement: u,
        middlewareData: N,
        rects: l,
        initialPlacement: n,
        platform: s,
        elements: a
      } = e, {
        mainAxis: o = !0,
        crossAxis: j = !0,
        fallbackPlacements: D,
        fallbackStrategy: r = "bestFit",
        fallbackAxisSideDirection: I = "none",
        flipAlignment: L = !0,
        ...d
      } = Re(M, e);
      if ((t = N.arrow) != null && t.alignmentOffset)
        return {};
      const m = Ne(u), x = Ne(n) === n, C = await (s.isRTL == null ? void 0 : s.isRTL(a.floating)), Q = D || (x || !L ? [Kt(n)] : ac(n));
      !D && I !== "none" && Q.push(...Tc(n, L, I, C));
      const S = [n, ...Q], h = await ti(e, d), W = [];
      let eM = ((i = N.flip) == null ? void 0 : i.overflows) || [];
      if (o && W.push(h[m]), j) {
        const F = Q1(u, l, C);
        W.push(h[F[0]], h[F[1]]);
      }
      if (eM = [...eM, {
        placement: u,
        overflows: W
      }], !W.every((F) => F <= 0)) {
        var NM, v;
        const F = (((NM = N.flip) == null ? void 0 : NM.index) || 0) + 1, $ = S[F];
        if ($)
          return {
            data: {
              index: F,
              overflows: eM
            },
            reset: {
              placement: $
            }
          };
        let X = (v = eM.filter((P) => P.overflows[0] <= 0).sort((P, q) => P.overflows[1] - q.overflows[1])[0]) == null ? void 0 : v.placement;
        if (!X)
          switch (r) {
            case "bestFit": {
              var H;
              const P = (H = eM.map((q) => [q.placement, q.overflows.filter((R) => R > 0).reduce((R, tM) => R + tM, 0)]).sort((q, R) => q[1] - R[1])[0]) == null ? void 0 : H[0];
              P && (X = P);
              break;
            }
            case "initialPlacement":
              X = n;
              break;
          }
        if (u !== X)
          return {
            reset: {
              placement: X
            }
          };
      }
      return {};
    }
  };
};
async function dc(M, e) {
  const {
    placement: t,
    platform: i,
    elements: u
  } = M, N = await (i.isRTL == null ? void 0 : i.isRTL(u.floating)), l = Ne(t), n = PM(t), s = ht(t) === "y", a = ["left", "top"].includes(l) ? -1 : 1, o = N && s ? -1 : 1, j = Re(e, M);
  let {
    mainAxis: D,
    crossAxis: r,
    alignmentAxis: I
  } = typeof j == "number" ? {
    mainAxis: j,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...j
  };
  return n && typeof I == "number" && (r = n === "end" ? I * -1 : I), s ? {
    x: r * o,
    y: D * a
  } : {
    x: D * a,
    y: r * o
  };
}
const yc = function(M) {
  return M === void 0 && (M = 0), {
    name: "offset",
    options: M,
    async fn(e) {
      const {
        x: t,
        y: i
      } = e, u = await dc(e, M);
      return {
        x: t + u.x,
        y: i + u.y,
        data: u
      };
    }
  };
}, zc = function(M) {
  return M === void 0 && (M = {}), {
    name: "shift",
    options: M,
    async fn(e) {
      const {
        x: t,
        y: i,
        placement: u
      } = e, {
        mainAxis: N = !0,
        crossAxis: l = !1,
        limiter: n = {
          fn: (d) => {
            let {
              x: m,
              y: x
            } = d;
            return {
              x: m,
              y: x
            };
          }
        },
        ...s
      } = Re(M, e), a = {
        x: t,
        y: i
      }, o = await ti(e, s), j = ht(Ne(u)), D = U1(j);
      let r = a[D], I = a[j];
      if (N) {
        const d = D === "y" ? "top" : "left", m = D === "y" ? "bottom" : "right", x = r + o[d], C = r - o[m];
        r = Pi(x, r, C);
      }
      if (l) {
        const d = j === "y" ? "top" : "left", m = j === "y" ? "bottom" : "right", x = I + o[d], C = I - o[m];
        I = Pi(x, I, C);
      }
      const L = n.fn({
        ...e,
        [D]: r,
        [j]: I
      });
      return {
        ...L,
        data: {
          x: L.x - t,
          y: L.y - i
        }
      };
    }
  };
}, mc = function(M) {
  return M === void 0 && (M = {}), {
    name: "size",
    options: M,
    async fn(e) {
      const {
        placement: t,
        rects: i,
        platform: u,
        elements: N
      } = e, {
        apply: l = () => {
        },
        ...n
      } = Re(M, e), s = await ti(e, n), a = Ne(t), o = PM(t), j = ht(t) === "y", {
        width: D,
        height: r
      } = i.floating;
      let I, L;
      a === "top" || a === "bottom" ? (I = a, L = o === (await (u.isRTL == null ? void 0 : u.isRTL(N.floating)) ? "start" : "end") ? "left" : "right") : (L = a, I = o === "end" ? "top" : "bottom");
      const d = r - s[I], m = D - s[L], x = !e.middlewareData.shift;
      let C = d, Q = m;
      if (j) {
        const h = D - s.left - s.right;
        Q = o || x ? It(m, h) : h;
      } else {
        const h = r - s.top - s.bottom;
        C = o || x ? It(d, h) : h;
      }
      if (x && !o) {
        const h = we(s.left, 0), W = we(s.right, 0), eM = we(s.top, 0), NM = we(s.bottom, 0);
        j ? Q = D - 2 * (h !== 0 || W !== 0 ? h + W : we(s.left, s.right)) : C = r - 2 * (eM !== 0 || NM !== 0 ? eM + NM : we(s.top, s.bottom));
      }
      await l({
        ...e,
        availableWidth: Q,
        availableHeight: C
      });
      const S = await u.getDimensions(N.floating);
      return D !== S.width || r !== S.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function FM(M) {
  var e;
  return ((e = M.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ie(M) {
  return FM(M).getComputedStyle(M);
}
const j0 = Math.min, at = Math.max, Bt = Math.round;
function W1(M) {
  const e = ie(M);
  let t = parseFloat(e.width), i = parseFloat(e.height);
  const u = M.offsetWidth, N = M.offsetHeight, l = Bt(t) !== u || Bt(i) !== N;
  return l && (t = u, i = N), { width: t, height: i, fallback: l };
}
function Ae(M) {
  return v1(M) ? (M.nodeName || "").toLowerCase() : "";
}
let St;
function f1() {
  if (St)
    return St;
  const M = navigator.userAgentData;
  return M && Array.isArray(M.brands) ? (St = M.brands.map((e) => e.brand + "/" + e.version).join(" "), St) : navigator.userAgent;
}
function ue(M) {
  return M instanceof FM(M).HTMLElement;
}
function de(M) {
  return M instanceof FM(M).Element;
}
function v1(M) {
  return M instanceof FM(M).Node;
}
function T0(M) {
  return typeof ShadowRoot > "u" ? !1 : M instanceof FM(M).ShadowRoot || M instanceof ShadowRoot;
}
function ii(M) {
  const { overflow: e, overflowX: t, overflowY: i, display: u } = ie(M);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + t) && !["inline", "contents"].includes(u);
}
function Ac(M) {
  return ["table", "td", "th"].includes(Ae(M));
}
function _i(M) {
  const e = /firefox/i.test(f1()), t = ie(M), i = t.backdropFilter || t.WebkitBackdropFilter;
  return t.transform !== "none" || t.perspective !== "none" || !!i && i !== "none" || e && t.willChange === "filter" || e && !!t.filter && t.filter !== "none" || ["transform", "perspective"].some((u) => t.willChange.includes(u)) || ["paint", "layout", "strict", "content"].some((u) => {
    const N = t.contain;
    return N != null && N.includes(u);
  });
}
function G1() {
  return !/^((?!chrome|android).)*safari/i.test(f1());
}
function ku(M) {
  return ["html", "body", "#document"].includes(Ae(M));
}
function R1(M) {
  return de(M) ? M : M.contextElement;
}
const F1 = { x: 1, y: 1 };
function Be(M) {
  const e = R1(M);
  if (!ue(e))
    return F1;
  const t = e.getBoundingClientRect(), { width: i, height: u, fallback: N } = W1(e);
  let l = (N ? Bt(t.width) : t.width) / i, n = (N ? Bt(t.height) : t.height) / u;
  return l && Number.isFinite(l) || (l = 1), n && Number.isFinite(n) || (n = 1), { x: l, y: n };
}
function dt(M, e, t, i) {
  var u, N;
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  const l = M.getBoundingClientRect(), n = R1(M);
  let s = F1;
  e && (i ? de(i) && (s = Be(i)) : s = Be(M));
  const a = n ? FM(n) : window, o = !G1() && t;
  let j = (l.left + (o && ((u = a.visualViewport) == null ? void 0 : u.offsetLeft) || 0)) / s.x, D = (l.top + (o && ((N = a.visualViewport) == null ? void 0 : N.offsetTop) || 0)) / s.y, r = l.width / s.x, I = l.height / s.y;
  if (n) {
    const L = FM(n), d = i && de(i) ? FM(i) : i;
    let m = L.frameElement;
    for (; m && i && d !== L; ) {
      const x = Be(m), C = m.getBoundingClientRect(), Q = getComputedStyle(m);
      C.x += (m.clientLeft + parseFloat(Q.paddingLeft)) * x.x, C.y += (m.clientTop + parseFloat(Q.paddingTop)) * x.y, j *= x.x, D *= x.y, r *= x.x, I *= x.y, j += C.x, D += C.y, m = FM(m).frameElement;
    }
  }
  return { width: r, height: I, top: D, right: j + r, bottom: D + I, left: j, x: j, y: D };
}
function ye(M) {
  return ((v1(M) ? M.ownerDocument : M.document) || window.document).documentElement;
}
function ui(M) {
  return de(M) ? { scrollLeft: M.scrollLeft, scrollTop: M.scrollTop } : { scrollLeft: M.pageXOffset, scrollTop: M.pageYOffset };
}
function X1(M) {
  return dt(ye(M)).left + ui(M).scrollLeft;
}
function yt(M) {
  if (Ae(M) === "html")
    return M;
  const e = M.assignedSlot || M.parentNode || T0(M) && M.host || ye(M);
  return T0(e) ? e.host : e;
}
function J1(M) {
  const e = yt(M);
  return ku(e) ? e.ownerDocument.body : ue(e) && ii(e) ? e : J1(e);
}
function Ht(M, e) {
  var t;
  e === void 0 && (e = []);
  const i = J1(M), u = i === ((t = M.ownerDocument) == null ? void 0 : t.body), N = FM(i);
  return u ? e.concat(N, N.visualViewport || [], ii(i) ? i : []) : e.concat(i, Ht(i));
}
function c0(M, e, t) {
  return e === "viewport" ? ot(function(i, u) {
    const N = FM(i), l = ye(i), n = N.visualViewport;
    let s = l.clientWidth, a = l.clientHeight, o = 0, j = 0;
    if (n) {
      s = n.width, a = n.height;
      const D = G1();
      (D || !D && u === "fixed") && (o = n.offsetLeft, j = n.offsetTop);
    }
    return { width: s, height: a, x: o, y: j };
  }(M, t)) : de(e) ? ot(function(i, u) {
    const N = dt(i, !0, u === "fixed"), l = N.top + i.clientTop, n = N.left + i.clientLeft, s = ue(i) ? Be(i) : { x: 1, y: 1 };
    return { width: i.clientWidth * s.x, height: i.clientHeight * s.y, x: n * s.x, y: l * s.y };
  }(e, t)) : ot(function(i) {
    const u = ye(i), N = ui(i), l = i.ownerDocument.body, n = at(u.scrollWidth, u.clientWidth, l.scrollWidth, l.clientWidth), s = at(u.scrollHeight, u.clientHeight, l.scrollHeight, l.clientHeight);
    let a = -N.scrollLeft + X1(i);
    const o = -N.scrollTop;
    return ie(l).direction === "rtl" && (a += at(u.clientWidth, l.clientWidth) - n), { width: n, height: s, x: a, y: o };
  }(ye(M)));
}
function D0(M) {
  return ue(M) && ie(M).position !== "fixed" ? M.offsetParent : null;
}
function r0(M) {
  const e = FM(M);
  let t = D0(M);
  for (; t && Ac(t) && ie(t).position === "static"; )
    t = D0(t);
  return t && (Ae(t) === "html" || Ae(t) === "body" && ie(t).position === "static" && !_i(t)) ? e : t || function(i) {
    let u = yt(i);
    for (; ue(u) && !ku(u); ) {
      if (_i(u))
        return u;
      u = yt(u);
    }
    return null;
  }(M) || e;
}
function xc(M, e, t) {
  const i = ue(e), u = ye(e), N = dt(M, !0, t === "fixed", e);
  let l = { scrollLeft: 0, scrollTop: 0 };
  const n = { x: 0, y: 0 };
  if (i || !i && t !== "fixed")
    if ((Ae(e) !== "body" || ii(u)) && (l = ui(e)), ue(e)) {
      const s = dt(e, !0);
      n.x = s.x + e.clientLeft, n.y = s.y + e.clientTop;
    } else
      u && (n.x = X1(u));
  return { x: N.left + l.scrollLeft - n.x, y: N.top + l.scrollTop - n.y, width: N.width, height: N.height };
}
const Ec = { getClippingRect: function(M) {
  let { element: e, boundary: t, rootBoundary: i, strategy: u } = M;
  const N = t === "clippingAncestors" ? function(a, o) {
    const j = o.get(a);
    if (j)
      return j;
    let D = Ht(a).filter((d) => de(d) && Ae(d) !== "body"), r = null;
    const I = ie(a).position === "fixed";
    let L = I ? yt(a) : a;
    for (; de(L) && !ku(L); ) {
      const d = ie(L), m = _i(L);
      (I ? m || r : m || d.position !== "static" || !r || !["absolute", "fixed"].includes(r.position)) ? r = d : D = D.filter((x) => x !== L), L = yt(L);
    }
    return o.set(a, D), D;
  }(e, this._c) : [].concat(t), l = [...N, i], n = l[0], s = l.reduce((a, o) => {
    const j = c0(e, o, u);
    return a.top = at(j.top, a.top), a.right = j0(j.right, a.right), a.bottom = j0(j.bottom, a.bottom), a.left = at(j.left, a.left), a;
  }, c0(e, n, u));
  return { width: s.right - s.left, height: s.bottom - s.top, x: s.left, y: s.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(M) {
  let { rect: e, offsetParent: t, strategy: i } = M;
  const u = ue(t), N = ye(t);
  if (t === N)
    return e;
  let l = { scrollLeft: 0, scrollTop: 0 }, n = { x: 1, y: 1 };
  const s = { x: 0, y: 0 };
  if ((u || !u && i !== "fixed") && ((Ae(t) !== "body" || ii(N)) && (l = ui(t)), ue(t))) {
    const a = dt(t);
    n = Be(t), s.x = a.x + t.clientLeft, s.y = a.y + t.clientTop;
  }
  return { width: e.width * n.x, height: e.height * n.y, x: e.x * n.x - l.scrollLeft * n.x + s.x, y: e.y * n.y - l.scrollTop * n.y + s.y };
}, isElement: de, getDimensions: function(M) {
  return ue(M) ? W1(M) : M.getBoundingClientRect();
}, getOffsetParent: r0, getDocumentElement: ye, getScale: Be, async getElementRects(M) {
  let { reference: e, floating: t, strategy: i } = M;
  const u = this.getOffsetParent || r0, N = this.getDimensions;
  return { reference: xc(e, await u(t), i), floating: { x: 0, y: 0, ...await N(t) } };
}, getClientRects: (M) => Array.from(M.getClientRects()), isRTL: (M) => ie(M).direction === "rtl" }, hc = (M, e, t) => {
  const i = /* @__PURE__ */ new Map(), u = { platform: Ec, ...t }, N = { ...u.platform, _c: i };
  return Dc(M, e, { ...u, platform: N });
};
function K1(M, e) {
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (typeof e[t] == "object" && M[t] ? K1(M[t], e[t]) : M[t] = e[t]);
}
const ce = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 5e3,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (M) => [...M, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function zt(M, e) {
  let t = ce.themes[M] || {}, i;
  do
    i = t[e], typeof i > "u" ? t.$extend ? t = ce.themes[t.$extend] || {} : (t = null, i = ce[e]) : t = null;
  while (t);
  return i;
}
function Cc(M) {
  const e = [M];
  let t = ce.themes[M] || {};
  do
    t.$extend && !t.$resetCss ? (e.push(t.$extend), t = ce.themes[t.$extend] || {}) : t = null;
  while (t);
  return e.map((i) => `v-popper--theme-${i}`);
}
function g0(M) {
  const e = [M];
  let t = ce.themes[M] || {};
  do
    t.$extend ? (e.push(t.$extend), t = ce.themes[t.$extend] || {}) : t = null;
  while (t);
  return e;
}
let Ue = !1;
if (typeof window < "u") {
  Ue = !1;
  try {
    const M = Object.defineProperty({}, "passive", {
      get() {
        Ue = !0;
      }
    });
    window.addEventListener("test", null, M);
  } catch {
  }
}
let B1 = !1;
typeof window < "u" && typeof navigator < "u" && (B1 = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const H1 = ["auto", "top", "bottom", "left", "right"].reduce((M, e) => M.concat([
  e,
  `${e}-start`,
  `${e}-end`
]), []), L0 = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, I0 = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function d0(M, e) {
  const t = M.indexOf(e);
  t !== -1 && M.splice(t, 1);
}
function di() {
  return new Promise((M) => requestAnimationFrame(() => {
    requestAnimationFrame(M);
  }));
}
const HM = [];
let Oe = null;
const y0 = {};
function z0(M) {
  let e = y0[M];
  return e || (e = y0[M] = []), e;
}
let $i = function() {
};
typeof window < "u" && ($i = window.Element);
function oM(M) {
  return function(e) {
    return zt(e.theme, M);
  };
}
const yi = "__floating-vue__popper", P1 = () => U({
  name: "VPopper",
  provide() {
    return {
      [yi]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [yi]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: oM("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: oM("positioningDisabled")
    },
    placement: {
      type: String,
      default: oM("placement"),
      validator: (M) => H1.includes(M)
    },
    delay: {
      type: [String, Number, Object],
      default: oM("delay")
    },
    distance: {
      type: [Number, String],
      default: oM("distance")
    },
    skidding: {
      type: [Number, String],
      default: oM("skidding")
    },
    triggers: {
      type: Array,
      default: oM("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: oM("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: oM("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: oM("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: oM("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: oM("popperHideTriggers")
    },
    container: {
      type: [String, Object, $i, Boolean],
      default: oM("container")
    },
    boundary: {
      type: [String, $i],
      default: oM("boundary")
    },
    strategy: {
      type: String,
      validator: (M) => ["absolute", "fixed"].includes(M),
      default: oM("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: oM("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: oM("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: oM("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: oM("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: oM("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: oM("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: oM("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: oM("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: oM("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: oM("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: oM("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: oM("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: oM("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: oM("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: oM("flip")
    },
    shift: {
      type: Boolean,
      default: oM("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: oM("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: oM("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: oM("disposeTimeout")
    }
  },
  emits: [
    "show",
    "hide",
    "update:shown",
    "apply-show",
    "apply-hide",
    "close-group",
    "close-directive",
    "auto-hide",
    "resize",
    "dispose"
  ],
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var M;
      return (M = this[yi]) == null ? void 0 : M.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var M, e;
      return ((M = this.popperTriggers) == null ? void 0 : M.includes("hover")) || ((e = this.popperShowTriggers) == null ? void 0 : e.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(M) {
      M ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    ...[
      "triggers",
      "positioningDisabled"
    ].reduce((M, e) => (M[e] = "$_refreshListeners", M), {}),
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((M, e) => (M[e] = "$_computePosition", M), {})
  },
  created() {
    this.$_isDisposed = !0, this.randomId = `popper_${[Math.random(), Date.now()].map((M) => M.toString(36).substring(2, 10)).join("_")}`, this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: M = null, skipDelay: e = !1, force: t = !1 } = {}) {
      var i, u;
      (i = this.parentPopper) != null && i.lockedChild && this.parentPopper.lockedChild !== this || (this.$_pendingHide = !1, (t || !this.disabled) && (((u = this.parentPopper) == null ? void 0 : u.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(M, e), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: M = null, skipDelay: e = !1 } = {}) {
      var t;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.$_pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: e }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((t = this.parentPopper) == null ? void 0 : t.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_pendingHide = !1, this.$_scheduleHide(M, e), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var M;
      this.$_isDisposed && (this.$_isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((M = this.referenceNode) == null ? void 0 : M.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((e) => e.nodeType === e.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.$_isDisposed || (this.$_isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"), this.$emit("dispose"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.$_isDisposed || this.positioningDisabled)
        return;
      const M = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && M.middleware.push(yc({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const e = this.placement.startsWith("auto");
      if (e ? M.middleware.push(Lc({
        alignment: this.placement.split("-")[1] ?? ""
      })) : M.placement = this.placement, this.preventOverflow && (this.shift && M.middleware.push(zc({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !e && this.flip && M.middleware.push(Ic({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), M.middleware.push(rc({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && M.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: i, rects: u, middlewareData: N }) => {
          let l;
          const { centerOffset: n } = N.arrow;
          return i.startsWith("top") || i.startsWith("bottom") ? l = Math.abs(n) > u.reference.width / 2 : l = Math.abs(n) > u.reference.height / 2, {
            data: {
              overflow: l
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const i = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        M.middleware.push({
          name: "autoSize",
          fn: ({ rects: u, placement: N, middlewareData: l }) => {
            var n;
            if ((n = l.autoSize) != null && n.skip)
              return {};
            let s, a;
            return N.startsWith("top") || N.startsWith("bottom") ? s = u.reference.width : a = u.reference.height, this.$_innerNode.style[i === "min" ? "minWidth" : i === "max" ? "maxWidth" : "width"] = s != null ? `${s}px` : null, this.$_innerNode.style[i === "min" ? "minHeight" : i === "max" ? "maxHeight" : "height"] = a != null ? `${a}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, M.middleware.push(mc({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: i, availableHeight: u }) => {
          this.$_innerNode.style.maxWidth = i != null ? `${i}px` : null, this.$_innerNode.style.maxHeight = u != null ? `${u}px` : null;
        }
      })));
      const t = await hc(this.$_referenceNode, this.$_popperNode, M);
      Object.assign(this.result, {
        x: t.x,
        y: t.y,
        placement: t.placement,
        strategy: t.strategy,
        arrow: {
          ...t.middlewareData.arrow,
          ...t.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(M = null, e = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), Oe && this.instantMove && Oe.instantMove && Oe !== this.parentPopper) {
        Oe.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      e ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(M = null, e = !1) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (Oe = this), e ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(M) {
      const e = this.delay;
      return parseInt(e && e[M] || e || 0);
    },
    async $_applyShow(M = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = M, !this.isShown && (this.$_ensureTeleport(), await di(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...Ht(this.$_referenceNode),
        ...Ht(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const e = this.$_referenceNode.getBoundingClientRect(), t = this.$_popperNode.querySelector(".v-popper__wrapper"), i = t.parentNode.getBoundingClientRect(), u = e.x + e.width / 2 - (i.left + t.offsetLeft), N = e.y + e.height / 2 - (i.top + t.offsetTop);
        this.result.transformOrigin = `${u}px ${N}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const M = this.showGroup;
      if (M) {
        let e;
        for (let t = 0; t < HM.length; t++)
          e = HM[t], e.showGroup !== M && (e.hide(), e.$emit("close-group"));
      }
      HM.push(this), document.body.classList.add("v-popper--some-open");
      for (const e of g0(this.theme))
        z0(e).push(this), document.body.classList.add(`v-popper--some-open--${e}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await di(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(M = !1) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = M, d0(HM, this), HM.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const t of g0(this.theme)) {
        const i = z0(t);
        d0(i, this), i.length === 0 && document.body.classList.remove(`v-popper--some-open--${t}`);
      }
      Oe === this && (Oe = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const e = this.disposeTimeout;
      e !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, e)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await di(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.$_isDisposed)
        return;
      let M = this.container;
      if (typeof M == "string" ? M = window.document.querySelector(M) : M === !1 && (M = this.$_targetNodes[0].parentNode), !M)
        throw new Error("No container for popover: " + this.container);
      M.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const M = (t) => {
        this.isShown && !this.$_hideInProgress || (t.usedByTooltip = !0, !this.$_preventShow && this.show({ event: t }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, L0, this.triggers, this.showTriggers, M), this.$_registerTriggerListeners([this.$_popperNode], L0, this.popperTriggers, this.popperShowTriggers, M);
      const e = (t) => {
        t.usedByTooltip || this.hide({ event: t });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, I0, this.triggers, this.hideTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], I0, this.popperTriggers, this.popperHideTriggers, e);
    },
    $_registerEventListeners(M, e, t) {
      this.$_events.push({ targetNodes: M, eventType: e, handler: t }), M.forEach((i) => i.addEventListener(e, t, Ue ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(M, e, t, i, u) {
      let N = t;
      i != null && (N = typeof i == "function" ? i(N) : i), N.forEach((l) => {
        const n = e[l];
        n && this.$_registerEventListeners(M, n, u);
      });
    },
    $_removeEventListeners(M) {
      const e = [];
      this.$_events.forEach((t) => {
        const { targetNodes: i, eventType: u, handler: N } = t;
        !M || M === u ? i.forEach((l) => l.removeEventListener(u, N)) : e.push(t);
      }), this.$_events = e;
    },
    $_refreshListeners() {
      this.$_isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(M, e = !1) {
      this.$_showFrameLocked || (this.hide({ event: M }), M.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), e && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(M, e) {
      for (const t of this.$_targetNodes) {
        const i = t.getAttribute(M);
        i && (t.removeAttribute(M), t.setAttribute(e, i));
      }
    },
    $_applyAttrsToTarget(M) {
      for (const e of this.$_targetNodes)
        for (const t in M) {
          const i = M[t];
          i == null ? e.removeAttribute(t) : e.setAttribute(t, i);
        }
    },
    $_updateParentShownChildren(M) {
      let e = this.parentPopper;
      for (; e; )
        M ? e.shownChildren.add(this.randomId) : (e.shownChildren.delete(this.randomId), e.$_pendingHide && e.hide()), e = e.parentPopper;
    },
    $_isAimingPopper() {
      const M = this.$_referenceNode.getBoundingClientRect();
      if (jt >= M.left && jt <= M.right && Tt >= M.top && Tt <= M.bottom) {
        const e = this.$_popperNode.getBoundingClientRect(), t = jt - re, i = Tt - ge, u = e.left + e.width / 2 - re + (e.top + e.height / 2) - ge + e.width + e.height, N = re + t * u, l = ge + i * u;
        return Zt(re, ge, N, l, e.left, e.top, e.left, e.bottom) || // Left edge
        Zt(re, ge, N, l, e.left, e.top, e.right, e.top) || // Top edge
        Zt(re, ge, N, l, e.right, e.top, e.right, e.bottom) || // Right edge
        Zt(re, ge, N, l, e.left, e.bottom, e.right, e.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
typeof document < "u" && typeof window < "u" && (B1 ? (document.addEventListener("touchstart", m0, Ue ? {
  passive: !0,
  capture: !0
} : !0), document.addEventListener("touchend", pc, Ue ? {
  passive: !0,
  capture: !0
} : !0)) : (window.addEventListener("mousedown", m0, !0), window.addEventListener("click", Oc, !0)), window.addEventListener("resize", Sc));
function m0(M) {
  for (let e = 0; e < HM.length; e++) {
    const t = HM[e];
    try {
      const i = t.popperNode();
      t.$_mouseDownContains = i.contains(M.target);
    } catch {
    }
  }
}
function Oc(M) {
  _1(M);
}
function pc(M) {
  _1(M, !0);
}
function _1(M, e = !1) {
  const t = {};
  for (let i = HM.length - 1; i >= 0; i--) {
    const u = HM[i];
    try {
      const N = u.$_containsGlobalTarget = wc(u, M);
      u.$_pendingHide = !1, requestAnimationFrame(() => {
        if (u.$_pendingHide = !1, !t[u.randomId] && A0(u, N, M)) {
          if (u.$_handleGlobalClose(M, e), !M.closeAllPopover && M.closePopover && N) {
            let n = u.parentPopper;
            for (; n; )
              t[n.randomId] = !0, n = n.parentPopper;
            return;
          }
          let l = u.parentPopper;
          for (; l && A0(l, l.$_containsGlobalTarget, M); )
            l.$_handleGlobalClose(M, e), l = l.parentPopper;
        }
      });
    } catch {
    }
  }
}
function wc(M, e) {
  const t = M.popperNode();
  return M.$_mouseDownContains || t.contains(e.target);
}
function A0(M, e, t) {
  return t.closeAllPopover || t.closePopover && e || Yc(M, t) && !e;
}
function Yc(M, e) {
  if (typeof M.autoHide == "function") {
    const t = M.autoHide(e);
    return M.lastAutoHide = t, t;
  }
  return M.autoHide;
}
function Sc(M) {
  for (let e = 0; e < HM.length; e++)
    HM[e].$_computePosition(M);
}
let re = 0, ge = 0, jt = 0, Tt = 0;
typeof window < "u" && window.addEventListener("mousemove", (M) => {
  re = jt, ge = Tt, jt = M.clientX, Tt = M.clientY;
}, Ue ? {
  passive: !0
} : void 0);
function Zt(M, e, t, i, u, N, l, n) {
  const s = ((l - u) * (e - N) - (n - N) * (M - u)) / ((n - N) * (t - M) - (l - u) * (i - e)), a = ((t - M) * (e - N) - (i - e) * (M - u)) / ((n - N) * (t - M) - (l - u) * (i - e));
  return s >= 0 && s <= 1 && a >= 0 && a <= 1;
}
const Zc = {
  extends: P1()
}, Ni = (M, e) => {
  const t = M.__vccOpts || M;
  for (const [i, u] of e)
    t[i] = u;
  return t;
};
function kc(M, e, t, i, u, N) {
  return c(), g("div", {
    ref: "reference",
    class: V(["v-popper", {
      "v-popper--shown": M.slotData.isShown
    }])
  }, [
    J(M.$slots, "default", se(xe(M.slotData)))
  ], 2);
}
const bc = /* @__PURE__ */ Ni(Zc, [["render", kc]]);
function Uc() {
  var M = window.navigator.userAgent, e = M.indexOf("MSIE ");
  if (e > 0)
    return parseInt(M.substring(e + 5, M.indexOf(".", e)), 10);
  var t = M.indexOf("Trident/");
  if (t > 0) {
    var i = M.indexOf("rv:");
    return parseInt(M.substring(i + 3, M.indexOf(".", i)), 10);
  }
  var u = M.indexOf("Edge/");
  return u > 0 ? parseInt(M.substring(u + 5, M.indexOf(".", u)), 10) : -1;
}
let Gt;
function qi() {
  qi.init || (qi.init = !0, Gt = Uc() !== -1);
}
var li = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    qi(), zM(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const M = document.createElement("object");
    this._resizeObject = M, M.setAttribute("aria-hidden", "true"), M.setAttribute("tabindex", -1), M.onload = this.addResizeHandlers, M.type = "text/html", Gt && this.$el.appendChild(M), M.data = "about:blank", Gt || this.$el.appendChild(M);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!Gt && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const Qc = /* @__PURE__ */ hN("data-v-b329ee4c");
xN("data-v-b329ee4c");
const Vc = {
  class: "resize-observer",
  tabindex: "-1"
};
EN();
const Wc = /* @__PURE__ */ Qc((M, e, t, i, u, N) => (c(), k("div", Vc)));
li.render = Wc;
li.__scopeId = "data-v-b329ee4c";
li.__file = "src/components/ResizeObserver.vue";
const $1 = (M = "theme") => ({
  computed: {
    themeClass() {
      return Cc(this[M]);
    }
  }
}), fc = U({
  name: "VPopperContent",
  components: {
    ResizeObserver: li
  },
  mixins: [
    $1()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(M) {
      return M != null && !isNaN(M) ? `${M}px` : null;
    }
  }
}), vc = ["id", "aria-hidden", "tabindex", "data-popper-placement"], Gc = {
  ref: "inner",
  class: "v-popper__inner"
}, Rc = /* @__PURE__ */ T("div", { class: "v-popper__arrow-outer" }, null, -1), Fc = /* @__PURE__ */ T("div", { class: "v-popper__arrow-inner" }, null, -1), Xc = [
  Rc,
  Fc
];
function Jc(M, e, t, i, u, N) {
  const l = AM("ResizeObserver");
  return c(), g("div", {
    id: M.popperId,
    ref: "popover",
    class: V(["v-popper__popper", [
      M.themeClass,
      M.classes.popperClass,
      {
        "v-popper__popper--shown": M.shown,
        "v-popper__popper--hidden": !M.shown,
        "v-popper__popper--show-from": M.classes.showFrom,
        "v-popper__popper--show-to": M.classes.showTo,
        "v-popper__popper--hide-from": M.classes.hideFrom,
        "v-popper__popper--hide-to": M.classes.hideTo,
        "v-popper__popper--skip-transition": M.skipTransition,
        "v-popper__popper--arrow-overflow": M.result && M.result.arrow.overflow,
        "v-popper__popper--no-positioning": !M.result
      }
    ]]),
    style: RM(M.result ? {
      position: M.result.strategy,
      transform: `translate3d(${Math.round(M.result.x)}px,${Math.round(M.result.y)}px,0)`
    } : void 0),
    "aria-hidden": M.shown ? "false" : "true",
    tabindex: M.autoHide ? 0 : void 0,
    "data-popper-placement": M.result ? M.result.placement : void 0,
    onKeyup: e[2] || (e[2] = CN((n) => M.autoHide && M.$emit("hide"), ["esc"]))
  }, [
    T("div", {
      class: "v-popper__backdrop",
      onClick: e[0] || (e[0] = (n) => M.autoHide && M.$emit("hide"))
    }),
    T("div", {
      class: "v-popper__wrapper",
      style: RM(M.result ? {
        transformOrigin: M.result.transformOrigin
      } : void 0)
    }, [
      T("div", Gc, [
        M.mounted ? (c(), g(K, { key: 0 }, [
          T("div", null, [
            J(M.$slots, "default")
          ]),
          M.handleResize ? (c(), k(l, {
            key: 0,
            onNotify: e[1] || (e[1] = (n) => M.$emit("resize", n))
          })) : A("", !0)
        ], 64)) : A("", !0)
      ], 512),
      T("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: RM(M.result ? {
          left: M.toPx(M.result.arrow.x),
          top: M.toPx(M.result.arrow.y)
        } : void 0)
      }, Xc, 4)
    ], 4)
  ], 46, vc);
}
const q1 = /* @__PURE__ */ Ni(fc, [["render", Jc]]), M4 = {
  methods: {
    show(...M) {
      return this.$refs.popper.show(...M);
    },
    hide(...M) {
      return this.$refs.popper.hide(...M);
    },
    dispose(...M) {
      return this.$refs.popper.dispose(...M);
    },
    onResize(...M) {
      return this.$refs.popper.onResize(...M);
    }
  }
}, Kc = U({
  name: "VPopperWrapper",
  components: {
    Popper: bc,
    PopperContent: q1
  },
  mixins: [
    M4,
    $1("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    }
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((M) => M !== this.$refs.popperContent.$el);
    }
  }
});
function Bc(M, e, t, i, u, N) {
  const l = AM("PopperContent"), n = AM("Popper");
  return c(), k(n, {
    ref: "popper",
    theme: M.finalTheme,
    "target-nodes": M.getTargetNodes,
    "popper-node": () => M.$refs.popperContent.$el,
    class: V([
      M.themeClass
    ])
  }, {
    default: O(({
      popperId: s,
      isShown: a,
      shouldMountContent: o,
      skipTransition: j,
      autoHide: D,
      show: r,
      hide: I,
      handleResize: L,
      onResize: d,
      classes: m,
      result: x
    }) => [
      J(M.$slots, "default", {
        shown: a,
        show: r,
        hide: I
      }),
      z(l, {
        ref: "popperContent",
        "popper-id": s,
        theme: M.finalTheme,
        shown: a,
        mounted: o,
        "skip-transition": j,
        "auto-hide": D,
        "handle-resize": L,
        classes: m,
        result: x,
        onHide: I,
        onResize: d
      }, {
        default: O(() => [
          J(M.$slots, "popper", {
            shown: a,
            hide: I
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 8, ["theme", "target-nodes", "popper-node", "class"]);
}
const bu = /* @__PURE__ */ Ni(Kc, [["render", Bc]]), Hc = {
  ...bu,
  name: "VDropdown",
  vPopperTheme: "dropdown"
}, Pc = {
  ...bu,
  name: "VMenu",
  vPopperTheme: "menu"
}, e4 = {
  ...bu,
  name: "VTooltip",
  vPopperTheme: "tooltip"
}, _c = U({
  name: "VTooltipDirective",
  components: {
    Popper: P1(),
    PopperContent: q1
  },
  mixins: [
    M4
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (M) => zt(M.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (M) => zt(M.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(M) {
      if (typeof this.content == "function" && this.$_isShown && (M || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const e = ++this.$_fetchId, t = this.content(this);
        t.then ? t.then((i) => this.onResult(e, i)) : this.onResult(e, t);
      }
    },
    onResult(M, e) {
      M === this.$_fetchId && (this.$_loading = !1, this.asyncContent = e);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
}), $c = ["innerHTML"], qc = ["textContent"];
function MD(M, e, t, i, u, N) {
  const l = AM("PopperContent"), n = AM("Popper");
  return c(), k(n, DM({ ref: "popper" }, M.$attrs, {
    theme: M.theme,
    "target-nodes": M.targetNodes,
    "popper-node": () => M.$refs.popperContent.$el,
    onApplyShow: M.onShow,
    onApplyHide: M.onHide
  }), {
    default: O(({
      popperId: s,
      isShown: a,
      shouldMountContent: o,
      skipTransition: j,
      autoHide: D,
      hide: r,
      handleResize: I,
      onResize: L,
      classes: d,
      result: m
    }) => [
      z(l, {
        ref: "popperContent",
        class: V({
          "v-popper--tooltip-loading": M.loading
        }),
        "popper-id": s,
        theme: M.theme,
        shown: a,
        mounted: o,
        "skip-transition": j,
        "auto-hide": D,
        "handle-resize": I,
        classes: d,
        result: m,
        onHide: r,
        onResize: L
      }, {
        default: O(() => [
          M.html ? (c(), g("div", {
            key: 0,
            innerHTML: M.finalContent
          }, null, 8, $c)) : (c(), g("div", {
            key: 1,
            textContent: w(M.finalContent)
          }, null, 8, qc))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "target-nodes", "popper-node", "onApplyShow", "onApplyHide"]);
}
const eD = /* @__PURE__ */ Ni(_c, [["render", MD]]), t4 = "v-popper--has-tooltip";
function tD(M, e) {
  let t = M.placement;
  if (!t && e)
    for (const i of H1)
      e[i] && (t = i);
  return t || (t = zt(M.theme || "tooltip", "placement")), t;
}
function i4(M, e, t) {
  let i;
  const u = typeof e;
  return u === "string" ? i = { content: e } : e && u === "object" ? i = e : i = { content: !1 }, i.placement = tD(i, t), i.targetNodes = () => [M], i.referenceNode = () => M, i;
}
let zi, mt, iD = 0;
function uD() {
  if (zi)
    return;
  mt = E([]), zi = ON({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: mt
      };
    },
    render() {
      return this.directives.map((e) => aM(eD, {
        ...e.options,
        shown: e.shown || e.options.shown,
        key: e.id
      }));
    },
    devtools: {
      hide: !0
    }
  });
  const M = document.createElement("div");
  document.body.appendChild(M), zi.mount(M);
}
function ND(M, e, t) {
  uD();
  const i = E(i4(M, e, t)), u = E(!1), N = {
    id: iD++,
    options: i,
    shown: u
  };
  return mt.value.push(N), M.classList && M.classList.add(t4), M.$_popper = {
    options: i,
    item: N,
    show() {
      u.value = !0;
    },
    hide() {
      u.value = !1;
    }
  };
}
function u4(M) {
  if (M.$_popper) {
    const e = mt.value.indexOf(M.$_popper.item);
    e !== -1 && mt.value.splice(e, 1), delete M.$_popper, delete M.$_popperOldShown, delete M.$_popperMountTarget;
  }
  M.classList && M.classList.remove(t4);
}
function x0(M, { value: e, modifiers: t }) {
  const i = i4(M, e, t);
  if (!i.content || zt(i.theme || "tooltip", "disabled"))
    u4(M);
  else {
    let u;
    M.$_popper ? (u = M.$_popper, u.options.value = i) : u = ND(M, e, t), typeof e.shown < "u" && e.shown !== M.$_popperOldShown && (M.$_popperOldShown = e.shown, e.shown ? u.show() : u.hide());
  }
}
const lD = {
  beforeMount: x0,
  updated: x0,
  beforeUnmount(M) {
    u4(M);
  }
};
function E0(M) {
  M.addEventListener("click", N4), M.addEventListener("touchstart", l4, Ue ? {
    passive: !0
  } : !1);
}
function h0(M) {
  M.removeEventListener("click", N4), M.removeEventListener("touchstart", l4), M.removeEventListener("touchend", n4), M.removeEventListener("touchcancel", s4);
}
function N4(M) {
  const e = M.currentTarget;
  M.closePopover = !e.$_vclosepopover_touch, M.closeAllPopover = e.$_closePopoverModifiers && !!e.$_closePopoverModifiers.all;
}
function l4(M) {
  if (M.changedTouches.length === 1) {
    const e = M.currentTarget;
    e.$_vclosepopover_touch = !0;
    const t = M.changedTouches[0];
    e.$_vclosepopover_touchPoint = t, e.addEventListener("touchend", n4), e.addEventListener("touchcancel", s4);
  }
}
function n4(M) {
  const e = M.currentTarget;
  if (e.$_vclosepopover_touch = !1, M.changedTouches.length === 1) {
    const t = M.changedTouches[0], i = e.$_vclosepopover_touchPoint;
    M.closePopover = Math.abs(t.screenY - i.screenY) < 20 && Math.abs(t.screenX - i.screenX) < 20, M.closeAllPopover = e.$_closePopoverModifiers && !!e.$_closePopoverModifiers.all;
  }
}
function s4(M) {
  const e = M.currentTarget;
  e.$_vclosepopover_touch = !1;
}
const nD = {
  beforeMount(M, { value: e, modifiers: t }) {
    M.$_closePopoverModifiers = t, (typeof e > "u" || e) && E0(M);
  },
  updated(M, { value: e, oldValue: t, modifiers: i }) {
    M.$_closePopoverModifiers = i, e !== t && (typeof e > "u" || e ? E0(M) : h0(M));
  },
  beforeUnmount(M) {
    h0(M);
  }
}, sD = e4;
function oD(M, e = {}) {
  M.$_vTooltipInstalled || (M.$_vTooltipInstalled = !0, K1(ce, e), M.directive("tooltip", lD), M.directive("close-popper", nD), M.component("VTooltip", e4), M.component("VDropdown", Hc), M.component("VMenu", Pc));
}
const aD = {
  // eslint-disable-next-line no-undef
  version: "2.0.0-beta.24",
  install: oD,
  options: ce
};
aD.options.themes["goodvibes-theme"] = {
  $extend: "tooltip",
  placement: "auto",
  distance: 12,
  html: !0
};
const oe = {
  ...sD,
  name: "PopperTooltip",
  vPopperTheme: "goodvibes-theme"
}, jD = { class: "flex justify-between items-start gap-x-28 max-w-screen-xl mx-auto" }, TD = {
  key: 0,
  class: "flex justify-between gap-4 mt-7 flex-wrap md:flex-nowrap"
}, cD = { class: "giphy-results w-9/12 grow flex flex-wrap gap-2 max-h-fit overflow-y-auto after:[flex-grow:10000]" }, DD = ["onClick", "src"], rD = { class: "w-3/12 flex" }, gD = { class: "flex items-center gap-x-3" }, LD = ["disabled"], ID = ["disabled"], dD = {
  key: 1,
  class: "flex items-center justify-center mt-6 h-40 w-full border-2 rounded-2xl border-[#F8F9FF] italic text-[#B2C3D4] text-2xl font-light"
}, yD = { class: "relative" }, zD = { key: 0 }, mD = { class: "flex" }, AD = /* @__PURE__ */ T("span", { class: "input-label" }, "Email(optional)", -1), xD = /* @__PURE__ */ T("div", { class: "w-56 font-semibold" }, " We will never send you any spam. This is just for the confirmation of this kudo post and our anti-spam protection. ", -1), ED = ["disabled", "textContent"], mi = 10, Ai = 75, JA = /* @__PURE__ */ U({
  __name: "GifKudoBuilder",
  props: {
    giphyApiKey: {},
    giphUrl: {},
    message: {},
    senderName: {},
    senderEmail: {},
    color: { default: fe[0] },
    isAuthenticated: { type: Boolean }
  },
  emits: ["update:message", "update:senderName", "update:senderEmail", "update:giphUrl", "update:color", "create"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = p(() => te.get(t.color)[0]), N = E(), l = E(""), n = E(0), s = E(!1), a = p(
      () => N.value && N.value.pagination.total_count > n.value + mi
    );
    CT(
      l,
      async function(m, x) {
        if (m === "") {
          N.value = void 0;
          return;
        }
        m !== x && (N.value = void 0);
        try {
          const { items: C, pagination: Q } = await j(
            m,
            n.value,
            mi
          );
          N.value = {
            items: C,
            pagination: Q
          };
        } catch (C) {
          if (C instanceof Error && C.name === "AbortError")
            return;
          throw C;
        }
      },
      { debounce: 500 }
    );
    let o = null;
    function j(d, m, x = 10) {
      return o == null || o.abort("New fetch"), o = new AbortController(), s.value = !0, fetch(
        `https://api.giphy.com/v1/gifs/search?api_key=${t.giphyApiKey}&q=${d}&offset=${m}&limit=${x}`,
        { signal: o.signal }
      ).then((C) => {
        if (C.ok)
          return C.json();
        throw new Error(C.statusText);
      }).then((C) => ({
        items: [
          ...C.data.filter(
            (Q) => Q.images.preview_webp && Q.images.fixed_height_downsampled
          ).map((Q) => ({
            previewUrl: Q.images.preview_webp.url,
            url: Q.images.fixed_height_downsampled.webp
          }))
        ],
        pagination: C.pagination
      })).finally(() => s.value = !1);
    }
    async function D() {
      n.value += 10;
      const { items: d, pagination: m } = await j(
        l.value,
        n.value,
        mi
      );
      N.value = {
        items: d,
        pagination: m
      };
    }
    const r = E(), I = p(
      () => {
        var d;
        return Ai - (((d = t.message) == null ? void 0 : d.length) || 0);
      }
    );
    function L(d) {
      var C;
      const m = d.target;
      m.value.length > Ai && ((C = r.value) == null || C.shake()), i("update:message", m.value);
    }
    return (d, m) => (c(), g("div", jD, [
      z(UM, { class: "w-7/12 grow lg:grow-0 shrink-0 space-y-14" }, {
        default: O(() => [
          T("div", null, [
            z(nM, {
              label: "Giphy GIF search",
              type: "text",
              modelValue: l.value,
              "onUpdate:modelValue": m[0] || (m[0] = (x) => l.value = x),
              placeholder: "Doge? Snoop Dog? Snoop Doge? :O",
              inputClass: "bg-[#F8F9FF] border-none"
            }, null, 8, ["modelValue"]),
            N.value && N.value.items.length ? (c(), g("div", TD, [
              T("div", cD, [
                (c(!0), g(K, null, lM(N.value.items, (x) => (c(), g("img", {
                  onClick: (C) => i("update:giphUrl", x.url),
                  key: x.previewUrl,
                  src: x.previewUrl,
                  class: V(["h-[76px] w-auto max-w-[80px] object-cover rounded-lg cursor-pointer grow", {
                    "border-[3px] border-[#FFCE21]": d.giphUrl === x.url
                  }])
                }, null, 10, DD))), 128))
              ]),
              CM(T("div", rD, [
                T("div", gD, [
                  T("button", {
                    disabled: s.value,
                    onClick: D,
                    class: "disabled:opacity-50 w-16 h-16 cursor-pointer grow-0 shrink-0 bg-[#DEF4FC] hover:bg-[#ACE7FC] transition-colors duration-300 rounded-full flex items-center justify-center relative"
                  }, [
                    z(y(y1), {
                      class: V(["w-5 aspect-square", { "animate-spin": s.value }])
                    }, null, 8, ["class"])
                  ], 8, LD),
                  T("button", {
                    class: "uppercase text-xs text-[#8C96A1]",
                    disabled: s.value,
                    onClick: D
                  }, " Refresh ", 8, ID)
                ])
              ], 512), [
                [WM, a.value]
              ])
            ])) : (c(), g("div", dD, w(!N.value || !l.value ? "Results" : "No results found."), 1))
          ]),
          T("div", yD, [
            z(me, {
              label: "And some extra text to it? No presh. Easy.",
              rows: "1",
              modelValue: d.message ?? "",
              onInput: L,
              placeholder: "Optional text. If image is enough, that’s just fine.",
              inputClass: "bg-[#F8F9FF] border-none resize-none"
            }, null, 8, ["modelValue"]),
            z(Et, {
              class: "right-0 mt-1 absolute",
              ref_key: "charCounterEl",
              ref: r,
              message: d.message ?? "",
              characterLimit: Ai
            }, null, 8, ["message"])
          ]),
          z(nM, {
            label: "Your name",
            type: "text",
            modelValue: d.senderName,
            maxlength: "75",
            onInput: m[1] || (m[1] = (x) => i("update:senderName", x.target.value)),
            placeholder: "Or nickname... we are not here to dictate",
            inputClass: "bg-[#F8F9FF] border-none"
          }, null, 8, ["modelValue"]),
          d.isAuthenticated ? A("", !0) : (c(), g("label", zD, [
            T("div", mD, [
              AD,
              z(oe, {
                triggers: ["hover"],
                distance: 20,
                placement: "top",
                popperTriggers: ["hover"],
                delay: { show: 200, hide: 150 }
              }, {
                popper: O(() => [
                  xD
                ]),
                default: O(() => [
                  z(y(Ee), {
                    class: "cursor-pointer h-4 w-4 fill-[#BBC4CD]",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })
            ]),
            z(nM, {
              modelValue: d.senderEmail,
              type: "email",
              "onUpdate:modelValue": m[2] || (m[2] = (x) => i("update:senderEmail", x)),
              placeholder: "Your email",
              inputClass: "bg-[#F8F9FF] border-none"
            }, null, 8, ["modelValue"])
          ])),
          A("", !0),
          d.giphUrl ? (c(), k(Xt, {
            key: 2,
            class: V(["block lg:hidden mx-auto", [u.value, "shrink-0 grow-0"]]),
            message: d.message,
            senderName: d.senderName,
            imgUrl: d.giphUrl
          }, null, 8, ["class", "message", "senderName", "imgUrl"])) : A("", !0),
          J(d.$slots, "submit", se(xe({ ...t, remainingCharacters: I.value })), () => [
            T("button", {
              onClick: m[4] || (m[4] = (x) => i("create", t)),
              class: "btn btn--primary self-start",
              disabled: !d.giphUrl || I.value < 0,
              textContent: w(d.giphUrl ? "Post the Kudo!" : "Create your kudo first")
            }, null, 8, ED)
          ])
        ]),
        _: 3
      }),
      d.giphUrl ? (c(), k(Xt, {
        key: 0,
        class: V(["hidden lg:block", [u.value, "shrink-0 grow-0"]]),
        message: d.message,
        senderName: d.senderName,
        imgUrl: d.giphUrl
      }, null, 8, ["class", "message", "senderName", "imgUrl"])) : A("", !0)
    ]));
  }
}), hD = ["src", "controls"], CD = { class: "absolute bottom-5 w-full px-8 flex items-center gap-x-3" }, OD = ["value", "max"], pD = {
  key: 1,
  class: "grow-0 shrink-0 text-xs bg-white text-[#1212E0] py-1 rounded-md w-14 text-center"
}, wD = {
  key: 0,
  class: "mt-5 text-center text-lg text-[#3F4A55] font-serif overflow-y-auto"
}, YD = { class: "text-center relative text-sm text-[#8C96A1]" }, C0 = /* @__PURE__ */ U({
  __name: "VideoKudo",
  props: {
    message: {},
    src: {},
    senderName: {},
    controls: { type: Boolean, default: !0 }
  },
  setup(M, { expose: e }) {
    const t = E(null);
    e({
      videoEl: t
    });
    const i = E(!1), u = E(), N = E();
    LM(() => {
      t.value.onplay = () => i.value = !0, t.value.onpause = () => i.value = !1, t.value.onloadedmetadata = () => {
        var j;
        return u.value = (j = t.value) == null ? void 0 : j.duration;
      }, t.value.ontimeupdate = () => {
        N.value = t.value.currentTime;
      };
    });
    const l = p(() => i.value ? A1 : x1);
    function n() {
      var j;
      (j = t.value) == null || j.play();
    }
    function s() {
      var j;
      (j = t.value) == null || j.pause();
    }
    function a() {
      i.value ? s() : n();
    }
    function o(j) {
      return new Date(+j * 1e3).toISOString().slice(11, 19);
    }
    return (j, D) => (c(), k(UM, { class: "kudo-card" }, Pe({
      default: O(() => [
        T("div", {
          class: V(["-mx-12 -mt-12 rounded-[2.5rem] overflow-hidden shrink-0 relative", { "-mb-12": !j.message && !j.senderName }])
        }, [
          T("video", {
            ref_key: "videoEl",
            ref: t,
            class: "w-full min-h-[20.75rem] max-h-[38.25rem] object-cover",
            src: j.src,
            controls: j.controls
          }, null, 8, hD),
          J(j.$slots, "default", se(xe({ formatToHms: o })), () => [
            T("div", CD, [
              (c(), k(cM(l.value), {
                onClick: a,
                class: "h-7 stroke-[#FFCE21] fill-[#FFCE21] drop-shadow-md cursor-pointer"
              })),
              u.value !== void 0 ? (c(), g("progress", {
                key: 0,
                class: "progress flex-grow h-2",
                value: N.value,
                max: u.value
              }, w(N.value), 9, OD)) : A("", !0),
              u.value !== void 0 ? (c(), g("small", pD, w(o(u.value)), 1)) : A("", !0)
            ])
          ])
        ], 2),
        j.message ? (c(), g("p", wD, w(j.message), 1)) : A("", !0)
      ]),
      _: 2
    }, [
      j.$slots.actions ? {
        name: "actions",
        fn: O(() => [
          J(j.$slots, "actions")
        ]),
        key: "0"
      } : void 0,
      j.senderName ? {
        name: "footer",
        fn: O(() => [
          T("div", YD, w(j.senderName), 1)
        ]),
        key: "1"
      } : void 0
    ]), 1024));
  }
});
function O0(M, e) {
  var t = Object.keys(M);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(M);
    e && (i = i.filter(function(u) {
      return Object.getOwnPropertyDescriptor(M, u).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function jM(M) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? O0(Object(t), !0).forEach(function(i) {
      XM(M, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(t)) : O0(Object(t)).forEach(function(i) {
      Object.defineProperty(M, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return M;
}
function XM(M, e, t) {
  return e in M ? Object.defineProperty(M, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : M[e] = t, M;
}
function SD(M, e) {
  if (M == null)
    return {};
  var t, i, u = function(l, n) {
    if (l == null)
      return {};
    var s, a, o = {}, j = Object.keys(l);
    for (a = 0; a < j.length; a++)
      s = j[a], n.indexOf(s) >= 0 || (o[s] = l[s]);
    return o;
  }(M, e);
  if (Object.getOwnPropertySymbols) {
    var N = Object.getOwnPropertySymbols(M);
    for (i = 0; i < N.length; i++)
      t = N[i], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(M, t) && (u[t] = M[t]);
  }
  return u;
}
function Qe(M) {
  return function(e) {
    if (Array.isArray(e))
      return xi(e);
  }(M) || function(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
      return Array.from(e);
  }(M) || function(e, t) {
    if (e) {
      if (typeof e == "string")
        return xi(e, t);
      var i = Object.prototype.toString.call(e).slice(8, -1);
      if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set")
        return Array.from(e);
      if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
        return xi(e, t);
    }
  }(M) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function xi(M, e) {
  (e == null || e > M.length) && (e = M.length);
  for (var t = 0, i = new Array(e); t < e; t++)
    i[t] = M[t];
  return i;
}
var p0, ZD, kt, hM = (p0 = function(M) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var e = {}.hasOwnProperty;
    function t() {
      for (var i = [], u = 0; u < arguments.length; u++) {
        var N = arguments[u];
        if (N) {
          var l = typeof N;
          if (l === "string" || l === "number")
            i.push(N);
          else if (Array.isArray(N)) {
            if (N.length) {
              var n = t.apply(null, N);
              n && i.push(n);
            }
          } else if (l === "object")
            if (N.toString === Object.prototype.toString)
              for (var s in N)
                e.call(N, s) && N[s] && i.push(s);
            else
              i.push(N.toString());
        }
      }
      return i.join(" ");
    }
    M.exports ? (t.default = t, M.exports = t) : window.classNames = t;
  })();
}, p0(kt = { path: ZD, exports: {}, require: function(M, e) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(e == null && kt.path);
} }, kt.exports), kt.exports), _M = function(M) {
  return function(e, t) {
    if (!e)
      return M;
    var i;
    typeof e == "string" ? i = e : t = e;
    var u = M;
    return i && (u += "__" + i), u + (t ? Object.keys(t).reduce(function(N, l) {
      var n = t[l];
      return n && (N += " " + (typeof n == "boolean" ? u + "--" + l : u + "--" + l + "_" + n)), N;
    }, "") : "");
  };
};
function Mu(M, e, t) {
  var i, u, N, l, n;
  function s() {
    var o = Date.now() - l;
    o < e && o >= 0 ? i = setTimeout(s, e - o) : (i = null, t || (n = M.apply(N, u), N = u = null));
  }
  e == null && (e = 100);
  var a = function() {
    N = this, u = arguments, l = Date.now();
    var o = t && !i;
    return i || (i = setTimeout(s, e)), o && (n = M.apply(N, u), N = u = null), n;
  };
  return a.clear = function() {
    i && (clearTimeout(i), i = null);
  }, a.flush = function() {
    i && (n = M.apply(N, u), N = u = null, clearTimeout(i), i = null);
  }, a;
}
Mu.debounce = Mu;
var eu = Mu, _ = function() {
  return _ = Object.assign || function(M) {
    for (var e, t = 1, i = arguments.length; t < i; t++)
      for (var u in e = arguments[t])
        Object.prototype.hasOwnProperty.call(e, u) && (M[u] = e[u]);
    return M;
  }, _.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function o4(M, e) {
  var t, i;
  return M && e ? (t = "" + M + e[0].toUpperCase() + e.slice(1), i = M + "-" + e) : (t = M || e, i = M || e), { name: t, classname: i };
}
function a4(M) {
  return /^blob:/.test(M);
}
function w0(M) {
  return a4(M) || function(e) {
    return /^data:/.test(e);
  }(M);
}
function Fe(M) {
  return !!(M && M.constructor && M.call && M.apply);
}
function wM(M) {
  return M === void 0;
}
function Rt(M) {
  return typeof M == "object" && M !== null;
}
function tu(M, e, t) {
  var i = {};
  return Rt(M) ? (Object.keys(e).forEach(function(u) {
    wM(M[u]) ? i[u] = e[u] : Rt(e[u]) ? Rt(M[u]) ? i[u] = tu(M[u], e[u], t[u]) : i[u] = M[u] ? e[u] : t[u] : e[u] === !0 || e[u] === !1 ? i[u] = !!M[u] : i[u] = M[u];
  }), i) : M ? e : t;
}
function bt(M) {
  var e = Number(M);
  return Number.isNaN(e) ? M : e;
}
function Y0(M) {
  return typeof (M == "number" || function(e) {
    return typeof e == "object" && e !== null;
  }(M) && toString.call(M) == "[object Number]") && !j4(M);
}
function j4(M) {
  return M != M;
}
function T4(M, e) {
  return Math.sqrt(Math.pow(M.x - e.x, 2) + Math.pow(M.y - e.y, 2));
}
var ct = function(M, e) {
  M === void 0 && (M = {}), e === void 0 && (e = {}), this.type = "manipulateImage", this.move = M, this.scale = e;
}, kD = function(M, e) {
  e === void 0 && (e = {}), this.type = "resize", this.directions = M, this.params = e;
}, Uu = function(M) {
  this.type = "move", this.directions = M;
}, bD = function() {
  function M(e, t, i, u, N) {
    this.type = "drag", this.nativeEvent = e, this.position = i, this.previousPosition = u, this.element = t, this.anchor = N;
  }
  return M.prototype.shift = function() {
    var e = this, t = e.element, i = e.anchor, u = e.position;
    if (t) {
      var N = t.getBoundingClientRect(), l = N.left, n = N.top;
      return { left: u.left - l - i.left, top: u.top - n - i.top };
    }
    return { left: 0, top: 0 };
  }, M;
}(), Qu = { name: "DraggableElement", props: { classname: { type: String } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  if (!this.$refs.draggable)
    throw new Error('You should add ref "draggable" to your root element to use draggable mixin');
  this.touches = [], this.hovered = !1;
}, methods: { onMouseOver: function() {
  this.hovered || (this.hovered = !0, this.$emit("enter"));
}, onMouseLeave: function() {
  this.hovered && !this.touches.length && (this.hovered = !1, this.$emit("leave"));
}, onTouchStart: function(M) {
  M.cancelable && !this.disabled && M.touches.length === 1 && (this.touches = Qe(M.touches), this.hovered || (this.$emit("enter"), this.hovered = !0), M.touches.length && this.initAnchor(this.touches.reduce(function(e, t) {
    return { clientX: e.clientX + t.clientX / M.touches.length, clientY: e.clientY + t.clientY / M.touches.length };
  }, { clientX: 0, clientY: 0 })), M.preventDefault && M.preventDefault(), M.stopPropagation());
}, onTouchEnd: function() {
  this.processEnd();
}, onTouchMove: function(M) {
  this.touches.length && (this.processMove(M, M.touches), M.preventDefault && M.preventDefault(), M.stopPropagation && M.stopPropagation());
}, onMouseDown: function(M) {
  if (!this.disabled) {
    var e = { fake: !0, clientX: M.clientX, clientY: M.clientY };
    this.touches = [e], this.initAnchor(e), M.stopPropagation();
  }
}, onMouseMove: function(M) {
  this.touches.length && (this.processMove(M, [{ fake: !0, clientX: M.clientX, clientY: M.clientY }]), M.preventDefault && M.preventDefault());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(M) {
  var e = this.$refs.draggable.getBoundingClientRect(), t = e.left, i = e.right, u = e.bottom, N = e.top;
  this.anchor = { left: M.clientX - t, top: M.clientY - N, bottom: u - M.clientY, right: i - M.clientX };
}, processMove: function(M, e) {
  var t = Qe(e);
  if (this.touches.length) {
    if (this.touches.length === 1 && t.length === 1) {
      var i = this.$refs.draggable;
      this.$emit("drag", new bD(M, i, { left: t[0].clientX, top: t[0].clientY }, { left: this.touches[0].clientX, top: this.touches[0].clientY }, this.anchor));
    }
    this.touches = t;
  }
}, processEnd: function() {
  this.touches.length && this.$emit("drag-end"), this.hovered && (this.$emit("leave"), this.hovered = !1), this.touches = [];
} }, emits: ["drag", "drag-end", "leave", "enter"] };
Qu.render = function(M, e, t, i, u, N) {
  return c(), k("div", { ref: "draggable", class: t.classname, onTouchstart: e[1] || (e[1] = function() {
    return N.onTouchStart && N.onTouchStart.apply(N, arguments);
  }), onMousedown: e[2] || (e[2] = function() {
    return N.onMouseDown && N.onMouseDown.apply(N, arguments);
  }), onMouseover: e[3] || (e[3] = function() {
    return N.onMouseOver && N.onMouseOver.apply(N, arguments);
  }), onMouseleave: e[4] || (e[4] = function() {
    return N.onMouseLeave && N.onMouseLeave.apply(N, arguments);
  }) }, [J(M.$slots, "default")], 34);
};
var Ei = _M("vue-handler-wrapper"), c4 = { name: "HandlerWrapper", components: { DraggableElement: Qu }, props: { horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, computed: { classes: function() {
  var M;
  if (this.horizontalPosition || this.verticalPosition) {
    var e, t = o4(this.horizontalPosition, this.verticalPosition);
    M = Ei((XM(e = {}, t.classname, !0), XM(e, "disabled", this.disabled), e));
  } else
    M = Ei({ disabled: this.disabled });
  return { root: M, draggable: Ei("draggable") };
} }, emits: ["leave", "enter", "drag", "drag-end"] };
c4.render = function(M, e, t, i, u, N) {
  var l = AM("DraggableElement");
  return c(), k("div", { class: N.classes.root }, [z(l, { class: N.classes.draggable, onDrag: e[1] || (e[1] = function(n) {
    return M.$emit("drag", n);
  }), onDragEnd: e[2] || (e[2] = function(n) {
    return M.$emit("drag-end");
  }), onLeave: e[3] || (e[3] = function(n) {
    return M.$emit("leave");
  }), onEnter: e[4] || (e[4] = function(n) {
    return M.$emit("enter");
  }) }, { default: O(function() {
    return [J(M.$slots, "default")];
  }), _: 3 }, 8, ["class"])], 2);
};
var UD = _M("vue-line-wrapper"), D4 = { name: "LineWrapper", components: { DraggableElement: Qu }, props: { position: { type: String, required: !0 }, disabled: { type: Boolean, default: !1 } }, computed: { classname: function() {
  var M;
  return UD((XM(M = {}, this.position, !0), XM(M, "disabled", this.disabled), M));
} }, emits: ["leave", "enter", "drag", "drag-end"] };
D4.render = function(M, e, t, i, u, N) {
  var l = AM("DraggableElement");
  return c(), k(l, { class: N.classname, onDrag: e[1] || (e[1] = function(n) {
    return M.$emit("drag", n);
  }), onDragEnd: e[2] || (e[2] = function(n) {
    return M.$emit("drag-end");
  }), onLeave: e[3] || (e[3] = function(n) {
    return M.$emit("leave");
  }), onEnter: e[4] || (e[4] = function(n) {
    return M.$emit("enter");
  }) }, { default: O(function() {
    return [J(M.$slots, "default")];
  }), _: 3 }, 8, ["class"]);
};
var Me = ["left", "right", "top", "bottom"], QD = ["left", "right"], VD = ["top", "bottom"], WD = ["left", "top"], fD = ["fill-area", "fit-area", "stencil", "none"], S0 = { left: 0, top: 0, width: 0, height: 0 };
function Z0(M, e, t) {
  return !(t = t || ["width", "height", "left", "top"]).some(function(i) {
    return M[i] !== e[i];
  });
}
function le(M) {
  return { left: M.left, top: M.top, right: M.left + M.width, bottom: M.top + M.height };
}
function _e(M, e) {
  return { left: M.left - e.left, top: M.top - e.top };
}
function kM(M) {
  return { left: M.left + M.width / 2, top: M.top + M.height / 2 };
}
function At(M, e) {
  var t = { left: 0, top: 0, right: 0, bottom: 0 };
  return Me.forEach(function(i) {
    var u = e[i], N = le(M)[i];
    t[i] = u !== void 0 && N !== void 0 ? i === "left" || i === "top" ? Math.max(0, u - N) : Math.max(0, N - u) : 0;
  }), t;
}
function $M(M, e) {
  return { left: M.left - e.left, top: M.top - e.top, width: M.width + e.left + e.right, height: M.height + e.top + e.bottom };
}
function ni(M) {
  return { left: -M.left, top: -M.top };
}
function GM(M, e) {
  return _(_({}, M), { left: M.left + e.left, top: M.top + e.top });
}
function JM(M, e, t, i) {
  if (e !== 1) {
    if (t) {
      var u = kM(M);
      return { width: M.width * e, height: M.height * e, left: M.left + M.width * (1 - e) / 2 + (t.left - u.left) * (i || 1 - e), top: M.top + M.height * (1 - e) / 2 + (t.top - u.top) * (i || 1 - e) };
    }
    return { width: M.width * e, height: M.height * e, left: M.left + M.width * (1 - e) / 2, top: M.top + M.height * (1 - e) / 2 };
  }
  return M;
}
function TM(M) {
  return M.width / M.height;
}
function $e(M, e) {
  return Math.min(e.right !== void 0 && e.left !== void 0 ? (e.right - e.left) / M.width : 1 / 0, e.bottom !== void 0 && e.top !== void 0 ? (e.bottom - e.top) / M.height : 1 / 0);
}
function qe(M, e) {
  var t = { left: 0, top: 0 }, i = At(M, e);
  return i.left && i.left > 0 ? t.left = i.left : i.right && i.right > 0 && (t.left = -i.right), i.top && i.top > 0 ? t.top = i.top : i.bottom && i.bottom > 0 && (t.top = -i.bottom), t;
}
function hi(M, e) {
  var t;
  return e.minimum && M < e.minimum ? t = e.minimum : e.maximum && M > e.maximum && (t = e.maximum), t;
}
function r4(M, e) {
  var t = TM(M), i = TM(e);
  return e.width < 1 / 0 && e.height < 1 / 0 ? t > i ? { width: e.width, height: e.width / t } : { width: e.height * t, height: e.height } : e.width < 1 / 0 ? { width: e.width, height: e.width / t } : e.height < 1 / 0 ? { width: e.height * t, height: e.height } : M;
}
function g4(M, e) {
  var t = e * Math.PI / 180;
  return { width: Math.abs(M.width * Math.cos(t)) + Math.abs(M.height * Math.sin(t)), height: Math.abs(M.width * Math.sin(t)) + Math.abs(M.height * Math.cos(t)) };
}
function Le(M, e) {
  var t = e * Math.PI / 180;
  return { left: M.left * Math.cos(t) - M.top * Math.sin(t), top: M.left * Math.sin(t) + M.top * Math.cos(t) };
}
function si(M, e) {
  var t = At(bM(M, e), e);
  return t.left + t.right + t.top + t.bottom ? t.left + t.right > t.top + t.bottom ? Math.min((M.width + t.left + t.right) / M.width, $e(M, e)) : Math.min((M.height + t.top + t.bottom) / M.height, $e(M, e)) : 1;
}
function bM(M, e, t) {
  t === void 0 && (t = !1);
  var i = qe(M, e);
  return GM(M, t ? ni(i) : i);
}
function iu(M) {
  return { width: M.right !== void 0 && M.left !== void 0 ? M.right - M.left : 1 / 0, height: M.bottom !== void 0 && M.top !== void 0 ? M.bottom - M.top : 1 / 0 };
}
function vD(M, e) {
  return _(_({}, M), { minWidth: Math.min(e.width, M.minWidth), minHeight: Math.min(e.height, M.minHeight), maxWidth: Math.min(e.width, M.maxWidth), maxHeight: Math.min(e.height, M.maxHeight) });
}
function L4(M, e, t) {
  t === void 0 && (t = !0);
  var i = {};
  return Me.forEach(function(u) {
    var N = M[u], l = e[u];
    N !== void 0 && l !== void 0 ? i[u] = u === "left" || u === "top" ? t ? Math.max(N, l) : Math.min(N, l) : t ? Math.min(N, l) : Math.max(N, l) : l !== void 0 ? i[u] = l : N !== void 0 && (i[u] = N);
  }), i;
}
function oi(M, e) {
  return L4(M, e, !0);
}
function k0(M) {
  var e = M.size, t = M.aspectRatio, i = M.ignoreMinimum, u = M.sizeRestrictions;
  return !!((e.correctRatio || TM(e) >= t.minimum && TM(e) <= t.maximum) && e.height <= u.maxHeight && e.width <= u.maxWidth && e.width && e.height && (i || e.height >= u.minHeight && e.width >= u.minWidth));
}
function b0(M, e) {
  return Math.pow(M.width - e.width, 2) + Math.pow(M.height - e.height, 2);
}
function je(M) {
  var e = M.width, t = M.height, i = M.sizeRestrictions, u = { minimum: M.aspectRatio && M.aspectRatio.minimum || 0, maximum: M.aspectRatio && M.aspectRatio.maximum || 1 / 0 }, N = { width: Math.max(i.minWidth, Math.min(i.maxWidth, e)), height: Math.max(i.minHeight, Math.min(i.maxHeight, t)) };
  function l(a, o) {
    return o === void 0 && (o = !1), a.reduce(function(j, D) {
      return k0({ size: D, aspectRatio: u, sizeRestrictions: i, ignoreMinimum: o }) && (!j || b0(D, { width: e, height: t }) < b0(j, { width: e, height: t })) ? D : j;
    }, null);
  }
  var n = [];
  u && [u.minimum, u.maximum].forEach(function(a) {
    a && n.push({ width: N.width, height: N.width / a, correctRatio: !0 }, { width: N.height * a, height: N.height, correctRatio: !0 });
  }), k0({ size: N, aspectRatio: u, sizeRestrictions: i }) && n.push(N);
  var s = l(n) || l(n, !0);
  return s && { width: s.width, height: s.height };
}
function uu(M) {
  var e = M.event, t = M.coordinates, i = M.positionRestrictions, u = i === void 0 ? {} : i, N = GM(t, e.directions);
  return GM(N, qe(N, u));
}
function GD(M) {
  var e = M.coordinates, t = M.transform, i = M.imageSize, u = M.sizeRestrictions, N = M.positionRestrictions, l = M.aspectRatio, n = M.visibleArea, s = function(o, j) {
    return uu({ coordinates: o, positionRestrictions: N, event: new Uu({ left: j.left - o.left, top: j.top - o.top }) });
  }, a = _({}, e);
  return (Array.isArray(t) ? t : [t]).forEach(function(o) {
    var j = {};
    wM((j = typeof o == "function" ? o({ coordinates: a, imageSize: i, visibleArea: n }) : o).width) && wM(j.height) || (a = function(D, r) {
      var I = _(_(_({}, D), je({ width: r.width, height: r.height, sizeRestrictions: u, aspectRatio: l })), { left: 0, top: 0 });
      return s(I, { left: D.left, top: D.top });
    }(a, _(_({}, a), j))), wM(j.left) && wM(j.top) || (a = s(a, _(_({}, a), j)));
  }), a;
}
function RD(M) {
  M.event;
  var e = M.getAreaRestrictions, t = M.boundaries, i = M.coordinates, u = M.visibleArea;
  M.aspectRatio;
  var N = M.stencilSize, l = M.sizeRestrictions, n = M.positionRestrictions;
  M.stencilReference;
  var s, a, o, j = _({}, i), D = _({}, u), r = _({}, N);
  s = TM(r), a = TM(j), o === void 0 && (o = 1e-3), (s === 0 || a === 0 ? Math.abs(a - s) < o : Math.abs(a / s) < 1 + o && Math.abs(a / s) > 1 - o) || (j = _(_({}, j), je({ sizeRestrictions: l, width: j.width, height: j.height, aspectRatio: { minimum: TM(r), maximum: TM(r) } })));
  var I = si(D = JM(D, j.width * t.width / (D.width * r.width)), e({ visibleArea: D, type: "resize" }));
  return I !== 1 && (D = JM(D, I), j = JM(j, I)), D = bM(D = GM(D, _e(kM(j), kM(D))), e({ visibleArea: D, type: "move" })), { coordinates: j = bM(j, oi(le(D), n)), visibleArea: D };
}
function FD(M) {
  var e = M.event, t = M.getAreaRestrictions, i = M.boundaries, u = M.coordinates, N = M.visibleArea;
  M.aspectRatio, M.stencilSize, M.sizeRestrictions;
  var l = M.positionRestrictions;
  M.stencilReference;
  var n = _({}, u), s = _({}, N);
  if (u && N && e.type !== "manipulateImage") {
    var a = { width: 0, height: 0 };
    s.width, i.width, TM(i) > TM(n) ? (a.height = 0.8 * i.height, a.width = a.height * TM(n)) : (a.width = 0.8 * i.width, a.height = a.width * TM(n));
    var o = si(s = JM(s, n.width * i.width / (s.width * a.width)), t({ visibleArea: s, type: "resize" }));
    s = JM(s, o), o !== 1 && (a.height /= o, a.width /= o), s = bM(s = GM(s, _e(kM(n), kM(s))), t({ visibleArea: s, type: "move" })), n = bM(n, oi(le(s), l));
  }
  return { coordinates: n, visibleArea: s };
}
function XD(M) {
  var e = M.event, t = M.coordinates, i = M.visibleArea, u = M.getAreaRestrictions, N = _({}, i), l = _({}, t);
  if (e.type === "setCoordinates") {
    var n = Math.max(0, l.width - N.width), s = Math.max(0, l.height - N.height);
    n > s ? N = JM(N, Math.min(l.width / N.width, $e(N, u({ visibleArea: N, type: "resize" })))) : s > n && (N = JM(N, Math.min(l.height / N.height, $e(N, u({ visibleArea: N, type: "resize" }))))), N = bM(N = GM(N, ni(qe(l, le(N)))), u({ visibleArea: N, type: "move" }));
  }
  return { visibleArea: N, coordinates: l };
}
function JD(M) {
  var e = M.imageSize, t = M.visibleArea, i = M.coordinates, u = t || e;
  return { left: (t ? t.left : 0) + u.width / 2 - i.width / 2, top: (t ? t.top : 0) + u.height / 2 - i.height / 2 };
}
function KD(M) {
  var e = M.imageSize, t = M.visibleArea, i = M.aspectRatio, u = M.sizeRestrictions, N = t || e, l = Math.min(i.maximum || 1 / 0, Math.max(i.minimum || 0, TM(N))), n = N.width < N.height ? { width: 0.8 * N.width, height: 0.8 * N.width / l } : { height: 0.8 * N.height, width: 0.8 * N.height * l };
  return je(_(_({}, n), { aspectRatio: i, sizeRestrictions: u }));
}
function BD(M) {
  var e, t, i = M.imageSize, u = M.visibleArea, N = M.boundaries, l = M.aspectRatio, n = M.sizeRestrictions, s = M.stencilSize, a = u || i;
  return TM(a) > TM(N) ? t = (e = s.height * a.height / N.height) * TM(s) : e = (t = s.width * a.width / N.width) / TM(s), je({ width: t, height: e, aspectRatio: l, sizeRestrictions: n });
}
function HD(M) {
  var e = M.getAreaRestrictions, t = M.coordinates, i = M.imageSize, u = TM(M.boundaries);
  if (t) {
    var N = { height: Math.max(t.height, i.height), width: Math.max(t.width, i.width) }, l = r4({ width: TM(N) > u ? N.width : N.height * u, height: TM(N) > u ? N.width / u : N.height }, iu(e())), n = { left: t.left + t.width / 2 - l.width / 2, top: t.top + t.height / 2 - l.height / 2, width: l.width, height: l.height }, s = At(t, le(_({ left: 0, top: 0 }, i))), a = {};
    return !s.left && !s.right && n.width <= i.width && (a.left = 0, a.right = i.width), !s.top && !s.bottom && n.height <= i.height && (a.top = 0, a.bottom = i.height), bM(n, a);
  }
  var o = TM(i);
  return l = { height: o > u ? i.height : i.width / u, width: o > u ? i.height * u : i.width }, { left: i.width / 2 - l.width / 2, top: i.height / 2 - l.height / 2, width: l.width, height: l.height };
}
function Ut(M, e) {
  return L4(M, le(e));
}
function PD(M) {
  var e = M.event, t = M.coordinates, i = M.visibleArea, u = M.sizeRestrictions, N = M.getAreaRestrictions, l = M.positionRestrictions, n = M.adjustStencil, s = e.scale, a = e.move, o = _({}, i), j = _({}, t), D = 1, r = 1, I = s.factor && Math.abs(s.factor - 1) > 1e-3;
  o = GM(o, { left: a.left || 0, top: a.top || 0 });
  var L = { stencil: { minimum: Math.max(u.minWidth ? u.minWidth / j.width : 0, u.minHeight ? u.minHeight / j.height : 0), maximum: Math.min(u.maxWidth ? u.maxWidth / j.width : 1 / 0, u.maxHeight ? u.maxHeight / j.height : 1 / 0, $e(j, l)) }, area: { maximum: $e(o, N({ visibleArea: o, type: "resize" })) } };
  s.factor && I && (s.factor < 1 ? (r = Math.max(s.factor, L.stencil.minimum)) > 1 && (r = 1) : s.factor > 1 && (r = Math.min(s.factor, Math.min(L.area.maximum, L.stencil.maximum))) < 1 && (r = 1)), r && (o = JM(o, r, s.center));
  var d = t.left - i.left, m = i.width + i.left - (t.width + t.left), x = t.top - i.top, C = i.height + i.top - (t.height + t.top);
  return o = bM(o = GM(o, qe(o, { left: l.left !== void 0 ? l.left - d * r : void 0, top: l.top !== void 0 ? l.top - x * r : void 0, bottom: l.bottom !== void 0 ? l.bottom + C * r : void 0, right: l.right !== void 0 ? l.right + m * r : void 0 })), N({ visibleArea: o, type: "move" })), j.width = j.width * r, j.height = j.height * r, j.left = o.left + d * r, j.top = o.top + x * r, j = bM(j, oi(le(o), l)), s.factor && I && n && (s.factor > 1 ? D = Math.min(L.area.maximum, s.factor) / r : s.factor < 1 && (D = Math.max(j.height / o.height, j.width / o.width, s.factor / r)), D !== 1 && (o = GM(o = bM(o = JM(o, D, s.factor > 1 ? s.center : kM(j)), N({ visibleArea: o, type: "move" })), ni(qe(j, le(o)))))), { coordinates: j, visibleArea: o };
}
function _D(M) {
  var e = M.aspectRatio, t = M.getAreaRestrictions, i = M.coordinates, u = M.visibleArea, N = M.sizeRestrictions, l = M.positionRestrictions, n = M.imageSize, s = M.previousImageSize, a = M.angle, o = _({}, i), j = _({}, u), D = Le(kM(_({ left: 0, top: 0 }, s)), a);
  return (o = _(_({}, je({ sizeRestrictions: N, aspectRatio: e, width: o.width, height: o.height })), Le(kM(o), a))).left -= D.left - n.width / 2 + o.width / 2, o.top -= D.top - n.height / 2 + o.height / 2, j = JM(j, si(j, t({ visibleArea: j, type: "resize" }))), { coordinates: o = bM(o, l), visibleArea: j = bM(j = GM(j, _e(kM(o), kM(i))), t({ visibleArea: j, type: "move" })) };
}
function $D(M) {
  var e = M.flip, t = M.previousFlip, i = M.rotate;
  M.aspectRatio;
  var u = M.getAreaRestrictions, N = M.coordinates, l = M.visibleArea, n = M.imageSize, s = _({}, N), a = _({}, l), o = t.horizontal !== e.horizontal, j = t.vertical !== e.vertical;
  if (o || j) {
    var D = Le({ left: n.width / 2, top: n.height / 2 }, -i), r = Le(kM(s), -i), I = Le({ left: o ? D.left - (r.left - D.left) : r.left, top: j ? D.top - (r.top - D.top) : r.top }, i);
    s = GM(s, _e(I, kM(s))), r = Le(kM(a), -i), a = bM(a = GM(a, _e(I = Le({ left: o ? D.left - (r.left - D.left) : r.left, top: j ? D.top - (r.top - D.top) : r.top }, i), kM(a))), u({ visibleArea: a, type: "move" }));
  }
  return { coordinates: s, visibleArea: a };
}
function U0(M) {
  var e = M.directions, t = M.coordinates, i = M.positionRestrictions, u = i === void 0 ? {} : i, N = M.sizeRestrictions, l = M.preserveRatio, n = M.compensate, s = _({}, e), a = $M(t, s).width, o = $M(t, s).height;
  a < 0 && (s.left < 0 && s.right < 0 ? (s.left = -(t.width - N.minWidth) / (s.left / s.right), s.right = -(t.width - N.minWidth) / (s.right / s.left)) : s.left < 0 ? s.left = -(t.width - N.minWidth) : s.right < 0 && (s.right = -(t.width - N.minWidth))), o < 0 && (s.top < 0 && s.bottom < 0 ? (s.top = -(t.height - N.minHeight) / (s.top / s.bottom), s.bottom = -(t.height - N.minHeight) / (s.bottom / s.top)) : s.top < 0 ? s.top = -(t.height - N.minHeight) : s.bottom < 0 && (s.bottom = -(t.height - N.minHeight)));
  var j = At($M(t, s), u);
  n && (j.left && j.left > 0 && j.right === 0 ? (s.right += j.left, s.left -= j.left) : j.right && j.right > 0 && j.left === 0 && (s.left += j.right, s.right -= j.right), j.top && j.top > 0 && j.bottom === 0 ? (s.bottom += j.top, s.top -= j.top) : j.bottom && j.bottom > 0 && j.top === 0 && (s.top += j.bottom, s.bottom -= j.bottom), j = At($M(t, s), u));
  var D = { width: 1 / 0, height: 1 / 0, left: 1 / 0, right: 1 / 0, top: 1 / 0, bottom: 1 / 0 };
  if (Me.forEach(function(L) {
    var d = j[L];
    d && s[L] && (D[L] = Math.max(0, 1 - d / s[L]));
  }), l) {
    var r = Math.min.apply(null, Me.map(function(L) {
      return D[L];
    }));
    r !== 1 / 0 && Me.forEach(function(L) {
      s[L] *= r;
    });
  } else
    Me.forEach(function(L) {
      D[L] !== 1 / 0 && (s[L] *= D[L]);
    });
  if (a = $M(t, s).width, o = $M(t, s).height, s.right + s.left && (a > N.maxWidth ? D.width = (N.maxWidth - t.width) / (s.right + s.left) : a < N.minWidth && (D.width = (N.minWidth - t.width) / (s.right + s.left))), s.bottom + s.top && (o > N.maxHeight ? D.height = (N.maxHeight - t.height) / (s.bottom + s.top) : o < N.minHeight && (D.height = (N.minHeight - t.height) / (s.bottom + s.top))), l) {
    var I = Math.min(D.width, D.height);
    I !== 1 / 0 && Me.forEach(function(L) {
      s[L] *= I;
    });
  } else
    D.width !== 1 / 0 && QD.forEach(function(L) {
      s[L] *= D.width;
    }), D.height !== 1 / 0 && VD.forEach(function(L) {
      s[L] *= D.height;
    });
  return s;
}
function Qt(M, e, t) {
  return e == 0 && t == 0 ? M / 2 : e == 0 ? 0 : t == 0 ? M : M * Math.abs(e / (e + t));
}
var qD = _M("vue-simple-handler"), Mr = _M("vue-simple-handler-wrapper"), Vu = { name: "SimpleHandler", components: { HandlerWrapper: c4 }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  var M, e = (XM(M = {}, this.horizontalPosition, !!this.horizontalPosition), XM(M, this.verticalPosition, !!this.verticalPosition), XM(M, "".concat(this.horizontalPosition, "-").concat(this.verticalPosition), !!(this.verticalPosition && this.horizontalPosition)), XM(M, "hover", this.hover), M);
  return { default: hM(qD(e), this.defaultClass, this.hover && this.hoverClass), wrapper: hM(Mr(e), this.wrapperClass) };
} }, methods: { onDrag: function(M) {
  this.$emit("drag", M);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
Vu.render = function(M, e, t, i, u, N) {
  var l = AM("HandlerWrapper");
  return c(), k(l, { class: N.classes.wrapper, "vertical-position": t.verticalPosition, "horizontal-position": t.horizontalPosition, disabled: t.disabled, onDrag: N.onDrag, onDragEnd: N.onDragEnd, onEnter: N.onEnter, onLeave: N.onLeave }, { default: O(function() {
    return [z("div", { class: N.classes.default }, null, 2)];
  }), _: 1 }, 8, ["class", "vertical-position", "horizontal-position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var er = _M("vue-simple-line"), tr = _M("vue-simple-line-wrapper"), Wu = { name: "SimpleLine", components: { LineWrapper: D4 }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, position: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  return { root: hM(er(XM({}, this.position, !0)), this.defaultClass, this.hover && this.hoverClass), wrapper: hM(tr(XM({}, this.position, !0)), this.wrapperClass) };
} }, methods: { onDrag: function(M) {
  this.$emit("drag", M);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
Wu.render = function(M, e, t, i, u, N) {
  var l = AM("LineWrapper");
  return c(), k(l, { class: N.classes.wrapper, position: t.position, disabled: t.disabled, onDrag: N.onDrag, onDragEnd: N.onDragEnd, onEnter: N.onEnter, onLeave: N.onLeave }, { default: O(function() {
    return [z("div", { class: N.classes.root }, null, 2)];
  }), _: 1 }, 8, ["class", "position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var Ci = _M("vue-bounding-box"), ir = ["east", "west", null], ur = ["south", "north", null], I4 = { name: "BoundingBox", props: { width: { type: Number }, height: { type: Number }, transitions: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, north: !0, westNorth: !0, west: !0, westSouth: !0, south: !0, eastSouth: !0, east: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return Vu;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object, default: function() {
  return { west: !0, north: !0, east: !0, south: !0 };
} }, linesComponent: { type: [Object, String], default: function() {
  return Wu;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, resizable: { type: Boolean, default: !0 } }, data: function() {
  var M = [];
  return ir.forEach(function(e) {
    ur.forEach(function(t) {
      if (e !== t) {
        var i = o4(e, t), u = i.name, N = i.classname;
        M.push({ name: u, classname: N, verticalDirection: t, horizontalDirection: e });
      }
    });
  }), { points: M };
}, computed: { style: function() {
  var M = {};
  return this.width && this.height && (M.width = "".concat(this.width, "px"), M.height = "".concat(this.height, "px"), this.transitions && this.transitions.enabled && (M.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction))), M;
}, classes: function() {
  var M = this.handlersClasses, e = this.handlersWrappersClasses, t = this.linesClasses, i = this.linesWrappersClasses;
  return { root: Ci(), handlers: M, handlersWrappers: e, lines: t, linesWrappers: i };
}, lineNodes: function() {
  var M = this, e = [];
  return this.points.forEach(function(t) {
    t.horizontalDirection && t.verticalDirection || !M.lines[t.name] || e.push({ name: t.name, component: M.linesComponent, class: hM(M.classes.lines.default, M.classes.lines[t.name], !M.resizable && M.classes.lines.disabled), wrapperClass: hM(M.classes.linesWrappers.default, M.classes.linesWrappers[t.name], !M.resizable && M.classes.linesWrappers.disabled), hoverClass: M.classes.lines.hover, verticalDirection: t.verticalDirection, horizontalDirection: t.horizontalDirection, disabled: !M.resizable });
  }), e;
}, handlerNodes: function() {
  var M = this, e = [], t = this.width, i = this.height;
  return this.points.forEach(function(u) {
    if (M.handlers[u.name]) {
      var N = { name: u.name, component: M.handlersComponent, class: hM(M.classes.handlers.default, M.classes.handlers[u.name]), wrapperClass: hM(M.classes.handlersWrappers.default, M.classes.handlersWrappers[u.name]), hoverClass: M.classes.handlers.hover, verticalDirection: u.verticalDirection, horizontalDirection: u.horizontalDirection, disabled: !M.resizable };
      if (t && i) {
        var l = u.horizontalDirection, n = u.verticalDirection, s = l === "east" ? t : l === "west" ? 0 : t / 2, a = n === "south" ? i : n === "north" ? 0 : i / 2;
        N.wrapperClass = Ci("handler"), N.wrapperStyle = { transform: "translate(".concat(s, "px, ").concat(a, "px)") }, M.transitions && M.transitions.enabled && (N.wrapperStyle.transition = "".concat(M.transitions.time, "ms ").concat(M.transitions.timingFunction));
      } else
        N.wrapperClass = Ci("handler", XM({}, u.classname, !0));
      e.push(N);
    }
  }), e;
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [];
}, methods: { onEnd: function() {
  this.$emit("resize-end");
}, onHandlerDrag: function(M, e, t) {
  var i, u = M.shift(), N = u.left, l = u.top, n = { left: 0, right: 0, top: 0, bottom: 0 };
  e === "west" ? n.left -= N : e === "east" && (n.right += N), t === "north" ? n.top -= l : t === "south" && (n.bottom += l), !t && e ? i = "width" : t && !e && (i = "height"), this.resizable && this.$emit("resize", new kD(n, { allowedDirections: { left: e === "west" || !e, right: e === "east" || !e, bottom: t === "south" || !t, top: t === "north" || !t }, preserveAspectRatio: M.nativeEvent && M.nativeEvent.shiftKey, respectDirection: i }));
} }, emits: ["resize", "resize-end"] };
I4.render = function(M, e, t, i, u, N) {
  return c(), k("div", { ref: "box", class: N.classes.root, style: N.style }, [J(M.$slots, "default"), z("div", null, [(c(!0), k(K, null, lM(N.lineNodes, function(l) {
    return c(), k(cM(l.component), { key: l.name, "default-class": l.class, "hover-class": l.hoverClass, "wrapper-class": l.wrapperClass, position: l.name, disabled: l.disabled, onDrag: function(n) {
      return N.onHandlerDrag(n, l.horizontalDirection, l.verticalDirection);
    }, onDragEnd: e[1] || (e[1] = function(n) {
      return N.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "position", "disabled", "onDrag"]);
  }), 128))]), (c(!0), k(K, null, lM(N.handlerNodes, function(l) {
    return c(), k("div", { key: l.name, style: l.wrapperStyle, class: l.wrapperClass }, [(c(), k(cM(l.component), { "default-class": l.class, "hover-class": l.hoverClass, "wrapper-class": l.wrapperClass, "horizontal-position": l.horizontalDirection, "vertical-position": l.verticalDirection, disabled: l.disabled, onDrag: function(n) {
      return N.onHandlerDrag(n, l.horizontalDirection, l.verticalDirection);
    }, onDragEnd: e[2] || (e[2] = function(n) {
      return N.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "horizontal-position", "vertical-position", "disabled", "onDrag"]))], 6);
  }), 128))], 6);
};
var Nr = _M("vue-draggable-area"), d4 = { name: "DraggableArea", props: { movable: { type: Boolean, default: !0 }, activationDistance: { type: Number, default: 20 } }, computed: { classnames: function() {
  return { default: Nr() };
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [], this.touchStarted = !1;
}, methods: { onTouchStart: function(M) {
  if (M.cancelable) {
    var e = this.movable && M.touches.length === 1;
    e && (this.touches = Qe(M.touches)), (this.touchStarted || e) && (M.preventDefault(), M.stopPropagation());
  }
}, onTouchEnd: function() {
  this.touchStarted = !1, this.processEnd();
}, onTouchMove: function(M) {
  this.touches.length >= 1 && (this.touchStarted ? (this.processMove(M, M.touches), M.preventDefault(), M.stopPropagation()) : T4({ x: this.touches[0].clientX, y: this.touches[0].clientY }, { x: M.touches[0].clientX, y: M.touches[0].clientY }) > this.activationDistance && (this.initAnchor({ clientX: M.touches[0].clientX, clientY: M.touches[0].clientY }), this.touchStarted = !0));
}, onMouseDown: function(M) {
  if (this.movable && M.button === 0) {
    var e = { fake: !0, clientX: M.clientX, clientY: M.clientY };
    this.touches = [e], this.initAnchor(e), M.stopPropagation();
  }
}, onMouseMove: function(M) {
  this.touches.length && (this.processMove(M, [{ fake: !0, clientX: M.clientX, clientY: M.clientY }]), M.preventDefault && M.cancelable && M.preventDefault(), M.stopPropagation());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(M) {
  var e = this.$refs.container.getBoundingClientRect(), t = e.left, i = e.top;
  this.anchor = { x: M.clientX - t, y: M.clientY - i };
}, processMove: function(M, e) {
  var t = Qe(e);
  if (this.touches.length) {
    var i = this.$refs.container.getBoundingClientRect(), u = i.left, N = i.top;
    this.touches.length === 1 && t.length === 1 && this.$emit("move", new Uu({ left: t[0].clientX - (u + this.anchor.x), top: t[0].clientY - (N + this.anchor.y) }));
  }
}, processEnd: function() {
  this.touches.length && this.$emit("move-end"), this.touches = [];
} }, emits: ["move", "move-end"] };
d4.render = function(M, e, t, i, u, N) {
  return c(), k("div", { ref: "container", onTouchstart: e[1] || (e[1] = function() {
    return N.onTouchStart && N.onTouchStart.apply(N, arguments);
  }), onMousedown: e[2] || (e[2] = function() {
    return N.onMouseDown && N.onMouseDown.apply(N, arguments);
  }) }, [J(M.$slots, "default")], 544);
};
function Oi(M) {
  var e, t;
  return { rotate: M.rotate || 0, flip: { horizontal: ((e = M == null ? void 0 : M.flip) === null || e === void 0 ? void 0 : e.horizontal) || !1, vertical: ((t = M == null ? void 0 : M.flip) === null || t === void 0 ? void 0 : t.vertical) || !1 } };
}
function lr(M) {
  return new Promise(function(e, t) {
    try {
      if (M)
        if (/^data:/i.test(M))
          e(function(s) {
            s = s.replace(/^data:([^;]+);base64,/gim, "");
            for (var a = atob(s), o = a.length, j = new ArrayBuffer(o), D = new Uint8Array(j), r = 0; r < o; r++)
              D[r] = a.charCodeAt(r);
            return j;
          }(M));
        else if (/^blob:/i.test(M)) {
          var i = new FileReader();
          i.onload = function(s) {
            e(s.target.result);
          }, N = M, l = function(s) {
            i.readAsArrayBuffer(s);
          }, (n = new XMLHttpRequest()).open("GET", N, !0), n.responseType = "blob", n.onload = function() {
            this.status != 200 && this.status !== 0 || l(this.response);
          }, n.send();
        } else {
          var u = new XMLHttpRequest();
          u.onreadystatechange = function() {
            u.readyState === 4 && (u.status === 200 || u.status === 0 ? e(u.response) : t("Warning: could not load an image to parse its orientation"), u = null);
          }, u.onprogress = function() {
            u.getResponseHeader("content-type") !== "image/jpeg" && u.abort();
          }, u.withCredentials = !1, u.open("GET", M, !0), u.responseType = "arraybuffer", u.send(null);
        }
      else
        t("Error: the image is empty");
    } catch (s) {
      t(s);
    }
    var N, l, n;
  });
}
function y4(M) {
  var e = M.rotate, t = M.flip, i = M.scaleX, u = M.scaleY, N = "";
  return N += " rotate(" + e + "deg) ", N += " scaleX(" + i * (t.horizontal ? -1 : 1) + ") ", N += " scaleY(" + u * (t.vertical ? -1 : 1) + ") ";
}
function nr(M) {
  try {
    var e, t = new DataView(M), i = void 0, u = void 0, N = void 0, l = void 0;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var n = t.byteLength, s = 2; s + 1 < n; ) {
        if (t.getUint8(s) === 255 && t.getUint8(s + 1) === 225) {
          N = s;
          break;
        }
        s++;
      }
    if (N && (i = N + 10, function(r, I, L) {
      var d, m = "";
      for (d = I, L += I; d < L; d++)
        m += String.fromCharCode(r.getUint8(d));
      return m;
    }(t, N + 4, 4) === "Exif")) {
      var a = t.getUint16(i);
      if (((u = a === 18761) || a === 19789) && t.getUint16(i + 2, u) === 42) {
        var o = t.getUint32(i + 4, u);
        o >= 8 && (l = i + o);
      }
    }
    if (l) {
      for (var j = t.getUint16(l, u), D = 0; D < j; D++)
        if (s = l + 12 * D + 2, t.getUint16(s, u) === 274) {
          s += 8, e = t.getUint16(s, u), t.setUint16(s, 1, u);
          break;
        }
    }
    return e;
  } catch {
    return null;
  }
}
function Q0(M, e) {
  var t = e.getBoundingClientRect(), i = t.left, u = t.top, N = { left: 0, top: 0 }, l = 0;
  return M.forEach(function(n) {
    N.left += (n.clientX - i) / M.length, N.top += (n.clientY - u) / M.length;
  }), M.forEach(function(n) {
    l += T4({ x: N.left, y: N.top }, { x: n.clientX - i, y: n.clientY - u });
  }), { centerMass: N, spread: l, count: M.length };
}
var z4 = { props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 }, eventsFilter: { type: Function, required: !1 } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, created: function() {
  this.transforming = !1, this.debouncedProcessEnd = eu(this.processEnd), this.touches = [];
}, methods: { processMove: function(M, e) {
  if (this.touches.length) {
    if (this.touches.length === 1 && e.length === 1)
      this.$emit("move", new ct({ left: this.touches[0].clientX - e[0].clientX, top: this.touches[0].clientY - e[0].clientY }));
    else if (this.touches.length > 1 && this.touchResize) {
      var t = Q0(e, this.$refs.container), i = this.oldGeometricProperties;
      i.count === t.count && i.count > 1 && this.$emit("resize", new ct({ left: i.centerMass.left - t.centerMass.left, top: i.centerMass.top - t.centerMass.top }, { factor: i.spread / t.spread, center: t.centerMass })), this.oldGeometricProperties = t;
    }
    this.touches = e;
  }
}, processEnd: function() {
  this.transforming && (this.transforming = !1, this.$emit("transform-end"));
}, processStart: function() {
  this.transforming = !0, this.debouncedProcessEnd.clear();
}, processEvent: function(M) {
  return this.eventsFilter ? this.eventsFilter(M, this.transforming) !== !1 : (M.preventDefault(), M.stopPropagation(), !0);
}, onTouchStart: function(M) {
  if (M.cancelable && (this.touchMove || this.touchResize && M.touches.length > 1) && this.processEvent(M)) {
    var e = this.$refs.container, t = e.getBoundingClientRect(), i = t.left, u = t.top, N = t.bottom, l = t.right;
    this.touches = Qe(M.touches).filter(function(n) {
      return n.clientX > i && n.clientX < l && n.clientY > u && n.clientY < N;
    }), this.oldGeometricProperties = Q0(this.touches, e);
  }
}, onTouchEnd: function(M) {
  M.touches.length === 0 && (this.touches = [], this.processEnd());
}, onTouchMove: function(M) {
  var e = this;
  if (this.touches.length) {
    var t = Qe(M.touches).filter(function(i) {
      return !i.identifier || e.touches.find(function(u) {
        return u.identifier === i.identifier;
      });
    });
    this.processEvent(M) && (this.processMove(M, t), this.processStart());
  }
}, onMouseDown: function(M) {
  if (this.mouseMove && "buttons" in M && M.buttons === 1 && this.processEvent(M)) {
    var e = { fake: !0, clientX: M.clientX, clientY: M.clientY };
    this.touches = [e], this.processStart();
  }
}, onMouseMove: function(M) {
  this.touches.length && this.processEvent(M) && this.processMove(M, [{ clientX: M.clientX, clientY: M.clientY }]);
}, onMouseUp: function() {
  this.touches = [], this.processEnd();
}, onWheel: function(M) {
  if (this.wheelResize && this.processEvent(M)) {
    var e = this.$refs.container.getBoundingClientRect(), t = e.left, i = e.top, u = 1 + this.wheelResize.ratio * (l = M.deltaY || M.detail || M.wheelDelta, (n = +l) == 0 || j4(n) ? n : n > 0 ? 1 : -1), N = { left: M.clientX - t, top: M.clientY - i };
    this.$emit("resize", new ct({}, { factor: u, center: N })), this.touches.length || this.debouncedProcessEnd();
  }
  var l, n;
} }, emits: ["resize", "move", "transform-end"] };
z4.render = function(M, e, t, i, u, N) {
  return c(), k("div", { ref: "container", onTouchstart: e[1] || (e[1] = function() {
    return N.onTouchStart && N.onTouchStart.apply(N, arguments);
  }), onMousedown: e[2] || (e[2] = function() {
    return N.onMouseDown && N.onMouseDown.apply(N, arguments);
  }), onWheel: e[3] || (e[3] = function() {
    return N.onWheel && N.onWheel.apply(N, arguments);
  }) }, [J(M.$slots, "default")], 544);
};
var Nu = { components: { TransformableImage: z4 }, props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 } }, emits: ["resize", "move"] };
Nu.render = function(M, e, t, i, u, N) {
  var l = AM("transformable-image");
  return c(), k(l, { "touch-move": t.touchMove, "touch-resize": t.touchResize, "mouse-move": t.mouseMove, "wheel-resize": t.wheelResize, onMove: e[1] || (e[1] = function(n) {
    return M.$emit("move", n);
  }), onResize: e[2] || (e[2] = function(n) {
    return M.$emit("resize", n);
  }) }, { default: O(function() {
    return [J(M.$slots, "default")];
  }), _: 3 }, 8, ["touch-move", "touch-resize", "mouse-move", "wheel-resize"]);
};
var Vt = _M("vue-preview"), m4 = { props: { coordinates: { type: Object }, transitions: { type: Object }, image: { type: Object, default: function() {
  return {};
} }, imageClass: { type: String }, width: { type: Number }, height: { type: Number }, fill: { type: Boolean } }, data: function() {
  return { calculatedImageSize: { width: 0, height: 0 }, calculatedSize: { width: 0, height: 0 } };
}, computed: { classes: function() {
  return { root: Vt({ fill: this.fill }), wrapper: Vt("wrapper"), imageWrapper: Vt("image-wrapper"), image: hM(Vt("image"), this.imageClass) };
}, style: function() {
  if (this.fill)
    return {};
  var M = {};
  return this.width && (M.width = "".concat(this.size.width, "px")), this.height && (M.height = "".concat(this.size.height, "px")), this.transitions && this.transitions.enabled && (M.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), M;
}, wrapperStyle: function() {
  var M = { width: "".concat(this.size.width, "px"), height: "".concat(this.size.height, "px"), left: "calc(50% - ".concat(this.size.width / 2, "px)"), top: "calc(50% - ".concat(this.size.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (M.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), M;
}, imageStyle: function() {
  if (this.coordinates && this.image) {
    var M = this.coordinates.width / this.size.width, e = jM(jM({ rotate: 0, flip: { horizontal: !1, vertical: !1 } }, this.image.transforms), {}, { scaleX: 1 / M, scaleY: 1 / M }), t = this.imageSize.width, i = this.imageSize.height, u = g4({ width: t, height: i }, e.rotate), N = { width: "".concat(t, "px"), height: "".concat(i, "px"), left: "0px", top: "0px" }, l = { rotate: { left: (t - u.width) * e.scaleX / 2, top: (i - u.height) * e.scaleY / 2 }, scale: { left: (1 - e.scaleX) * t / 2, top: (1 - e.scaleY) * i / 2 } };
    return N.transform = `translate(
				`.concat(-this.coordinates.left / M - l.rotate.left - l.scale.left, "px,").concat(-this.coordinates.top / M - l.rotate.top - l.scale.top, "px) ") + y4(e), this.transitions && this.transitions.enabled && (N.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), N;
  }
  return {};
}, size: function() {
  return { width: this.width || this.calculatedSize.width, height: this.height || this.calculatedSize.height };
}, imageSize: function() {
  return { width: this.image.width || this.calculatedImageSize.width, height: this.image.height || this.calculatedImageSize.height };
} }, watch: { image: function(M) {
  (M.width || M.height) && this.onChangeImage();
} }, mounted: function() {
  var M = this;
  this.onChangeImage(), this.$refs.image.addEventListener("load", function() {
    M.refreshImage();
  }), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh);
}, methods: { refreshImage: function() {
  var M = this.$refs.image;
  this.calculatedImageSize.height = M.naturalHeight, this.calculatedImageSize.width = M.naturalWidth;
}, refresh: function() {
  var M = this.$refs.root;
  this.width || (this.calculatedSize.width = M.clientWidth), this.height || (this.calculatedSize.height = M.clientHeight);
}, onChangeImage: function() {
  var M = this.$refs.image;
  M && M.complete && this.refreshImage(), this.refresh();
} } };
m4.render = function(M, e, t, i, u, N) {
  return c(), k("div", { ref: "root", class: N.classes.root, style: N.style }, [z("div", { ref: "wrapper", class: N.classes.wrapper, style: N.wrapperStyle }, [CM(z("img", { ref: "image", src: t.image && t.image.src, class: N.classes.image, style: N.imageStyle }, null, 14, ["src"]), [[WM, t.image && t.image.src]])], 6)], 6);
};
var A4 = { components: { Preview: m4 }, inheritAttrs: !1 };
A4.render = function(M, e, t, i, u, N) {
  var l = AM("preview");
  return c(), k(l, DM(M.$attrs, { fill: !0 }), null, 16);
};
var pi = _M("vue-rectangle-stencil"), x4 = { name: "RectangleStencil", components: { StencilPreview: A4, BoundingBox: I4, DraggableArea: d4 }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object }, handlersComponent: { type: [Object, String], default: function() {
  return Vu;
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return Wu;
} }, aspectRatio: { type: [Number, String] }, minAspectRatio: { type: [Number, String] }, maxAspectRatio: { type: [Number, String] }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: hM(pi({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: hM(pi("preview"), this.previewClass), boundingBox: hM(pi("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var M = this.stencilCoordinates, e = M.height, t = M.width, i = M.left, u = M.top, N = { width: "".concat(t, "px"), height: "".concat(e, "px"), transform: "translate(".concat(i, "px, ").concat(u, "px)") };
  return this.transitions && this.transitions.enabled && (N.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), N;
} }, methods: { onMove: function(M) {
  this.$emit("move", M), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(M) {
  this.$emit("resize", M), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: this.aspectRatio || this.minAspectRatio, maximum: this.aspectRatio || this.maxAspectRatio };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
x4.render = function(M, e, t, i, u, N) {
  var l = AM("stencil-preview"), n = AM("draggable-area"), s = AM("bounding-box");
  return c(), k("div", { class: N.classes.stencil, style: N.style }, [z(s, { width: t.stencilCoordinates.width, height: t.stencilCoordinates.height, transitions: t.transitions, class: N.classes.boundingBox, handlers: t.handlers, "handlers-component": t.handlersComponent, "handlers-classes": t.handlersClasses, "handlers-wrappers-classes": t.handlersWrappersClasses, lines: t.lines, "lines-component": t.linesComponent, "lines-classes": t.linesClasses, "lines-wrappers-classes": t.linesWrappersClasses, resizable: t.resizable, onResize: N.onResize, onResizeEnd: N.onResizeEnd }, { default: O(function() {
    return [z(n, { movable: t.movable, onMove: N.onMove, onMoveEnd: N.onMoveEnd }, { default: O(function() {
      return [z(l, { image: t.image, coordinates: t.coordinates, width: t.stencilCoordinates.width, height: t.stencilCoordinates.height, class: N.classes.preview, transitions: t.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var sr = ["transitions"], ae = _M("vue-advanced-cropper"), E4 = { name: "Cropper", components: { BackgroundWrapper: Nu }, props: { src: { type: String, default: null }, stencilComponent: { type: [Object, String], default: function() {
  return x4;
} }, backgroundWrapperComponent: { type: [Object, String], default: function() {
  return Nu;
} }, stencilProps: { type: Object, default: function() {
  return {};
} }, autoZoom: { type: Boolean, default: !1 }, imageClass: { type: String }, boundariesClass: { type: String }, backgroundClass: { type: String }, foregroundClass: { type: String }, minWidth: { type: [Number, String] }, minHeight: { type: [Number, String] }, maxWidth: { type: [Number, String] }, maxHeight: { type: [Number, String] }, debounce: { type: [Boolean, Number], default: 500 }, transitions: { type: Boolean, default: !0 }, checkOrientation: { type: Boolean, default: !0 }, canvas: { type: [Object, Boolean], default: !0 }, crossOrigin: { type: [Boolean, String], default: void 0 }, transitionTime: { type: Number, default: 300 }, imageRestriction: { type: String, default: "fit-area", validator: function(M) {
  return fD.indexOf(M) !== -1;
} }, roundResult: { type: Boolean, default: !0 }, defaultSize: { type: [Function, Object] }, defaultPosition: { type: [Function, Object] }, defaultVisibleArea: { type: [Function, Object] }, defaultTransforms: { type: [Function, Object] }, defaultBoundaries: { type: [Function, String], validator: function(M) {
  return !(typeof M == "string" && M !== "fill" && M !== "fit");
} }, priority: { type: String, default: "coordinates" }, stencilSize: { type: [Object, Function] }, resizeImage: { type: [Boolean, Object], default: !0 }, moveImage: { type: [Boolean, Object], default: !0 }, autoZoomAlgorithm: { type: Function }, resizeAlgorithm: { type: Function, default: function(M) {
  var e = M.event, t = M.coordinates, i = M.aspectRatio, u = M.positionRestrictions, N = M.sizeRestrictions, l = _(_({}, t), { right: t.left + t.width, bottom: t.top + t.height }), n = e.params || {}, s = _({}, e.directions), a = n.allowedDirections || { left: !0, right: !0, bottom: !0, top: !0 };
  N.widthFrozen && (s.left = 0, s.right = 0), N.heightFrozen && (s.top = 0, s.bottom = 0), Me.forEach(function(Q) {
    a[Q] || (s[Q] = 0);
  });
  var o = $M(l, s = U0({ coordinates: l, directions: s, sizeRestrictions: N, positionRestrictions: u })).width, j = $M(l, s).height, D = n.preserveRatio ? TM(l) : hi(o / j, i);
  if (D) {
    var r = n.respectDirection;
    if (r || (r = l.width >= l.height || D === 1 ? "width" : "height"), r === "width") {
      var I = o / D - l.height;
      if (a.top && a.bottom) {
        var L = s.top, d = s.bottom;
        s.bottom = Qt(I, d, L), s.top = Qt(I, L, d);
      } else
        a.bottom ? s.bottom = I : a.top ? s.top = I : a.right ? s.right = 0 : a.left && (s.left = 0);
    } else if (r === "height") {
      var m = l.width - j * D;
      if (a.left && a.right) {
        var x = s.left, C = s.right;
        s.left = -Qt(m, x, C), s.right = -Qt(m, C, x);
      } else
        a.left ? s.left = -m : a.right ? s.right = -m : a.top ? s.top = 0 : a.bottom && (s.bottom = 0);
    }
    s = U0({ directions: s, coordinates: l, sizeRestrictions: N, positionRestrictions: u, preserveRatio: !0, compensate: n.compensate });
  }
  return o = $M(l, s).width, j = $M(l, s).height, (D = n.preserveRatio ? TM(l) : hi(o / j, i)) && Math.abs(D - o / j) > 1e-3 && Me.forEach(function(Q) {
    a[Q] || (s[Q] = 0);
  }), uu({ event: new Uu({ left: -s.left, top: -s.top }), coordinates: { width: t.width + s.right + s.left, height: t.height + s.top + s.bottom, left: t.left, top: t.top }, positionRestrictions: u });
} }, moveAlgorithm: { type: Function, default: uu }, initStretcher: { type: Function, default: function(M) {
  var e = M.stretcher, t = M.imageSize, i = TM(t);
  e.style.width = t.width + "px", e.style.height = e.clientWidth / i + "px", e.style.width = e.clientWidth + "px";
} }, fitCoordinates: { type: Function, default: function(M) {
  var e = M.visibleArea, t = M.coordinates, i = M.aspectRatio, u = M.sizeRestrictions, N = M.positionRestrictions, l = _(_({}, t), je({ width: t.width, height: t.height, aspectRatio: i, sizeRestrictions: { maxWidth: e.width, maxHeight: e.height, minHeight: Math.min(e.height, u.minHeight), minWidth: Math.min(e.width, u.minWidth) } }));
  return l = bM(l = GM(l, _e(kM(t), kM(l))), oi(le(e), N));
} }, fitVisibleArea: { type: Function, default: function(M) {
  var e = M.visibleArea, t = M.boundaries, i = M.getAreaRestrictions, u = M.coordinates, N = _({}, e);
  N.height = N.width / TM(t), N.top += (e.height - N.height) / 2, (u.height - N.height > 0 || u.width - N.width > 0) && (N = JM(N, Math.max(u.height / N.height, u.width / N.width)));
  var l = ni(qe(u, le(N = JM(N, si(N, i({ visibleArea: N, type: "resize" }))))));
  return N.width < u.width && (l.left = 0), N.height < u.height && (l.top = 0), N = bM(N = GM(N, l), i({ visibleArea: N, type: "move" }));
} }, areaRestrictionsAlgorithm: { type: Function, default: function(M) {
  var e = M.visibleArea, t = M.boundaries, i = M.imageSize, u = M.imageRestriction, N = M.type, l = {};
  return u === "fill-area" ? l = { left: 0, top: 0, right: i.width, bottom: i.height } : u === "fit-area" && (TM(t) > TM(i) ? (l = { top: 0, bottom: i.height }, e && N === "move" && (e.width > i.width ? (l.left = -(e.width - i.width) / 2, l.right = i.width - l.left) : (l.left = 0, l.right = i.width))) : (l = { left: 0, right: i.width }, e && N === "move" && (e.height > i.height ? (l.top = -(e.height - i.height) / 2, l.bottom = i.height - l.top) : (l.top = 0, l.bottom = i.height)))), l;
} }, sizeRestrictionsAlgorithm: { type: Function, default: function(M) {
  return { minWidth: M.minWidth, minHeight: M.minHeight, maxWidth: M.maxWidth, maxHeight: M.maxHeight };
} }, positionRestrictionsAlgorithm: { type: Function, default: function(M) {
  var e = M.imageSize, t = {};
  return M.imageRestriction !== "none" && (t = { left: 0, top: 0, right: e.width, bottom: e.height }), t;
} } }, data: function() {
  return { transitionsActive: !1, imageLoaded: !1, imageAttributes: { width: null, height: null, crossOrigin: null, src: null }, defaultImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, appliedImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, boundaries: { width: 0, height: 0 }, visibleArea: null, coordinates: jM({}, S0) };
}, computed: { image: function() {
  return { src: this.imageAttributes.src, width: this.imageAttributes.width, height: this.imageAttributes.height, transforms: this.imageTransforms };
}, imageTransforms: function() {
  return { rotate: this.appliedImageTransforms.rotate, flip: { horizontal: this.appliedImageTransforms.flip.horizontal, vertical: this.appliedImageTransforms.flip.vertical }, translateX: this.visibleArea ? this.visibleArea.left / this.coefficient : 0, translateY: this.visibleArea ? this.visibleArea.top / this.coefficient : 0, scaleX: 1 / this.coefficient, scaleY: 1 / this.coefficient };
}, imageSize: function() {
  var M = function(e) {
    return e * Math.PI / 180;
  }(this.imageTransforms.rotate);
  return { width: Math.abs(this.imageAttributes.width * Math.cos(M)) + Math.abs(this.imageAttributes.height * Math.sin(M)), height: Math.abs(this.imageAttributes.width * Math.sin(M)) + Math.abs(this.imageAttributes.height * Math.cos(M)) };
}, initialized: function() {
  return !!(this.visibleArea && this.imageLoaded);
}, settings: function() {
  var M = tu(this.resizeImage, { touch: !0, wheel: { ratio: 0.1 }, adjustStencil: !0 }, { touch: !1, wheel: !1, adjustStencil: !1 });
  return { moveImage: tu(this.moveImage, { touch: !0, mouse: !0 }, { touch: !1, mouse: !1 }), resizeImage: M };
}, coefficient: function() {
  return this.visibleArea ? this.visibleArea.width / this.boundaries.width : 0;
}, areaRestrictions: function() {
  return this.imageLoaded ? this.areaRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction, boundaries: this.boundaries }) : {};
}, transitionsOptions: function() {
  return { enabled: this.transitionsActive, timingFunction: "ease-in-out", time: 350 };
}, sizeRestrictions: function() {
  if (this.boundaries.width && this.boundaries.height && this.imageSize.width && this.imageSize.height) {
    var M = this.sizeRestrictionsAlgorithm({ imageSize: this.imageSize, minWidth: wM(this.minWidth) ? 0 : bt(this.minWidth), minHeight: wM(this.minHeight) ? 0 : bt(this.minHeight), maxWidth: wM(this.maxWidth) ? 1 / 0 : bt(this.maxWidth), maxHeight: wM(this.maxHeight) ? 1 / 0 : bt(this.maxHeight) });
    if (M = function(i) {
      var u = i.areaRestrictions, N = i.sizeRestrictions;
      i.imageSize;
      var l = i.boundaries, n = i.positionRestrictions;
      i.imageRestriction;
      var s = _(_({}, N), { minWidth: N.minWidth !== void 0 ? N.minWidth : 0, minHeight: N.minHeight !== void 0 ? N.minHeight : 0, maxWidth: N.maxWidth !== void 0 ? N.maxWidth : 1 / 0, maxHeight: N.maxHeight !== void 0 ? N.maxHeight : 1 / 0 });
      n.left !== void 0 && n.right !== void 0 && (s.maxWidth = Math.min(s.maxWidth, n.right - n.left)), n.bottom !== void 0 && n.top !== void 0 && (s.maxHeight = Math.min(s.maxHeight, n.bottom - n.top));
      var a = iu(u), o = r4(l, a);
      return a.width < 1 / 0 && (!s.maxWidth || s.maxWidth > o.width) && (s.maxWidth = Math.min(s.maxWidth, o.width)), a.height < 1 / 0 && (!s.maxHeight || s.maxHeight > o.height) && (s.maxHeight = Math.min(s.maxHeight, o.height)), s.minWidth > s.maxWidth && (s.minWidth = s.maxWidth, s.widthFrozen = !0), s.minHeight > s.maxHeight && (s.minHeight = s.maxHeight, s.heightFrozen = !0), s;
    }({ sizeRestrictions: M, areaRestrictions: this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }), imageSize: this.imageSize, boundaries: this.boundaries, positionRestrictions: this.positionRestrictions, imageRestriction: this.imageRestriction, visibleArea: this.visibleArea, stencilSize: this.getStencilSize() }), this.visibleArea && this.stencilSize) {
      var e = this.getStencilSize(), t = iu(this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }));
      M.maxWidth = Math.min(M.maxWidth, t.width * e.width / this.boundaries.width), M.maxHeight = Math.min(M.maxHeight, t.height * e.height / this.boundaries.height), M.maxWidth < M.minWidth && (M.minWidth = M.maxWidth), M.maxHeight < M.minHeight && (M.minHeight = M.maxHeight);
    }
    return M;
  }
  return { minWidth: 0, minHeight: 0, maxWidth: 0, maxHeight: 0 };
}, positionRestrictions: function() {
  return this.positionRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction });
}, classes: function() {
  return { cropper: ae(), image: hM(ae("image"), this.imageClass), stencil: ae("stencil"), boundaries: hM(ae("boundaries"), this.boundariesClass), stretcher: hM(ae("stretcher")), background: hM(ae("background"), this.backgroundClass), foreground: hM(ae("foreground"), this.foregroundClass), imageWrapper: hM(ae("image-wrapper")), cropperWrapper: hM(ae("cropper-wrapper")) };
}, stencilCoordinates: function() {
  if (this.initialized) {
    var M = this.coordinates, e = M.width, t = M.height, i = M.left, u = M.top;
    return { width: e / this.coefficient, height: t / this.coefficient, left: (i - this.visibleArea.left) / this.coefficient, top: (u - this.visibleArea.top) / this.coefficient };
  }
  return this.defaultCoordinates();
}, boundariesStyle: function() {
  var M = { width: this.boundaries.width ? "".concat(Math.round(this.boundaries.width), "px") : "auto", height: this.boundaries.height ? "".concat(Math.round(this.boundaries.height), "px") : "auto", transition: "opacity ".concat(this.transitionTime, "ms"), pointerEvents: this.imageLoaded ? "all" : "none" };
  return this.imageLoaded || (M.opacity = "0"), M;
}, imageStyle: function() {
  var M = this.imageAttributes.width > this.imageAttributes.height ? { width: Math.min(1024, this.imageAttributes.width), height: Math.min(1024, this.imageAttributes.width) / (this.imageAttributes.width / this.imageAttributes.height) } : { height: Math.min(1024, this.imageAttributes.height), width: Math.min(1024, this.imageAttributes.height) * (this.imageAttributes.width / this.imageAttributes.height) }, e = { left: (M.width - this.imageSize.width) / (2 * this.coefficient), top: (M.height - this.imageSize.height) / (2 * this.coefficient) }, t = { left: (1 - 1 / this.coefficient) * M.width / 2, top: (1 - 1 / this.coefficient) * M.height / 2 }, i = jM(jM({}, this.imageTransforms), {}, { scaleX: this.imageTransforms.scaleX * (this.imageAttributes.width / M.width), scaleY: this.imageTransforms.scaleY * (this.imageAttributes.height / M.height) }), u = { width: "".concat(M.width, "px"), height: "".concat(M.height, "px"), left: "0px", top: "0px", transform: "translate(".concat(-e.left - t.left - this.imageTransforms.translateX, "px, ").concat(-e.top - t.top - this.imageTransforms.translateY, "px)") + y4(i) };
  return this.transitionsOptions.enabled && (u.transition = "".concat(this.transitionsOptions.time, "ms ").concat(this.transitionsOptions.timingFunction)), u;
} }, watch: { src: function() {
  this.onChangeImage();
}, stencilComponent: function() {
  var M = this;
  this.$nextTick(function() {
    M.resetCoordinates(), M.runAutoZoom("setCoordinates"), M.onChange();
  });
}, minWidth: function() {
  this.onPropsChange();
}, maxWidth: function() {
  this.onPropsChange();
}, minHeight: function() {
  this.onPropsChange();
}, maxHeight: function() {
  this.onPropsChange();
}, imageRestriction: function() {
  this.reset();
}, stencilProps: function(M, e) {
  ["aspectRatio", "minAspectRatio", "maxAspectRatio"].find(function(t) {
    return M[t] !== e[t];
  }) && this.$nextTick(this.onPropsChange);
} }, created: function() {
  this.debouncedUpdate = eu(this.update, this.debounce), this.debouncedDisableTransitions = eu(this.disableTransitions, this.transitionsOptions.time), this.awaiting = !1;
}, mounted: function() {
  this.$refs.image.addEventListener("load", this.onSuccessLoadImage), this.$refs.image.addEventListener("error", this.onFailLoadImage), this.onChangeImage(), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh), this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.debouncedUpdate.clear(), this.debouncedDisableTransitions.clear();
}, methods: { getResult: function() {
  var M = this.initialized ? this.prepareResult(jM({}, this.coordinates)) : this.defaultCoordinates(), e = { rotate: this.imageTransforms.rotate % 360, flip: jM({}, this.imageTransforms.flip) };
  if (this.src && this.imageLoaded) {
    var t = this;
    return { image: this.image, coordinates: M, visibleArea: this.visibleArea ? jM({}, this.visibleArea) : null, imageTransforms: e, get canvas() {
      return t.canvas ? t.getCanvas() : void 0;
    } };
  }
  return { image: this.image, coordinates: M, visibleArea: this.visibleArea ? jM({}, this.visibleArea) : null, canvas: void 0, imageTransforms: e };
}, zoom: function(M, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = t.transitions, u = i === void 0 || i;
  this.onManipulateImage(new ct({}, { factor: 1 / M, center: e }), { normalize: !1, transitions: u });
}, move: function(M, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = t.transitions, u = i === void 0 || i;
  this.onManipulateImage(new ct({ left: M || 0, top: e || 0 }), { normalize: !1, transitions: u });
}, setCoordinates: function(M) {
  var e = this, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = t.autoZoom, u = i === void 0 || i, N = t.transitions, l = N === void 0 || N;
  this.$nextTick(function() {
    e.imageLoaded ? (e.transitionsActive || (l && e.enableTransitions(), e.coordinates = e.applyTransform(M), u && e.runAutoZoom("setCoordinates"), l && e.debouncedDisableTransitions()), e.onChange()) : e.delayedTransforms = M;
  });
}, refresh: function() {
  var M = this, e = this.$refs.image;
  if (this.src && e)
    return this.initialized ? this.updateVisibleArea().then(function() {
      M.onChange();
    }) : this.resetVisibleArea().then(function() {
      M.onChange();
    });
}, reset: function() {
  var M = this;
  return this.resetVisibleArea().then(function() {
    M.onChange(!1);
  });
}, awaitRender: function(M) {
  var e = this;
  this.awaiting || (this.awaiting = !0, this.$nextTick(function() {
    M(), e.awaiting = !1;
  }));
}, prepareResult: function(M) {
  return this.roundResult ? function(e) {
    var t = e.coordinates, i = e.sizeRestrictions, u = e.positionRestrictions, N = { width: Math.round(t.width), height: Math.round(t.height), left: Math.round(t.left), top: Math.round(t.top) };
    return N.width > i.maxWidth ? N.width = Math.floor(t.width) : N.width < i.minWidth && (N.width = Math.ceil(t.width)), N.height > i.maxHeight ? N.height = Math.floor(t.height) : N.height < i.minHeight && (N.height = Math.ceil(t.height)), bM(N, u);
  }(jM(jM({}, this.getPublicProperties()), {}, { positionRestrictions: Ut(this.positionRestrictions, this.visibleArea), coordinates: M })) : M;
}, processAutoZoom: function(M, e, t, i) {
  var u = this.autoZoomAlgorithm;
  u || (u = this.stencilSize ? RD : this.autoZoom ? FD : XD);
  var N = u({ event: { type: M, params: i }, visibleArea: e, coordinates: t, boundaries: this.boundaries, aspectRatio: this.getAspectRatio(), positionRestrictions: this.positionRestrictions, getAreaRestrictions: this.getAreaRestrictions, sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize() });
  return jM(jM({}, N), {}, { changed: !Z0(N.visibleArea, e) || !Z0(N.coordinates, t) });
}, runAutoZoom: function(M) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.transitions, i = t !== void 0 && t, u = SD(e, sr), N = this.processAutoZoom(M, this.visibleArea, this.coordinates, u), l = N.visibleArea, n = N.coordinates, s = N.changed;
  i && s && this.enableTransitions(), this.visibleArea = l, this.coordinates = n, i && s && this.debouncedDisableTransitions();
}, normalizeEvent: function(M) {
  return function(e) {
    var t = e.event, i = e.visibleArea, u = e.coefficient;
    if (t.type === "manipulateImage")
      return _(_({}, t), { move: { left: t.move && t.move.left ? u * t.move.left : 0, top: t.move && t.move.top ? u * t.move.top : 0 }, scale: { factor: t.scale && t.scale.factor ? t.scale.factor : 1, center: t.scale && t.scale.center ? { left: t.scale.center.left * u + i.left, top: t.scale.center.top * u + i.top } : null } });
    if (t.type === "resize") {
      var N = _(_({}, t), { directions: _({}, t.directions) });
      return Me.forEach(function(n) {
        N.directions[n] *= u;
      }), N;
    }
    if (t.type === "move") {
      var l = _(_({}, t), { directions: _({}, t.directions) });
      return WD.forEach(function(n) {
        l.directions[n] *= u;
      }), l;
    }
    return t;
  }(jM(jM({}, this.getPublicProperties()), {}, { event: M }));
}, getCanvas: function() {
  if (this.$refs.canvas) {
    var M = this.$refs.canvas, e = this.$refs.image, t = this.imageTransforms.rotate !== 0 || this.imageTransforms.flip.horizontal || this.imageTransforms.flip.vertical ? function(n, s, a) {
      var o = a.rotate, j = a.flip, D = { width: s.naturalWidth, height: s.naturalHeight }, r = g4(D, o), I = n.getContext("2d");
      n.height = r.height, n.width = r.width, I.save();
      var L = Le(kM(_({ left: 0, top: 0 }, D)), o);
      return I.translate(-(L.left - r.width / 2), -(L.top - r.height / 2)), I.rotate(o * Math.PI / 180), I.translate(j.horizontal ? D.width : 0, j.vertical ? D.height : 0), I.scale(j.horizontal ? -1 : 1, j.vertical ? -1 : 1), I.drawImage(s, 0, 0, D.width, D.height), I.restore(), n;
    }(this.$refs.sourceCanvas, e, this.imageTransforms) : e, i = jM({ minWidth: 0, minHeight: 0, maxWidth: 1 / 0, maxHeight: 1 / 0, maxArea: this.maxCanvasSize, imageSmoothingEnabled: !0, imageSmoothingQuality: "high", fillColor: "transparent" }, this.canvas), u = function(n) {
      return n.find(function(s) {
        return a = s, !Number.isNaN(parseFloat(a)) && isFinite(a);
        var a;
      });
    }, N = je({ sizeRestrictions: { minWidth: u([i.width, i.minWidth]) || 0, minHeight: u([i.height, i.minHeight]) || 0, maxWidth: u([i.width, i.maxWidth]) || 1 / 0, maxHeight: u([i.height, i.maxHeight]) || 1 / 0 }, width: this.coordinates.width, height: this.coordinates.height, aspectRatio: { minimum: this.coordinates.width / this.coordinates.height, maximum: this.coordinates.width / this.coordinates.height } });
    if (i.maxArea && N.width * N.height > i.maxArea) {
      var l = Math.sqrt(i.maxArea / (N.width * N.height));
      N = { width: Math.round(l * N.width), height: Math.round(l * N.height) };
    }
    return function(n, s, a, o, j) {
      n.width = o ? o.width : a.width, n.height = o ? o.height : a.height;
      var D = n.getContext("2d");
      D.clearRect(0, 0, n.width, n.height), j && (j.imageSmoothingEnabled && (D.imageSmoothingEnabled = j.imageSmoothingEnabled), j.imageSmoothingQuality && (D.imageSmoothingQuality = j.imageSmoothingQuality), j.fillColor && (D.fillStyle = j.fillColor, D.fillRect(0, 0, n.width, n.height), D.save()));
      var r = a.left < 0 ? -a.left : 0, I = a.top < 0 ? -a.top : 0;
      D.drawImage(s, a.left + r, a.top + I, a.width, a.height, r, I, n.width, n.height);
    }(M, t, this.coordinates, N, i), M;
  }
}, update: function() {
  this.$emit("change", this.getResult());
}, applyTransform: function(M) {
  var e = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], t = this.visibleArea && e ? vD(this.sizeRestrictions, this.visibleArea) : this.sizeRestrictions, i = this.visibleArea && e ? Ut(this.positionRestrictions, this.visibleArea) : this.positionRestrictions;
  return GD({ transform: M, coordinates: this.coordinates, imageSize: this.imageSize, sizeRestrictions: t, positionRestrictions: i, aspectRatio: this.getAspectRatio(), visibleArea: this.visibleArea });
}, resetCoordinates: function() {
  var M = this;
  if (this.$refs.image) {
    this.$refs.cropper, this.$refs.image;
    var e = this.defaultSize;
    e || (e = this.stencilSize ? BD : KD);
    var t = this.sizeRestrictions;
    t.minWidth, t.minHeight, t.maxWidth, t.maxHeight;
    var i = Fe(e) ? e({ boundaries: this.boundaries, imageSize: this.imageSize, aspectRatio: this.getAspectRatio(), sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize(), visibleArea: this.visibleArea }) : e, u = this.defaultPosition || JD, N = [i, function(l) {
      var n = l.coordinates;
      return jM({}, Fe(u) ? u({ coordinates: n, imageSize: M.imageSize, visibleArea: M.visibleArea }) : M.defaultPosition);
    }];
    this.delayedTransforms && N.push.apply(N, Qe(Array.isArray(this.delayedTransforms) ? this.delayedTransforms : [this.delayedTransforms])), this.coordinates = this.applyTransform(N, !0), this.delayedTransforms = null;
  }
}, clearImage: function() {
  var M = this;
  this.imageLoaded = !1, setTimeout(function() {
    var e = M.$refs.stretcher;
    e && (e.style.height = "auto", e.style.width = "auto"), M.coordinates = M.defaultCoordinates(), M.boundaries = { width: 0, height: 0 };
  }, this.transitionTime);
}, enableTransitions: function() {
  this.transitions && (this.transitionsActive = !0);
}, disableTransitions: function() {
  this.transitionsActive = !1;
}, updateBoundaries: function() {
  var M = this, e = this.$refs.stretcher, t = this.$refs.cropper;
  return this.initStretcher({ cropper: t, stretcher: e, imageSize: this.imageSize }), this.$nextTick().then(function() {
    var i = { cropper: t, imageSize: M.imageSize };
    if (Fe(M.defaultBoundaries) ? M.boundaries = M.defaultBoundaries(i) : M.defaultBoundaries === "fit" ? M.boundaries = function(u) {
      var N = u.cropper, l = u.imageSize, n = N.clientHeight, s = N.clientWidth, a = n, o = l.width * n / l.height;
      return o > s && (o = s, a = l.height * s / l.width), { width: o, height: a };
    }(i) : M.boundaries = function(u) {
      var N = u.cropper;
      return { width: N.clientWidth, height: N.clientHeight };
    }(i), !M.boundaries.width || !M.boundaries.height)
      throw new Error("It's impossible to fit the cropper in the current container");
  });
}, resetVisibleArea: function() {
  var M = this;
  return this.appliedImageTransforms = jM(jM({}, this.defaultImageTransforms), {}, { flip: jM({}, this.defaultImageTransforms.flip) }), this.updateBoundaries().then(function() {
    M.priority !== "visible-area" && (M.visibleArea = null, M.resetCoordinates());
    var e, t, i, u, N, l, n = M.defaultVisibleArea || HD;
    M.visibleArea = Fe(n) ? n({ imageSize: M.imageSize, boundaries: M.boundaries, coordinates: M.priority !== "visible-area" ? M.coordinates : null, getAreaRestrictions: M.getAreaRestrictions, stencilSize: M.getStencilSize() }) : M.defaultVisibleArea, M.visibleArea = (e = { visibleArea: M.visibleArea, boundaries: M.boundaries, getAreaRestrictions: M.getAreaRestrictions }, t = e.visibleArea, i = e.boundaries, u = e.getAreaRestrictions, N = _({}, t), l = TM(i), N.width / N.height !== l && (N.height = N.width / l), bM(N, u({ visibleArea: N, type: "move" }))), M.priority === "visible-area" ? M.resetCoordinates() : M.coordinates = M.fitCoordinates({ visibleArea: M.visibleArea, coordinates: M.coordinates, aspectRatio: M.getAspectRatio(), positionRestrictions: M.positionRestrictions, sizeRestrictions: M.sizeRestrictions }), M.runAutoZoom("resetVisibleArea");
  }).catch(function() {
    M.visibleArea = null;
  });
}, updateVisibleArea: function() {
  var M = this;
  return this.updateBoundaries().then(function() {
    M.visibleArea = M.fitVisibleArea({ imageSize: M.imageSize, boundaries: M.boundaries, visibleArea: M.visibleArea, coordinates: M.coordinates, getAreaRestrictions: M.getAreaRestrictions }), M.coordinates = M.fitCoordinates({ visibleArea: M.visibleArea, coordinates: M.coordinates, aspectRatio: M.getAspectRatio(), positionRestrictions: M.positionRestrictions, sizeRestrictions: M.sizeRestrictions }), M.runAutoZoom("updateVisibleArea");
  }).catch(function() {
    M.visibleArea = null;
  });
}, onChange: function() {
  var M = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
  M && this.debounce ? this.debouncedUpdate() : this.update();
}, onChangeImage: function() {
  var M, e = this;
  if (this.imageLoaded = !1, this.delayedTransforms = null, this.src) {
    if (function(u) {
      if (w0(u))
        return !1;
      var N = window.location, l = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec(u) || [], n = { protocol: l[1] || "", host: l[2] || "", port: l[3] || "" }, s = function(a) {
        return a.port || ((a.protocol || N.protocol) === "http" ? 80 : 433);
      };
      return !(!n.protocol && !n.host && !n.port || n.protocol && n.protocol == N.protocol && n.host && n.host == N.host && n.host && s(n) == s(N));
    }(this.src)) {
      var t = wM(this.crossOrigin) ? this.canvas : this.crossOrigin;
      t === !0 && (t = "anonymous"), this.imageAttributes.crossOrigin = t || null;
    }
    if (this.checkOrientation) {
      var i = (M = this.src, new Promise(function(u) {
        lr(M).then(function(N) {
          var l = nr(N);
          u(N ? { source: M, arrayBuffer: N, orientation: l } : { source: M, arrayBuffer: null, orientation: null });
        }).catch(function(N) {
          console.warn(N), u({ source: M, arrayBuffer: null, orientation: null });
        });
      }));
      setTimeout(function() {
        i.then(e.onParseImage);
      }, this.transitionTime);
    } else
      setTimeout(function() {
        e.onParseImage({ source: e.src });
      }, this.transitionTime);
  } else
    this.clearImage();
}, onFailLoadImage: function() {
  this.imageAttributes.src && (this.clearImage(), this.$emit("error"));
}, onSuccessLoadImage: function() {
  var M = this, e = this.$refs.image;
  e && !this.imageLoaded && (this.imageAttributes.height = e.naturalHeight, this.imageAttributes.width = e.naturalWidth, this.imageLoaded = !0, this.resetVisibleArea().then(function() {
    M.$emit("ready"), M.onChange(!1);
  }));
}, onParseImage: function(M) {
  var e = this, t = M.source, i = M.arrayBuffer, u = M.orientation;
  this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.imageAttributes.revoke = !1, i && u && u > 1 ? a4(t) || !w0(t) ? (this.imageAttributes.src = URL.createObjectURL(new Blob([i])), this.imageAttributes.revoke = !0) : this.imageAttributes.src = function(N) {
    for (var l = [], n = new Uint8Array(N); n.length > 0; ) {
      var s = n.subarray(0, 8192);
      l.push(String.fromCharCode.apply(null, Array.from ? Array.from(s) : s.slice())), n = n.subarray(8192);
    }
    return "data:image/jpeg;base64," + btoa(l.join(""));
  }(i) : this.imageAttributes.src = t, Fe(this.defaultTransforms) ? this.appliedImageTransforms = Oi(this.defaultTransforms()) : Rt(this.defaultTransforms) ? this.appliedImageTransforms = Oi(this.defaultTransforms) : this.appliedImageTransforms = function(N) {
    var l = Oi({});
    if (N)
      switch (N) {
        case 2:
          l.flip.horizontal = !0;
          break;
        case 3:
          l.rotate = -180;
          break;
        case 4:
          l.flip.vertical = !0;
          break;
        case 5:
          l.rotate = 90, l.flip.vertical = !0;
          break;
        case 6:
          l.rotate = 90;
          break;
        case 7:
          l.rotate = 90, l.flip.horizontal = !0;
          break;
        case 8:
          l.rotate = -90;
      }
    return l;
  }(u), this.defaultImageTransforms = jM(jM({}, this.appliedImageTransforms), {}, { flip: jM({}, this.appliedImageTransforms.flip) }), this.$nextTick(function() {
    var N = e.$refs.image;
    N && N.complete && (function(l) {
      return !!l.naturalWidth;
    }(N) ? e.onSuccessLoadImage() : e.onFailLoadImage());
  });
}, onResizeEnd: function() {
  this.runAutoZoom("resize", { transitions: !0 });
}, onMoveEnd: function() {
  this.runAutoZoom("move", { transitions: !0 });
}, onMove: function(M) {
  var e = this;
  this.transitionsOptions.enabled || this.awaitRender(function() {
    e.coordinates = e.moveAlgorithm(jM(jM({}, e.getPublicProperties()), {}, { positionRestrictions: Ut(e.positionRestrictions, e.visibleArea), coordinates: e.coordinates, event: e.normalizeEvent(M) })), e.onChange();
  });
}, onResize: function(M) {
  var e = this;
  this.transitionsOptions.enabled || this.stencilSize && !this.autoZoom || this.awaitRender(function() {
    var t = e.sizeRestrictions, i = Math.min(e.coordinates.width, e.coordinates.height, 20 * e.coefficient);
    e.coordinates = e.resizeAlgorithm(jM(jM({}, e.getPublicProperties()), {}, { positionRestrictions: Ut(e.positionRestrictions, e.visibleArea), sizeRestrictions: { maxWidth: Math.min(t.maxWidth, e.visibleArea.width), maxHeight: Math.min(t.maxHeight, e.visibleArea.height), minWidth: Math.max(t.minWidth, i), minHeight: Math.max(t.minHeight, i) }, event: e.normalizeEvent(M) })), e.onChange(), e.ticking = !1;
  });
}, onManipulateImage: function(M) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!this.transitionsOptions.enabled) {
    var t = e.transitions, i = t !== void 0 && t, u = e.normalize, N = u === void 0 || u;
    i && this.enableTransitions();
    var l = PD(jM(jM({}, this.getPublicProperties()), {}, { event: N ? this.normalizeEvent(M) : M, getAreaRestrictions: this.getAreaRestrictions, imageRestriction: this.imageRestriction, adjustStencil: !this.stencilSize && this.settings.resizeImage.adjustStencil })), n = l.visibleArea, s = l.coordinates;
    this.visibleArea = n, this.coordinates = s, this.runAutoZoom("manipulateImage"), this.onChange(), i && this.debouncedDisableTransitions();
  }
}, onPropsChange: function() {
  this.coordinates = this.applyTransform(this.coordinates, !0), this.onChange(!1);
}, getAreaRestrictions: function() {
  var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = M.visibleArea, t = M.type, i = t === void 0 ? "move" : t;
  return this.areaRestrictionsAlgorithm({ boundaries: this.boundaries, imageSize: this.imageSize, imageRestriction: this.imageRestriction, visibleArea: e, type: i });
}, getAspectRatio: function(M) {
  var e, t, i = this.stencilProps, u = i.aspectRatio, N = i.minAspectRatio, l = i.maxAspectRatio;
  if (this.$refs.stencil && this.$refs.stencil.aspectRatios) {
    var n = this.$refs.stencil.aspectRatios();
    e = n.minimum, t = n.maximum;
  }
  if (wM(e) && (e = wM(u) ? N : u), wM(t) && (t = wM(u) ? l : u), !M && (wM(e) || wM(t))) {
    var s = this.getStencilSize(), a = s ? TM(s) : null;
    wM(e) && (e = Y0(a) ? a : void 0), wM(t) && (t = Y0(a) ? a : void 0);
  }
  return { minimum: e, maximum: t };
}, getStencilSize: function() {
  if (this.stencilSize)
    return M = { currentStencilSize: { width: this.stencilCoordinates.width, height: this.stencilCoordinates.height }, stencilSize: this.stencilSize, boundaries: this.boundaries, coefficient: this.coefficient, coordinates: this.coordinates, aspectRatio: this.getAspectRatio(!0) }, e = M.boundaries, t = M.stencilSize, i = M.aspectRatio, hi(TM(u = Fe(t) ? t({ boundaries: e, aspectRatio: i }) : t), i) && (u = je({ sizeRestrictions: { maxWidth: e.width, maxHeight: e.height, minWidth: 0, minHeight: 0 }, width: u.width, height: u.height, aspectRatio: { minimum: i.minimum, maximum: i.maximum } })), (u.width > e.width || u.height > e.height) && (u = je({ sizeRestrictions: { maxWidth: e.width, maxHeight: e.height, minWidth: 0, minHeight: 0 }, width: u.width, height: u.height, aspectRatio: { minimum: TM(u), maximum: TM(u) } })), u;
  var M, e, t, i, u;
}, getPublicProperties: function() {
  return { coefficient: this.coefficient, visibleArea: this.visibleArea, coordinates: this.coordinates, boundaries: this.boundaries, sizeRestrictions: this.sizeRestrictions, positionRestrictions: this.positionRestrictions, aspectRatio: this.getAspectRatio(), imageRestriction: this.imageRestriction };
}, defaultCoordinates: function() {
  return jM({}, S0);
}, flip: function(M, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = t.transitions, u = i === void 0 || i;
  if (!this.transitionsActive) {
    u && this.enableTransitions();
    var N = jM({}, this.imageTransforms.flip), l = $D({ flip: { horizontal: M ? !N.horizontal : N.horizontal, vertical: e ? !N.vertical : N.vertical }, previousFlip: N, rotate: this.imageTransforms.rotate, visibleArea: this.visibleArea, coordinates: this.coordinates, imageSize: this.imageSize, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), n = l.visibleArea, s = l.coordinates;
    M && (this.appliedImageTransforms.flip.horizontal = !this.appliedImageTransforms.flip.horizontal), e && (this.appliedImageTransforms.flip.vertical = !this.appliedImageTransforms.flip.vertical), this.visibleArea = n, this.coordinates = s, this.onChange(), u && this.debouncedDisableTransitions();
  }
}, rotate: function(M) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.transitions, i = t === void 0 || t;
  if (!this.transitionsActive) {
    i && this.enableTransitions();
    var u = jM({}, this.imageSize);
    this.appliedImageTransforms.rotate += M;
    var N = _D({ visibleArea: this.visibleArea, coordinates: this.coordinates, previousImageSize: u, imageSize: this.imageSize, angle: M, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), l = N.visibleArea, n = N.coordinates, s = this.processAutoZoom("rotateImage", l, n);
    l = s.visibleArea, n = s.coordinates, this.visibleArea = l, this.coordinates = n, this.onChange(), i && this.debouncedDisableTransitions();
  }
} }, emits: ["change", "error", "ready"] }, or = { key: 0, ref: "canvas", style: { display: "none" } }, ar = { key: 1, ref: "sourceCanvas", style: { display: "none" } };
E4.render = function(M, e, t, i, u, N) {
  return c(), k("div", { ref: "cropper", class: N.classes.cropper }, [z("div", { ref: "stretcher", class: N.classes.stretcher }, null, 2), z("div", { class: N.classes.boundaries, style: N.boundariesStyle }, [(c(), k(cM(t.backgroundWrapperComponent), { class: N.classes.cropperWrapper, "wheel-resize": N.settings.resizeImage.wheel, "touch-resize": N.settings.resizeImage.touch, "touch-move": N.settings.moveImage.touch, "mouse-move": N.settings.moveImage.mouse, onMove: N.onManipulateImage, onResize: N.onManipulateImage }, { default: O(function() {
    return [z("div", { class: N.classes.background, style: N.boundariesStyle }, null, 6), z("div", { class: N.classes.imageWrapper }, [z("img", { ref: "image", crossorigin: u.imageAttributes.crossOrigin, src: u.imageAttributes.src, class: N.classes.image, style: N.imageStyle, onMousedown: e[1] || (e[1] = M1(function() {
    }, ["prevent"])) }, null, 46, ["crossorigin", "src"])], 2), z("div", { class: N.classes.foreground, style: N.boundariesStyle }, null, 6), CM((c(), k(cM(t.stencilComponent), DM({ ref: "stencil", image: N.image, coordinates: u.coordinates, "stencil-coordinates": N.stencilCoordinates, transitions: N.transitionsOptions }, t.stencilProps, { onResize: N.onResize, onResizeEnd: N.onResizeEnd, onMove: N.onMove, onMoveEnd: N.onMoveEnd }), null, 16, ["image", "coordinates", "stencil-coordinates", "transitions", "onResize", "onResizeEnd", "onMove", "onMoveEnd"])), [[WM, u.imageLoaded]]), t.canvas ? (c(), k("canvas", or, null, 512)) : A("", !0), t.canvas ? (c(), k("canvas", ar, null, 512)) : A("", !0)];
  }), _: 1 }, 8, ["class", "wheel-resize", "touch-resize", "touch-move", "mouse-move", "onMove", "onResize"]))], 6)], 2);
};
const jr = { class: "image-kudo-builder flex justify-between items-start gap-x-28 max-w-screen-xl mx-auto" }, Tr = { class: "flex gap-x-12 justify-between items-center" }, cr = {
  key: 1,
  class: "cursor-pointer"
}, Dr = {
  key: 0,
  class: "flex items-center cursor-pointer"
}, rr = { class: "w-16 aspect-square bg-[#DAF7E8] hover:bg-[#A8F7CE] transition-colors duration-300 rounded-full flex items-center justify-center relative" }, gr = ["src"], Lr = /* @__PURE__ */ T("span", { class: "uppercase ml-4 text-xs tracking-wider text-[#8C96A1]" }, "Add image", -1), Ir = { key: 1 }, dr = { class: "flex items-center cursor-pointer" }, yr = { class: "w-16 aspect-square bg-[#FCF7DE] hover:bg-[#FFD9AD] transition-colors duration-300 rounded-full flex items-center justify-center relative" }, zr = ["src"], mr = /* @__PURE__ */ T("span", { class: "uppercase ml-4 text-xs tracking-wider text-[#8C96A1]" }, "Exchange", -1), Ar = { class: "w-16 aspect-square bg-[#FCDEDE] hover:bg-[#FCACCC] transition-colors duration-300 rounded-full flex items-center justify-center relative" }, xr = ["src"], Er = /* @__PURE__ */ T("span", { class: "uppercase ml-4 text-xs tracking-wider text-[#8C96A1]" }, "Remove", -1), hr = { class: "relative" }, Cr = { key: 0 }, Or = { class: "flex" }, pr = /* @__PURE__ */ T("span", { class: "input-label" }, "Email(optional)", -1), wr = /* @__PURE__ */ T("div", { class: "w-56 font-semibold" }, " We will never send you any spam. This is just for the confirmation of this kudo post and our anti-spam protection. ", -1), Yr = ["disabled", "textContent"], wi = 452, Sr = 332, Zr = 615, Yi = 75, KA = /* @__PURE__ */ U({
  __name: "ImageKudoBuilder",
  props: {
    message: {},
    imgUrl: {},
    senderName: {},
    senderEmail: {},
    color: { default: fe[0] },
    isAuthenticated: { type: Boolean }
  },
  emits: ["update:message", "update:senderName", "update:senderEmail", "update:imgUrl", "update:color", "create"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = p(() => te.get(t.color)[0]), N = E(), l = E();
    kT(N, a);
    const n = E(), s = p(
      () => Yi - t.message.length
    );
    function a(I) {
      if (!I || !I[0])
        return;
      const L = new FileReader();
      L.onload = function() {
        l.value = L.result;
      }, L.readAsDataURL(I[0]);
    }
    function o() {
      i("update:imgUrl", void 0), l.value = void 0;
    }
    function j(I) {
      i("update:imgUrl", I.canvas.toDataURL("image/png"));
    }
    function D(I) {
      var m;
      const L = I.target;
      L.value.length > Yi && ((m = n.value) == null || m.shake()), i("update:message", L.value);
    }
    async function r() {
      if (!t.imgUrl)
        return;
      const I = await s1(t.imgUrl, wi * 3);
      i("update:imgUrl", I), i("create", t);
    }
    return (I, L) => (c(), g("div", jr, [
      z(UM, { class: "w-7/12 grow lg:grow-0 shrink-0 space-y-14" }, {
        default: O(() => [
          T("div", Tr, [
            T("label", {
              ref_key: "$dropZone",
              ref: N,
              class: V([
                "dropzone relative overflow-hidden basis-2/3 flex-grow flex items-center justify-center text-2xl font-sans font-normal text-[#B2C3D4] h-72 rounded-[1.25rem]",
                l.value ? "border-none" : "border-2 border-dashed border-[#C9C9FF] cursor-pointer"
              ])
            }, [
              l.value ? A("", !0) : (c(), g("input", {
                key: 0,
                type: "file",
                class: "opacity-0 w-0 h-0 absolute",
                onChange: L[0] || (L[0] = (d) => a(Array.from(d.target.files ?? [])))
              }, null, 32)),
              l.value ? A("", !0) : (c(), g("p", cr, " Drag and drop image here ")),
              T("div", {
                class: V(l.value ? "cropper-wrapper" : "")
              }, [
                T("div", {
                  style: RM({ backgroundImage: "url(" + l.value + ")" }),
                  class: "image-background"
                }, null, 4),
                l.value ? (c(), k(y(E4), {
                  key: 0,
                  class: "absolute inset-0 h-full",
                  "background-class": "bg-none",
                  src: l.value,
                  "stencil-props": {
                    minAspectRatio: wi / Zr,
                    maxAspectRatio: wi / Sr
                  },
                  onChange: j
                }, null, 8, ["src", "stencil-props"])) : A("", !0)
              ], 2)
            ], 2),
            l.value ? l.value ? (c(), g("div", Ir, [
              T("label", dr, [
                T("div", yr, [
                  T("input", {
                    type: "file",
                    class: "opacity-0 w-0 h-0 absolute",
                    onChange: L[2] || (L[2] = (d) => a(Array.from(d.target.files ?? [])))
                  }, null, 32),
                  T("img", {
                    src: y(t1),
                    alt: "change image icon"
                  }, null, 8, zr)
                ]),
                mr
              ]),
              T("div", {
                class: "flex items-center cursor-pointer mt-4",
                onClick: o
              }, [
                T("div", Ar, [
                  T("img", {
                    src: y(zu),
                    alt: "remove image icon"
                  }, null, 8, xr)
                ]),
                Er
              ])
            ])) : A("", !0) : (c(), g("label", Dr, [
              T("div", rr, [
                T("input", {
                  type: "file",
                  class: "opacity-0 w-0 h-0 absolute",
                  onChange: L[1] || (L[1] = (d) => a(Array.from(d.target.files ?? [])))
                }, null, 32),
                T("img", {
                  src: y(e1),
                  alt: "add image icon"
                }, null, 8, gr)
              ]),
              Lr
            ]))
          ]),
          T("div", hr, [
            z(me, {
              label: "And some extra text to it? No presh. Easy.",
              modelValue: I.message,
              onInput: D,
              placeholder: "Optional text. If image is enough, don’t push it. Or push it. Listen, your call.",
              inputClass: "bg-[#F8F9FF] border-none resize-none min-h-[11.25rem]"
            }, null, 8, ["modelValue"]),
            z(Et, {
              ref_key: "charCounterEl",
              ref: n,
              class: "right-0 mt-1 absolute",
              message: I.message,
              characterLimit: Yi
            }, null, 8, ["message"])
          ]),
          z(nM, {
            label: "Your name",
            modelValue: I.senderName,
            maxlength: "75",
            onInput: L[3] || (L[3] = (d) => i("update:senderName", d.target.value)),
            placeholder: "Or nickname... we are not here to dictate",
            inputClass: "bg-[#F8F9FF] border-none"
          }, null, 8, ["modelValue"]),
          I.isAuthenticated ? A("", !0) : (c(), g("label", Cr, [
            T("div", Or, [
              pr,
              z(y(oe), {
                triggers: ["hover"],
                distance: 20,
                placement: "top",
                popperTriggers: ["hover"],
                delay: { show: 200, hide: 150 }
              }, {
                popper: O(() => [
                  wr
                ]),
                default: O(() => [
                  z(y(Ee), {
                    class: "cursor-pointer h-4 w-4 fill-[#BBC4CD]",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })
            ]),
            z(nM, {
              modelValue: I.senderEmail,
              type: "email",
              "onUpdate:modelValue": L[4] || (L[4] = (d) => i("update:senderEmail", d)),
              placeholder: "Your email",
              inputClass: "bg-[#F8F9FF] border-none"
            }, null, 8, ["modelValue"])
          ])),
          A("", !0),
          I.imgUrl ? (c(), k(Xt, {
            key: 2,
            class: V(["block lg:hidden mx-auto mt-24 mb-12", [u.value, "shrink-0 grow-0"]]),
            message: I.message,
            senderName: I.senderName,
            imgUrl: I.imgUrl
          }, null, 8, ["class", "message", "senderName", "imgUrl"])) : A("", !0),
          J(I.$slots, "submit", se(xe({ ...t, remainingCharacters: s.value })), () => [
            T("button", {
              onClick: r,
              class: "btn btn--primary self-start",
              disabled: !I.imgUrl || s.value < 0,
              textContent: w(I.imgUrl ? "Post the Kudo!" : "Create your kudo first")
            }, null, 8, Yr)
          ])
        ]),
        _: 3
      }),
      I.imgUrl ? (c(), k(Xt, {
        key: 0,
        class: V(["hidden lg:block", [u.value, "shrink-0 grow-0"]]),
        message: I.message,
        senderName: I.senderName,
        imgUrl: I.imgUrl
      }, null, 8, ["class", "message", "senderName", "imgUrl"])) : A("", !0)
    ]));
  }
}), kr = ["src"], br = {
  key: 0,
  class: "mt-5 text-center text-lg text-[#3F4A55] font-serif overflow-y-auto"
}, Ur = { class: "text-center relative text-sm text-[#8C96A1]" }, Pt = /* @__PURE__ */ U({
  __name: "YtKudo",
  props: {
    message: {},
    url: {},
    senderName: {}
  },
  setup(M) {
    const e = M, t = p(() => {
      const i = new URL(e.url);
      let u = null;
      i.pathname.startsWith("/embed") ? u = i.pathname.split("/")[2] : i.searchParams.has("v") && (u = i.searchParams.get("v"));
      const N = new URL(`https://www.youtube.com/embed/${u}`);
      return N.searchParams.set("controls", "0"), N.searchParams.set("modestbranding", "1"), N.searchParams.set("color", "white"), N.toString();
    });
    return (i, u) => (c(), k(UM, { class: "kudo-card" }, Pe({
      default: O(() => [
        T("div", {
          class: V(["-mx-12 -mt-12 rounded-[2.5rem] overflow-hidden shrink-0", { "-mb-12": !i.message && !i.senderName }])
        }, [
          T("iframe", {
            class: "w-full min-h-[20.75rem] max-h-[38.25rem] object-cover",
            src: t.value,
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }, null, 8, kr)
        ], 2),
        i.message ? (c(), g("p", br, w(i.message), 1)) : A("", !0)
      ]),
      _: 2
    }, [
      i.$slots.actions ? {
        name: "actions",
        fn: O(() => [
          J(i.$slots, "actions")
        ]),
        key: "0"
      } : void 0,
      i.senderName ? {
        name: "footer",
        fn: O(() => [
          T("div", Ur, w(i.senderName), 1)
        ]),
        key: "1"
      } : void 0
    ]), 1024));
  }
}), Qr = { class: "flex justify-between items-start gap-x-28 max-w-screen-xl mx-auto" }, Vr = { class: "relative" }, Wr = { key: 0 }, fr = { class: "flex" }, vr = /* @__PURE__ */ T("span", { class: "input-label" }, "Email(optional)", -1), Gr = /* @__PURE__ */ T("div", { class: "w-56 font-semibold" }, " We will never send you any spam. This is just for the confirmation of this kudo post and our anti-spam protection. ", -1), Rr = ["disabled", "textContent"], Si = 75, BA = /* @__PURE__ */ U({
  __name: "YtKudoBuilder",
  props: {
    message: {},
    videoUrl: {},
    senderName: {},
    senderEmail: {},
    color: { default: fe[0] },
    isAuthenticated: { type: Boolean }
  },
  emits: ["update:message", "update:senderName", "update:senderEmail", "update:videoUrl", "update:color", "create"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = p(() => te.get(t.color)[0]), N = E(), l = p(
      () => Si - t.message.length
    );
    function n(s) {
      var j;
      const a = s.target;
      a.value.length > Si && ((j = N.value) == null || j.shake()), i("update:message", a.value);
    }
    return (s, a) => (c(), g("div", Qr, [
      z(UM, { class: "w-7/12 grow lg:grow-0 shrink-0 space-y-14" }, {
        default: O(() => [
          z(nM, {
            label: "Youtube url",
            type: "url",
            modelValue: s.videoUrl,
            maxlength: "75",
            onInput: a[0] || (a[0] = (o) => i("update:videoUrl", o.target.value)),
            placeholder: "https://www.youtube.com/...",
            inputClass: "bg-[#F8F9FF] border-none"
          }, null, 8, ["modelValue"]),
          T("div", Vr, [
            z(y(me), {
              label: "And some extra text to it? No presh. Easy.",
              modelValue: s.message,
              onInput: n,
              placeholder: "Optional text. If image is enough, don’t push it. Or push it. Listen, your call.",
              inputClass: "bg-[#F8F9FF] border-none resize-none min-h-[11.25rem]"
            }, null, 8, ["modelValue"]),
            z(Et, {
              ref_key: "charCounterEl",
              ref: N,
              class: "right-0 mt-1 absolute",
              message: s.message,
              characterLimit: Si
            }, null, 8, ["message"])
          ]),
          z(nM, {
            label: "Your name",
            type: "text",
            modelValue: s.senderName,
            maxlength: "75",
            onInput: a[1] || (a[1] = (o) => i("update:senderName", o.target.value)),
            placeholder: "Or nickname... we are not here to dictate",
            inputClass: "bg-[#F8F9FF] border-none"
          }, null, 8, ["modelValue"]),
          s.isAuthenticated ? A("", !0) : (c(), g("label", Wr, [
            T("div", fr, [
              vr,
              z(y(oe), {
                triggers: ["hover"],
                distance: 20,
                placement: "top",
                popperTriggers: ["hover"],
                delay: { show: 200, hide: 150 }
              }, {
                popper: O(() => [
                  Gr
                ]),
                default: O(() => [
                  z(y(Ee), {
                    class: "cursor-pointer h-4 w-4 fill-[#BBC4CD]",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })
            ]),
            z(nM, {
              modelValue: s.senderEmail,
              type: "email",
              "onUpdate:modelValue": a[2] || (a[2] = (o) => i("update:senderEmail", o)),
              placeholder: "Your email",
              inputClass: "bg-[#F8F9FF] border-none"
            }, null, 8, ["modelValue"])
          ])),
          A("", !0),
          s.videoUrl ? (c(), k(Pt, {
            key: 2,
            class: V(["block mx-auto", [u.value, "shrink-0 grow-0"]]),
            message: s.message,
            senderName: s.senderName,
            url: s.videoUrl
          }, null, 8, ["class", "message", "senderName", "url"])) : A("", !0),
          J(s.$slots, "submit", se(xe({ ...t, remainingCharacters: l.value })), () => [
            T("button", {
              onClick: a[4] || (a[4] = (o) => i("create", t)),
              class: "btn btn--primary self-start",
              disabled: !s.videoUrl || l.value < 0,
              textContent: w(s.videoUrl ? "Post the Kudo!" : "Create your kudo first")
            }, null, 8, Rr)
          ])
        ]),
        _: 3
      }),
      s.videoUrl ? (c(), k(Pt, {
        key: 0,
        class: V(["block", [u.value, "shrink-0 grow-0"]]),
        message: s.message,
        senderName: s.senderName,
        url: s.videoUrl
      }, null, 8, ["class", "message", "senderName", "url"])) : A("", !0)
    ]));
  }
}), Fr = { class: "flex justify-between items-start gap-x-16 max-w-screen-xl mx-auto" }, Xr = {
  key: 0,
  class: "flex flex-wrap mt-7 gap-2 max-h-44 overflow-y-auto after:[flex-grow:10000] scrollbar scrollbar--stay-visible"
}, Jr = ["src", "onClick"], Kr = {
  key: 1,
  class: "flex items-center justify-center mt-6 h-40 w-full border-2 rounded-2xl border-[#F8F9FF] italic text-[#B2C3D4] text-2xl font-light"
}, Br = { class: "flex items-center w-full gap-4" }, Hr = ["onClick"], Pr = ["src"], _r = { class: "space-y-14 mt-14" }, $r = { class: "relative" }, qr = { key: 0 }, Mg = { class: "flex" }, eg = /* @__PURE__ */ T("span", { class: "input-label" }, "Email(optional)", -1), tg = /* @__PURE__ */ T("div", { class: "w-56 font-semibold" }, " We will never send you any spam. This is just for the confirmation of this kudo post and our anti-spam protection. ", -1), ig = { key: 0 }, ug = {
  key: 0,
  class: "mt-5 text-center text-lg text-[#3F4A55] font-serif overflow-y-auto"
}, Ng = { class: "text-center relative text-sm text-[#8C96A1]" }, lg = ["disabled", "textContent"], ng = { key: 0 }, sg = {
  key: 0,
  class: "mt-5 text-center text-lg text-[#3F4A55] font-serif overflow-y-auto"
}, og = { class: "text-center relative text-sm text-[#8C96A1]" }, Zi = 75, HA = /* @__PURE__ */ U({
  __name: "MemeKudoBuilder",
  props: {
    memeTemplates: {},
    message: { default: "" },
    imgUrl: {},
    senderName: {},
    senderEmail: {},
    color: { default: fe[0] },
    initialLabelText: { default: "Your text" },
    labelName: { default: "textarea" },
    branding: {},
    isAuthenticated: { type: Boolean }
  },
  emits: ["update:message", "update:senderName", "update:senderEmail", "update:imgUrl", "update:color", "create"],
  setup(M, { emit: e }) {
    const t = M, i = e;
    p(() => te.get(t.color)[0]);
    const u = E(), N = p(
      () => Zi - t.message.length
    ), n = ZT(OT).smaller("lg"), s = E(), { width: a } = WT(s, void 0, {
      box: "border-box"
    }), o = E(t.memeTemplates[0]), j = E();
    xM(
      o,
      () => {
        const v = new Image();
        v.onload = () => {
          j.value = v;
        }, v.src = o.value, v.crossOrigin = "Anonymous";
      },
      { immediate: !0 }
    );
    const D = E(), r = E();
    let I = "";
    const L = rt([
      {
        text: t.initialLabelText,
        fontSize: 30,
        fontFamily: "impact",
        fill: "white",
        stroke: "black",
        strokeWidth: 2,
        rotation: 0,
        x: 100,
        y: 100,
        scaleX: 1,
        scaleY: 1,
        name: t.labelName + "1",
        draggable: !0
      }
    ]);
    function d(v) {
      const H = L.find(($) => $.name === I);
      if (!H)
        return;
      const F = v.target;
      H.x = F.x(), H.y = F.y(), H.rotation = F.rotation(), H.scaleX = F.scaleX(), H.scaleY = F.scaleY();
    }
    function m(v) {
      const H = v.target;
      if (v.target === H.getStage()) {
        I = "", x();
        return;
      }
      if (H.getParent().className === "Transformer")
        return;
      const $ = H.name();
      L.find((P) => P.name === $) ? I = $ : I = "", x();
    }
    function x() {
      const v = D.value.getNode(), F = v.getStage().findOne("." + I);
      F !== v.node() && (F ? v.nodes([F]) : v.nodes([]));
    }
    function C(v) {
      const H = v.target, F = L.find(($) => $.name === H.name);
      F && (F.text = H.value);
    }
    function Q(v) {
      var $;
      const H = v.target;
      H.value.length > Zi && (($ = u.value) == null || $.shake()), i("update:message", H.value);
    }
    function S() {
      L.push({
        text: t.initialLabelText,
        fontSize: 30,
        fontFamily: "impact",
        fill: "white",
        stroke: "black",
        strokeWidth: 2,
        rotation: 0,
        x: j.value ? a.value / 2 : 100,
        y: j.value ? j.value.height / j.value.width * a.value / 2 : 100,
        scaleX: 1,
        scaleY: 1,
        name: t.labelName + (L.length + 1),
        draggable: !0
      });
    }
    function h(v) {
      const H = L.findIndex((F) => F.name === v);
      L.splice(H, 1), L.forEach((F, $) => {
        F.name = t.labelName + ($ + 1);
      });
    }
    function W(v) {
      const H = v.target, F = L.find(($) => $.name === H.name);
      F && F.text == t.initialLabelText && (F.text = "");
    }
    async function eM() {
      t.branding && (NM(), await zM()), I = "", x();
      const v = r.value.getNode(), H = n ? v.toDataURL({ pixelRatio: 2 }) : v.toDataURL();
      i("update:imgUrl", H), i("create", t);
    }
    function NM() {
      L.push({
        text: t.branding ? t.branding : "",
        fontSize: 14,
        fontFamily: "impact",
        fill: "white",
        stroke: "black",
        strokeWidth: 1,
        rotation: 0,
        x: j.value ? a.value - 200 : 20,
        y: j.value ? j.value.height / j.value.width * a.value - 16 : 2,
        scaleX: 1,
        scaleY: 1,
        name: "branding",
        draggable: !1
      });
    }
    return (v, H) => {
      const F = AM("v-image"), $ = AM("v-text"), X = AM("v-transformer"), P = AM("v-layer"), q = AM("v-stage");
      return c(), g("div", Fr, [
        z(UM, { class: "w-7/12 grow lg:grow-0 shrink-0" }, {
          default: O(() => [
            v.memeTemplates ? (c(), g("div", Xr, [
              (c(!0), g(K, null, lM(v.memeTemplates, (R) => (c(), g("img", {
                key: R,
                src: R,
                onClick: (tM) => o.value = R,
                class: "h-20 w-auto object-cover rounded-lg cursor-pointer grow"
              }, null, 8, Jr))), 128))
            ])) : (c(), g("div", Kr, w("No images"))),
            (c(!0), g(K, null, lM(L, (R) => (c(), g("div", {
              class: "flex items-end space-x-4 space-y-14 mt-14 w-full",
              key: R.name
            }, [
              T("div", Br, [
                z(y(me), {
                  label: R.name,
                  name: R.name,
                  modelValue: R.text,
                  maxlength: "75",
                  onFocus: W,
                  onInput: C,
                  placeholder: "Add some text",
                  inputClass: "bg-[#F8F9FF] border-none resize-none min-h-[11.25rem]",
                  class: "grow"
                }, null, 8, ["label", "name", "modelValue"]),
                T("div", {
                  class: "mt-14 h-16 cursor-pointer aspect-square bg-[#FCDEDE] hover:bg-[#FCACCC] transition-colors duration-300 rounded-full flex items-center justify-center",
                  onClick: (tM) => h(R.name)
                }, [
                  T("img", {
                    src: y(zu),
                    alt: "remove image icon"
                  }, null, 8, Pr)
                ], 8, Hr)
              ])
            ]))), 128)),
            T("button", {
              onClick: S,
              class: "btn btn--tertiary mt-7 w-full lg:w-1/2"
            }, " Add label "),
            J(v.$slots, "additionals", {}, () => [
              T("div", _r, [
                T("div", $r, [
                  z(y(me), {
                    label: "And some extra text to it? No presh. Easy.",
                    modelValue: v.message,
                    onInput: Q,
                    placeholder: "Optional text. If image is enough, don’t push it. Or push it. Listen, your call.",
                    inputClass: "bg-[#F8F9FF] border-none resize-none min-h-[11.25rem]"
                  }, null, 8, ["modelValue"]),
                  z(Et, {
                    ref_key: "charCounterEl",
                    ref: u,
                    class: "right-0 mt-1 absolute",
                    message: v.message,
                    characterLimit: Zi
                  }, null, 8, ["message"])
                ]),
                z(nM, {
                  label: "Your name",
                  type: "text",
                  modelValue: v.senderName,
                  maxlength: "75",
                  onInput: H[0] || (H[0] = (R) => i(
                    "update:senderName",
                    R.target.value
                  )),
                  placeholder: "Or nickname... we are not here to dictate",
                  inputClass: "bg-[#F8F9FF] border-none"
                }, null, 8, ["modelValue"]),
                v.isAuthenticated ? A("", !0) : (c(), g("div", qr, [
                  T("div", Mg, [
                    eg,
                    z(y(oe), {
                      triggers: ["hover"],
                      distance: 20,
                      placement: "top",
                      popperTriggers: ["hover"],
                      delay: { show: 200, hide: 150 }
                    }, {
                      popper: O(() => [
                        tg
                      ]),
                      default: O(() => [
                        z(y(Ee), {
                          class: "cursor-pointer h-4 w-4 fill-[#BBC4CD]",
                          "aria-hidden": "true"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  z(nM, {
                    modelValue: v.senderEmail,
                    type: "email",
                    "onUpdate:modelValue": H[1] || (H[1] = (R) => i("update:senderEmail", R)),
                    placeholder: "Your email",
                    inputClass: "bg-[#F8F9FF] border-none"
                  }, null, 8, ["modelValue"])
                ])),
                A("", !0)
              ])
            ]),
            j.value && y(n) ? (c(), k(UM, {
              key: 2,
              ref_key: "previewEl",
              ref: s,
              class: "block lg:hidden mt-24 mb-12 mx-auto w-3/4"
            }, Pe({
              default: O(() => [
                T("div", {
                  class: V(["-mx-6 md:-mx-12 -mt-12 rounded-[2.5rem] overflow-hidden", { "-mb-12": !v.message && !v.senderName }])
                }, [
                  z(q, {
                    ref_key: "stage",
                    ref: r,
                    config: {
                      width: y(a),
                      height: j.value.height * (y(a) / j.value.width)
                    },
                    onMousedown: m,
                    onTouchstart: m
                  }, {
                    default: O(() => [
                      z(P, { ref: "layer" }, {
                        default: O(() => [
                          z(F, {
                            class: "",
                            config: {
                              image: j.value,
                              width: y(a),
                              height: j.value.height * (y(a) / j.value.width)
                            }
                          }, null, 8, ["config"]),
                          D.value ? (c(), g("div", ig, [
                            (c(!0), g(K, null, lM(L, (R) => (c(), k($, {
                              key: R.name,
                              config: R,
                              onTransformend: d,
                              onDragend: d
                            }, null, 8, ["config"]))), 128))
                          ])) : A("", !0),
                          z(X, {
                            ref_key: "transformer",
                            ref: D
                          }, null, 512)
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  }, 8, ["config"])
                ], 2),
                v.message ? (c(), g("p", ug, w(v.message), 1)) : A("", !0)
              ]),
              _: 2
            }, [
              v.$slots.actions ? {
                name: "actions",
                fn: O(() => [
                  J(v.$slots, "actions")
                ]),
                key: "0"
              } : void 0,
              v.senderName ? {
                name: "footer",
                fn: O(() => [
                  T("div", Ng, w(v.senderName), 1)
                ]),
                key: "1"
              } : void 0
            ]), 1536)) : A("", !0),
            J(v.$slots, "submit", se(xe({ ...t, remainingCharacters: N.value, handleMemeCreate: eM })), () => [
              T("button", {
                onClick: eM,
                class: "btn btn--primary mt-14 self-start",
                disabled: !o.value || N.value < 0,
                textContent: w(
                  o.value ? "Post the Kudo!" : "Create your kudo first"
                )
              }, null, 8, lg)
            ])
          ]),
          _: 3
        }),
        j.value && !y(n) ? (c(), k(UM, {
          key: 0,
          ref_key: "previewEl",
          ref: s,
          class: "hidden lg:block w-fit max-w-xl grow shrink-0"
        }, Pe({
          default: O(() => [
            T("div", {
              class: V(["-mx-12 -mt-12 rounded-[2.5rem] overflow-hidden shrink-0", { "-mb-12": !v.message && !v.senderName }])
            }, [
              z(q, {
                ref_key: "stage",
                ref: r,
                config: {
                  width: y(a),
                  height: j.value.height * (y(a) / j.value.width)
                },
                onMousedown: m,
                onTouchstart: m
              }, {
                default: O(() => [
                  z(P, { ref: "layer" }, {
                    default: O(() => [
                      z(F, {
                        class: "min-h-[20.75rem] max-h-[38.25rem]",
                        config: {
                          image: j.value,
                          width: y(a),
                          height: j.value.height * (y(a) / j.value.width)
                        }
                      }, null, 8, ["config"]),
                      D.value ? (c(), g("div", ng, [
                        (c(!0), g(K, null, lM(L, (R) => (c(), k($, {
                          key: R.name,
                          config: R,
                          onDragend: d,
                          onTransformend: d
                        }, null, 8, ["config"]))), 128))
                      ])) : A("", !0),
                      z(X, {
                        ref_key: "transformer",
                        ref: D
                      }, null, 512)
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              }, 8, ["config"])
            ], 2),
            v.message ? (c(), g("p", sg, w(v.message), 1)) : A("", !0)
          ]),
          _: 2
        }, [
          v.$slots.actions ? {
            name: "actions",
            fn: O(() => [
              J(v.$slots, "actions")
            ]),
            key: "0"
          } : void 0,
          v.senderName ? {
            name: "footer",
            fn: O(() => [
              T("div", og, w(v.senderName), 1)
            ]),
            key: "1"
          } : void 0
        ]), 1536)) : A("", !0)
      ]);
    };
  }
});
var ag = typeof global == "object" && global && global.Object === Object && global;
const jg = ag;
var Tg = typeof self == "object" && self && self.Object === Object && self, cg = jg || Tg || Function("return this")();
const h4 = cg;
var Dg = h4.Symbol;
const _t = Dg;
var C4 = Object.prototype, rg = C4.hasOwnProperty, gg = C4.toString, Nt = _t ? _t.toStringTag : void 0;
function Lg(M) {
  var e = rg.call(M, Nt), t = M[Nt];
  try {
    M[Nt] = void 0;
    var i = !0;
  } catch {
  }
  var u = gg.call(M);
  return i && (e ? M[Nt] = t : delete M[Nt]), u;
}
var Ig = Object.prototype, dg = Ig.toString;
function yg(M) {
  return dg.call(M);
}
var zg = "[object Null]", mg = "[object Undefined]", V0 = _t ? _t.toStringTag : void 0;
function Ag(M) {
  return M == null ? M === void 0 ? mg : zg : V0 && V0 in Object(M) ? Lg(M) : yg(M);
}
function xg(M) {
  return M != null && typeof M == "object";
}
var Eg = "[object Symbol]";
function hg(M) {
  return typeof M == "symbol" || xg(M) && Ag(M) == Eg;
}
var Cg = /\s/;
function Og(M) {
  for (var e = M.length; e-- && Cg.test(M.charAt(e)); )
    ;
  return e;
}
var pg = /^\s+/;
function wg(M) {
  return M && M.slice(0, Og(M) + 1).replace(pg, "");
}
function $t(M) {
  var e = typeof M;
  return M != null && (e == "object" || e == "function");
}
var W0 = 0 / 0, Yg = /^[-+]0x[0-9a-f]+$/i, Sg = /^0b[01]+$/i, Zg = /^0o[0-7]+$/i, kg = parseInt;
function f0(M) {
  if (typeof M == "number")
    return M;
  if (hg(M))
    return W0;
  if ($t(M)) {
    var e = typeof M.valueOf == "function" ? M.valueOf() : M;
    M = $t(e) ? e + "" : e;
  }
  if (typeof M != "string")
    return M === 0 ? M : +M;
  M = wg(M);
  var t = Sg.test(M);
  return t || Zg.test(M) ? kg(M.slice(2), t ? 2 : 8) : Yg.test(M) ? W0 : +M;
}
var bg = function() {
  return h4.Date.now();
};
const ki = bg;
var Ug = "Expected a function", Qg = Math.max, Vg = Math.min;
function Wg(M, e, t) {
  var i, u, N, l, n, s, a = 0, o = !1, j = !1, D = !0;
  if (typeof M != "function")
    throw new TypeError(Ug);
  e = f0(e) || 0, $t(t) && (o = !!t.leading, j = "maxWait" in t, N = j ? Qg(f0(t.maxWait) || 0, e) : N, D = "trailing" in t ? !!t.trailing : D);
  function r(h) {
    var W = i, eM = u;
    return i = u = void 0, a = h, l = M.apply(eM, W), l;
  }
  function I(h) {
    return a = h, n = setTimeout(m, e), o ? r(h) : l;
  }
  function L(h) {
    var W = h - s, eM = h - a, NM = e - W;
    return j ? Vg(NM, N - eM) : NM;
  }
  function d(h) {
    var W = h - s, eM = h - a;
    return s === void 0 || W >= e || W < 0 || j && eM >= N;
  }
  function m() {
    var h = ki();
    if (d(h))
      return x(h);
    n = setTimeout(m, L(h));
  }
  function x(h) {
    return n = void 0, D && i ? r(h) : (i = u = void 0, l);
  }
  function C() {
    n !== void 0 && clearTimeout(n), a = 0, i = s = u = n = void 0;
  }
  function Q() {
    return n === void 0 ? l : x(ki());
  }
  function S() {
    var h = ki(), W = d(h);
    if (i = arguments, u = this, s = h, W) {
      if (n === void 0)
        return I(s);
      if (j)
        return clearTimeout(n), n = setTimeout(m, e), r(s);
    }
    return n === void 0 && (n = setTimeout(m, e)), l;
  }
  return S.cancel = C, S.flush = Q, S;
}
var fg = "Expected a function";
function vg(M, e, t) {
  var i = !0, u = !0;
  if (typeof M != "function")
    throw new TypeError(fg);
  return $t(t) && (i = "leading" in t ? !!t.leading : i, u = "trailing" in t ? !!t.trailing : u), Wg(M, e, {
    leading: i,
    maxWait: e,
    trailing: u
  });
}
function Gg(M) {
  if (M.__esModule)
    return M;
  var e = M.default;
  if (typeof e == "function") {
    var t = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(M).forEach(function(i) {
    var u = Object.getOwnPropertyDescriptor(M, i);
    Object.defineProperty(t, i, u.get ? u : {
      enumerable: !0,
      get: function() {
        return M[i];
      }
    });
  }), t;
}
var Rg = { exports: {} };
(function(M) {
  var e = function(t) {
    var i = Object.prototype, u = i.hasOwnProperty, N = Object.defineProperty || function(b, Z, G) {
      b[Z] = G.value;
    }, l, n = typeof Symbol == "function" ? Symbol : {}, s = n.iterator || "@@iterator", a = n.asyncIterator || "@@asyncIterator", o = n.toStringTag || "@@toStringTag";
    function j(b, Z, G) {
      return Object.defineProperty(b, Z, {
        value: G,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), b[Z];
    }
    try {
      j({}, "");
    } catch {
      j = function(Z, G, Y) {
        return Z[G] = Y;
      };
    }
    function D(b, Z, G, Y) {
      var f = Z && Z.prototype instanceof C ? Z : C, MM = Object.create(f.prototype), EM = new q(Y || []);
      return N(MM, "_invoke", { value: F(b, G, EM) }), MM;
    }
    t.wrap = D;
    function r(b, Z, G) {
      try {
        return { type: "normal", arg: b.call(Z, G) };
      } catch (Y) {
        return { type: "throw", arg: Y };
      }
    }
    var I = "suspendedStart", L = "suspendedYield", d = "executing", m = "completed", x = {};
    function C() {
    }
    function Q() {
    }
    function S() {
    }
    var h = {};
    j(h, s, function() {
      return this;
    });
    var W = Object.getPrototypeOf, eM = W && W(W(R([])));
    eM && eM !== i && u.call(eM, s) && (h = eM);
    var NM = S.prototype = C.prototype = Object.create(h);
    Q.prototype = S, N(NM, "constructor", { value: S, configurable: !0 }), N(
      S,
      "constructor",
      { value: Q, configurable: !0 }
    ), Q.displayName = j(
      S,
      o,
      "GeneratorFunction"
    );
    function v(b) {
      ["next", "throw", "return"].forEach(function(Z) {
        j(b, Z, function(G) {
          return this._invoke(Z, G);
        });
      });
    }
    t.isGeneratorFunction = function(b) {
      var Z = typeof b == "function" && b.constructor;
      return Z ? Z === Q || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (Z.displayName || Z.name) === "GeneratorFunction" : !1;
    }, t.mark = function(b) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(b, S) : (b.__proto__ = S, j(b, o, "GeneratorFunction")), b.prototype = Object.create(NM), b;
    }, t.awrap = function(b) {
      return { __await: b };
    };
    function H(b, Z) {
      function G(MM, EM, ZM, OM) {
        var pM = r(b[MM], b, EM);
        if (pM.type === "throw")
          OM(pM.arg);
        else {
          var Li = pM.arg, tt = Li.value;
          return tt && typeof tt == "object" && u.call(tt, "__await") ? Z.resolve(tt.__await).then(function(Ce) {
            G("next", Ce, ZM, OM);
          }, function(Ce) {
            G("throw", Ce, ZM, OM);
          }) : Z.resolve(tt).then(function(Ce) {
            Li.value = Ce, ZM(Li);
          }, function(Ce) {
            return G("throw", Ce, ZM, OM);
          });
        }
      }
      var Y;
      function f(MM, EM) {
        function ZM() {
          return new Z(function(OM, pM) {
            G(MM, EM, OM, pM);
          });
        }
        return Y = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        Y ? Y.then(
          ZM,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          ZM
        ) : ZM();
      }
      N(this, "_invoke", { value: f });
    }
    v(H.prototype), j(H.prototype, a, function() {
      return this;
    }), t.AsyncIterator = H, t.async = function(b, Z, G, Y, f) {
      f === void 0 && (f = Promise);
      var MM = new H(
        D(b, Z, G, Y),
        f
      );
      return t.isGeneratorFunction(Z) ? MM : MM.next().then(function(EM) {
        return EM.done ? EM.value : MM.next();
      });
    };
    function F(b, Z, G) {
      var Y = I;
      return function(MM, EM) {
        if (Y === d)
          throw new Error("Generator is already running");
        if (Y === m) {
          if (MM === "throw")
            throw EM;
          return tM();
        }
        for (G.method = MM, G.arg = EM; ; ) {
          var ZM = G.delegate;
          if (ZM) {
            var OM = $(ZM, G);
            if (OM) {
              if (OM === x)
                continue;
              return OM;
            }
          }
          if (G.method === "next")
            G.sent = G._sent = G.arg;
          else if (G.method === "throw") {
            if (Y === I)
              throw Y = m, G.arg;
            G.dispatchException(G.arg);
          } else
            G.method === "return" && G.abrupt("return", G.arg);
          Y = d;
          var pM = r(b, Z, G);
          if (pM.type === "normal") {
            if (Y = G.done ? m : L, pM.arg === x)
              continue;
            return {
              value: pM.arg,
              done: G.done
            };
          } else
            pM.type === "throw" && (Y = m, G.method = "throw", G.arg = pM.arg);
        }
      };
    }
    function $(b, Z) {
      var G = Z.method, Y = b.iterator[G];
      if (Y === l)
        return Z.delegate = null, G === "throw" && b.iterator.return && (Z.method = "return", Z.arg = l, $(b, Z), Z.method === "throw") || G !== "return" && (Z.method = "throw", Z.arg = new TypeError(
          "The iterator does not provide a '" + G + "' method"
        )), x;
      var f = r(Y, b.iterator, Z.arg);
      if (f.type === "throw")
        return Z.method = "throw", Z.arg = f.arg, Z.delegate = null, x;
      var MM = f.arg;
      if (!MM)
        return Z.method = "throw", Z.arg = new TypeError("iterator result is not an object"), Z.delegate = null, x;
      if (MM.done)
        Z[b.resultName] = MM.value, Z.next = b.nextLoc, Z.method !== "return" && (Z.method = "next", Z.arg = l);
      else
        return MM;
      return Z.delegate = null, x;
    }
    v(NM), j(NM, o, "Generator"), j(NM, s, function() {
      return this;
    }), j(NM, "toString", function() {
      return "[object Generator]";
    });
    function X(b) {
      var Z = { tryLoc: b[0] };
      1 in b && (Z.catchLoc = b[1]), 2 in b && (Z.finallyLoc = b[2], Z.afterLoc = b[3]), this.tryEntries.push(Z);
    }
    function P(b) {
      var Z = b.completion || {};
      Z.type = "normal", delete Z.arg, b.completion = Z;
    }
    function q(b) {
      this.tryEntries = [{ tryLoc: "root" }], b.forEach(X, this), this.reset(!0);
    }
    t.keys = function(b) {
      var Z = Object(b), G = [];
      for (var Y in Z)
        G.push(Y);
      return G.reverse(), function f() {
        for (; G.length; ) {
          var MM = G.pop();
          if (MM in Z)
            return f.value = MM, f.done = !1, f;
        }
        return f.done = !0, f;
      };
    };
    function R(b) {
      if (b) {
        var Z = b[s];
        if (Z)
          return Z.call(b);
        if (typeof b.next == "function")
          return b;
        if (!isNaN(b.length)) {
          var G = -1, Y = function f() {
            for (; ++G < b.length; )
              if (u.call(b, G))
                return f.value = b[G], f.done = !1, f;
            return f.value = l, f.done = !0, f;
          };
          return Y.next = Y;
        }
      }
      return { next: tM };
    }
    t.values = R;
    function tM() {
      return { value: l, done: !0 };
    }
    return q.prototype = {
      constructor: q,
      reset: function(b) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = l, this.done = !1, this.delegate = null, this.method = "next", this.arg = l, this.tryEntries.forEach(P), !b)
          for (var Z in this)
            Z.charAt(0) === "t" && u.call(this, Z) && !isNaN(+Z.slice(1)) && (this[Z] = l);
      },
      stop: function() {
        this.done = !0;
        var b = this.tryEntries[0], Z = b.completion;
        if (Z.type === "throw")
          throw Z.arg;
        return this.rval;
      },
      dispatchException: function(b) {
        if (this.done)
          throw b;
        var Z = this;
        function G(OM, pM) {
          return MM.type = "throw", MM.arg = b, Z.next = OM, pM && (Z.method = "next", Z.arg = l), !!pM;
        }
        for (var Y = this.tryEntries.length - 1; Y >= 0; --Y) {
          var f = this.tryEntries[Y], MM = f.completion;
          if (f.tryLoc === "root")
            return G("end");
          if (f.tryLoc <= this.prev) {
            var EM = u.call(f, "catchLoc"), ZM = u.call(f, "finallyLoc");
            if (EM && ZM) {
              if (this.prev < f.catchLoc)
                return G(f.catchLoc, !0);
              if (this.prev < f.finallyLoc)
                return G(f.finallyLoc);
            } else if (EM) {
              if (this.prev < f.catchLoc)
                return G(f.catchLoc, !0);
            } else if (ZM) {
              if (this.prev < f.finallyLoc)
                return G(f.finallyLoc);
            } else
              throw new Error("try statement without catch or finally");
          }
        }
      },
      abrupt: function(b, Z) {
        for (var G = this.tryEntries.length - 1; G >= 0; --G) {
          var Y = this.tryEntries[G];
          if (Y.tryLoc <= this.prev && u.call(Y, "finallyLoc") && this.prev < Y.finallyLoc) {
            var f = Y;
            break;
          }
        }
        f && (b === "break" || b === "continue") && f.tryLoc <= Z && Z <= f.finallyLoc && (f = null);
        var MM = f ? f.completion : {};
        return MM.type = b, MM.arg = Z, f ? (this.method = "next", this.next = f.finallyLoc, x) : this.complete(MM);
      },
      complete: function(b, Z) {
        if (b.type === "throw")
          throw b.arg;
        return b.type === "break" || b.type === "continue" ? this.next = b.arg : b.type === "return" ? (this.rval = this.arg = b.arg, this.method = "return", this.next = "end") : b.type === "normal" && Z && (this.next = Z), x;
      },
      finish: function(b) {
        for (var Z = this.tryEntries.length - 1; Z >= 0; --Z) {
          var G = this.tryEntries[Z];
          if (G.finallyLoc === b)
            return this.complete(G.completion, G.afterLoc), P(G), x;
        }
      },
      catch: function(b) {
        for (var Z = this.tryEntries.length - 1; Z >= 0; --Z) {
          var G = this.tryEntries[Z];
          if (G.tryLoc === b) {
            var Y = G.completion;
            if (Y.type === "throw") {
              var f = Y.arg;
              P(G);
            }
            return f;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(b, Z, G) {
        return this.delegate = {
          iterator: R(b),
          resultName: Z,
          nextLoc: G
        }, this.method === "next" && (this.arg = l), x;
      }
    }, t;
  }(
    // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    M.exports
  );
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
})(Rg);
var Fg = {
  defaultArgs: [
    /* args[0] is always the binary path */
    "./ffmpeg",
    /* Disable interaction mode */
    "-nostdin",
    /* Force to override output file */
    "-y"
  ],
  baseOptions: {
    /* Flag to turn on/off log messages in console */
    log: !1,
    /*
     * Custom logger to get ffmpeg.wasm output messages.
     * a sample logger looks like this:
     *
     * ```
     * logger = ({ type, message }) => {
     *   console.log(type, message);
     * }
     * ```
     *
     * type can be one of following:
     *
     * info: internal workflow debug messages
     * fferr: ffmpeg native stderr output
     * ffout: ffmpeg native stdout output
     */
    logger: () => {
    },
    /*
     * Progress handler to get current progress of ffmpeg command.
     * a sample progress handler looks like this:
     *
     * ```
     * progress = ({ ratio }) => {
     *   console.log(ratio);
     * }
     * ```
     *
     * ratio is a float number between 0 to 1.
     */
    progress: () => {
    },
    /*
     * Path to find/download ffmpeg.wasm-core,
     * this value should be overwriten by `defaultOptions` in
     * each environment.
     */
    corePath: ""
  }
}, Xg = (M, e) => {
  const t = M._malloc(e.length * Uint32Array.BYTES_PER_ELEMENT);
  return e.forEach((i, u) => {
    const N = M.lengthBytesUTF8(i) + 1, l = M._malloc(N);
    M.stringToUTF8(i, l, N), M.setValue(t + Uint32Array.BYTES_PER_ELEMENT * u, l, "i32");
  }), [e.length, t];
};
const Jg = "@ffmpeg/ffmpeg", Kg = "0.11.6", Bg = "FFmpeg WebAssembly version", Hg = "src/index.js", Pg = "src/index.d.ts", _g = {
  example: "examples"
}, $g = {
  start: "node scripts/server.js",
  "start:worker": "node scripts/worker-server.js",
  build: "rimraf dist && webpack --config scripts/webpack.config.prod.js",
  "build:worker": "rimraf dist && webpack --config scripts/webpack.config.worker.prod.js",
  prepublishOnly: "npm run build",
  lint: "eslint src",
  wait: "rimraf dist && wait-on http://localhost:3000/dist/ffmpeg.dev.js",
  test: "npm-run-all -p -r start test:all",
  "test:all": "npm-run-all wait test:browser:ffmpeg test:node:all",
  "test:node": "node node_modules/mocha/bin/_mocha --exit --bail --require ./scripts/test-helper.js",
  "test:node:all": "npm run test:node -- ./tests/*.test.js",
  "test:browser": "mocha-headless-chrome -a allow-file-access-from-files -a incognito -a no-sandbox -a disable-setuid-sandbox -a disable-logging -t 300000",
  "test:browser:ffmpeg": "npm run test:browser -- -f ./tests/ffmpeg.test.html"
}, qg = {
  "./src/node/index.js": "./src/browser/index.js"
}, M2 = {
  type: "git",
  url: "git+https://github.com/ffmpegwasm/ffmpeg.wasm.git"
}, e2 = [
  "ffmpeg",
  "WebAssembly",
  "video"
], t2 = "Jerome Wu <jeromewus@gmail.com>", i2 = "MIT", u2 = {
  url: "https://github.com/ffmpegwasm/ffmpeg.wasm/issues"
}, N2 = {
  node: ">=12.16.1"
}, l2 = "https://github.com/ffmpegwasm/ffmpeg.wasm#readme", n2 = {
  "is-url": "^1.2.4",
  "node-fetch": "^2.6.1",
  "regenerator-runtime": "^0.13.7",
  "resolve-url": "^0.2.1"
}, s2 = {
  "@babel/core": "^7.12.3",
  "@babel/preset-env": "^7.12.1",
  "@ffmpeg/core": "^0.11.0",
  "@types/emscripten": "^1.39.4",
  "babel-eslint": "^10.1.0",
  "babel-loader": "^8.1.0",
  chai: "^4.2.0",
  cors: "^2.8.5",
  eslint: "^7.12.1",
  "eslint-config-airbnb-base": "^14.1.0",
  "eslint-plugin-import": "^2.22.1",
  express: "^4.17.1",
  mocha: "^8.2.1",
  "mocha-headless-chrome": "^2.0.3",
  "npm-run-all": "^4.1.5",
  "wait-on": "^5.3.0",
  webpack: "^5.3.2",
  "webpack-cli": "^4.1.0",
  "webpack-dev-middleware": "^4.0.0"
}, O4 = {
  name: Jg,
  version: Kg,
  description: Bg,
  main: Hg,
  types: Pg,
  directories: _g,
  scripts: $g,
  browser: qg,
  repository: M2,
  keywords: e2,
  author: t2,
  license: i2,
  bugs: u2,
  engines: N2,
  homepage: l2,
  dependencies: n2,
  devDependencies: s2
}, o2 = typeof process < "u" && process.env.NODE_ENV === "development" ? new URL("data:application/javascript;base64,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", self.location).href : `https://unpkg.com/@ffmpeg/core@${O4.devDependencies["@ffmpeg/core"].substring(1)}/dist/ffmpeg-core.js`, a2 = { corePath: o2 };
let fu = !1, p4 = () => {
};
const j2 = (M) => {
  fu = M;
}, T2 = (M) => {
  p4 = M;
}, c2 = (M, e) => {
  p4({ type: M, message: e }), fu && console.log(`[${M}] ${e}`);
};
var Ze = {
  logging: fu,
  setLogging: j2,
  setCustomLogger: T2,
  log: c2
};
const D2 = (M) => `
createFFmpegCore is not defined. ffmpeg.wasm is unable to find createFFmpegCore after loading ffmpeg-core.js from ${M}. Use another URL when calling createFFmpeg():

const ffmpeg = createFFmpeg({
  corePath: 'http://localhost:3000/ffmpeg-core.js',
});
`;
var v0 = {
  CREATE_FFMPEG_CORE_IS_NOT_DEFINED: D2
};
const Xe = async (M, e) => {
  Ze.log("info", `fetch ${M}`);
  const t = await (await fetch(M)).arrayBuffer();
  Ze.log("info", `${M} file size = ${t.byteLength} bytes`);
  const i = new Blob([t], { type: e }), u = URL.createObjectURL(i);
  return Ze.log("info", `${M} blob URL = ${u}`), u;
}, r2 = async ({
  corePath: M,
  workerPath: e,
  wasmPath: t
}) => {
  if (typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope) {
    if (typeof M != "string")
      throw Error("corePath should be a string!");
    const n = new URL(M, import.meta.url).href, s = await Xe(
      n,
      "application/javascript"
    ), a = await Xe(
      t !== void 0 ? t : n.replace("ffmpeg-core.js", "ffmpeg-core.wasm"),
      "application/wasm"
    ), o = await Xe(
      e !== void 0 ? e : n.replace("ffmpeg-core.js", "ffmpeg-core.worker.js"),
      "application/javascript"
    );
    return typeof createFFmpegCore > "u" ? new Promise((j) => {
      if (globalThis.importScripts(s), typeof createFFmpegCore > "u")
        throw Error(v0.CREATE_FFMPEG_CORE_IS_NOT_DEFINED(n));
      Ze.log("info", "ffmpeg-core.js script loaded"), j({
        createFFmpegCore,
        corePath: s,
        wasmPath: a,
        workerPath: o
      });
    }) : (Ze.log("info", "ffmpeg-core.js script is loaded already"), Promise.resolve({
      createFFmpegCore,
      corePath: s,
      wasmPath: a,
      workerPath: o
    }));
  }
  if (typeof M != "string")
    throw Error("corePath should be a string!");
  const i = new URL(M, import.meta.url).href, u = await Xe(
    i,
    "application/javascript"
  ), N = await Xe(
    t !== void 0 ? t : i.replace("ffmpeg-core.js", "ffmpeg-core.wasm"),
    "application/wasm"
  ), l = await Xe(
    e !== void 0 ? e : i.replace("ffmpeg-core.js", "ffmpeg-core.worker.js"),
    "application/javascript"
  );
  return typeof createFFmpegCore > "u" ? new Promise((n) => {
    const s = document.createElement("script"), a = () => {
      if (s.removeEventListener("load", a), typeof createFFmpegCore > "u")
        throw Error(v0.CREATE_FFMPEG_CORE_IS_NOT_DEFINED(i));
      Ze.log("info", "ffmpeg-core.js script loaded"), n({
        createFFmpegCore,
        corePath: u,
        wasmPath: N,
        workerPath: l
      });
    };
    s.src = u, s.type = "text/javascript", s.addEventListener("load", a), document.getElementsByTagName("head")[0].appendChild(s);
  }) : (Ze.log("info", "ffmpeg-core.js script is loaded already"), Promise.resolve({
    createFFmpegCore,
    corePath: u,
    wasmPath: N,
    workerPath: l
  }));
}, g2 = (M) => new Promise((e, t) => {
  const i = new FileReader();
  i.onload = () => {
    e(i.result);
  }, i.onerror = ({ target: { error: { code: u } } }) => {
    t(Error(`File could not be read! Code=${u}`));
  }, i.readAsArrayBuffer(M);
}), L2 = async (M) => {
  let e = M;
  return typeof M > "u" ? new Uint8Array() : (typeof M == "string" ? /data:_data\/([a-zA-Z]*);base64,([^"]*)/.test(M) ? e = atob(M.split(",")[1]).split("").map((t) => t.charCodeAt(0)) : e = await (await fetch(new URL(M, import.meta.url).href)).arrayBuffer() : (M instanceof File || M instanceof Blob) && (e = await g2(M)), new Uint8Array(e));
}, I2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultOptions: a2,
  fetchFile: L2,
  getCreateFFmpegCore: r2
}, Symbol.toStringTag, { value: "Module" })), w4 = /* @__PURE__ */ Gg(I2), { defaultArgs: d2, baseOptions: y2 } = Fg, z2 = Xg, { defaultOptions: m2, getCreateFFmpegCore: A2 } = w4, { version: x2 } = O4, bi = Error("ffmpeg.wasm is not ready, make sure you have completed load().");
var E2 = (M = {}) => {
  const {
    log: e,
    logger: t,
    progress: i,
    ...u
  } = {
    ...y2,
    ...m2,
    ...M
  };
  let N = null, l = null, n = null, s = null, a = !1, o = () => {
  }, j = e, D = i, r = 0, I = 0, L = !1, d = 0;
  const m = (X) => {
    X === "FFMPEG_END" && n !== null && (n(), n = null, s = null, a = !1);
  }, x = (X, P) => {
    o({ type: X, message: P }), j && console.log(`[${X}] ${P}`);
  }, C = (X) => {
    const [P, q, R] = X.split(":");
    return parseFloat(P) * 60 * 60 + parseFloat(q) * 60 + parseFloat(R);
  }, Q = (X, P) => {
    if (typeof X == "string")
      if (X.startsWith("  Duration")) {
        const q = X.split(", ")[0].split(": ")[1], R = C(q);
        P({ duration: R, ratio: d }), (r === 0 || r > R) && (r = R, L = !0);
      } else if (L && X.startsWith("    Stream")) {
        const q = X.match(/([\d.]+) fps/);
        if (q) {
          const R = parseFloat(q[1]);
          I = r * R;
        } else
          I = 0;
        L = !1;
      } else if (X.startsWith("frame") || X.startsWith("size")) {
        const q = X.split("time=")[1].split(" ")[0], R = C(q), tM = X.match(/frame=\s*(\d+)/);
        if (I && tM) {
          const b = parseFloat(tM[1]);
          d = Math.min(b / I, 1);
        } else
          d = R / r;
        P({ ratio: d, time: R });
      } else
        X.startsWith("video:") && (P({ ratio: 1 }), r = 0);
  }, S = ({ type: X, message: P }) => {
    x(X, P), Q(P, D), m(P);
  }, h = async () => {
    if (x("info", "load ffmpeg-core"), N === null) {
      x("info", "loading ffmpeg-core");
      const {
        createFFmpegCore: X,
        corePath: P,
        workerPath: q,
        wasmPath: R
      } = await A2(u);
      N = await X({
        /*
         * Assign mainScriptUrlOrBlob fixes chrome extension web worker issue
         * as there is no document.currentScript in the context of content_scripts
         */
        mainScriptUrlOrBlob: P,
        printErr: (tM) => S({ type: "fferr", message: tM }),
        print: (tM) => S({ type: "ffout", message: tM }),
        /*
         * locateFile overrides paths of files that is loaded by main script (ffmpeg-core.js).
         * It is critical for browser environment and we override both wasm and worker paths
         * as we are using blob URL instead of original URL to avoid cross origin issues.
         */
        locateFile: (tM, b) => {
          if (typeof window < "u" || typeof WorkerGlobalScope < "u") {
            if (typeof R < "u" && tM.endsWith("ffmpeg-core.wasm"))
              return R;
            if (typeof q < "u" && tM.endsWith("ffmpeg-core.worker.js"))
              return q;
          }
          return b + tM;
        }
      }), l = N.cwrap(u.mainName || "proxy_main", "number", ["number", "number"]), x("info", "ffmpeg-core loaded");
    } else
      throw Error("ffmpeg.wasm was loaded, you should not load it again, use ffmpeg.isLoaded() to check next time.");
  }, W = () => N !== null, eM = (...X) => {
    if (x("info", `run ffmpeg command: ${X.join(" ")}`), N === null)
      throw bi;
    if (a)
      throw Error("ffmpeg.wasm can only run one command at a time");
    return a = !0, new Promise((P, q) => {
      const R = [...d2, ...X].filter((tM) => tM.length !== 0);
      n = P, s = q, l(...z2(N, R));
    });
  }, NM = (X, ...P) => {
    if (x("info", `run FS.${X} ${P.map((q) => typeof q == "string" ? q : `<${q.length} bytes binary file>`).join(" ")}`), N === null)
      throw bi;
    {
      let q = null;
      try {
        q = N.FS[X](...P);
      } catch {
        throw Error(X === "readdir" ? `ffmpeg.FS('readdir', '${P[0]}') error. Check if the path exists, ex: ffmpeg.FS('readdir', '/')` : X === "readFile" ? `ffmpeg.FS('readFile', '${P[0]}') error. Check if the path exists` : "Oops, something went wrong in FS operation.");
      }
      return q;
    }
  }, v = () => {
    if (N === null)
      throw bi;
    s && s("ffmpeg has exited"), a = !1;
    try {
      N.exit(1);
    } catch (X) {
      x(X.message), s && s(X);
    } finally {
      N = null, l = null, n = null, s = null;
    }
  }, H = (X) => {
    D = X;
  }, F = (X) => {
    o = X;
  }, $ = (X) => {
    j = X;
  };
  return x("info", `use ffmpeg.wasm v${x2}`), {
    setProgress: H,
    setLogger: F,
    setLogging: $,
    load: h,
    isLoaded: W,
    run: eM,
    exit: v,
    FS: NM
  };
};
const h2 = E2, { fetchFile: C2 } = w4;
var G0 = {
  /*
   * Create ffmpeg instance.
   * Each ffmpeg instance owns an isolated MEMFS and works
   * independently.
   *
   * For example:
   *
   * ```
   * const ffmpeg = createFFmpeg({
   *  log: true,
   *  logger: () => {},
   *  progress: () => {},
   *  corePath: '',
   * })
   * ```
   *
   * For the usage of these four arguments, check config.js
   *
   */
  createFFmpeg: h2,
  /*
   * Helper function for fetching files from various resource.
   * Sometimes the video/audio file you want to process may located
   * in a remote URL and somewhere in your local file system.
   *
   * This helper function helps you to fetch to file and return an
   * Uint8Array variable for ffmpeg.wasm to consume.
   *
   */
  fetchFile: C2
};
const O2 = { class: "trim-slider relative h-1 bg-[#DBDBF9] rounded-md w-full" }, p2 = ["value", "onInput", "min", "max", "step"], R0 = /* @__PURE__ */ U({
  __name: "TrimSlider",
  props: {
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = E(!1), N = p(() => t.modelValue[0] / t.max * 100), l = p(() => 100 - t.modelValue.slice(-1)[0] / t.max * 100);
    function n(s, a) {
      const o = [...t.modelValue];
      o[a] = s, i("update:modelValue", o, a);
    }
    return (s, a) => (c(), g("div", O2, [
      T("div", {
        class: "fill absolute top-0 bottom-0 bg-[#FFCE21] rounded-md z-10",
        style: RM({ left: `${N.value}%`, right: `${l.value}%` })
      }, null, 4),
      (c(!0), g(K, null, lM(s.modelValue, (o, j) => (c(), g("input", DM({
        key: j,
        type: "range",
        value: o
      }, pN(
        j !== 1 ? {
          mousedown: () => u.value = !0,
          mouseup: () => u.value = !1
        } : {},
        !0
      ), {
        onInput: (D) => n(+D.target.value, j),
        min: s.min,
        max: s.max,
        step: s.step,
        class: ["absolute h-full w-full appearance-none bg-inherit rounded-md", [
          j === 0 ? "trim-left" : j === s.modelValue.length - 1 ? "trim-right" : "playhead",
          u.value && j === 1 ? "hidden" : null
        ]]
      }), null, 16, p2))), 128))
    ]));
  }
}), w2 = { class: "flex justify-between items-start gap-x-28 max-w-screen-xl mx-auto" }, Y2 = { key: 0 }, S2 = { class: "relative" }, Z2 = { key: 3 }, k2 = { class: "flex" }, b2 = /* @__PURE__ */ T("span", { class: "input-label" }, "Email(optional)", -1), U2 = /* @__PURE__ */ T("div", { class: "w-56 font-semibold" }, " We will never send you any spam. This is just for the confirmation of this kudo post and our anti-spam protection. ", -1), Q2 = {
  key: 5,
  class: "mx-auto"
}, V2 = { class: "absolute bottom-5 w-full px-8 flex items-center gap-x-3" }, W2 = {
  key: 1,
  class: "grow-0 shrink-0 text-xs bg-white text-[#1212E0] py-1 rounded-md w-14 text-center"
}, f2 = {
  key: 0,
  class: "overlay absolute inset-0 bg-[hsla(231,100%,99%,0.95)] z-10 flex items-center justify-center"
}, v2 = ["value"], G2 = /* @__PURE__ */ T("p", { class: "text-sm text-[#1212E0] mt-4 text-center" }, " Processing the video... ", -1), R2 = ["disabled", "textContent"], F2 = { key: 0 }, X2 = { class: "absolute bottom-5 w-full px-8 flex items-center gap-x-3" }, J2 = {
  key: 1,
  class: "grow-0 shrink-0 text-xs bg-white text-[#1212E0] py-1 rounded-md w-14 text-center"
}, K2 = {
  key: 0,
  class: "overlay absolute inset-0 bg-[hsla(231,100%,99%,0.95)] z-10 flex items-center justify-center"
}, B2 = ["value"], H2 = /* @__PURE__ */ T("p", { class: "text-sm text-[#1212E0] mt-4 text-center" }, " Processing the video... ", -1), Ui = 75, PA = /* @__PURE__ */ U({
  __name: "VideoKudoBuilder",
  props: {
    message: {},
    video: {},
    ytUrl: {},
    senderName: {},
    senderEmail: {},
    color: { default: fe[0] },
    isAuthenticated: { type: Boolean }
  },
  emits: ["update:message", "update:senderName", "update:senderEmail", "update:video", "update:ytUrl", "update:color", "create"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = E(0), N = rt({
      trim: { start: 0, end: void 0 }
    }), l = rt({
      duration: void 0,
      currentTime: 0,
      isPlaying: !1
    }), n = E(), s = p(() => {
      if (L.value !== void 0 && n.value !== void 0)
        return n.value / L.value * 100;
    }), a = p(() => {
      if (t.video)
        return URL.createObjectURL(t.video);
    }), o = E(
      null
    );
    let j = null;
    const D = p(() => te.get(t.color)[0]), r = E(), I = p(
      () => Ui - t.message.length
    ), L = p(() => {
      if (l.duration !== void 0)
        return (N.trim.end ?? l.duration) - N.trim.start;
    }), d = p(() => {
      if (o.value)
        return o.value.videoEl;
    }), m = Je("(min-width: 1024px)");
    xM(
      d,
      () => {
        d.value && (d.value.onloadedmetadata = function() {
          l.duration = R(d.value.duration, 1), N.trim.end = l.duration;
        }, d.value.ontimeupdate = function(f) {
          const MM = f.target;
          l.currentTime = MM.currentTime;
        }, d.value.onplay = () => l.isPlaying = !0, d.value.onpause = () => l.isPlaying = !1);
      },
      { flush: "post" }
    ), xM(
      () => l.currentTime,
      (Y) => {
        const f = Y >= N.trim.end;
        l.isPlaying && f && x();
      }
    );
    function x() {
      W(N.trim.start);
    }
    const C = p(
      () => l.isPlaying ? A1 : x1
    );
    function Q() {
      var Y;
      (Y = d.value) == null || Y.play();
    }
    function S() {
      var Y;
      (Y = d.value) == null || Y.pause();
    }
    function h() {
      l.isPlaying ? S() : Q();
    }
    function W(Y) {
      d.value && (d.value.currentTime = Y);
    }
    function eM(Y) {
      N.trim.start = Y;
    }
    function NM(Y) {
      N.trim.end = Y;
    }
    function v(Y) {
      S(), eM(Y), W(Y);
    }
    function H(Y) {
      S(), NM(Y), W(Y);
    }
    function F(Y) {
      var EM;
      const f = Y.target;
      f.value.length > Ui && ((EM = r.value) == null || EM.shake()), i("update:message", f.value);
    }
    async function $() {
      const Y = G0.createFFmpeg({
        log: !1,
        progress: ({ time: f = 0 }) => {
          n.value = f;
        }
      });
      return await Y.load(), Promise.resolve(Y);
    }
    async function X(Y) {
      i("update:video", Y);
    }
    async function P() {
      if (!t.video)
        return;
      n.value = 0.01;
      const Y = j === null ? await $() : await j;
      Y.FS("writeFile", "video.mp4", await G0.fetchFile(t.video)), await Y.run(
        "-ss",
        `${N.trim.start}`,
        "-t",
        `${L.value}`,
        "-i",
        "video.mp4",
        "-vf",
        //eslint-disable-next-line
        "scale=w=576:h=720:force_original_aspect_ratio=decrease,crop='iw-mod(iw,2)':'ih-mod(ih,2)'",
        "-crf",
        "18",
        "-f",
        "mp4",
        `${t.video.name}`
      );
      const f = Y.FS("readFile", t.video.name);
      i(
        "update:video",
        new File([new Blob([f.buffer], { type: "video/mp4" })], t.video.name)
      );
    }
    async function q() {
      try {
        await P();
      } finally {
        n.value = void 0;
      }
      i("create", t);
    }
    function R(Y, f = 2) {
      const MM = Math.pow(10, f);
      return Math.floor(Y * MM) / MM;
    }
    function tM() {
      i("update:video", void 0);
    }
    function b() {
      u.value += 1;
    }
    const Z = vg(
      (Y, f) => {
        const [MM, EM, ZM] = Y;
        if (f === 0) {
          const OM = Math.min(MM, ZM), pM = N.trim.start;
          v(OM), OM === pM && b();
        } else if (f === 1)
          W(EM);
        else if (f === 2) {
          const OM = Math.max(ZM, MM), pM = N.trim.end;
          H(OM), OM === pM && b();
        }
      },
      1e3 / 30
    );
    function G() {
      t.video && tM(), j = $();
    }
    return (Y, f) => (c(), g("div", w2, [
      z(y(UM), { class: "w-7/12 grow lg:grow-0 shrink-0 space-y-14" }, {
        default: O(() => [
          Y.ytUrl ? A("", !0) : (c(), g("div", Y2, [
            z(y(TN), {
              name: "video",
              label: "Upload Video",
              modelValue: Y.video,
              onClick: G,
              "onUpdate:modelValue": f[0] || (f[0] = (MM) => X(MM)),
              accept: "video/*"
            }, null, 8, ["modelValue"])
          ])),
          A("", !0),
          T("div", S2, [
            z(y(me), {
              label: "And some extra text to it? No presh. Easy.",
              modelValue: Y.message,
              onInput: F,
              placeholder: "Optional text. If image is enough, don’t push it. Or push it. Listen, your call.",
              inputClass: "bg-[#F8F9FF] border-none resize-none min-h-[11.25rem]"
            }, null, 8, ["modelValue"]),
            z(Et, {
              ref_key: "charCounterEl",
              ref: r,
              class: "right-0 mt-1 absolute",
              message: Y.message,
              characterLimit: Ui
            }, null, 8, ["message"])
          ]),
          A("", !0),
          z(y(nM), {
            label: "Your name",
            modelValue: Y.senderName,
            maxlength: "75",
            onInput: f[3] || (f[3] = (MM) => i("update:senderName", MM.target.value)),
            placeholder: "Or nickname... we are not here to dictate",
            inputClass: "bg-[#F8F9FF] border-none"
          }, null, 8, ["modelValue"]),
          Y.isAuthenticated ? A("", !0) : (c(), g("label", Z2, [
            T("div", k2, [
              b2,
              z(y(oe), {
                triggers: ["hover"],
                distance: 20,
                placement: "top",
                popperTriggers: ["hover"],
                delay: { show: 200, hide: 150 }
              }, {
                popper: O(() => [
                  U2
                ]),
                default: O(() => [
                  z(y(Ee), {
                    class: "cursor-pointer h-4 w-4 fill-[#BBC4CD]",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })
            ]),
            z(y(nM), {
              modelValue: Y.senderEmail,
              type: "email",
              "onUpdate:modelValue": f[4] || (f[4] = (MM) => i("update:senderEmail", MM)),
              placeholder: "Your email",
              inputClass: "bg-[#F8F9FF] border-none"
            }, null, 8, ["modelValue"])
          ])),
          A("", !0),
          y(m) ? A("", !0) : (c(), g("div", Q2, [
            a.value ? (c(), k(y(C0), {
              key: 0,
              ref_key: "videoKudoComp",
              ref: o,
              class: V([D.value, "shrink-0 grow-0"]),
              message: Y.message,
              senderName: Y.senderName,
              src: a.value,
              controls: !1
            }, {
              default: O(({ formatToHms: MM }) => [
                T("div", V2, [
                  (c(), k(cM(C.value), {
                    onClick: h,
                    class: "h-7 stroke-[#FFCE21] fill-[#FFCE21] drop-shadow-md cursor-pointer"
                  })),
                  Y.video && N.trim.end && l.duration ? (c(), k(R0, {
                    key: u.value,
                    class: "w-full flex-grow",
                    min: 0,
                    max: l.duration,
                    step: 0.1,
                    modelValue: [
                      N.trim.start,
                      l.currentTime,
                      N.trim.end
                    ],
                    "onUpdate:modelValue": y(Z)
                  }, null, 8, ["max", "modelValue", "onUpdate:modelValue"])) : A("", !0),
                  L.value !== void 0 ? (c(), g("small", W2, w(MM(L.value)), 1)) : A("", !0)
                ]),
                s.value !== void 0 ? (c(), g("div", f2, [
                  T("div", null, [
                    T("progress", {
                      class: "progress",
                      value: s.value,
                      max: 100
                    }, w(s.value) + "% ", 9, v2),
                    G2
                  ])
                ])) : A("", !0)
              ]),
              _: 1
            }, 8, ["class", "message", "senderName", "src"])) : Y.ytUrl ? (c(), k(y(Pt), {
              key: 1,
              class: V([D.value, "shrink-0 grow-0"]),
              message: Y.message,
              senderName: Y.senderName,
              url: Y.ytUrl
            }, null, 8, ["class", "message", "senderName", "url"])) : A("", !0)
          ])),
          J(Y.$slots, "submit", se(xe({
            ...t,
            remainingCharacters: I.value,
            handleCreate: q,
            videoProcessingProgress: s.value
          })), () => [
            T("button", {
              onClick: q,
              class: "btn btn--primary self-start",
              disabled: !a.value && !Y.ytUrl || I.value < 0 || s.value !== void 0,
              textContent: w(
                s.value !== void 0 ? "Processing the video..." : !a.value && !Y.ytUrl ? "Create your kudo first" : "Post the Kudo!"
              )
            }, null, 8, R2)
          ])
        ]),
        _: 3
      }),
      y(m) ? (c(), g("div", F2, [
        a.value ? (c(), k(y(C0), {
          key: 0,
          ref_key: "videoKudoComp",
          ref: o,
          class: V([D.value, "shrink-0 grow-0"]),
          message: Y.message,
          senderName: Y.senderName,
          src: a.value,
          controls: !1
        }, {
          default: O(({ formatToHms: MM }) => [
            T("div", X2, [
              (c(), k(cM(C.value), {
                onClick: h,
                class: "h-7 stroke-[#FFCE21] fill-[#FFCE21] drop-shadow-md cursor-pointer"
              })),
              Y.video && N.trim.end !== void 0 && l.duration ? (c(), k(R0, {
                key: u.value,
                class: "w-full flex-grow",
                min: 0,
                max: l.duration,
                step: 0.1,
                modelValue: [
                  N.trim.start,
                  l.currentTime,
                  N.trim.end
                ],
                "onUpdate:modelValue": y(Z)
              }, null, 8, ["max", "modelValue", "onUpdate:modelValue"])) : A("", !0),
              L.value !== void 0 ? (c(), g("small", J2, w(MM(L.value)), 1)) : A("", !0)
            ]),
            s.value !== void 0 ? (c(), g("div", K2, [
              T("div", null, [
                T("progress", {
                  class: "progress",
                  value: s.value,
                  max: 100
                }, w(s.value) + "% ", 9, B2),
                H2
              ])
            ])) : A("", !0)
          ]),
          _: 1
        }, 8, ["class", "message", "senderName", "src"])) : Y.ytUrl ? (c(), k(y(Pt), {
          key: 1,
          class: V([D.value, "shrink-0 grow-0"]),
          message: Y.message,
          senderName: Y.senderName,
          url: Y.ytUrl
        }, null, 8, ["class", "message", "senderName", "url"])) : A("", !0)
      ])) : A("", !0)
    ]));
  }
}), P2 = "data:image/svg+xml;base64,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";
function mM(M, e, ...t) {
  if (M in e) {
    let u = e[M];
    return typeof u == "function" ? u(...t) : u;
  }
  let i = new Error(`Tried to handle "${M}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((u) => `"${u}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(i, mM), i;
}
var ne = ((M) => (M[M.None = 0] = "None", M[M.RenderStrategy = 1] = "RenderStrategy", M[M.Static = 2] = "Static", M))(ne || {}), Ie = ((M) => (M[M.Unmount = 0] = "Unmount", M[M.Hidden = 1] = "Hidden", M))(Ie || {});
function rM({ visible: M = !0, features: e = 0, ourProps: t, theirProps: i, ...u }) {
  var N;
  let l = S4(i, t), n = Object.assign(u, { props: l });
  if (M || e & 2 && l.static)
    return Qi(n);
  if (e & 1) {
    let s = (N = l.unmount) == null || N ? 0 : 1;
    return mM(s, { 0() {
      return null;
    }, 1() {
      return Qi({ ...u, props: { ...l, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Qi(n);
}
function Qi({ props: M, attrs: e, slots: t, slot: i, name: u }) {
  var N, l;
  let { as: n, ...s } = ai(M, ["unmount", "static"]), a = (N = t.default) == null ? void 0 : N.call(t, i), o = {};
  if (i) {
    let j = !1, D = [];
    for (let [r, I] of Object.entries(i))
      typeof I == "boolean" && (j = !0), I === !0 && D.push(r);
    j && (o["data-headlessui-state"] = D.join(" "));
  }
  if (n === "template") {
    if (a = Y4(a ?? []), Object.keys(s).length > 0 || Object.keys(e).length > 0) {
      let [j, ...D] = a ?? [];
      if (!_2(j) || D.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${u} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(s).concat(Object.keys(e)).map((L) => L.trim()).filter((L, d, m) => m.indexOf(L) === d).sort((L, d) => L.localeCompare(d)).map((L) => `  - ${L}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((L) => `  - ${L}`).join(`
`)].join(`
`));
      let r = S4((l = j.props) != null ? l : {}, s), I = wN(j, r);
      for (let L in r)
        L.startsWith("on") && (I.props || (I.props = {}), I.props[L] = r[L]);
      return I;
    }
    return Array.isArray(a) && a.length === 1 ? a[0] : a;
  }
  return aM(n, Object.assign({}, s, o), { default: () => a });
}
function Y4(M) {
  return M.flatMap((e) => e.type === K ? Y4(e.children) : [e]);
}
function S4(...M) {
  if (M.length === 0)
    return {};
  if (M.length === 1)
    return M[0];
  let e = {}, t = {};
  for (let i of M)
    for (let u in i)
      u.startsWith("on") && typeof i[u] == "function" ? (t[u] != null || (t[u] = []), t[u].push(i[u])) : e[u] = i[u];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(t).map((i) => [i, void 0])));
  for (let i in t)
    Object.assign(e, { [i](u, ...N) {
      let l = t[i];
      for (let n of l) {
        if (u instanceof Event && u.defaultPrevented)
          return;
        n(u, ...N);
      }
    } });
  return e;
}
function Z4(M) {
  let e = Object.assign({}, M);
  for (let t in e)
    e[t] === void 0 && delete e[t];
  return e;
}
function ai(M, e = []) {
  let t = Object.assign({}, M);
  for (let i of e)
    i in t && delete t[i];
  return t;
}
function _2(M) {
  return M == null ? !1 : typeof M.type == "string" || typeof M.type == "object" || typeof M.type == "function";
}
let $2 = 0;
function q2() {
  return ++$2;
}
function SM() {
  return q2();
}
var uM = ((M) => (M.Space = " ", M.Enter = "Enter", M.Escape = "Escape", M.Backspace = "Backspace", M.Delete = "Delete", M.ArrowLeft = "ArrowLeft", M.ArrowUp = "ArrowUp", M.ArrowRight = "ArrowRight", M.ArrowDown = "ArrowDown", M.Home = "Home", M.End = "End", M.PageUp = "PageUp", M.PageDown = "PageDown", M.Tab = "Tab", M))(uM || {});
function ML(M) {
  throw new Error("Unexpected object: " + M);
}
var gM = ((M) => (M[M.First = 0] = "First", M[M.Previous = 1] = "Previous", M[M.Next = 2] = "Next", M[M.Last = 3] = "Last", M[M.Specific = 4] = "Specific", M[M.Nothing = 5] = "Nothing", M))(gM || {});
function k4(M, e) {
  let t = e.resolveItems();
  if (t.length <= 0)
    return null;
  let i = e.resolveActiveIndex(), u = i ?? -1, N = (() => {
    switch (M.focus) {
      case 0:
        return t.findIndex((l) => !e.resolveDisabled(l));
      case 1: {
        let l = t.slice().reverse().findIndex((n, s, a) => u !== -1 && a.length - s - 1 >= u ? !1 : !e.resolveDisabled(n));
        return l === -1 ? l : t.length - 1 - l;
      }
      case 2:
        return t.findIndex((l, n) => n <= u ? !1 : !e.resolveDisabled(l));
      case 3: {
        let l = t.slice().reverse().findIndex((n) => !e.resolveDisabled(n));
        return l === -1 ? l : t.length - 1 - l;
      }
      case 4:
        return t.findIndex((l) => e.resolveId(l) === M.id);
      case 5:
        return null;
      default:
        ML(M);
    }
  })();
  return N === -1 ? i : N;
}
function B(M) {
  var e;
  return M == null || M.value == null ? null : (e = M.value.$el) != null ? e : M.value;
}
let b4 = Symbol("Context");
var dM = ((M) => (M[M.Open = 1] = "Open", M[M.Closed = 2] = "Closed", M[M.Closing = 4] = "Closing", M[M.Opening = 8] = "Opening", M))(dM || {});
function eL() {
  return et() !== null;
}
function et() {
  return YM(b4, null);
}
function ji(M) {
  fM(b4, M);
}
function F0(M, e) {
  if (M)
    return M;
  let t = e ?? "button";
  if (typeof t == "string" && t.toLowerCase() === "button")
    return "button";
}
function Ti(M, e) {
  let t = E(F0(M.value.type, M.value.as));
  return LM(() => {
    t.value = F0(M.value.type, M.value.as);
  }), VM(() => {
    var i;
    t.value || B(e) && B(e) instanceof HTMLButtonElement && !((i = B(e)) != null && i.hasAttribute("type")) && (t.value = "button");
  }), t;
}
var tL = Object.defineProperty, iL = (M, e, t) => e in M ? tL(M, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : M[e] = t, X0 = (M, e, t) => (iL(M, typeof e != "symbol" ? e + "" : e, t), t);
class uL {
  constructor() {
    X0(this, "current", this.detect()), X0(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
let Ct = new uL();
function he(M) {
  if (Ct.isServer)
    return null;
  if (M instanceof Node)
    return M.ownerDocument;
  if (M != null && M.hasOwnProperty("value")) {
    let e = B(M);
    if (e)
      return e.ownerDocument;
  }
  return document;
}
function NL({ container: M, accept: e, walk: t, enabled: i }) {
  VM(() => {
    let u = M.value;
    if (!u || i !== void 0 && !i.value)
      return;
    let N = he(M);
    if (!N)
      return;
    let l = Object.assign((s) => e(s), { acceptNode: e }), n = N.createTreeWalker(u, NodeFilter.SHOW_ELEMENT, l, !1);
    for (; n.nextNode(); )
      t(n.currentNode);
  });
}
let lu = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((M) => `${M}:not([tabindex='-1'])`).join(",");
var ee = ((M) => (M[M.First = 1] = "First", M[M.Previous = 2] = "Previous", M[M.Next = 4] = "Next", M[M.Last = 8] = "Last", M[M.WrapAround = 16] = "WrapAround", M[M.NoScroll = 32] = "NoScroll", M))(ee || {}), U4 = ((M) => (M[M.Error = 0] = "Error", M[M.Overflow = 1] = "Overflow", M[M.Success = 2] = "Success", M[M.Underflow = 3] = "Underflow", M))(U4 || {}), lL = ((M) => (M[M.Previous = -1] = "Previous", M[M.Next = 1] = "Next", M))(lL || {});
function Q4(M = document.body) {
  return M == null ? [] : Array.from(M.querySelectorAll(lu)).sort((e, t) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var ci = ((M) => (M[M.Strict = 0] = "Strict", M[M.Loose = 1] = "Loose", M))(ci || {});
function Di(M, e = 0) {
  var t;
  return M === ((t = he(M)) == null ? void 0 : t.body) ? !1 : mM(e, { 0() {
    return M.matches(lu);
  }, 1() {
    let i = M;
    for (; i !== null; ) {
      if (i.matches(lu))
        return !0;
      i = i.parentElement;
    }
    return !1;
  } });
}
function V4(M) {
  let e = he(M);
  zM(() => {
    e && !Di(e.activeElement, 0) && ze(M);
  });
}
var nL = ((M) => (M[M.Keyboard = 0] = "Keyboard", M[M.Mouse = 1] = "Mouse", M))(nL || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (M) => {
  M.metaKey || M.altKey || M.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (M) => {
  M.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : M.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function ze(M) {
  M == null || M.focus({ preventScroll: !0 });
}
let sL = ["textarea", "input"].join(",");
function oL(M) {
  var e, t;
  return (t = (e = M == null ? void 0 : M.matches) == null ? void 0 : e.call(M, sL)) != null ? t : !1;
}
function vu(M, e = (t) => t) {
  return M.slice().sort((t, i) => {
    let u = e(t), N = e(i);
    if (u === null || N === null)
      return 0;
    let l = u.compareDocumentPosition(N);
    return l & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : l & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function aL(M, e) {
  return Dt(Q4(), e, { relativeTo: M });
}
function Dt(M, e, { sorted: t = !0, relativeTo: i = null, skipElements: u = [] } = {}) {
  var N;
  let l = (N = Array.isArray(M) ? M.length > 0 ? M[0].ownerDocument : document : M == null ? void 0 : M.ownerDocument) != null ? N : document, n = Array.isArray(M) ? t ? vu(M) : M : Q4(M);
  u.length > 0 && n.length > 1 && (n = n.filter((I) => !u.includes(I))), i = i ?? l.activeElement;
  let s = (() => {
    if (e & 5)
      return 1;
    if (e & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), a = (() => {
    if (e & 1)
      return 0;
    if (e & 2)
      return Math.max(0, n.indexOf(i)) - 1;
    if (e & 4)
      return Math.max(0, n.indexOf(i)) + 1;
    if (e & 8)
      return n.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), o = e & 32 ? { preventScroll: !0 } : {}, j = 0, D = n.length, r;
  do {
    if (j >= D || j + D <= 0)
      return 0;
    let I = a + j;
    if (e & 16)
      I = (I + D) % D;
    else {
      if (I < 0)
        return 3;
      if (I >= D)
        return 1;
    }
    r = n[I], r == null || r.focus(o), j += s;
  } while (r !== l.activeElement);
  return e & 6 && oL(r) && r.select(), 2;
}
function Wt(M, e, t) {
  Ct.isServer || VM((i) => {
    document.addEventListener(M, e, t), i(() => document.removeEventListener(M, e, t));
  });
}
function W4(M, e, t) {
  Ct.isServer || VM((i) => {
    window.addEventListener(M, e, t), i(() => window.removeEventListener(M, e, t));
  });
}
function Gu(M, e, t = p(() => !0)) {
  function i(N, l) {
    if (!t.value || N.defaultPrevented)
      return;
    let n = l(N);
    if (n === null || !n.getRootNode().contains(n))
      return;
    let s = function a(o) {
      return typeof o == "function" ? a(o()) : Array.isArray(o) || o instanceof Set ? o : [o];
    }(M);
    for (let a of s) {
      if (a === null)
        continue;
      let o = a instanceof HTMLElement ? a : B(a);
      if (o != null && o.contains(n) || N.composed && N.composedPath().includes(o))
        return;
    }
    return !Di(n, ci.Loose) && n.tabIndex !== -1 && N.preventDefault(), e(N, n);
  }
  let u = E(null);
  Wt("pointerdown", (N) => {
    var l, n;
    t.value && (u.value = ((n = (l = N.composedPath) == null ? void 0 : l.call(N)) == null ? void 0 : n[0]) || N.target);
  }, !0), Wt("mousedown", (N) => {
    var l, n;
    t.value && (u.value = ((n = (l = N.composedPath) == null ? void 0 : l.call(N)) == null ? void 0 : n[0]) || N.target);
  }, !0), Wt("click", (N) => {
    u.value && (i(N, () => u.value), u.value = null);
  }, !0), Wt("touchend", (N) => i(N, () => N.target instanceof HTMLElement ? N.target : null), !0), W4("blur", (N) => i(N, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var Mt = ((M) => (M[M.None = 1] = "None", M[M.Focusable = 2] = "Focusable", M[M.Hidden = 4] = "Hidden", M))(Mt || {});
let xt = U({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(M, { slots: e, attrs: t }) {
  return () => {
    let { features: i, ...u } = M, N = { "aria-hidden": (i & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
    return rM({ ourProps: N, theirProps: u, slot: {}, attrs: t, slots: e, name: "Hidden" });
  };
} });
function f4(M = {}, e = null, t = []) {
  for (let [i, u] of Object.entries(M))
    G4(t, v4(e, i), u);
  return t;
}
function v4(M, e) {
  return M ? M + "[" + e + "]" : e;
}
function G4(M, e, t) {
  if (Array.isArray(t))
    for (let [i, u] of t.entries())
      G4(M, v4(e, i.toString()), u);
  else
    t instanceof Date ? M.push([e, t.toISOString()]) : typeof t == "boolean" ? M.push([e, t ? "1" : "0"]) : typeof t == "string" ? M.push([e, t]) : typeof t == "number" ? M.push([e, `${t}`]) : t == null ? M.push([e, ""]) : f4(t, e, M);
}
function jL(M) {
  var e, t;
  let i = (e = M == null ? void 0 : M.form) != null ? e : M.closest("form");
  if (i) {
    for (let u of i.elements)
      if (u !== M && (u.tagName === "INPUT" && u.type === "submit" || u.tagName === "BUTTON" && u.type === "submit" || u.nodeName === "INPUT" && u.type === "image")) {
        u.click();
        return;
      }
    (t = i.requestSubmit) == null || t.call(i);
  }
}
function R4(M, e, t) {
  let i = E(t == null ? void 0 : t.value), u = p(() => M.value !== void 0);
  return [p(() => u.value ? M.value : i.value), function(N) {
    return u.value || (i.value = N), e == null ? void 0 : e(N);
  }];
}
function J0(M) {
  return [M.screenX, M.screenY];
}
function F4() {
  let M = E([-1, -1]);
  return { wasMoved(e) {
    let t = J0(e);
    return M.value[0] === t[0] && M.value[1] === t[1] ? !1 : (M.value = t, !0);
  }, update(e) {
    M.value = J0(e);
  } };
}
function TL() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Ru(M) {
  typeof queueMicrotask == "function" ? queueMicrotask(M) : Promise.resolve().then(M).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function Ot() {
  let M = [], e = { addEventListener(t, i, u, N) {
    return t.addEventListener(i, u, N), e.add(() => t.removeEventListener(i, u, N));
  }, requestAnimationFrame(...t) {
    let i = requestAnimationFrame(...t);
    e.add(() => cancelAnimationFrame(i));
  }, nextFrame(...t) {
    e.requestAnimationFrame(() => {
      e.requestAnimationFrame(...t);
    });
  }, setTimeout(...t) {
    let i = setTimeout(...t);
    e.add(() => clearTimeout(i));
  }, microTask(...t) {
    let i = { current: !0 };
    return Ru(() => {
      i.current && t[0]();
    }), e.add(() => {
      i.current = !1;
    });
  }, style(t, i, u) {
    let N = t.style.getPropertyValue(i);
    return Object.assign(t.style, { [i]: u }), this.add(() => {
      Object.assign(t.style, { [i]: N });
    });
  }, group(t) {
    let i = Ot();
    return t(i), this.add(() => i.dispose());
  }, add(t) {
    return M.push(t), () => {
      let i = M.indexOf(t);
      if (i >= 0)
        for (let u of M.splice(i, 1))
          u();
    };
  }, dispose() {
    for (let t of M.splice(0))
      t();
  } };
  return e;
}
var st = ((M) => (M[M.Forwards = 0] = "Forwards", M[M.Backwards = 1] = "Backwards", M))(st || {});
function cL() {
  let M = E(0);
  return W4("keydown", (e) => {
    e.key === "Tab" && (M.value = e.shiftKey ? 1 : 0);
  }), M;
}
function X4(M, e, t, i) {
  Ct.isServer || VM((u) => {
    M = M ?? window, M.addEventListener(e, t, i), u(() => M.removeEventListener(e, t, i));
  });
}
function DL(M) {
  function e() {
    document.readyState !== "loading" && (M(), document.removeEventListener("DOMContentLoaded", e));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", e), e());
}
function J4(M) {
  if (!M)
    return /* @__PURE__ */ new Set();
  if (typeof M == "function")
    return new Set(M());
  let e = /* @__PURE__ */ new Set();
  for (let t of M.value) {
    let i = B(t);
    i instanceof HTMLElement && e.add(i);
  }
  return e;
}
var K4 = ((M) => (M[M.None = 1] = "None", M[M.InitialFocus = 2] = "InitialFocus", M[M.TabLock = 4] = "TabLock", M[M.FocusLock = 8] = "FocusLock", M[M.RestoreFocus = 16] = "RestoreFocus", M[M.All = 30] = "All", M))(K4 || {});
let lt = Object.assign(U({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: E(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = E(null);
  i({ el: u, $el: u });
  let N = p(() => he(u)), l = E(!1);
  LM(() => l.value = !0), QM(() => l.value = !1), gL({ ownerDocument: N }, p(() => l.value && !!(M.features & 16)));
  let n = LL({ ownerDocument: N, container: u, initialFocus: p(() => M.initialFocus) }, p(() => l.value && !!(M.features & 2)));
  IL({ ownerDocument: N, container: u, containers: M.containers, previousActiveElement: n }, p(() => l.value && !!(M.features & 8)));
  let s = cL();
  function a(r) {
    let I = B(u);
    I && ((L) => L())(() => {
      mM(s.value, { [st.Forwards]: () => {
        Dt(I, ee.First, { skipElements: [r.relatedTarget] });
      }, [st.Backwards]: () => {
        Dt(I, ee.Last, { skipElements: [r.relatedTarget] });
      } });
    });
  }
  let o = E(!1);
  function j(r) {
    r.key === "Tab" && (o.value = !0, requestAnimationFrame(() => {
      o.value = !1;
    }));
  }
  function D(r) {
    if (!l.value)
      return;
    let I = J4(M.containers);
    B(u) instanceof HTMLElement && I.add(B(u));
    let L = r.relatedTarget;
    L instanceof HTMLElement && L.dataset.headlessuiFocusGuard !== "true" && (B4(I, L) || (o.value ? Dt(B(u), mM(s.value, { [st.Forwards]: () => ee.Next, [st.Backwards]: () => ee.Previous }) | ee.WrapAround, { relativeTo: r.target }) : r.target instanceof HTMLElement && ze(r.target)));
  }
  return () => {
    let r = {}, I = { ref: u, onKeydown: j, onFocusout: D }, { features: L, initialFocus: d, containers: m, ...x } = M;
    return aM(K, [!!(L & 4) && aM(xt, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: a, features: Mt.Focusable }), rM({ ourProps: I, theirProps: { ...e, ...x }, slot: r, attrs: e, slots: t, name: "FocusTrap" }), !!(L & 4) && aM(xt, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: a, features: Mt.Focusable })]);
  };
} }), { features: K4 }), Ye = [];
DL(() => {
  function M(e) {
    e.target instanceof HTMLElement && e.target !== document.body && Ye[0] !== e.target && (Ye.unshift(e.target), Ye = Ye.filter((t) => t != null && t.isConnected), Ye.splice(10));
  }
  window.addEventListener("click", M, { capture: !0 }), window.addEventListener("mousedown", M, { capture: !0 }), window.addEventListener("focus", M, { capture: !0 }), document.body.addEventListener("click", M, { capture: !0 }), document.body.addEventListener("mousedown", M, { capture: !0 }), document.body.addEventListener("focus", M, { capture: !0 });
});
function rL(M) {
  let e = E(Ye.slice());
  return xM([M], ([t], [i]) => {
    i === !0 && t === !1 ? Ru(() => {
      e.value.splice(0);
    }) : i === !1 && t === !0 && (e.value = Ye.slice());
  }, { flush: "post" }), () => {
    var t;
    return (t = e.value.find((i) => i != null && i.isConnected)) != null ? t : null;
  };
}
function gL({ ownerDocument: M }, e) {
  let t = rL(e);
  LM(() => {
    VM(() => {
      var i, u;
      e.value || ((i = M.value) == null ? void 0 : i.activeElement) === ((u = M.value) == null ? void 0 : u.body) && ze(t());
    }, { flush: "post" });
  }), QM(() => {
    e.value && ze(t());
  });
}
function LL({ ownerDocument: M, container: e, initialFocus: t }, i) {
  let u = E(null), N = E(!1);
  return LM(() => N.value = !0), QM(() => N.value = !1), LM(() => {
    xM([e, t, i], (l, n) => {
      if (l.every((a, o) => (n == null ? void 0 : n[o]) === a) || !i.value)
        return;
      let s = B(e);
      s && Ru(() => {
        var a, o;
        if (!N.value)
          return;
        let j = B(t), D = (a = M.value) == null ? void 0 : a.activeElement;
        if (j) {
          if (j === D) {
            u.value = D;
            return;
          }
        } else if (s.contains(D)) {
          u.value = D;
          return;
        }
        j ? ze(j) : Dt(s, ee.First | ee.NoScroll) === U4.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), u.value = (o = M.value) == null ? void 0 : o.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), u;
}
function IL({ ownerDocument: M, container: e, containers: t, previousActiveElement: i }, u) {
  var N;
  X4((N = M.value) == null ? void 0 : N.defaultView, "focus", (l) => {
    if (!u.value)
      return;
    let n = J4(t);
    B(e) instanceof HTMLElement && n.add(B(e));
    let s = i.value;
    if (!s)
      return;
    let a = l.target;
    a && a instanceof HTMLElement ? B4(n, a) ? (i.value = a, ze(a)) : (l.preventDefault(), l.stopPropagation(), ze(s)) : ze(i.value);
  }, !0);
}
function B4(M, e) {
  for (let t of M)
    if (t.contains(e))
      return !0;
  return !1;
}
let Vi = /* @__PURE__ */ new Map(), nt = /* @__PURE__ */ new Map();
function K0(M, e = E(!0)) {
  VM((t) => {
    var i;
    if (!e.value)
      return;
    let u = B(M);
    if (!u)
      return;
    t(function() {
      var l;
      if (!u)
        return;
      let n = (l = nt.get(u)) != null ? l : 1;
      if (n === 1 ? nt.delete(u) : nt.set(u, n - 1), n !== 1)
        return;
      let s = Vi.get(u);
      s && (s["aria-hidden"] === null ? u.removeAttribute("aria-hidden") : u.setAttribute("aria-hidden", s["aria-hidden"]), u.inert = s.inert, Vi.delete(u));
    });
    let N = (i = nt.get(u)) != null ? i : 0;
    nt.set(u, N + 1), N === 0 && (Vi.set(u, { "aria-hidden": u.getAttribute("aria-hidden"), inert: u.inert }), u.setAttribute("aria-hidden", "true"), u.inert = !0);
  });
}
let H4 = Symbol("ForcePortalRootContext");
function dL() {
  return YM(H4, !1);
}
let nu = U({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(M, { slots: e, attrs: t }) {
  return fM(H4, M.force), () => {
    let { force: i, ...u } = M;
    return rM({ theirProps: u, ourProps: {}, slot: {}, slots: e, attrs: t, name: "ForcePortalRoot" });
  };
} });
function yL(M) {
  let e = he(M);
  if (!e) {
    if (M === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${M}`);
  }
  let t = e.getElementById("headlessui-portal-root");
  if (t)
    return t;
  let i = e.createElement("div");
  return i.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(i);
}
let P4 = U({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(M, { slots: e, attrs: t }) {
  let i = E(null), u = p(() => he(i)), N = dL(), l = YM(_4, null), n = E(N === !0 || l == null ? yL(i.value) : l.resolveTarget());
  VM(() => {
    N || l != null && (n.value = l.resolveTarget());
  });
  let s = YM(su, null);
  return LM(() => {
    let a = B(i);
    a && s && QM(s.register(a));
  }), QM(() => {
    var a, o;
    let j = (a = u.value) == null ? void 0 : a.getElementById("headlessui-portal-root");
    j && n.value === j && n.value.children.length <= 0 && ((o = n.value.parentElement) == null || o.removeChild(n.value));
  }), () => {
    if (n.value === null)
      return null;
    let a = { ref: i, "data-headlessui-portal": "" };
    return aM(ru, { to: n.value }, rM({ ourProps: a, theirProps: M, slot: {}, attrs: t, slots: e, name: "Portal" }));
  };
} }), su = Symbol("PortalParentContext");
function zL() {
  let M = YM(su, null), e = E([]);
  function t(N) {
    return e.value.push(N), M && M.register(N), () => i(N);
  }
  function i(N) {
    let l = e.value.indexOf(N);
    l !== -1 && e.value.splice(l, 1), M && M.unregister(N);
  }
  let u = { register: t, unregister: i, portals: e };
  return [e, U({ name: "PortalWrapper", setup(N, { slots: l }) {
    return fM(su, u), () => {
      var n;
      return (n = l.default) == null ? void 0 : n.call(l);
    };
  } })];
}
let _4 = Symbol("PortalGroupContext"), mL = U({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(M, { attrs: e, slots: t }) {
  let i = rt({ resolveTarget() {
    return M.target;
  } });
  return fM(_4, i), () => {
    let { target: u, ...N } = M;
    return rM({ theirProps: N, ourProps: {}, slot: {}, attrs: e, slots: t, name: "PortalGroup" });
  };
} }), $4 = Symbol("StackContext");
var ou = ((M) => (M[M.Add = 0] = "Add", M[M.Remove = 1] = "Remove", M))(ou || {});
function AL() {
  return YM($4, () => {
  });
}
function xL({ type: M, enabled: e, element: t, onUpdate: i }) {
  let u = AL();
  function N(...l) {
    i == null || i(...l), u(...l);
  }
  LM(() => {
    xM(e, (l, n) => {
      l ? N(0, M, t) : n === !0 && N(1, M, t);
    }, { immediate: !0, flush: "sync" });
  }), QM(() => {
    e.value && N(1, M, t);
  }), fM($4, N);
}
let q4 = Symbol("DescriptionContext");
function EL() {
  let M = YM(q4, null);
  if (M === null)
    throw new Error("Missing parent");
  return M;
}
function MN({ slot: M = E({}), name: e = "Description", props: t = {} } = {}) {
  let i = E([]);
  function u(N) {
    return i.value.push(N), () => {
      let l = i.value.indexOf(N);
      l !== -1 && i.value.splice(l, 1);
    };
  }
  return fM(q4, { register: u, slot: M, name: e, props: t }), p(() => i.value.length > 0 ? i.value.join(" ") : void 0);
}
U({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: () => `headlessui-description-${SM()}` } }, setup(M, { attrs: e, slots: t }) {
  let i = EL();
  return LM(() => QM(i.register(M.id))), () => {
    let { name: u = "Description", slot: N = E({}), props: l = {} } = i, { id: n, ...s } = M, a = { ...Object.entries(l).reduce((o, [j, D]) => Object.assign(o, { [j]: y(D) }), {}), id: n };
    return rM({ ourProps: a, theirProps: s, slot: N.value, attrs: e, slots: t, name: u });
  };
} });
function hL(M) {
  let e = YN(M.getSnapshot());
  return QM(M.subscribe(() => {
    e.value = M.getSnapshot();
  })), e;
}
function CL(M, e) {
  let t = M(), i = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t;
  }, subscribe(u) {
    return i.add(u), () => i.delete(u);
  }, dispatch(u, ...N) {
    let l = e[u].call(t, ...N);
    l && (t = l, i.forEach((n) => n()));
  } };
}
function OL() {
  let M;
  return { before({ doc: e }) {
    var t;
    let i = e.documentElement;
    M = ((t = e.defaultView) != null ? t : window).innerWidth - i.clientWidth;
  }, after({ doc: e, d: t }) {
    let i = e.documentElement, u = i.clientWidth - i.offsetWidth, N = M - u;
    t.style(i, "paddingRight", `${N}px`);
  } };
}
function pL() {
  if (!TL())
    return {};
  let M;
  return { before() {
    M = window.pageYOffset;
  }, after({ doc: e, d: t, meta: i }) {
    function u(l) {
      return i.containers.flatMap((n) => n()).some((n) => n.contains(l));
    }
    if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
      let l = Ot();
      l.style(e.documentElement, "scroll-behavior", "auto"), t.add(() => t.microTask(() => l.dispose()));
    }
    t.style(e.body, "marginTop", `-${M}px`), window.scrollTo(0, 0);
    let N = null;
    t.addEventListener(e, "click", (l) => {
      if (l.target instanceof HTMLElement)
        try {
          let n = l.target.closest("a");
          if (!n)
            return;
          let { hash: s } = new URL(n.href), a = e.querySelector(s);
          a && !u(a) && (N = a);
        } catch {
        }
    }, !0), t.addEventListener(e, "touchmove", (l) => {
      l.target instanceof HTMLElement && !u(l.target) && l.preventDefault();
    }, { passive: !1 }), t.add(() => {
      window.scrollTo(0, window.pageYOffset + M), N && N.isConnected && (N.scrollIntoView({ block: "nearest" }), N = null);
    });
  } };
}
function wL() {
  return { before({ doc: M, d: e }) {
    e.style(M.documentElement, "overflow", "hidden");
  } };
}
function YL(M) {
  let e = {};
  for (let t of M)
    Object.assign(e, t(e));
  return e;
}
let ke = CL(() => /* @__PURE__ */ new Map(), { PUSH(M, e) {
  var t;
  let i = (t = this.get(M)) != null ? t : { doc: M, count: 0, d: Ot(), meta: /* @__PURE__ */ new Set() };
  return i.count++, i.meta.add(e), this.set(M, i), this;
}, POP(M, e) {
  let t = this.get(M);
  return t && (t.count--, t.meta.delete(e)), this;
}, SCROLL_PREVENT({ doc: M, d: e, meta: t }) {
  let i = { doc: M, d: e, meta: YL(t) }, u = [pL(), OL(), wL()];
  u.forEach(({ before: N }) => N == null ? void 0 : N(i)), u.forEach(({ after: N }) => N == null ? void 0 : N(i));
}, SCROLL_ALLOW({ d: M }) {
  M.dispose();
}, TEARDOWN({ doc: M }) {
  this.delete(M);
} });
ke.subscribe(() => {
  let M = ke.getSnapshot(), e = /* @__PURE__ */ new Map();
  for (let [t] of M)
    e.set(t, t.documentElement.style.overflow);
  for (let t of M.values()) {
    let i = e.get(t.doc) === "hidden", u = t.count !== 0;
    (u && !i || !u && i) && ke.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && ke.dispatch("TEARDOWN", t);
  }
});
function SL(M, e, t) {
  let i = hL(ke), u = p(() => {
    let N = M.value ? i.value.get(M.value) : void 0;
    return N ? N.count > 0 : !1;
  });
  return xM([M, e], ([N, l], [n], s) => {
    if (!N || !l)
      return;
    ke.dispatch("PUSH", N, t);
    let a = !1;
    s(() => {
      a || (ke.dispatch("POP", n ?? N, t), a = !0);
    });
  }, { immediate: !0 }), u;
}
function ZL({ defaultContainers: M = [], portals: e, mainTreeNodeRef: t } = {}) {
  let i = E(null), u = he(i);
  function N() {
    var l;
    let n = [];
    for (let s of M)
      s !== null && (s instanceof HTMLElement ? n.push(s) : "value" in s && s.value instanceof HTMLElement && n.push(s.value));
    if (e != null && e.value)
      for (let s of e.value)
        n.push(s);
    for (let s of (l = u == null ? void 0 : u.querySelectorAll("html > *, body > *")) != null ? l : [])
      s !== document.body && s !== document.head && s instanceof HTMLElement && s.id !== "headlessui-portal-root" && (s.contains(B(i)) || n.some((a) => s.contains(a)) || n.push(s));
    return n;
  }
  return { resolveContainers: N, contains(l) {
    return N().some((n) => n.contains(l));
  }, mainTreeNodeRef: i, MainTreeNode() {
    return t != null ? null : aM(xt, { features: Mt.Hidden, ref: i });
  } };
}
var kL = ((M) => (M[M.Open = 0] = "Open", M[M.Closed = 1] = "Closed", M))(kL || {});
let au = Symbol("DialogContext");
function pt(M) {
  let e = YM(au, null);
  if (e === null) {
    let t = new Error(`<${M} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, pt), t;
  }
  return e;
}
let ft = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", bL = U({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: ft }, initialFocus: { type: Object, default: null }, id: { type: String, default: () => `headlessui-dialog-${SM()}` } }, emits: { close: (M) => !0 }, setup(M, { emit: e, attrs: t, slots: i, expose: u }) {
  var N;
  let l = E(!1);
  LM(() => {
    l.value = !0;
  });
  let n = E(0), s = et(), a = p(() => M.open === ft && s !== null ? (s.value & dM.Open) === dM.Open : M.open), o = E(null), j = p(() => he(o));
  if (u({ el: o, $el: o }), !(M.open !== ft || s !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof a.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${a.value === ft ? void 0 : M.open}`);
  let D = p(() => l.value && a.value ? 0 : 1), r = p(() => D.value === 0), I = p(() => n.value > 1), L = YM(au, null) !== null, [d, m] = zL(), { resolveContainers: x, mainTreeNodeRef: C, MainTreeNode: Q } = ZL({ portals: d, defaultContainers: [p(() => {
    var R;
    return (R = $.panelRef.value) != null ? R : o.value;
  })] }), S = p(() => I.value ? "parent" : "leaf"), h = p(() => s !== null ? (s.value & dM.Closing) === dM.Closing : !1), W = p(() => L || h.value ? !1 : r.value), eM = p(() => {
    var R, tM, b;
    return (b = Array.from((tM = (R = j.value) == null ? void 0 : R.querySelectorAll("body > *")) != null ? tM : []).find((Z) => Z.id === "headlessui-portal-root" ? !1 : Z.contains(B(C)) && Z instanceof HTMLElement)) != null ? b : null;
  });
  K0(eM, W);
  let NM = p(() => I.value ? !0 : r.value), v = p(() => {
    var R, tM, b;
    return (b = Array.from((tM = (R = j.value) == null ? void 0 : R.querySelectorAll("[data-headlessui-portal]")) != null ? tM : []).find((Z) => Z.contains(B(C)) && Z instanceof HTMLElement)) != null ? b : null;
  });
  K0(v, NM), xL({ type: "Dialog", enabled: p(() => D.value === 0), element: o, onUpdate: (R, tM) => {
    if (tM === "Dialog")
      return mM(R, { [ou.Add]: () => n.value += 1, [ou.Remove]: () => n.value -= 1 });
  } });
  let H = MN({ name: "DialogDescription", slot: p(() => ({ open: a.value })) }), F = E(null), $ = { titleId: F, panelRef: E(null), dialogState: D, setTitleId(R) {
    F.value !== R && (F.value = R);
  }, close() {
    e("close", !1);
  } };
  fM(au, $);
  let X = p(() => !(!r.value || I.value));
  Gu(x, (R, tM) => {
    $.close(), zM(() => tM == null ? void 0 : tM.focus());
  }, X);
  let P = p(() => !(I.value || D.value !== 0));
  X4((N = j.value) == null ? void 0 : N.defaultView, "keydown", (R) => {
    P.value && (R.defaultPrevented || R.key === uM.Escape && (R.preventDefault(), R.stopPropagation(), $.close()));
  });
  let q = p(() => !(h.value || D.value !== 0 || L));
  return SL(j, q, (R) => {
    var tM;
    return { containers: [...(tM = R.containers) != null ? tM : [], x] };
  }), VM((R) => {
    if (D.value !== 0)
      return;
    let tM = B(o);
    if (!tM)
      return;
    let b = new ResizeObserver((Z) => {
      for (let G of Z) {
        let Y = G.target.getBoundingClientRect();
        Y.x === 0 && Y.y === 0 && Y.width === 0 && Y.height === 0 && $.close();
      }
    });
    b.observe(tM), R(() => b.disconnect());
  }), () => {
    let { id: R, open: tM, initialFocus: b, ...Z } = M, G = { ...t, ref: o, id: R, role: "dialog", "aria-modal": D.value === 0 ? !0 : void 0, "aria-labelledby": F.value, "aria-describedby": H.value }, Y = { open: D.value === 0 };
    return aM(nu, { force: !0 }, () => [aM(P4, () => aM(mL, { target: o.value }, () => aM(nu, { force: !1 }, () => aM(lt, { initialFocus: b, containers: x, features: r.value ? mM(S.value, { parent: lt.features.RestoreFocus, leaf: lt.features.All & ~lt.features.FocusLock }) : lt.features.None }, () => aM(m, {}, () => rM({ ourProps: G, theirProps: { ...Z, ...t }, slot: Y, attrs: t, slots: i, visible: D.value === 0, features: ne.RenderStrategy | ne.Static, name: "Dialog" })))))), aM(Q)]);
  };
} });
U({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-overlay-${SM()}` } }, setup(M, { attrs: e, slots: t }) {
  let i = pt("DialogOverlay");
  function u(N) {
    N.target === N.currentTarget && (N.preventDefault(), N.stopPropagation(), i.close());
  }
  return () => {
    let { id: N, ...l } = M;
    return rM({ ourProps: { id: N, "aria-hidden": !0, onClick: u }, theirProps: l, slot: { open: i.dialogState.value === 0 }, attrs: e, slots: t, name: "DialogOverlay" });
  };
} });
U({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-backdrop-${SM()}` } }, inheritAttrs: !1, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = pt("DialogBackdrop"), N = E(null);
  return i({ el: N, $el: N }), LM(() => {
    if (u.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { id: l, ...n } = M, s = { id: l, ref: N, "aria-hidden": !0 };
    return aM(nu, { force: !0 }, () => aM(P4, () => rM({ ourProps: s, theirProps: { ...e, ...n }, slot: { open: u.dialogState.value === 0 }, attrs: e, slots: t, name: "DialogBackdrop" })));
  };
} });
let UL = U({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-panel-${SM()}` } }, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = pt("DialogPanel");
  i({ el: u.panelRef, $el: u.panelRef });
  function N(l) {
    l.stopPropagation();
  }
  return () => {
    let { id: l, ...n } = M, s = { id: l, ref: u.panelRef, onClick: N };
    return rM({ ourProps: s, theirProps: n, slot: { open: u.dialogState.value === 0 }, attrs: e, slots: t, name: "DialogPanel" });
  };
} }), QL = U({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: () => `headlessui-dialog-title-${SM()}` } }, setup(M, { attrs: e, slots: t }) {
  let i = pt("DialogTitle");
  return LM(() => {
    i.setTitleId(M.id), QM(() => i.setTitleId(null));
  }), () => {
    let { id: u, ...N } = M;
    return rM({ ourProps: { id: u }, theirProps: N, slot: { open: i.dialogState.value === 0 }, attrs: e, slots: t, name: "DialogTitle" });
  };
} });
var VL = ((M) => (M[M.Open = 0] = "Open", M[M.Closed = 1] = "Closed", M))(VL || {});
let eN = Symbol("DisclosureContext");
function Fu(M) {
  let e = YM(eN, null);
  if (e === null) {
    let t = new Error(`<${M} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Fu), t;
  }
  return e;
}
let tN = Symbol("DisclosurePanelContext");
function WL() {
  return YM(tN, null);
}
let Wi = U({ name: "Disclosure", props: { as: { type: [Object, String], default: "template" }, defaultOpen: { type: [Boolean], default: !1 } }, setup(M, { slots: e, attrs: t }) {
  let i = E(M.defaultOpen ? 0 : 1), u = E(null), N = E(null), l = { buttonId: E(`headlessui-disclosure-button-${SM()}`), panelId: E(`headlessui-disclosure-panel-${SM()}`), disclosureState: i, panel: u, button: N, toggleDisclosure() {
    i.value = mM(i.value, { 0: 1, 1: 0 });
  }, closeDisclosure() {
    i.value !== 1 && (i.value = 1);
  }, close(n) {
    l.closeDisclosure();
    let s = (() => n ? n instanceof HTMLElement ? n : n.value instanceof HTMLElement ? B(n) : B(l.button) : B(l.button))();
    s == null || s.focus();
  } };
  return fM(eN, l), ji(p(() => mM(i.value, { 0: dM.Open, 1: dM.Closed }))), () => {
    let { defaultOpen: n, ...s } = M, a = { open: i.value === 0, close: l.close };
    return rM({ theirProps: s, ourProps: {}, slot: a, slots: e, attrs: t, name: "Disclosure" });
  };
} }), fi = U({ name: "DisclosureButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = Fu("DisclosureButton"), N = WL(), l = p(() => N === null ? !1 : N.value === u.panelId.value);
  LM(() => {
    l.value || M.id !== null && (u.buttonId.value = M.id);
  }), QM(() => {
    l.value || (u.buttonId.value = null);
  });
  let n = E(null);
  i({ el: n, $el: n }), l.value || VM(() => {
    u.button.value = n.value;
  });
  let s = Ti(p(() => ({ as: M.as, type: e.type })), n);
  function a() {
    var D;
    M.disabled || (l.value ? (u.toggleDisclosure(), (D = B(u.button)) == null || D.focus()) : u.toggleDisclosure());
  }
  function o(D) {
    var r;
    if (!M.disabled)
      if (l.value)
        switch (D.key) {
          case uM.Space:
          case uM.Enter:
            D.preventDefault(), D.stopPropagation(), u.toggleDisclosure(), (r = B(u.button)) == null || r.focus();
            break;
        }
      else
        switch (D.key) {
          case uM.Space:
          case uM.Enter:
            D.preventDefault(), D.stopPropagation(), u.toggleDisclosure();
            break;
        }
  }
  function j(D) {
    switch (D.key) {
      case uM.Space:
        D.preventDefault();
        break;
    }
  }
  return () => {
    var D;
    let r = { open: u.disclosureState.value === 0 }, { id: I, ...L } = M, d = l.value ? { ref: n, type: s.value, onClick: a, onKeydown: o } : { id: (D = u.buttonId.value) != null ? D : I, ref: n, type: s.value, "aria-expanded": u.disclosureState.value === 0, "aria-controls": u.disclosureState.value === 0 || B(u.panel) ? u.panelId.value : void 0, disabled: M.disabled ? !0 : void 0, onClick: a, onKeydown: o, onKeyup: j };
    return rM({ ourProps: d, theirProps: L, slot: r, attrs: e, slots: t, name: "DisclosureButton" });
  };
} }), vi = U({ name: "DisclosurePanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = Fu("DisclosurePanel");
  LM(() => {
    M.id !== null && (u.panelId.value = M.id);
  }), QM(() => {
    u.panelId.value = null;
  }), i({ el: u.panel, $el: u.panel }), fM(tN, u.panelId);
  let N = et(), l = p(() => N !== null ? (N.value & dM.Open) === dM.Open : u.disclosureState.value === 0);
  return () => {
    var n;
    let s = { open: u.disclosureState.value === 0, close: u.close }, { id: a, ...o } = M, j = { id: (n = u.panelId.value) != null ? n : a, ref: u.panel };
    return rM({ ourProps: j, theirProps: o, slot: s, attrs: e, slots: t, features: ne.RenderStrategy | ne.Static, visible: l.value, name: "DisclosurePanel" });
  };
} }), B0 = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function H0(M) {
  var e, t;
  let i = (e = M.innerText) != null ? e : "", u = M.cloneNode(!0);
  if (!(u instanceof HTMLElement))
    return i;
  let N = !1;
  for (let n of u.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    n.remove(), N = !0;
  let l = N ? (t = u.innerText) != null ? t : "" : i;
  return B0.test(l) && (l = l.replace(B0, "")), l;
}
function fL(M) {
  let e = M.getAttribute("aria-label");
  if (typeof e == "string")
    return e.trim();
  let t = M.getAttribute("aria-labelledby");
  if (t) {
    let i = t.split(" ").map((u) => {
      let N = document.getElementById(u);
      if (N) {
        let l = N.getAttribute("aria-label");
        return typeof l == "string" ? l.trim() : H0(N).trim();
      }
      return null;
    }).filter(Boolean);
    if (i.length > 0)
      return i.join(", ");
  }
  return H0(M).trim();
}
function iN(M) {
  let e = E(""), t = E("");
  return () => {
    let i = B(M);
    if (!i)
      return "";
    let u = i.innerText;
    if (e.value === u)
      return t.value;
    let N = fL(i).trim().toLowerCase();
    return e.value = u, t.value = N, N;
  };
}
function vL(M, e) {
  return M === e;
}
var GL = ((M) => (M[M.Open = 0] = "Open", M[M.Closed = 1] = "Closed", M))(GL || {}), RL = ((M) => (M[M.Single = 0] = "Single", M[M.Multi = 1] = "Multi", M))(RL || {}), FL = ((M) => (M[M.Pointer = 0] = "Pointer", M[M.Other = 1] = "Other", M))(FL || {});
function XL(M) {
  requestAnimationFrame(() => requestAnimationFrame(M));
}
let uN = Symbol("ListboxContext");
function wt(M) {
  let e = YM(uN, null);
  if (e === null) {
    let t = new Error(`<${M} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, wt), t;
  }
  return e;
}
let JL = U({ name: "Listbox", emits: { "update:modelValue": (M) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => vL }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(M, { slots: e, attrs: t, emit: i }) {
  let u = E(1), N = E(null), l = E(null), n = E(null), s = E([]), a = E(""), o = E(null), j = E(1);
  function D(C = (Q) => Q) {
    let Q = o.value !== null ? s.value[o.value] : null, S = vu(C(s.value.slice()), (W) => B(W.dataRef.domRef)), h = Q ? S.indexOf(Q) : null;
    return h === -1 && (h = null), { options: S, activeOptionIndex: h };
  }
  let r = p(() => M.multiple ? 1 : 0), [I, L] = R4(p(() => M.modelValue), (C) => i("update:modelValue", C), p(() => M.defaultValue)), d = p(() => I.value === void 0 ? mM(r.value, { 1: [], 0: void 0 }) : I.value), m = { listboxState: u, value: d, mode: r, compare(C, Q) {
    if (typeof M.by == "string") {
      let S = M.by;
      return (C == null ? void 0 : C[S]) === (Q == null ? void 0 : Q[S]);
    }
    return M.by(C, Q);
  }, orientation: p(() => M.horizontal ? "horizontal" : "vertical"), labelRef: N, buttonRef: l, optionsRef: n, disabled: p(() => M.disabled), options: s, searchQuery: a, activeOptionIndex: o, activationTrigger: j, closeListbox() {
    M.disabled || u.value !== 1 && (u.value = 1, o.value = null);
  }, openListbox() {
    M.disabled || u.value !== 0 && (u.value = 0);
  }, goToOption(C, Q, S) {
    if (M.disabled || u.value === 1)
      return;
    let h = D(), W = k4(C === gM.Specific ? { focus: gM.Specific, id: Q } : { focus: C }, { resolveItems: () => h.options, resolveActiveIndex: () => h.activeOptionIndex, resolveId: (eM) => eM.id, resolveDisabled: (eM) => eM.dataRef.disabled });
    a.value = "", o.value = W, j.value = S ?? 1, s.value = h.options;
  }, search(C) {
    if (M.disabled || u.value === 1)
      return;
    let Q = a.value !== "" ? 0 : 1;
    a.value += C.toLowerCase();
    let S = (o.value !== null ? s.value.slice(o.value + Q).concat(s.value.slice(0, o.value + Q)) : s.value).find((W) => W.dataRef.textValue.startsWith(a.value) && !W.dataRef.disabled), h = S ? s.value.indexOf(S) : -1;
    h === -1 || h === o.value || (o.value = h, j.value = 1);
  }, clearSearch() {
    M.disabled || u.value !== 1 && a.value !== "" && (a.value = "");
  }, registerOption(C, Q) {
    let S = D((h) => [...h, { id: C, dataRef: Q }]);
    s.value = S.options, o.value = S.activeOptionIndex;
  }, unregisterOption(C) {
    let Q = D((S) => {
      let h = S.findIndex((W) => W.id === C);
      return h !== -1 && S.splice(h, 1), S;
    });
    s.value = Q.options, o.value = Q.activeOptionIndex, j.value = 1;
  }, theirOnChange(C) {
    M.disabled || L(C);
  }, select(C) {
    M.disabled || L(mM(r.value, { 0: () => C, 1: () => {
      let Q = BM(m.value.value).slice(), S = BM(C), h = Q.findIndex((W) => m.compare(S, BM(W)));
      return h === -1 ? Q.push(S) : Q.splice(h, 1), Q;
    } }));
  } };
  Gu([l, n], (C, Q) => {
    var S;
    m.closeListbox(), Di(Q, ci.Loose) || (C.preventDefault(), (S = B(l)) == null || S.focus());
  }, p(() => u.value === 0)), fM(uN, m), ji(p(() => mM(u.value, { 0: dM.Open, 1: dM.Closed })));
  let x = p(() => {
    var C;
    return (C = B(l)) == null ? void 0 : C.closest("form");
  });
  return LM(() => {
    xM([x], () => {
      if (!x.value || M.defaultValue === void 0)
        return;
      function C() {
        m.theirOnChange(M.defaultValue);
      }
      return x.value.addEventListener("reset", C), () => {
        var Q;
        (Q = x.value) == null || Q.removeEventListener("reset", C);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: C, modelValue: Q, disabled: S, form: h, ...W } = M, eM = { open: u.value === 0, disabled: S, value: d.value };
    return aM(K, [...C != null && d.value != null ? f4({ [C]: d.value }).map(([NM, v]) => aM(xt, Z4({ features: Mt.Hidden, key: NM, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: h, name: NM, value: v }))) : [], rM({ ourProps: {}, theirProps: { ...t, ...ai(W, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: eM, slots: e, attrs: t, name: "Listbox" })]);
  };
} }), KL = U({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-listbox-label-${SM()}` } }, setup(M, { attrs: e, slots: t }) {
  let i = wt("ListboxLabel");
  function u() {
    var N;
    (N = B(i.buttonRef)) == null || N.focus({ preventScroll: !0 });
  }
  return () => {
    let N = { open: i.listboxState.value === 0, disabled: i.disabled.value }, { id: l, ...n } = M, s = { id: l, ref: i.labelRef, onClick: u };
    return rM({ ourProps: s, theirProps: n, slot: N, attrs: e, slots: t, name: "ListboxLabel" });
  };
} }), BL = U({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-listbox-button-${SM()}` } }, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = wt("ListboxButton");
  i({ el: u.buttonRef, $el: u.buttonRef });
  function N(a) {
    switch (a.key) {
      case uM.Space:
      case uM.Enter:
      case uM.ArrowDown:
        a.preventDefault(), u.openListbox(), zM(() => {
          var o;
          (o = B(u.optionsRef)) == null || o.focus({ preventScroll: !0 }), u.value.value || u.goToOption(gM.First);
        });
        break;
      case uM.ArrowUp:
        a.preventDefault(), u.openListbox(), zM(() => {
          var o;
          (o = B(u.optionsRef)) == null || o.focus({ preventScroll: !0 }), u.value.value || u.goToOption(gM.Last);
        });
        break;
    }
  }
  function l(a) {
    switch (a.key) {
      case uM.Space:
        a.preventDefault();
        break;
    }
  }
  function n(a) {
    u.disabled.value || (u.listboxState.value === 0 ? (u.closeListbox(), zM(() => {
      var o;
      return (o = B(u.buttonRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
    })) : (a.preventDefault(), u.openListbox(), XL(() => {
      var o;
      return (o = B(u.optionsRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
    })));
  }
  let s = Ti(p(() => ({ as: M.as, type: e.type })), u.buttonRef);
  return () => {
    var a, o;
    let j = { open: u.listboxState.value === 0, disabled: u.disabled.value, value: u.value.value }, { id: D, ...r } = M, I = { ref: u.buttonRef, id: D, type: s.value, "aria-haspopup": "listbox", "aria-controls": (a = B(u.optionsRef)) == null ? void 0 : a.id, "aria-expanded": u.listboxState.value === 0, "aria-labelledby": u.labelRef.value ? [(o = B(u.labelRef)) == null ? void 0 : o.id, D].join(" ") : void 0, disabled: u.disabled.value === !0 ? !0 : void 0, onKeydown: N, onKeyup: l, onClick: n };
    return rM({ ourProps: I, theirProps: r, slot: j, attrs: e, slots: t, name: "ListboxButton" });
  };
} }), HL = U({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-listbox-options-${SM()}` } }, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = wt("ListboxOptions"), N = E(null);
  i({ el: u.optionsRef, $el: u.optionsRef });
  function l(a) {
    switch (N.value && clearTimeout(N.value), a.key) {
      case uM.Space:
        if (u.searchQuery.value !== "")
          return a.preventDefault(), a.stopPropagation(), u.search(a.key);
      case uM.Enter:
        if (a.preventDefault(), a.stopPropagation(), u.activeOptionIndex.value !== null) {
          let o = u.options.value[u.activeOptionIndex.value];
          u.select(o.dataRef.value);
        }
        u.mode.value === 0 && (u.closeListbox(), zM(() => {
          var o;
          return (o = B(u.buttonRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
        }));
        break;
      case mM(u.orientation.value, { vertical: uM.ArrowDown, horizontal: uM.ArrowRight }):
        return a.preventDefault(), a.stopPropagation(), u.goToOption(gM.Next);
      case mM(u.orientation.value, { vertical: uM.ArrowUp, horizontal: uM.ArrowLeft }):
        return a.preventDefault(), a.stopPropagation(), u.goToOption(gM.Previous);
      case uM.Home:
      case uM.PageUp:
        return a.preventDefault(), a.stopPropagation(), u.goToOption(gM.First);
      case uM.End:
      case uM.PageDown:
        return a.preventDefault(), a.stopPropagation(), u.goToOption(gM.Last);
      case uM.Escape:
        a.preventDefault(), a.stopPropagation(), u.closeListbox(), zM(() => {
          var o;
          return (o = B(u.buttonRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
        });
        break;
      case uM.Tab:
        a.preventDefault(), a.stopPropagation();
        break;
      default:
        a.key.length === 1 && (u.search(a.key), N.value = setTimeout(() => u.clearSearch(), 350));
        break;
    }
  }
  let n = et(), s = p(() => n !== null ? (n.value & dM.Open) === dM.Open : u.listboxState.value === 0);
  return () => {
    var a, o, j, D;
    let r = { open: u.listboxState.value === 0 }, { id: I, ...L } = M, d = { "aria-activedescendant": u.activeOptionIndex.value === null || (a = u.options.value[u.activeOptionIndex.value]) == null ? void 0 : a.id, "aria-multiselectable": u.mode.value === 1 ? !0 : void 0, "aria-labelledby": (D = (o = B(u.labelRef)) == null ? void 0 : o.id) != null ? D : (j = B(u.buttonRef)) == null ? void 0 : j.id, "aria-orientation": u.orientation.value, id: I, onKeydown: l, role: "listbox", tabIndex: 0, ref: u.optionsRef };
    return rM({ ourProps: d, theirProps: L, slot: r, attrs: e, slots: t, features: ne.RenderStrategy | ne.Static, visible: s.value, name: "ListboxOptions" });
  };
} }), PL = U({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-listbox.option-${SM()}` } }, setup(M, { slots: e, attrs: t, expose: i }) {
  let u = wt("ListboxOption"), N = E(null);
  i({ el: N, $el: N });
  let l = p(() => u.activeOptionIndex.value !== null ? u.options.value[u.activeOptionIndex.value].id === M.id : !1), n = p(() => mM(u.mode.value, { 0: () => u.compare(BM(u.value.value), BM(M.value)), 1: () => BM(u.value.value).some((m) => u.compare(BM(m), BM(M.value))) })), s = p(() => mM(u.mode.value, { 1: () => {
    var m;
    let x = BM(u.value.value);
    return ((m = u.options.value.find((C) => x.some((Q) => u.compare(BM(Q), BM(C.dataRef.value))))) == null ? void 0 : m.id) === M.id;
  }, 0: () => n.value })), a = iN(N), o = p(() => ({ disabled: M.disabled, value: M.value, get textValue() {
    return a();
  }, domRef: N }));
  LM(() => u.registerOption(M.id, o)), QM(() => u.unregisterOption(M.id)), LM(() => {
    xM([u.listboxState, n], () => {
      u.listboxState.value === 0 && n.value && mM(u.mode.value, { 1: () => {
        s.value && u.goToOption(gM.Specific, M.id);
      }, 0: () => {
        u.goToOption(gM.Specific, M.id);
      } });
    }, { immediate: !0 });
  }), VM(() => {
    u.listboxState.value === 0 && l.value && u.activationTrigger.value !== 0 && zM(() => {
      var m, x;
      return (x = (m = B(N)) == null ? void 0 : m.scrollIntoView) == null ? void 0 : x.call(m, { block: "nearest" });
    });
  });
  function j(m) {
    if (M.disabled)
      return m.preventDefault();
    u.select(M.value), u.mode.value === 0 && (u.closeListbox(), zM(() => {
      var x;
      return (x = B(u.buttonRef)) == null ? void 0 : x.focus({ preventScroll: !0 });
    }));
  }
  function D() {
    if (M.disabled)
      return u.goToOption(gM.Nothing);
    u.goToOption(gM.Specific, M.id);
  }
  let r = F4();
  function I(m) {
    r.update(m);
  }
  function L(m) {
    r.wasMoved(m) && (M.disabled || l.value || u.goToOption(gM.Specific, M.id, 0));
  }
  function d(m) {
    r.wasMoved(m) && (M.disabled || l.value && u.goToOption(gM.Nothing));
  }
  return () => {
    let { disabled: m } = M, x = { active: l.value, selected: n.value, disabled: m }, { id: C, value: Q, disabled: S, ...h } = M, W = { id: C, ref: N, role: "option", tabIndex: m === !0 ? void 0 : -1, "aria-disabled": m === !0 ? !0 : void 0, "aria-selected": n.value, disabled: void 0, onClick: j, onFocus: D, onPointerenter: I, onMouseenter: I, onPointermove: L, onMousemove: L, onPointerleave: d, onMouseleave: d };
    return rM({ ourProps: W, theirProps: h, slot: x, attrs: t, slots: e, name: "ListboxOption" });
  };
} });
var _L = ((M) => (M[M.Open = 0] = "Open", M[M.Closed = 1] = "Closed", M))(_L || {}), $L = ((M) => (M[M.Pointer = 0] = "Pointer", M[M.Other = 1] = "Other", M))($L || {});
function qL(M) {
  requestAnimationFrame(() => requestAnimationFrame(M));
}
let NN = Symbol("MenuContext");
function ri(M) {
  let e = YM(NN, null);
  if (e === null) {
    let t = new Error(`<${M} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, ri), t;
  }
  return e;
}
let MI = U({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(M, { slots: e, attrs: t }) {
  let i = E(1), u = E(null), N = E(null), l = E([]), n = E(""), s = E(null), a = E(1);
  function o(D = (r) => r) {
    let r = s.value !== null ? l.value[s.value] : null, I = vu(D(l.value.slice()), (d) => B(d.dataRef.domRef)), L = r ? I.indexOf(r) : null;
    return L === -1 && (L = null), { items: I, activeItemIndex: L };
  }
  let j = { menuState: i, buttonRef: u, itemsRef: N, items: l, searchQuery: n, activeItemIndex: s, activationTrigger: a, closeMenu: () => {
    i.value = 1, s.value = null;
  }, openMenu: () => i.value = 0, goToItem(D, r, I) {
    let L = o(), d = k4(D === gM.Specific ? { focus: gM.Specific, id: r } : { focus: D }, { resolveItems: () => L.items, resolveActiveIndex: () => L.activeItemIndex, resolveId: (m) => m.id, resolveDisabled: (m) => m.dataRef.disabled });
    n.value = "", s.value = d, a.value = I ?? 1, l.value = L.items;
  }, search(D) {
    let r = n.value !== "" ? 0 : 1;
    n.value += D.toLowerCase();
    let I = (s.value !== null ? l.value.slice(s.value + r).concat(l.value.slice(0, s.value + r)) : l.value).find((d) => d.dataRef.textValue.startsWith(n.value) && !d.dataRef.disabled), L = I ? l.value.indexOf(I) : -1;
    L === -1 || L === s.value || (s.value = L, a.value = 1);
  }, clearSearch() {
    n.value = "";
  }, registerItem(D, r) {
    let I = o((L) => [...L, { id: D, dataRef: r }]);
    l.value = I.items, s.value = I.activeItemIndex, a.value = 1;
  }, unregisterItem(D) {
    let r = o((I) => {
      let L = I.findIndex((d) => d.id === D);
      return L !== -1 && I.splice(L, 1), I;
    });
    l.value = r.items, s.value = r.activeItemIndex, a.value = 1;
  } };
  return Gu([u, N], (D, r) => {
    var I;
    j.closeMenu(), Di(r, ci.Loose) || (D.preventDefault(), (I = B(u)) == null || I.focus());
  }, p(() => i.value === 0)), fM(NN, j), ji(p(() => mM(i.value, { 0: dM.Open, 1: dM.Closed }))), () => {
    let D = { open: i.value === 0, close: j.closeMenu };
    return rM({ ourProps: {}, theirProps: M, slot: D, slots: e, attrs: t, name: "Menu" });
  };
} }), eI = U({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-menu-button-${SM()}` } }, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = ri("MenuButton");
  i({ el: u.buttonRef, $el: u.buttonRef });
  function N(a) {
    switch (a.key) {
      case uM.Space:
      case uM.Enter:
      case uM.ArrowDown:
        a.preventDefault(), a.stopPropagation(), u.openMenu(), zM(() => {
          var o;
          (o = B(u.itemsRef)) == null || o.focus({ preventScroll: !0 }), u.goToItem(gM.First);
        });
        break;
      case uM.ArrowUp:
        a.preventDefault(), a.stopPropagation(), u.openMenu(), zM(() => {
          var o;
          (o = B(u.itemsRef)) == null || o.focus({ preventScroll: !0 }), u.goToItem(gM.Last);
        });
        break;
    }
  }
  function l(a) {
    switch (a.key) {
      case uM.Space:
        a.preventDefault();
        break;
    }
  }
  function n(a) {
    M.disabled || (u.menuState.value === 0 ? (u.closeMenu(), zM(() => {
      var o;
      return (o = B(u.buttonRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
    })) : (a.preventDefault(), u.openMenu(), qL(() => {
      var o;
      return (o = B(u.itemsRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
    })));
  }
  let s = Ti(p(() => ({ as: M.as, type: e.type })), u.buttonRef);
  return () => {
    var a;
    let o = { open: u.menuState.value === 0 }, { id: j, ...D } = M, r = { ref: u.buttonRef, id: j, type: s.value, "aria-haspopup": "menu", "aria-controls": (a = B(u.itemsRef)) == null ? void 0 : a.id, "aria-expanded": u.menuState.value === 0, onKeydown: N, onKeyup: l, onClick: n };
    return rM({ ourProps: r, theirProps: D, slot: o, attrs: e, slots: t, name: "MenuButton" });
  };
} }), tI = U({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-menu-items-${SM()}` } }, setup(M, { attrs: e, slots: t, expose: i }) {
  let u = ri("MenuItems"), N = E(null);
  i({ el: u.itemsRef, $el: u.itemsRef }), NL({ container: p(() => B(u.itemsRef)), enabled: p(() => u.menuState.value === 0), accept(o) {
    return o.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : o.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(o) {
    o.setAttribute("role", "none");
  } });
  function l(o) {
    var j;
    switch (N.value && clearTimeout(N.value), o.key) {
      case uM.Space:
        if (u.searchQuery.value !== "")
          return o.preventDefault(), o.stopPropagation(), u.search(o.key);
      case uM.Enter:
        if (o.preventDefault(), o.stopPropagation(), u.activeItemIndex.value !== null) {
          let D = u.items.value[u.activeItemIndex.value];
          (j = B(D.dataRef.domRef)) == null || j.click();
        }
        u.closeMenu(), V4(B(u.buttonRef));
        break;
      case uM.ArrowDown:
        return o.preventDefault(), o.stopPropagation(), u.goToItem(gM.Next);
      case uM.ArrowUp:
        return o.preventDefault(), o.stopPropagation(), u.goToItem(gM.Previous);
      case uM.Home:
      case uM.PageUp:
        return o.preventDefault(), o.stopPropagation(), u.goToItem(gM.First);
      case uM.End:
      case uM.PageDown:
        return o.preventDefault(), o.stopPropagation(), u.goToItem(gM.Last);
      case uM.Escape:
        o.preventDefault(), o.stopPropagation(), u.closeMenu(), zM(() => {
          var D;
          return (D = B(u.buttonRef)) == null ? void 0 : D.focus({ preventScroll: !0 });
        });
        break;
      case uM.Tab:
        o.preventDefault(), o.stopPropagation(), u.closeMenu(), zM(() => aL(B(u.buttonRef), o.shiftKey ? ee.Previous : ee.Next));
        break;
      default:
        o.key.length === 1 && (u.search(o.key), N.value = setTimeout(() => u.clearSearch(), 350));
        break;
    }
  }
  function n(o) {
    switch (o.key) {
      case uM.Space:
        o.preventDefault();
        break;
    }
  }
  let s = et(), a = p(() => s !== null ? (s.value & dM.Open) === dM.Open : u.menuState.value === 0);
  return () => {
    var o, j;
    let D = { open: u.menuState.value === 0 }, { id: r, ...I } = M, L = { "aria-activedescendant": u.activeItemIndex.value === null || (o = u.items.value[u.activeItemIndex.value]) == null ? void 0 : o.id, "aria-labelledby": (j = B(u.buttonRef)) == null ? void 0 : j.id, id: r, onKeydown: l, onKeyup: n, role: "menu", tabIndex: 0, ref: u.itemsRef };
    return rM({ ourProps: L, theirProps: I, slot: D, attrs: e, slots: t, features: ne.RenderStrategy | ne.Static, visible: a.value, name: "MenuItems" });
  };
} }), iI = U({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-menu-item-${SM()}` } }, setup(M, { slots: e, attrs: t, expose: i }) {
  let u = ri("MenuItem"), N = E(null);
  i({ el: N, $el: N });
  let l = p(() => u.activeItemIndex.value !== null ? u.items.value[u.activeItemIndex.value].id === M.id : !1), n = iN(N), s = p(() => ({ disabled: M.disabled, get textValue() {
    return n();
  }, domRef: N }));
  LM(() => u.registerItem(M.id, s)), QM(() => u.unregisterItem(M.id)), VM(() => {
    u.menuState.value === 0 && l.value && u.activationTrigger.value !== 0 && zM(() => {
      var L, d;
      return (d = (L = B(N)) == null ? void 0 : L.scrollIntoView) == null ? void 0 : d.call(L, { block: "nearest" });
    });
  });
  function a(L) {
    if (M.disabled)
      return L.preventDefault();
    u.closeMenu(), V4(B(u.buttonRef));
  }
  function o() {
    if (M.disabled)
      return u.goToItem(gM.Nothing);
    u.goToItem(gM.Specific, M.id);
  }
  let j = F4();
  function D(L) {
    j.update(L);
  }
  function r(L) {
    j.wasMoved(L) && (M.disabled || l.value || u.goToItem(gM.Specific, M.id, 0));
  }
  function I(L) {
    j.wasMoved(L) && (M.disabled || l.value && u.goToItem(gM.Nothing));
  }
  return () => {
    let { disabled: L } = M, d = { active: l.value, disabled: L, close: u.closeMenu }, { id: m, ...x } = M;
    return rM({ ourProps: { id: m, ref: N, role: "menuitem", tabIndex: L === !0 ? void 0 : -1, "aria-disabled": L === !0 ? !0 : void 0, disabled: void 0, onClick: a, onFocus: o, onPointerenter: D, onMouseenter: D, onPointermove: r, onMousemove: r, onPointerleave: I, onMouseleave: I }, theirProps: { ...t, ...x }, slot: d, attrs: t, slots: e, name: "MenuItem" });
  };
} }), lN = Symbol("LabelContext");
function nN() {
  let M = YM(lN, null);
  if (M === null) {
    let e = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, nN), e;
  }
  return M;
}
function uI({ slot: M = {}, name: e = "Label", props: t = {} } = {}) {
  let i = E([]);
  function u(N) {
    return i.value.push(N), () => {
      let l = i.value.indexOf(N);
      l !== -1 && i.value.splice(l, 1);
    };
  }
  return fM(lN, { register: u, slot: M, name: e, props: t }), p(() => i.value.length > 0 ? i.value.join(" ") : void 0);
}
U({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-label-${SM()}` } }, setup(M, { slots: e, attrs: t }) {
  let i = nN();
  return LM(() => QM(i.register(M.id))), () => {
    let { name: u = "Label", slot: N = {}, props: l = {} } = i, { id: n, passive: s, ...a } = M, o = { ...Object.entries(l).reduce((j, [D, r]) => Object.assign(j, { [D]: y(r) }), {}), id: n };
    return s && (delete o.onClick, delete o.htmlFor, delete a.onClick), rM({ ourProps: o, theirProps: a, slot: N, attrs: t, slots: e, name: u });
  };
} });
let sN = Symbol("GroupContext");
U({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(M, { slots: e, attrs: t }) {
  let i = E(null), u = uI({ name: "SwitchLabel", props: { htmlFor: p(() => {
    var l;
    return (l = i.value) == null ? void 0 : l.id;
  }), onClick(l) {
    i.value && (l.currentTarget.tagName === "LABEL" && l.preventDefault(), i.value.click(), i.value.focus({ preventScroll: !0 }));
  } } }), N = MN({ name: "SwitchDescription" });
  return fM(sN, { switchRef: i, labelledby: u, describedby: N }), () => rM({ theirProps: M, ourProps: {}, slot: {}, slots: e, attrs: t, name: "SwitchGroup" });
} });
let NI = U({ name: "Switch", emits: { "update:modelValue": (M) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: () => `headlessui-switch-${SM()}` } }, inheritAttrs: !1, setup(M, { emit: e, attrs: t, slots: i, expose: u }) {
  let N = YM(sN, null), [l, n] = R4(p(() => M.modelValue), (d) => e("update:modelValue", d), p(() => M.defaultChecked));
  function s() {
    n(!l.value);
  }
  let a = E(null), o = N === null ? a : N.switchRef, j = Ti(p(() => ({ as: M.as, type: t.type })), o);
  u({ el: o, $el: o });
  function D(d) {
    d.preventDefault(), s();
  }
  function r(d) {
    d.key === uM.Space ? (d.preventDefault(), s()) : d.key === uM.Enter && jL(d.currentTarget);
  }
  function I(d) {
    d.preventDefault();
  }
  let L = p(() => {
    var d, m;
    return (m = (d = B(o)) == null ? void 0 : d.closest) == null ? void 0 : m.call(d, "form");
  });
  return LM(() => {
    xM([L], () => {
      if (!L.value || M.defaultChecked === void 0)
        return;
      function d() {
        n(M.defaultChecked);
      }
      return L.value.addEventListener("reset", d), () => {
        var m;
        (m = L.value) == null || m.removeEventListener("reset", d);
      };
    }, { immediate: !0 });
  }), () => {
    let { id: d, name: m, value: x, form: C, ...Q } = M, S = { checked: l.value }, h = { id: d, ref: o, role: "switch", type: j.value, tabIndex: 0, "aria-checked": l.value, "aria-labelledby": N == null ? void 0 : N.labelledby.value, "aria-describedby": N == null ? void 0 : N.describedby.value, onClick: D, onKeyup: r, onKeypress: I };
    return aM(K, [m != null && l.value != null ? aM(xt, Z4({ features: Mt.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: l.value, form: C, name: m, value: x })) : null, rM({ ourProps: h, theirProps: { ...t, ...ai(Q, ["modelValue", "defaultChecked"]) }, slot: S, attrs: t, slots: i, name: "Switch" })]);
  };
} });
function lI(M) {
  let e = { called: !1 };
  return (...t) => {
    if (!e.called)
      return e.called = !0, M(...t);
  };
}
function Gi(M, ...e) {
  M && e.length > 0 && M.classList.add(...e);
}
function vt(M, ...e) {
  M && e.length > 0 && M.classList.remove(...e);
}
var ju = ((M) => (M.Finished = "finished", M.Cancelled = "cancelled", M))(ju || {});
function nI(M, e) {
  let t = Ot();
  if (!M)
    return t.dispose;
  let { transitionDuration: i, transitionDelay: u } = getComputedStyle(M), [N, l] = [i, u].map((n) => {
    let [s = 0] = n.split(",").filter(Boolean).map((a) => a.includes("ms") ? parseFloat(a) : parseFloat(a) * 1e3).sort((a, o) => o - a);
    return s;
  });
  return N !== 0 ? t.setTimeout(() => e("finished"), N + l) : e("finished"), t.add(() => e("cancelled")), t.dispose;
}
function P0(M, e, t, i, u, N) {
  let l = Ot(), n = N !== void 0 ? lI(N) : () => {
  };
  return vt(M, ...u), Gi(M, ...e, ...t), l.nextFrame(() => {
    vt(M, ...t), Gi(M, ...i), l.add(nI(M, (s) => (vt(M, ...i, ...e), Gi(M, ...u), n(s))));
  }), l.add(() => vt(M, ...e, ...t, ...i, ...u)), l.add(() => n("cancelled")), l.dispose;
}
function pe(M = "") {
  return M.split(" ").filter((e) => e.trim().length > 1);
}
let Xu = Symbol("TransitionContext");
var sI = ((M) => (M.Visible = "visible", M.Hidden = "hidden", M))(sI || {});
function oI() {
  return YM(Xu, null) !== null;
}
function aI() {
  let M = YM(Xu, null);
  if (M === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return M;
}
function jI() {
  let M = YM(Ju, null);
  if (M === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return M;
}
let Ju = Symbol("NestingContext");
function gi(M) {
  return "children" in M ? gi(M.children) : M.value.filter(({ state: e }) => e === "visible").length > 0;
}
function oN(M) {
  let e = E([]), t = E(!1);
  LM(() => t.value = !0), QM(() => t.value = !1);
  function i(N, l = Ie.Hidden) {
    let n = e.value.findIndex(({ id: s }) => s === N);
    n !== -1 && (mM(l, { [Ie.Unmount]() {
      e.value.splice(n, 1);
    }, [Ie.Hidden]() {
      e.value[n].state = "hidden";
    } }), !gi(e) && t.value && (M == null || M()));
  }
  function u(N) {
    let l = e.value.find(({ id: n }) => n === N);
    return l ? l.state !== "visible" && (l.state = "visible") : e.value.push({ id: N, state: "visible" }), () => i(N, Ie.Unmount);
  }
  return { children: e, register: u, unregister: i };
}
let aN = ne.RenderStrategy, Tu = U({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(M, { emit: e, attrs: t, slots: i, expose: u }) {
  let N = E(0);
  function l() {
    N.value |= dM.Opening, e("beforeEnter");
  }
  function n() {
    N.value &= ~dM.Opening, e("afterEnter");
  }
  function s() {
    N.value |= dM.Closing, e("beforeLeave");
  }
  function a() {
    N.value &= ~dM.Closing, e("afterLeave");
  }
  if (!oI() && eL())
    return () => aM(jN, { ...M, onBeforeEnter: l, onAfterEnter: n, onBeforeLeave: s, onAfterLeave: a }, i);
  let o = E(null), j = p(() => M.unmount ? Ie.Unmount : Ie.Hidden);
  u({ el: o, $el: o });
  let { show: D, appear: r } = aI(), { register: I, unregister: L } = jI(), d = E(D.value ? "visible" : "hidden"), m = { value: !0 }, x = SM(), C = { value: !1 }, Q = oN(() => {
    !C.value && d.value !== "hidden" && (d.value = "hidden", L(x), a());
  });
  LM(() => {
    let $ = I(x);
    QM($);
  }), VM(() => {
    if (j.value === Ie.Hidden && x) {
      if (D.value && d.value !== "visible") {
        d.value = "visible";
        return;
      }
      mM(d.value, { hidden: () => L(x), visible: () => I(x) });
    }
  });
  let S = pe(M.enter), h = pe(M.enterFrom), W = pe(M.enterTo), eM = pe(M.entered), NM = pe(M.leave), v = pe(M.leaveFrom), H = pe(M.leaveTo);
  LM(() => {
    VM(() => {
      if (d.value === "visible") {
        let $ = B(o);
        if ($ instanceof Comment && $.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function F($) {
    let X = m.value && !r.value, P = B(o);
    !P || !(P instanceof HTMLElement) || X || (C.value = !0, D.value && l(), D.value || s(), $(D.value ? P0(P, S, h, W, eM, (q) => {
      C.value = !1, q === ju.Finished && n();
    }) : P0(P, NM, v, H, eM, (q) => {
      C.value = !1, q === ju.Finished && (gi(Q) || (d.value = "hidden", L(x), a()));
    })));
  }
  return LM(() => {
    xM([D], ($, X, P) => {
      F(P), m.value = !1;
    }, { immediate: !0 });
  }), fM(Ju, Q), ji(p(() => mM(d.value, { visible: dM.Open, hidden: dM.Closed }) | N.value)), () => {
    let { appear: $, show: X, enter: P, enterFrom: q, enterTo: R, entered: tM, leave: b, leaveFrom: Z, leaveTo: G, ...Y } = M, f = { ref: o }, MM = { ...Y, ...r.value && D.value && Ct.isServer ? { class: V([t.class, Y.class, ...S, ...h]) } : {} };
    return rM({ theirProps: MM, ourProps: f, slot: {}, slots: i, attrs: t, features: aN, visible: d.value === "visible", name: "TransitionChild" });
  };
} }), TI = Tu, jN = U({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(M, { emit: e, attrs: t, slots: i }) {
  let u = et(), N = p(() => M.show === null && u !== null ? (u.value & dM.Open) === dM.Open : M.show);
  VM(() => {
    if (![!0, !1].includes(N.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let l = E(N.value ? "visible" : "hidden"), n = oN(() => {
    l.value = "hidden";
  }), s = E(!0), a = { show: N, appear: p(() => M.appear || !s.value) };
  return LM(() => {
    VM(() => {
      s.value = !1, N.value ? l.value = "visible" : gi(n) || (l.value = "hidden");
    });
  }), fM(Ju, n), fM(Xu, a), () => {
    let o = ai(M, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), j = { unmount: M.unmount };
    return rM({ ourProps: { ...j, as: "template" }, theirProps: {}, slot: {}, slots: { ...i, default: () => [aM(TI, { onBeforeEnter: () => e("beforeEnter"), onAfterEnter: () => e("afterEnter"), onBeforeLeave: () => e("beforeLeave"), onAfterLeave: () => e("afterLeave"), ...t, ...j, ...o }, i.default)] }, attrs: {}, features: aN, visible: l.value === "visible", name: "Transition" });
  };
} });
const cI = { class: "relative" }, DI = { class: "block" }, rI = { key: 0 }, gI = { class: "pointer-events-none inset-y-0 flex items-center" }, LI = { key: 0 }, II = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}, dI = {
  inheritAttrs: !1
}, Ve = /* @__PURE__ */ U({
  ...dI,
  __name: "ListBox",
  props: {
    errors: {},
    modelValue: {},
    getLabel: { type: Function },
    getKey: { type: Function },
    dropdownItems: {},
    label: {},
    classListListBoxButton: {},
    classListListBoxOptions: {},
    classListListBoxOption: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = e;
    return (i, u) => (c(), g(K, null, [
      z(y(JL), DM(i.$attrs, {
        as: "div",
        modelValue: i.modelValue,
        "onUpdate:modelValue": u[0] || (u[0] = (N) => t("update:modelValue", N))
      }), {
        default: O(({ open: N }) => [
          i.$slots.label || i.label ? (c(), k(y(KL), {
            key: 0,
            class: "input-label"
          }, {
            default: O(() => [
              i.$slots.label ? J(i.$slots, "label", { key: 0 }) : (c(), g(K, { key: 1 }, [
                vM(w(i.label), 1)
              ], 64))
            ]),
            _: 3
          })) : A("", !0),
          T("div", cI, [
            z(y(BL), {
              class: V(
                y(iM)(
                  "relative w-full cursor-default capitalize input flex items-center min-w-[4rem] justify-between",
                  N ? "!border-[#1212E0]" : "",
                  i.classListListBoxButton
                )
              )
            }, {
              default: O(() => [
                T("span", DI, [
                  typeof i.modelValue == "object" && !(i.modelValue instanceof String) && i.getLabel !== void 0 ? (c(), g(K, { key: 0 }, [
                    typeof i.getLabel(i.modelValue) == "string" ? (c(), g("span", rI, w(i.getLabel(i.modelValue)), 1)) : (c(), k(cM(i.getLabel(i.modelValue)), { key: 1 }))
                  ], 64)) : (c(), g(K, { key: 1 }, [
                    vM(w(i.modelValue), 1)
                  ], 64))
                ]),
                T("span", gI, [
                  z(y(E1), {
                    class: "h-3 w-3 text-[#3F4A55]",
                    "aria-hidden": "true"
                  })
                ])
              ]),
              _: 2
            }, 1032, ["class"]),
            z(We, {
              "leave-active-class": "transition duration-100 ease-in",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: O(() => [
                z(y(HL), {
                  class: V(
                    y(iM)(
                      "absolute bg-white mt-1 w-full overflow-auto rounded-2xl border-[#EAF0F5] border-2",
                      i.classListListBoxOptions
                    )
                  )
                }, {
                  default: O(() => [
                    (c(!0), g(K, null, lM(i.dropdownItems, (l, n) => (c(), k(y(PL), {
                      key: typeof l == "object" && typeof l != "string" ? i.getKey ? i.getKey(l) : n : typeof l == "boolean" ? n : l,
                      value: l,
                      as: "template",
                      class: V(
                        y(iM)(
                          "hover:bg-[#DEF4FC] hover:text-[#1212E0] text-[#8C96A1] relative cursor-pointer select-none rounded-2xl py-5 pl-7 pr-24 mx-2 my-1 capitalize",
                          i.classListListBoxOption
                        )
                      )
                    }, {
                      default: O(({ selected: s }) => [
                        T("li", null, [
                          T("span", {
                            class: V(["font-normal", "block"])
                          }, [
                            (typeof l == "function" || typeof l == "object" && !(l instanceof String)) && i.getLabel !== void 0 ? (c(), g(K, { key: 0 }, [
                              typeof i.getLabel(l) == "string" ? (c(), g("span", LI, w(i.getLabel(l)), 1)) : (c(), k(cM(i.getLabel(l)), { key: 1 }))
                            ], 64)) : (c(), g(K, { key: 1 }, [
                              vM(w(l), 1)
                            ], 64))
                          ], 2),
                          s ? (c(), g("span", II)) : A("", !0)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value", "class"]))), 128))
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 16, ["modelValue"]),
      i.errors ? (c(), k(Te, {
        key: 0,
        errors: i.errors
      }, null, 8, ["errors"])) : A("", !0)
    ], 64));
  }
}), yI = ["value"], zI = {
  inheritAttrs: !1
}, He = /* @__PURE__ */ U({
  ...zI,
  __name: "RadioInput",
  props: {
    modelValue: {},
    value: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = p({
      get() {
        return t.modelValue;
      },
      set(s) {
        i("update:modelValue", s);
      }
    }), { class: N, inputClass: l, ...n } = yM();
    return (s, a) => (c(), g("label", {
      class: V(y(iM)("relative w-8 h-8 inline-flex items-center justify-center rounded-full border-[#DBDBF9] border p-1", y(N)))
    }, [
      CM(T("input", DM(n, {
        value: s.value,
        "onUpdate:modelValue": a[0] || (a[0] = (o) => u.value = o),
        type: "radio",
        class: y(iM)("w-full h-full appearance-none rounded-full checked:bg-[#1212E0]", y(l))
      }), null, 16, yI), [
        [SN, u.value]
      ])
    ], 2));
  }
});
function mI(M, e = {}) {
  let t = null;
  const i = E(null);
  return xM(M, () => {
    if (!M.value)
      return;
    const u = () => t = null;
    M.value.addEventListener("touchend", u);
    const N = (l) => {
      e.onTouchMove && e.onTouchMove(l);
      const { clientX: n, clientY: s } = l.touches[0];
      t || (t = { x: n, y: s }), i.value = {
        x: n - t.x,
        y: s - t.y
      }, t = { x: n, y: s };
    };
    return M.value.addEventListener("touchmove", N), () => {
      var l, n;
      (l = M.value) == null || l.removeEventListener("touchend", u), (n = M.value) == null || n.removeEventListener("touchMove", u);
    };
  }), i;
}
function AI(M, { behaviour: e = "replacePrevious" } = {}) {
  const t = { behaviour: e };
  let i = null;
  return (...u) => {
    i !== null && t.behaviour === "dropCurrent" || (i !== null && window.cancelAnimationFrame(i), i = window.requestAnimationFrame(() => {
      M(...u), i = null;
    }));
  };
}
const xI = /* @__PURE__ */ T("g", { filter: "url(#filter0_dddddd_1_7105)" }, [
  /* @__PURE__ */ T("path", {
    d: "M49.8214 1071.89C37.5461 1079.06 30 1092.21 30 1106.43V1354C30 1376.09 47.9086 1394 70 1394H1378C1400.09 1394 1418 1376.09 1418 1354V1106.43C1418 1092.21 1410.45 1079.06 1398.18 1071.89L744.179 689.789C731.712 682.506 716.288 682.506 703.821 689.789L49.8214 1071.89Z",
    fill: "#E4EDF5"
  })
], -1), EI = {
  x: "80",
  y: "994",
  width: "1288",
  height: "400",
  class: "overflow-visible relative"
}, hI = { class: "header flex justify-between items-center" }, CI = /* @__PURE__ */ T("svg", {
  width: "222",
  height: "13",
  viewBox: "0 0 222 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ T("path", {
    d: "M1.92982e-07 12.9808L0.0197146 13L11.1075 2.20748L22.1954 13L33.2832 2.20747L44.371 13L55.4589 2.20747L66.5466 13L77.6345 2.20747L88.7223 13L99.8101 2.20747L110.898 13L121.986 2.20747L133.074 13L144.161 2.20746L155.249 13L166.337 2.20746L177.425 13L188.513 2.20746L199.6 13L210.688 2.20746L221.5 12.7313V10.5238L210.688 0L199.6 10.7925L188.513 1.93866e-06L177.425 10.7925L166.337 3.87731e-06L155.249 10.7925L144.161 5.81596e-06L133.074 10.7925L121.986 7.75462e-06L110.898 10.7926L99.8101 9.69328e-06L88.7223 10.7926L77.6345 1.16319e-05L66.5466 10.7926L55.4589 1.35706e-05L44.371 10.7926L33.2832 1.55092e-05L22.1954 10.7926L11.1075 1.74479e-05L0.0197144 10.7926L0 10.7734L1.92982e-07 12.9808Z",
    class: "wave fill-gray-400"
  })
], -1), OI = {
  key: 0,
  class: "sender flex justify-center items-center"
}, pI = ["src", "alt"], wI = { class: "name text-gray-400 text-xl max-w-[51ch]" }, YI = /* @__PURE__ */ T("svg", {
  width: "222",
  height: "13",
  viewBox: "0 0 222 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ T("path", {
    d: "M1.92982e-07 12.9808L0.0197146 13L11.1075 2.20748L22.1954 13L33.2832 2.20747L44.371 13L55.4589 2.20747L66.5466 13L77.6345 2.20747L88.7223 13L99.8101 2.20747L110.898 13L121.986 2.20747L133.074 13L144.161 2.20746L155.249 13L166.337 2.20746L177.425 13L188.513 2.20746L199.6 13L210.688 2.20746L221.5 12.7313V10.5238L210.688 0L199.6 10.7925L188.513 1.93866e-06L177.425 10.7925L166.337 3.87731e-06L155.249 10.7925L144.161 5.81596e-06L133.074 10.7925L121.986 7.75462e-06L110.898 10.7926L99.8101 9.69328e-06L88.7223 10.7926L77.6345 1.16319e-05L66.5466 10.7926L55.4589 1.35706e-05L44.371 10.7926L33.2832 1.55092e-05L22.1954 10.7926L11.1075 1.74479e-05L0.0197144 10.7926L0 10.7734L1.92982e-07 12.9808Z",
    class: "wave fill-gray-400"
  })
], -1), SI = { class: "message mt-[118px] text-[#3F4A55] text-4xl [line-height:4.25rem] font-serif whitespace-pre-line" }, ZI = /* @__PURE__ */ T("rect", {
  x: "80",
  y: "994",
  width: "1288",
  height: "400",
  fill: "url('#paper_fade_gradient')"
}, null, -1), kI = /* @__PURE__ */ T("text", {
  x: "50%",
  y: "1272",
  "text-anchor": "middle",
  class: "text-center fill-gray-400 text-xl"
}, " The End ", -1), bI = /* @__PURE__ */ T("path", {
  class: "the-end-checkmark",
  d: "M730.71 1229.21C730.617 1229.12 730.506 1229.04 730.385 1228.99C730.263 1228.94 730.132 1228.91 730 1228.91C729.868 1228.91 729.737 1228.94 729.615 1228.99C729.494 1229.04 729.383 1229.12 729.29 1229.21L721.84 1236.67L718.71 1233.53C718.613 1233.44 718.499 1233.36 718.375 1233.31C718.25 1233.26 718.116 1233.24 717.982 1233.24C717.848 1233.25 717.716 1233.27 717.593 1233.33C717.47 1233.38 717.358 1233.46 717.265 1233.55C717.172 1233.65 717.098 1233.77 717.049 1233.89C717 1234.02 716.976 1234.15 716.978 1234.28C716.981 1234.42 717.009 1234.55 717.063 1234.67C717.116 1234.8 717.193 1234.91 717.29 1235L721.13 1238.84C721.223 1238.93 721.334 1239.01 721.455 1239.06C721.577 1239.11 721.708 1239.14 721.84 1239.14C721.972 1239.14 722.103 1239.11 722.225 1239.06C722.346 1239.01 722.457 1238.93 722.55 1238.84L730.71 1230.68C730.811 1230.59 730.892 1230.47 730.948 1230.35C731.003 1230.22 731.032 1230.08 731.032 1229.94C731.032 1229.81 731.003 1229.67 730.948 1229.54C730.892 1229.42 730.811 1229.3 730.71 1229.21Z",
  fill: "#BBC4CD"
}, null, -1), UI = [
  kI,
  bI
], QI = /* @__PURE__ */ Du('<mask id="mask0_1_7105" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="30" y="678" width="1388" height="716"><path fill-rule="evenodd" clip-rule="evenodd" d="M49.8214 1071.89C37.5461 1079.06 30 1092.21 30 1106.43V1394H724H1418V1106.43C1418 1092.21 1410.45 1079.06 1398.18 1071.89L724 678L49.8214 1071.89Z" fill="#8C96A1"></path></mask><g mask="url(#mask0_1_7105)"><g filter="url(#filter2_d_1_7105)"><path d="M724 1356L30 1134V1394H1418V1134L724 1356Z" fill="white" style="mix-blend-mode:multiply;" shape-rendering="crispEdges"></path></g></g><path d="M1418 1134L604 1394H724H1418V1134Z" fill="#F2F4FC"></path><path d="M30 1134L844 1394H724H30V1134Z" fill="#F8F9FF"></path><defs><filter id="filter0_dddddd_1_7105" x="0" y="680.327" width="1448" height="834.673" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset></feOffset><feColorMatrix type="matrix" values="0 0 0 0 0.694118 0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0.16 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_7105"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="4"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0.694118 0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0.15 0"></feColorMatrix><feBlend mode="normal" in2="effect1_dropShadow_1_7105" result="effect2_dropShadow_1_7105"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="14"></feOffset><feGaussianBlur stdDeviation="7"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0.694118 0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0.13 0"></feColorMatrix><feBlend mode="normal" in2="effect2_dropShadow_1_7105" result="effect3_dropShadow_1_7105"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="33"></feOffset><feGaussianBlur stdDeviation="10"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0.694118 0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0.08 0"></feColorMatrix><feBlend mode="normal" in2="effect3_dropShadow_1_7105" result="effect4_dropShadow_1_7105"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="58"></feOffset><feGaussianBlur stdDeviation="11.5"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0.694118 0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0.02 0"></feColorMatrix><feBlend mode="normal" in2="effect4_dropShadow_1_7105" result="effect5_dropShadow_1_7105"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="91"></feOffset><feGaussianBlur stdDeviation="15"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0.694118 0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0.1 0"></feColorMatrix><feBlend mode="normal" in2="effect5_dropShadow_1_7105" result="effect6_dropShadow_1_7105"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect6_dropShadow_1_7105" result="shape"></feBlend></filter><filter id="filter2_d_1_7105" x="10" y="1106" width="1428" height="300" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="-8"></feOffset><feGaussianBlur stdDeviation="10"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0.54902 0 0 0 0 0.588235 0 0 0 0 0.631373 0 0 0 0.2 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_7105"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_7105" result="shape"></feBlend></filter><linearGradient id="paper_fade_gradient" gradientTransform="rotate(90)"><stop stop-color="white" offset="0.1" stop-opacity="0"></stop><stop offset="0.4" stop-color="white"></stop></linearGradient></defs>', 5), VI = /* @__PURE__ */ U({
  __name: "LetterNote",
  props: {
    senderName: {
      type: String,
      required: !1
    },
    avatarUrl: {
      type: String,
      required: !1
    },
    naturalScroll: {
      type: Boolean,
      required: !1,
      default: !0
    },
    paperRevealPercentage: {
      type: Number,
      required: !1,
      default: 0,
      validator: (M) => +M >= 0 && +M <= 100
    },
    revealTransitionDurationMs: {
      type: Number,
      required: !1,
      default: 300
    }
  },
  emits: ["update:paperRevealPercentage"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = E(null), N = E(null), l = AI(
      function(o, j = 1) {
        if (!u.value)
          return;
        const D = o / u.value.clientHeight * 100, r = t.paperRevealPercentage + D * j;
        i(
          "update:paperRevealPercentage",
          Hi(r, 0, 100)
        );
      },
      { behaviour: "dropCurrent" }
    ), n = (a) => {
      a.preventDefault();
      const { deltaY: o } = a, j = 0.4;
      l(o * (t.naturalScroll ? 1 : -1), j);
    }, s = mI(N, {
      onTouchMove: function(o) {
        o.preventDefault();
      }
    });
    return xM(s, () => {
      const a = s.value.y, o = 5.5;
      l(-a, o);
    }), (a, o) => (c(), g("svg", {
      width: "100%",
      viewBox: "0 0 1448 1394",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref_key: "$swipeTarget",
      ref: N,
      onWheel: n,
      class: "overflow-visible"
    }, [
      xI,
      T("g", null, [
        (c(), g("foreignObject", EI, [
          T("div", {
            ref_key: "$paper",
            ref: u,
            class: "paper w-full bg-white pt-[140px] pb-[250px] absolute top-0 px-[168px] transition-transform ease-linear sm:ease-out [box-shadow:0_0_30px_rgba(177,178,213,0.16)]",
            style: RM({
              transitionDuration: `${M.revealTransitionDurationMs}ms`,
              transform: `translateY(calc(-${M.paperRevealPercentage}% + 400px * ${M.paperRevealPercentage} / 100))`
            })
          }, [
            T("div", hI, [
              CI,
              M.senderName ? (c(), g("div", OI, [
                M.avatarUrl ? (c(), g("img", {
                  key: 0,
                  src: M.avatarUrl,
                  class: "avatar object-cover w-16 aspect-square rounded-full bg-gray-400 mr-[14px]",
                  alt: `${M.senderName} profile photo`
                }, null, 8, pI)) : A("", !0),
                T("div", wI, w(M.senderName), 1)
              ])) : A("", !0),
              YI
            ]),
            T("pre", SI, [
              vM("            "),
              J(a.$slots, "default"),
              vM(`
          `)
            ])
          ], 4)
        ]))
      ]),
      ZI,
      T("g", {
        class: V([{ "opacity-0": M.paperRevealPercentage !== 100 }, "transition-opacity duration-500 ease-linear"])
      }, UI, 2),
      QI
    ], 544));
  }
}), WI = { class: "flex items-center gap-x-8" }, Ri = /* @__PURE__ */ U({
  __name: "SectionTitle",
  props: {
    lineClass: {
      type: String,
      default: "text"
    },
    textClass: {
      type: String,
      required: !1
    }
  },
  setup(M) {
    return (e, t) => (c(), g("div", WI, [
      T("div", {
        class: V(y(iM)("uppercase text-[#1212E0] text-xs font-semibold", M.textClass))
      }, [
        J(e.$slots, "default")
      ], 2),
      T("div", {
        class: V(y(iM)("h-[1px] grow bg-[#E4EDF5]", M.lineClass))
      }, null, 2)
    ]));
  }
}), fI = { class: "ai-kudo-builder flex justify-between items-start gap-x-28 max-w-screen-xl mx-auto" }, vI = { class: "mt-12" }, GI = {
  key: 0,
  class: "mt-12"
}, RI = { class: "flex" }, FI = /* @__PURE__ */ T("span", { class: "input-label" }, "Email(optional)", -1), XI = /* @__PURE__ */ T("div", { class: "w-56 font-semibold" }, " We will never send you any spam. This is just for the confirmation of this kudo post and our anti-spam protection. ", -1), JI = { class: "mt-12 flex justify-between items-center" }, KI = ["disabled"], BI = /* @__PURE__ */ T("p", { class: "uppercase text-xs leading-9" }, "* Required stuff", -1), HI = /* @__PURE__ */ T("p", { class: "input-label" }, "CHOOSE LENGTH OF THE MESSAGE*", -1), PI = { class: "grid sm:grid-cols-3 gap-x-4 gap-y-8" }, _I = { class: "border border-[#EAF0F5] rounded-[80px] py-3 px-8 inline-flex justify-between items-center" }, $I = /* @__PURE__ */ T("span", { class: "align-middle mr-8" }, "SHORT", -1), qI = { class: "border border-[#EAF0F5] rounded-[80px] py-3 px-8 inline-flex justify-between items-center" }, Md = /* @__PURE__ */ T("span", { class: "align-middle mr-8" }, "MEDIUM", -1), ed = { class: "border border-[#EAF0F5] rounded-[80px] py-3 px-8 inline-flex justify-between items-center" }, td = /* @__PURE__ */ T("span", { class: "align-middle mr-8" }, "LONG", -1), id = { class: "mt-12 flex justify-between items-center" }, ud = ["disabled"], Nd = /* @__PURE__ */ T("p", { class: "uppercase text-xs leading-9" }, "* Required stuff", -1), ld = {
  key: 1,
  class: "flex w-fit items-center gap-2 px-10 py-4 bg-white border-2 text-[#12DE74] border-[#12DE74] rounded-[2.5rem] text-center font-bold tracking-wider text-lg uppercase"
}, nd = ["src"], sd = /* @__PURE__ */ T("p", null, "done!", -1), od = {
  key: 2,
  class: "flex w-fit items-center gap-2 px-10 py-4 bg-white border-2 border-dashed text-[#1212E0] border-[#1212E0] rounded-[2.5rem] text-center font-bold tracking-wider text-lg uppercase"
}, ad = /* @__PURE__ */ T("p", null, "writing a masterpiece (gimme sec)", -1), jd = ["disabled", "textContent"], Td = { class: "w-full text-center mt-12" }, cd = ["innerHTML"], Dd = { class: "flex justify-center mt-24" }, rd = { class: "relative" }, gd = /* @__PURE__ */ T("div", { class: "absolute -top-5 w-5 aspect-square rounded-full bg-[#DBDBF9]" }, null, -1), Ld = { class: "relative aspect-square bg-[#DBDBF9] w-36 rounded-full overflow-hidden" }, Id = ["src"], dd = {
  key: 0,
  class: "font-[schoolbell] text-[#8C96A1] mt-5 -rotate-6"
}, yd = ["src"], zd = /* @__PURE__ */ T("p", null, "Check the kudo", -1), md = ["textContent"], Ad = {
  inheritAttrs: !1
}, _A = /* @__PURE__ */ U({
  ...Ad,
  __name: "AiKudoBuilder",
  props: {
    message: {},
    senderName: {},
    senderEmail: {},
    color: { default: fe[0] },
    occasionItems: {},
    messageTypeItems: {},
    linkOccasion: {},
    avatar: {},
    isAuthenticated: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["update:message", "update:senderName", "update:senderEmail", "update:color", "openaiApiCall", "create"],
  setup(M, { emit: e }) {
    const t = M, i = e;
    p(() => te.get(t.color)[0]);
    const u = E(100), N = E(""), l = E(""), n = E(""), s = E(t.linkOccasion), a = E(""), o = E(""), j = E(1), D = E(!1), r = E(), I = p(() => N.value && l.value && n.value && s.value ? 3 : N.value ? 2 : 1), L = p(() => (o.value ? `In ${o.value} style ` : "") + `write ${l.value} length ${n.value} to ${N.value} ` + (t.senderName ? `from ${t.senderName} ` : "") + `for ${s.value}` + (a.value ? ` and mention ${a.value}.` : ".")), d = p(() => "We will create a " + (l.value ? `<b>${l.value}</b> ` : "Kudo ") + (n.value ? `<b>${s.value} ${n.value}</b> ` : "") + (N.value ? `for <b>${N.value}</b> ` : "") + (t.senderName ? `from <b>${t.senderName}</b> ` : "") + (a.value ? `mentioning this: <b>${a.value}</b> ` : "") + (o.value ? `all this in <b>${o.value}</b> style.` : ".")), m = ["Got it", "Interesting", "Super solid", "*Crunch crunch"];
    function x(S) {
      I.value >= S && (j.value = S);
    }
    function C() {
      r.value = null, D.value = !0;
    }
    function Q() {
      j.value = 3, D.value = !1, i("openaiApiCall", L.value);
    }
    return (S, h) => (c(), g(K, null, [
      T("div", fI, [
        z(UM, { class: "w-7/12 grow lg:grow-0 shrink-0 space-y-6" }, {
          default: O(() => [
            z(y(Wi), null, {
              default: O(() => [
                z(y(fi), {
                  onClick: h[0] || (h[0] = (W) => x(1)),
                  class: "flex cursor-pointer w-full"
                }, {
                  default: O(() => [
                    z(Ri, {
                      class: "w-full text-[#1212E0]",
                      textClass: I.value >= 1 ? "" : "text-[#BBC4CD]"
                    }, {
                      default: O(() => [
                        vM(" Basic information ")
                      ]),
                      _: 1
                    }, 8, ["textClass"]),
                    z(y(Ii), {
                      class: V(["ml-2 stroke-2 h-4 w-4 transition-all text-[#1212E0]", {
                        "rotate-180": j.value == 1,
                        "text-[#BBC4CD]": I.value < 1
                      }]),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }),
                CM(T("div", null, [
                  z(y(vi), {
                    static: "",
                    class: "py-12"
                  }, {
                    default: O(() => [
                      z(nM, {
                        modelValue: N.value,
                        "onUpdate:modelValue": h[1] || (h[1] = (W) => N.value = W),
                        label: "who is it for*",
                        placeholder: "Who’s the lucky person",
                        inputClass: "bg-[#F8F9FF] border-none"
                      }, null, 8, ["modelValue"]),
                      T("div", vI, [
                        z(nM, {
                          modelValue: S.senderName,
                          "onUpdate:modelValue": h[2] || (h[2] = (W) => i("update:senderName", W)),
                          label: "your name",
                          placeholder: "Or nickname... we are not here to dictate",
                          inputClass: "bg-[#F8F9FF] border-none"
                        }, null, 8, ["modelValue"])
                      ]),
                      S.isAuthenticated ? A("", !0) : (c(), g("label", GI, [
                        T("div", RI, [
                          FI,
                          z(y(oe), {
                            triggers: ["hover"],
                            distance: 20,
                            placement: "top",
                            popperTriggers: ["hover"],
                            delay: { show: 200, hide: 150 }
                          }, {
                            popper: O(() => [
                              XI
                            ]),
                            default: O(() => [
                              z(y(Ee), {
                                class: "cursor-pointer h-4 w-4 fill-[#BBC4CD]",
                                "aria-hidden": "true"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        z(nM, {
                          modelValue: S.senderEmail,
                          type: "email",
                          "onUpdate:modelValue": h[3] || (h[3] = (W) => i("update:senderEmail", W)),
                          placeholder: "Your email",
                          inputClass: "bg-[#F8F9FF] border-none"
                        }, null, 8, ["modelValue"])
                      ])),
                      T("div", JI, [
                        T("button", {
                          onClick: h[4] || (h[4] = (W) => x(2)),
                          disabled: !N.value,
                          class: "btn btn--tertiary px-10 py-4"
                        }, " next step ", 8, KI),
                        BI
                      ])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [WM, j.value == 1]
                ])
              ]),
              _: 1
            }),
            z(y(Wi), null, {
              default: O(() => [
                z(y(fi), {
                  onClick: h[5] || (h[5] = (W) => x(2)),
                  class: "flex cursor-pointer w-full"
                }, {
                  default: O(() => [
                    z(Ri, {
                      class: "w-full text-[#1212E0]",
                      textClass: I.value >= 2 ? "" : "text-[#BBC4CD]"
                    }, {
                      default: O(() => [
                        vM(" message type ")
                      ]),
                      _: 1
                    }, 8, ["textClass"]),
                    z(y(Ii), {
                      class: V(["ml-2 stroke-2 h-4 w-4 transition-all text-[#1212E0]", {
                        "rotate-180": j.value == 2,
                        "text-[#BBC4CD]": I.value < 2
                      }]),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }),
                CM(T("div", null, [
                  z(y(vi), {
                    static: "",
                    class: "py-12 space-y-12"
                  }, {
                    default: O(() => [
                      z(Ve, {
                        classListListBoxButton: ["input--small", "min-h-[4rem]"],
                        classListListBoxOptions: ["z-20"],
                        modelValue: s.value,
                        "onUpdate:modelValue": h[6] || (h[6] = (W) => s.value = W),
                        dropdownItems: S.occasionItems,
                        value: s.value,
                        label: "WHAT’s THE OCCASION*"
                      }, null, 8, ["modelValue", "dropdownItems", "value"]),
                      z(Ve, {
                        classListListBoxButton: ["input--small", "min-h-[4rem]"],
                        classListListBoxOptions: ["z-20"],
                        modelValue: n.value,
                        "onUpdate:modelValue": h[7] || (h[7] = (W) => n.value = W),
                        value: n.value,
                        dropdownItems: S.messageTypeItems,
                        label: "MESSAGE TYPE*"
                      }, null, 8, ["modelValue", "value", "dropdownItems"]),
                      T("div", null, [
                        HI,
                        T("div", PI, [
                          T("label", _I, [
                            $I,
                            z(He, {
                              modelValue: l.value,
                              "onUpdate:modelValue": h[8] || (h[8] = (W) => l.value = W),
                              class: "align-middle",
                              value: "short"
                            }, null, 8, ["modelValue"])
                          ]),
                          T("label", qI, [
                            Md,
                            z(He, {
                              modelValue: l.value,
                              "onUpdate:modelValue": h[9] || (h[9] = (W) => l.value = W),
                              class: "align-middle",
                              value: "medium"
                            }, null, 8, ["modelValue"])
                          ]),
                          T("label", ed, [
                            td,
                            z(He, {
                              modelValue: l.value,
                              "onUpdate:modelValue": h[10] || (h[10] = (W) => l.value = W),
                              class: "align-middle",
                              value: "long"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      T("div", id, [
                        T("button", {
                          onClick: h[11] || (h[11] = (W) => x(3)),
                          disabled: !(l.value && n.value && s.value),
                          class: "btn btn--tertiary px-10 py-4"
                        }, " next step ", 8, ud),
                        Nd
                      ])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [WM, j.value == 2]
                ])
              ]),
              _: 1
            }),
            z(y(Wi), null, {
              default: O(() => [
                z(y(fi), {
                  onClick: h[12] || (h[12] = (W) => x(3)),
                  class: "flex cursor-pointer w-full"
                }, {
                  default: O(() => [
                    z(Ri, {
                      class: "w-full text-[#1212E0]",
                      textClass: I.value >= 3 ? "" : "text-[#BBC4CD]"
                    }, {
                      default: O(() => [
                        vM(" message extras ")
                      ]),
                      _: 1
                    }, 8, ["textClass"]),
                    z(y(Ii), {
                      class: V(["ml-2 stroke-2 h-4 w-4 transition-all text-[#1212E0]", {
                        "rotate-180": j.value == 3,
                        "text-[#BBC4CD]": I.value < 3
                      }]),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }),
                CM(T("div", null, [
                  z(y(vi), {
                    static: "",
                    class: "py-12 space-y-12"
                  }, {
                    default: O(() => [
                      z(nM, {
                        modelValue: a.value,
                        "onUpdate:modelValue": h[13] || (h[13] = (W) => a.value = W),
                        label: "what to mention",
                        placeholder: "E.g.: Likes dogs, watching movies, she’s a kind weirdo",
                        inputClass: "bg-[#F8F9FF] border-none"
                      }, null, 8, ["modelValue"]),
                      z(nM, {
                        modelValue: o.value,
                        "onUpdate:modelValue": h[14] || (h[14] = (W) => o.value = W),
                        label: "style of the message",
                        placeholder: "E.g.: Serious, enthusiastic, 9 year old, tired",
                        inputClass: "bg-[#F8F9FF] border-none"
                      }, null, 8, ["modelValue"]),
                      !S.message && !S.isLoading ? (c(), g("button", {
                        key: 0,
                        onClick: Q,
                        class: "btn px-10 py-4 text-[#ffff] bg-[#1212E0]"
                      }, " generate the kudo ")) : A("", !0),
                      S.message && !S.isLoading && !D.value ? (c(), g("div", ld, [
                        T("img", {
                          src: y(i1),
                          alt: "check icon"
                        }, null, 8, nd),
                        sd
                      ])) : A("", !0),
                      S.isLoading ? (c(), g("div", od, [
                        z(y(g1), { class: "fill-[#1212E0] w-4 h-4" }),
                        ad
                      ])) : A("", !0),
                      A("", !0)
                    ]),
                    _: 1
                  })
                ], 512), [
                  [WM, j.value == 3]
                ])
              ]),
              _: 1
            }),
            D.value && !S.isLoading ? J(S.$slots, "submit", se(DM({ key: 0 }, t)), () => [
              T("button", {
                onClick: h[16] || (h[16] = (W) => i("create", t)),
                class: "btn btn--primary mt-14 self-start",
                disabled: !S.message,
                textContent: w(S.message ? "Post the Kudo!" : "Create your kudo first")
              }, null, 8, jd)
            ]) : A("", !0)
          ]),
          _: 3
        }),
        T("div", Td, [
          T("p", {
            innerHTML: d.value,
            class: "w-full text-2xl text-[#3F4A55] leading-10"
          }, null, 8, cd),
          T("div", Dd, [
            T("div", rd, [
              gd,
              T("div", Ld, [
                T("img", {
                  class: "absolute scale-150 right-0 -bottom-3",
                  width: "356",
                  height: "356",
                  src: S.avatar,
                  alt: "avatar"
                }, null, 8, Id)
              ])
            ])
          ]),
          S.message ? A("", !0) : (c(), g("p", dd, w(m[j.value - 1] ? m[j.value - 1] : ""), 1)),
          S.message && !S.isLoading ? (c(), g("button", {
            key: 1,
            onClick: h[17] || (h[17] = (W) => r.value = S.message),
            class: "mt-10 mx-auto flex btn px-10 py-4 text-[#ffff] bg-[#1212E0] items-center gap-5"
          }, [
            T("img", {
              src: y(P2),
              alt: "open envelope icon"
            }, null, 8, yd),
            zd
          ])) : A("", !0),
          D.value && !S.isLoading ? (c(), g("button", {
            key: 2,
            onClick: Q,
            class: "mt-5 btn btn--tertiary px-10 py-4"
          }, " Generate new kudo ")) : A("", !0)
        ])
      ]),
      z(zj, {
        class: "z-50",
        show: !!r.value,
        onClose: C
      }, {
        default: O(() => [
          z(VI, {
            "paper-reveal-percentage": u.value,
            "onUpdate:paperRevealPercentage": h[18] || (h[18] = (W) => u.value = W),
            "sender-name": S.senderName ? S.senderName : "",
            class: "fixed bottom-0 left-1/2 -translate-x-1/2 max-w-4xl"
          }, {
            default: O(() => [
              T("p", {
                textContent: w(r.value)
              }, null, 8, md)
            ]),
            _: 1
          }, 8, ["paper-reveal-percentage", "sender-name"])
        ]),
        _: 1
      }, 8, ["show"])
    ], 64));
  }
}), xd = ["for"], Ed = { class: "input input--small flex overflow-hidden" }, hd = {
  key: 0,
  class: "text-[#8C96A1] align-middle"
}, Cd = {
  key: 0,
  class: "text-[#8C96A1] align-middle"
}, Od = ["for"], pd = ["id"], wd = {
  inheritAttrs: !1,
  components: { MultimediaIcon: xu }
}, TN = /* @__PURE__ */ U({
  ...wd,
  __name: "FileInput",
  props: {
    modelValue: {},
    errors: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = e, i = crypto.randomUUID(), u = E();
    function N(n) {
      const s = n.target;
      t("update:modelValue", s.files[0]);
    }
    function l() {
      u.value && (u.value.value = ""), t("update:modelValue", null);
    }
    return (n, s) => (c(), g(K, null, [
      n.label ? (c(), g("label", {
        key: 0,
        for: y(i),
        class: "input-label"
      }, w(n.label), 9, xd)) : A("", !0),
      T("div", Ed, [
        (c(), k(cM(n.modelValue ? "div" : "label"), {
          for: n.modelValue ? null : y(i),
          class: "file-input__prepend bg-[#E4EDF5] px-5 -my-4 py-4 -ml-5 cursor-pointer"
        }, {
          default: O(() => [
            z(y(xu), {
              class: V(["h-5 inline-block mr-3 align-middle", [n.modelValue ? "fill-[#E31266]" : "fill-[#3F4A55]"]])
            }, null, 8, ["class"]),
            n.modelValue ? (c(), g("span", {
              key: 1,
              class: "text-[#E31266] align-middle",
              onClick: l
            }, "Delete file")) : (c(), g("span", hd, "Choose file"))
          ]),
          _: 1
        }, 8, ["for"])),
        (c(), k(cM(n.modelValue ? "div" : "label"), {
          for: n.modelValue ? null : y(i),
          class: "file-input__input pl-5 grow cursor-pointer"
        }, {
          default: O(() => [
            n.modelValue ? (c(), g("label", {
              key: 1,
              for: y(i)
            }, w(n.modelValue.name), 9, Od)) : (c(), g("span", Cd, "No file chosen"))
          ]),
          _: 1
        }, 8, ["for"]))
      ]),
      T("input", DM({
        id: y(i),
        type: "file"
      }, { accept: "image/*", ...n.$attrs }, {
        class: "hidden",
        ref_key: "inputEl",
        ref: u,
        onChange: s[0] || (s[0] = (a) => N(a))
      }), null, 16, pd),
      n.errors ? (c(), k(Te, {
        key: 1,
        errors: n.errors
      }, null, 8, ["errors"])) : A("", !0)
    ], 64));
  }
}), Yd = { class: "justify-center flex flex-wrap gap-y-3 items-center text-sm leading-6" }, Sd = {
  key: 0,
  class: "flex space-x-1.5 mr-3"
}, Zd = { class: "flex space-x-2.5" }, kd = ["src"], bd = /* @__PURE__ */ T("p", null, "Previous", -1), Ud = ["onClick"], Qd = { class: "flex space-x-2.5" }, Vd = /* @__PURE__ */ T("p", null, "Next", -1), Wd = ["src"], fd = { class: "items-center space-x-5 ml-5 text-[#8C96A1] hidden md:flex" }, vd = { class: "w-full" }, Gd = ["max"], Rd = /* @__PURE__ */ T("p", null, "Go", -1), Fd = ["src"], $A = /* @__PURE__ */ U({
  __name: "PagePagination",
  props: {
    modelValue: {},
    numberOfPages: {},
    ranger: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = M, i = E(), u = e, N = p(() => {
      let a = [];
      if (t.numberOfPages <= t.ranger) {
        for (let o = 1; o <= t.numberOfPages; o++)
          a.push(o);
        return a.sort((o, j) => o - j);
      }
      a.push(t.modelValue);
      for (let o = 0; o < (t.ranger - 1) / 2; o++)
        a.push(
          t.modelValue - ((t.ranger - 1) / 2 - o) < 1 ? t.modelValue + ((t.ranger - 1) / 2 + 1 + o) : t.modelValue - ((t.ranger - 1) / 2 - o)
        );
      for (let o = 0; o < (t.ranger - 1) / 2; o++)
        a.push(
          t.modelValue + ((t.ranger - 1) / 2 - o) > t.numberOfPages ? t.modelValue - ((t.ranger - 1) / 2 + 1 + o) : t.modelValue + ((t.ranger - 1) / 2 - o)
        );
      return a.sort((o, j) => o - j);
    }), l = (a) => {
      a > t.numberOfPages || a < 1 || u("update:modelValue", a);
    }, n = () => {
      t.modelValue !== 1 && u("update:modelValue", t.modelValue - 1);
    }, s = () => {
      t.modelValue >= t.numberOfPages || u("update:modelValue", t.modelValue + 1);
    };
    return (a, o) => (c(), g("div", Yd, [
      a.numberOfPages >= 1 ? (c(), g("ul", Sd, [
        T("li", {
          class: V(["cursor-pointer flex items-center py-2 px-5 bg-[#DBDBF9] hover:bg-[#CECEFB] transition-color duration-300 text-[#1212E0] hover:text-[#1212E0] rounded-full", {
            disabled: a.modelValue === 1
          }]),
          onClick: o[0] || (o[0] = (j) => n())
        }, [
          T("span", Zd, [
            T("img", {
              src: y(u1),
              alt: "previous icon"
            }, null, 8, kd),
            bd
          ])
        ], 2),
        (c(!0), g(K, null, lM(N.value, (j) => (c(), g("li", {
          key: j,
          class: "cursor-pointer hidden md:block",
          onClick: (D) => l(j)
        }, [
          T("div", {
            class: V(["border-[#DBDBF9] hover:border-[#CECEFB] border-2 rounded-full py-2 px-4", {
              "bg-white text-black": a.modelValue === j,
              "text-[#1212E0] hover:text-[#1212E0] bg-[#DBDBF9] hover:bg-[#CECEFB] transition-color duration-300": a.modelValue !== j
            }])
          }, w(j), 3)
        ], 8, Ud))), 128)),
        T("li", {
          class: V(["items-center flex cursor-pointer ml-3 py-2 px-5 bg-[#DBDBF9] hover:bg-[#CECEFB] transition-color duration-300 text-[#1212E0] hover:text-[#1212E0] rounded-full", {
            disabled: a.modelValue === a.numberOfPages || !a.numberOfPages
          }]),
          onClick: o[1] || (o[1] = (j) => s())
        }, [
          T("div", Qd, [
            Vd,
            T("img", {
              class: "",
              src: y(Ji),
              alt: "next icon"
            }, null, 8, Wd)
          ])
        ], 2)
      ])) : A("", !0),
      T("div", fd, [
        T("p", vd, "Total " + w(a.numberOfPages) + " pages • Go to page", 1),
        CM(T("input", {
          class: "w-1/6 rounded-lg border-[#DBDBF9] hover:border-[#CECEFB] border-2 py-[0.125rem] px-2",
          type: "number",
          "onUpdate:modelValue": o[2] || (o[2] = (j) => i.value = j),
          min: "1",
          max: a.numberOfPages
        }, null, 8, Gd), [
          [ZN, i.value]
        ]),
        T("button", {
          class: "items-center flex space-x-2.5 ml-3 py-2 px-5 bg-[#DBDBF9] hover:bg-[#CECEFB] transition-color duration-300 text-[#1212E0] hover:text-[#1212E0] rounded-full",
          onClick: o[3] || (o[3] = (j) => i.value && l(i.value))
        }, [
          Rd,
          T("img", {
            class: "",
            src: y(Ji),
            alt: "next icon"
          }, null, 8, Fd)
        ])
      ])
    ]));
  }
}), cN = [
  {
    id: 0,
    value: "Too weak",
    minDiversity: 0,
    minLength: 0
  },
  {
    id: 1,
    value: "Weak",
    minDiversity: 2,
    minLength: 6
  },
  {
    id: 2,
    value: "Medium",
    minDiversity: 4,
    minLength: 8
  },
  {
    id: 3,
    value: "Strong",
    minDiversity: 4,
    minLength: 10
  }
], Xd = (M, e = cN, t = "!\"#$%&'()*+,-./:;<=>?@[\\\\\\]^_`{|}~") => {
  let i = M || "";
  e[0].minDiversity = 0, e[0].minLength = 0;
  const u = [
    {
      regex: "[a-z]",
      message: "lowercase"
    },
    {
      regex: "[A-Z]",
      message: "uppercase"
    },
    {
      regex: "[0-9]",
      message: "number"
    }
  ];
  t && u.push({
    regex: `[${t}]`,
    message: "symbol"
  });
  let N = {};
  N.contains = u.filter((n) => new RegExp(`${n.regex}`).test(i)).map((n) => n.message), N.length = i.length;
  let l = e.filter((n) => N.contains.length >= n.minDiversity).filter((n) => N.length >= n.minLength).sort((n, s) => s.id - n.id).map((n) => ({ id: n.id, value: n.value }));
  return Object.assign(N, l[0]), N;
};
var DN = { passwordStrength: Xd, defaultOptions: cN };
const Jd = {
  key: 0,
  class: "input-label"
}, Kd = { class: "relative" }, Bd = ["type", "value"], Hd = ["src"], Pd = ["src"], _d = {
  key: 0,
  class: "gap-x-2 flex flex-wrap mx-5"
}, $d = {
  key: 0,
  class: "relative inline-block [filter:drop-shadow(0_42px_25px_rgba(177,195,213,0.08))_drop-shadow(0_19px_19px_rgba(177,195,213,0.14))_drop-shadow(0_-2px_10px_rgba(177,195,213,0.17))] bg-white rounded-2xl sm:mr-20 mt-5 px-5 sm:py-10 sm:ml-10 ml-5 py-3 mr-4"
}, qd = ["src"], My = /* @__PURE__ */ T("p", { class: "text-[#8C96A1]" }, "Requirements:", -1), ey = { class: "mt-2" }, ty = ["src"], iy = ["textContent"], uy = {
  inheritAttrs: !1
};
var rN = /* @__PURE__ */ ((M) => (M[M["Too Weak"] = 1] = "Too Weak", M[M.Weak = 2] = "Weak", M[M.Medium = 3] = "Medium", M[M.Strong = 4] = "Strong", M))(rN || {});
const qA = /* @__PURE__ */ U({
  ...uy,
  __name: "PasswordInput",
  props: {
    errors: {},
    modelValue: {},
    label: {},
    constraints: {},
    strength: {}
  },
  emits: ["update:modelValue", "update:strength", "update:constraints"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = E(!1), { class: N, inputClass: l, ...n } = yM();
    function s(r) {
      i("update:modelValue", r), a(r);
    }
    function a(r) {
      const I = DN.passwordStrength(r, [
        {
          id: 1,
          value: "Too Weak",
          minDiversity: 0,
          minLength: 0
        },
        { id: 2, value: "Weak", minDiversity: 0, minLength: 4 },
        { id: 3, value: "Medium", minDiversity: 1, minLength: 6 },
        { id: 4, value: "Strong", minDiversity: 2, minLength: 8 }
      ]);
      i("update:strength", I.id), i("update:constraints", {
        casing: I.contains.includes("lowercase") && I.contains.includes("uppercase"),
        length: r.length >= 8,
        number: I.contains.includes("number")
      });
    }
    function o(r) {
      return {
        casing: "An uppercase and a lowercase letter",
        number: "At least one number",
        length: "At least 8 characters"
      }[r];
    }
    function j(r) {
      return {
        1: "bg-[#E31266]",
        2: "bg-[#E58312]",
        3: "bg-[#FFCE21]",
        4: "bg-[#12DE74]"
      }[r];
    }
    const D = p(
      () => Object.values(t.constraints ?? {}).some((r) => !r)
    );
    return (r, I) => (c(), g(K, null, [
      T("div", {
        class: V(y(N))
      }, [
        T("label", null, [
          r.label ? (c(), g("div", Jd, w(r.label), 1)) : A("", !0),
          T("div", Kd, [
            T("input", DM({
              type: u.value ? "text" : "password",
              value: r.modelValue
            }, n, {
              onInput: I[0] || (I[0] = (L) => s(L.target.value)),
              class: ["input w-full", [
                r.errors || D.value ? "input--error" : null,
                y(iM)("input w-full", y(l))
              ]]
            }), null, 16, Bd),
            T("img", {
              onClick: I[1] || (I[1] = (L) => u.value = !u.value),
              class: "absolute right-4 top-1/2 -translate-y-1/2",
              src: u.value ? y(gu) : y(Lu),
              alt: "password visibility icon"
            }, null, 8, Hd),
            CM(T("img", {
              class: "absolute right-4 top-1/2 -translate-y-1/2 bg-white",
              src: y(mu),
              alt: "error icon"
            }, null, 8, Pd), [
              [WM, !!r.errors]
            ])
          ])
        ])
      ], 2),
      J(r.$slots, "strength", {}, () => [
        r.modelValue ? (c(), g("div", _d, [
          (c(), g(K, null, lM(rN, (L) => T("span", {
            key: L,
            class: V(["w-1/5 flex-grow h-1 mt-2", [
              j(L),
              t.strength && L > t.strength ? "invisible" : ""
            ]])
          }, null, 2)), 64))
        ])) : A("", !0)
      ]),
      J(r.$slots, "constraints", {}, () => [
        r.modelValue && t.constraints ? (c(), g("div", $d, [
          T("img", {
            src: y(Iu),
            class: "absolute left-0 -top-[0.63rem] -z-10",
            alt: "svg for bubble validation styling"
          }, null, 8, qd),
          My,
          T("ul", ey, [
            (c(!0), g(K, null, lM(Object.entries(t.constraints), ([L, d]) => (c(), g("li", {
              key: L,
              class: "my-1"
            }, [
              T("img", {
                class: "inline-block align-middle",
                src: d ? y(yu) : y(du),
                alt: "password requirements icon"
              }, null, 8, ty),
              T("span", {
                class: "align-middle ml-2",
                textContent: w(o(L))
              }, null, 8, iy)
            ]))), 128))
          ])
        ])) : A("", !0)
      ]),
      r.errors ? (c(), k(Te, {
        key: 0,
        errors: r.errors
      }, null, 8, ["errors"])) : A("", !0)
    ], 64));
  }
}), Ny = {
  key: 0,
  class: "input-label"
}, ly = { class: "flex !bg-[#E4EDF5] text-[#8C96A1] text-lg input input--small rounded-none border-none" }, ny = ["value"], sy = {
  inheritAttrs: !1
}, Mx = /* @__PURE__ */ U({
  ...sy,
  __name: "PrependedInput",
  props: {
    modelValue: {},
    prepend: {},
    label: {},
    errors: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = e;
    function i(s) {
      t("update:modelValue", s);
    }
    const {
      class: u,
      inputClass: N,
      ...l
    } = kN(yM()), n = rt(l);
    return (s, a) => (c(), g("div", {
      class: V(y(u))
    }, [
      T("label", null, [
        s.label ? (c(), g("div", Ny, w(s.label), 1)) : A("", !0),
        T("div", {
          class: V([
            s.errors ? "input--error" : null,
            "flex font-normal focus-within:!border-[#1212E0] overflow-hidden rounded-[1.25rem] hover:border-[#BBC4CD] border-[#E4EDF5] border-2"
          ])
        }, [
          T("span", ly, w(s.prepend), 1),
          T("input", DM({ type: "text" }, n, {
            onInput: a[0] || (a[0] = (o) => i(o.target.value)),
            value: s.modelValue,
            class: y(iM)("input w-full input--small rounded-l-none focus:outline-none border-none", y(N))
          }), null, 16, ny)
        ], 2)
      ]),
      s.errors ? (c(), k(Te, {
        key: 0,
        errors: s.errors
      }, null, 8, ["errors"])) : A("", !0)
    ], 2));
  }
}), oy = { class: "relative text-center" }, ay = ["src", "alt"], jy = {
  key: 1,
  class: "inline-block text-xs"
}, Ty = ["innerHTML"], gN = /* @__PURE__ */ U({
  __name: "LentilMenuItem",
  props: {
    iconPath: {
      type: String,
      required: !1
    },
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    transforms: {
      type: Object,
      required: !0
    }
  },
  setup(M) {
    return (e, t) => (c(), g("div", {
      class: "menu-btn absolute w-[4.5rem] aspect-square rounded-full bg-white hover:bg-[#FFCE21] border-[3px] border-[#FFCE21] flex items-center justify-center transition-all duration-500 ease-in-out flex-grow-0 flex-shrink-0 cursor-pointer [box-shadow:0_74px_30px_rgba(177,195,213,0.02),0_42px_25px_rgba(177,195,213,0.08),0_19px_19px_rgba(177,195,213,0.14),0_-2px_10px_rgba(177,195,213,0.17)]",
      style: RM({
        transform: `rotateZ(${M.transforms.rotateZ ? M.transforms.rotateZ : 0}deg) translateX(${M.transforms.translateX ? M.transforms.translateX : 0}) translateY(${M.transforms.translateY ? M.transforms.translateY : 0}) scale(${M.transforms.scale ? M.transforms.scale : 0})`,
        opacity: M.transforms.opacity
      })
    }, [
      T("div", {
        class: "absolute inset-0",
        style: RM({
          transform: `rotateZ(${M.transforms.rotateZ ? M.transforms.rotateZ * -1 : 0}deg)`
        })
      }, [
        J(e.$slots, "default")
      ], 4),
      J(e.$slots, "customTooltip", {}, () => [
        (c(), k(cM(M.tooltip ? y(oe) : "div"), {
          triggers: ["hover"],
          distance: 40,
          placement: "top",
          popperTriggers: ["hover"],
          delay: { show: 200, hide: 150 }
        }, Pe({
          default: O(() => [
            T("div", {
              class: "flex-shrink-0 flex-grow-0 transition-all duration-500 flex items-center justify-center",
              style: RM({
                transform: `rotateZ(${(M.transforms.rotateZ ? M.transforms.rotateZ : 0) * -1}deg)`
              })
            }, [
              T("div", oy, [
                M.iconPath ? (c(), g("img", {
                  key: 0,
                  src: M.iconPath,
                  alt: `${M.label ?? "menu item"} icon`
                }, null, 8, ay)) : A("", !0),
                M.label ? (c(), g("div", jy, w(M.label), 1)) : A("", !0)
              ])
            ], 4)
          ]),
          _: 2
        }, [
          M.tooltip ? {
            name: "popper",
            fn: O(() => [
              typeof M.tooltip == "function" ? (c(), k(cM(M.tooltip), { key: 0 })) : (c(), g("span", {
                key: 1,
                innerHTML: M.tooltip
              }, null, 8, Ty))
            ]),
            key: "0"
          } : void 0
        ]), 1024))
      ])
    ], 4));
  }
}), cy = { class: "mx-auto w-[6.25rem] aspect-square rounded-full relative flex items-center justify-center" }, ex = /* @__PURE__ */ U({
  __name: "RadialMenu",
  props: {
    isOpen: {
      type: Boolean,
      required: !1,
      default: !1
    },
    items: {
      type: Array,
      required: !0
    }
  },
  emits: ["update:isOpen", "select"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = () => i("update:isOpen", !t.isOpen), N = p(() => t.items.length > 4);
    function l(s) {
      i("select", s.value);
    }
    function n(s) {
      const a = t.items.length <= 3 ? t.items.length + 1 : t.items.length, o = (N.value ? 360 : 180) / a, j = t.items.length <= 3 ? 90 : 90 + o / 2, D = o * s - j;
      return {
        rotateZ: t.isOpen ? D : 0,
        scale: t.isOpen ? 1 : 0.5,
        translateY: t.isOpen ? "-8rem" : "0rem",
        opacity: t.isOpen ? 1 : 0.1
      };
    }
    return (s, a) => (c(), g("div", {
      class: V(["radial-menu flex justify-center w-[20.25rem]", [
        N.value ? "h-[20.25rem] items-center" : "h-[14rem] items-end"
      ]])
    }, [
      T("div", cy, [
        (c(!0), g(K, null, lM(M.items, (o, j) => (c(), k(gN, {
          key: `${o.iconPath}-${o.label}-${j}`,
          transforms: n(j + 1),
          iconPath: o.iconPath,
          label: o.label,
          tooltip: o.tooltip,
          onClick: (D) => l(o)
        }, {
          default: O(() => [
            o.defaultSlot ? (c(), k(cM(o.defaultSlot), { key: 0 })) : A("", !0)
          ]),
          _: 2
        }, 1032, ["transforms", "iconPath", "label", "tooltip", "onClick"]))), 128)),
        T("div", {
          onClick: u,
          class: "absolute main-btn inset-0 bg-[#FFCE21] rounded-full flex items-center justify-center cursor-pointer [box-shadow:0_42px_25px_rgba(177,195,213,0.08),0_19px_19px_rgba(177,195,213,0.14),0_-2px_10px_rgba(177,195,213,0.17)]"
        }, [
          T("div", {
            class: V(["w-12 h-2.5 rounded-2xl bg-white absolute transition-transform duration-500 ease-in-out", { "rotate-45": M.isOpen }])
          }, null, 2),
          T("div", {
            class: V(["w-12 h-2.5 rounded-2xl bg-white absolute transition-transform duration-500 ease-in-out", [M.isOpen ? "-rotate-45" : "-rotate-90"]])
          }, null, 2)
        ])
      ])
    ], 2));
  }
}), Dy = { class: "radial-menu flex justify-center w-[20.25rem] h-[20.25rem] items-center" }, ry = { class: "flex-wrap mx-auto w-[6.25rem] aspect-square rounded-full relative flex items-center justify-center" }, tx = /* @__PURE__ */ U({
  __name: "LineMenu",
  props: {
    isOpen: {
      type: Boolean,
      required: !1,
      default: !1
    },
    items: {
      type: Array,
      required: !0
    },
    gapBetweenItems: {
      type: Number,
      required: !1,
      default: 5
    }
  },
  emits: ["update:isOpen", "select"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = () => i("update:isOpen", !t.isOpen);
    function N(n) {
      i("select", n.value);
    }
    function l(n) {
      const a = -((t.items.length + 1) * t.gapBetweenItems) / 2 + n * t.gapBetweenItems;
      return {
        scale: t.isOpen ? 1 : 0.5,
        translateY: t.isOpen ? "-8rem" : "0rem",
        translateX: t.isOpen ? `${a}rem` : "0rem",
        opacity: t.isOpen ? 1 : 0.1
      };
    }
    return (n, s) => (c(), g("div", Dy, [
      T("div", ry, [
        (c(!0), g(K, null, lM(M.items, (a, o) => (c(), k(gN, {
          key: `${a.iconPath}-${a.label}-${o}`,
          transforms: l(o + 1),
          iconPath: a.iconPath,
          label: a.label,
          tooltip: a.tooltip,
          onClick: (j) => N(a)
        }, {
          default: O(() => [
            a.defaultSlot ? (c(), k(cM(a.defaultSlot), { key: 0 })) : A("", !0)
          ]),
          _: 2
        }, 1032, ["transforms", "iconPath", "label", "tooltip", "onClick"]))), 128)),
        T("div", {
          onClick: u,
          class: "absolute main-btn inset-0 bg-[#FFCE21] rounded-full flex items-center justify-center cursor-pointer [box-shadow:0_42px_25px_rgba(177,195,213,0.08),0_19px_19px_rgba(177,195,213,0.14),0_-2px_10px_rgba(177,195,213,0.17)]"
        }, [
          T("div", {
            class: V(["w-12 h-2.5 rounded-2xl bg-white absolute transition-transform duration-500 ease-in-out", { "rotate-45": M.isOpen }])
          }, null, 2),
          T("div", {
            class: V(["w-12 h-2.5 rounded-2xl bg-white absolute transition-transform duration-500 ease-in-out", [M.isOpen ? "-rotate-45" : "-rotate-90"]])
          }, null, 2)
        ])
      ])
    ]));
  }
}), gy = {
  inheritAttrs: !1
}, Ly = /* @__PURE__ */ U({
  ...gy,
  __name: "TooltipPosition",
  props: {
    attachTo: {
      type: Object,
      required: !0
    }
  },
  setup(M, { expose: e }) {
    const t = M, i = E(null);
    e({ $el: i });
    const { x: u, y: N } = k1({
      type: "client",
      eventFilter: TT(1e3 / 60)
    }), l = p(() => {
      var j, D;
      const a = ((j = i.value) == null ? void 0 : j.clientWidth) ?? 0, o = ((D = i.value) == null ? void 0 : D.clientHeight) ?? 0;
      return {
        x: Hi(u.value, 0, window.innerWidth - a),
        y: Hi(N.value - o, 0, window.innerHeight)
      };
    }), { isOutside: n } = b1(t.attachTo), s = p(() => !n.value);
    return (a, o) => (c(), k(ru, { to: "body" }, [
      z(We, { name: "fade" }, {
        default: O(() => [
          CM(T("div", DM({
            ref_key: "$el",
            ref: i
          }, a.$attrs, {
            class: "fixed z-30",
            style: { left: `${l.value.x}px`, top: `${l.value.y}px` }
          }), [
            J(a.$slots, "default")
          ], 16), [
            [WM, s.value]
          ])
        ]),
        _: 3
      })
    ]));
  }
}), Iy = { class: "flex-grow overflow-hidden" }, dy = {
  class: "envelope-icon mb-8 mx-auto",
  width: "20",
  height: "16",
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yy = /* @__PURE__ */ T("path", {
  d: "M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM16.59 2L10.71 7.88C10.617 7.97373 10.5064 8.04812 10.3846 8.09889C10.2627 8.14966 10.132 8.1758 10 8.1758C9.86799 8.1758 9.73728 8.14966 9.61542 8.09889C9.49356 8.04812 9.38296 7.97373 9.29 7.88L3.41 2H16.59ZM18 13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V3.41L7.88 9.29C8.4425 9.8518 9.205 10.1674 10 10.1674C10.795 10.1674 11.5575 9.8518 12.12 9.29L18 3.41V13Z",
  fill: "#BBC4CD"
}, null, -1), zy = [
  yy
], my = { class: "message transition-all duration-300 ease-in-out font-serif text-center w-full text-[#3F4A55] [overflow-wrap:break-word] leading-[1.642]" }, Ay = /* @__PURE__ */ T("div", { class: "flex h-full justify-center items-center" }, [
  /* @__PURE__ */ T("div", { class: "text-center" }, [
    /* @__PURE__ */ T("svg", {
      class: "inline-block",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /* @__PURE__ */ T("path", {
        d: "M20.21 8.82003L14 2.78003C13.474 2.27988 12.7759 2.00098 12.05 2.00098C11.3241 2.00098 10.626 2.27988 10.1 2.78003L3.89 8.78003C3.61408 9.02089 3.39216 9.31733 3.23879 9.64993C3.08541 9.98253 3.00404 10.3438 3 10.71V19.29C3.01054 20.0176 3.30904 20.7114 3.83012 21.2194C4.35119 21.7273 5.05235 22.008 5.78 22H18.22C18.9476 22.008 19.6488 21.7273 20.1699 21.2194C20.691 20.7114 20.9895 20.0176 21 19.29V10.71C20.9992 10.3585 20.929 10.0106 20.7935 9.68625C20.6579 9.36191 20.4596 9.06754 20.21 8.82003V8.82003ZM11.44 4.22003C11.593 4.08019 11.7927 4.00264 12 4.00264C12.2073 4.00264 12.407 4.08019 12.56 4.22003L18 9.50003L12.53 14.78C12.377 14.9199 12.1773 14.9974 11.97 14.9974C11.7627 14.9974 11.563 14.9199 11.41 14.78L6 9.50003L11.44 4.22003ZM19 19.29C18.9871 19.4863 18.8987 19.67 18.7532 19.8024C18.6078 19.9348 18.4166 20.0056 18.22 20H5.78C5.58338 20.0056 5.39225 19.9348 5.24678 19.8024C5.10132 19.67 5.01286 19.4863 5 19.29V11.35L9.05 15.25L7.39 16.85C7.20375 17.0374 7.09921 17.2908 7.09921 17.555C7.09921 17.8192 7.20375 18.0727 7.39 18.26C7.48295 18.3575 7.59463 18.4352 7.71836 18.4885C7.84208 18.5418 7.97529 18.5695 8.11 18.57C8.36747 18.569 8.61462 18.4687 8.8 18.29L10.57 16.59C11.0096 16.8587 11.5148 17.0008 12.03 17.0008C12.5452 17.0008 13.0504 16.8587 13.49 16.59L15.26 18.29C15.4454 18.4687 15.6925 18.569 15.95 18.57C16.0847 18.5695 16.2179 18.5418 16.3416 18.4885C16.4654 18.4352 16.5771 18.3575 16.67 18.26C16.8563 18.0727 16.9608 17.8192 16.9608 17.555C16.9608 17.2908 16.8563 17.0374 16.67 16.85L15 15.25L19 11.35V19.29Z",
        fill: "#3F4A55"
      })
    ]),
    /* @__PURE__ */ T("div", { class: "uppercase text-[#8C96A1] tracking-wider text-xs mt-3" }, " Open Kudo ")
  ])
], -1), Fi = 125, xy = /* @__PURE__ */ U({
  __name: "TextKudo",
  props: {
    message: {},
    senderName: {}
  },
  emits: ["open"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = E(null), N = E(), { isOutside: l } = b1(N), n = p(() => !l.value), s = p(() => t.message.length > Fi), a = p(() => {
      const j = Math.min(Math.max(t.message.length, 2), Fi);
      return `${36 / Math.log(j)}cqw`;
    });
    return (o, j) => (c(), k(UM, {
      ref_key: "$kudoCard",
      ref: u,
      style: RM({
        "--font-size": a.value,
        "--font-size-fallback": `${5.2 / Math.log(Math.min(Math.max(o.message.length, 2), Fi))}rem`
      }),
      onClick: j[1] || (j[1] = () => s.value && i("open")),
      class: V(["kudo-card text-kudo-card aspect-square", { "cursor-pointer": s.value }])
    }, {
      actions: O(() => [
        o.$slots.actions ? (c(), g("div", {
          key: 0,
          ref_key: "actionsEl",
          ref: N
        }, [
          J(o.$slots, "actions")
        ], 512)) : A("", !0)
      ]),
      footer: O(() => [
        T("div", {
          class: V([
            "text-center relative text-sm text-[#8C96A1]",
            s.value ? "before:absolute before:left-0 before:w-full before:bottom-[calc(100%+36px)] before:h-40 before:[background:linear-gradient(180deg,rgba(255,255,255,0),20%,rgba(255,255,255,1)_80%)]" : ""
          ])
        }, w(o.senderName), 3)
      ]),
      default: O(() => [
        T("div", Iy, [
          z(We, { name: "fade" }, {
            default: O(() => [
              CM((c(), g("svg", dy, zy, 512)), [
                [WM, s.value]
              ])
            ]),
            _: 1
          }),
          T("div", {
            class: V(["flex overflow-hidden h-full", { "items-center": !s.value }])
          }, [
            T("p", my, w(o.message), 1)
          ], 2)
        ]),
        s.value && u.value ? (c(), k(Ly, {
          key: 0,
          attachTo: u.value.$el
        }, {
          default: O(() => [
            CM(z(Cj, {
              class: "w-[10rem]",
              onClick: j[0] || (j[0] = (D) => i("open"))
            }, {
              default: O(() => [
                Ay
              ]),
              _: 1
            }, 512), [
              [WM, !n.value]
            ])
          ]),
          _: 1
        }, 8, ["attachTo"])) : A("", !0)
      ]),
      _: 3
    }, 8, ["style", "class"]));
  }
}), Ey = /* @__PURE__ */ T("div", { class: "flex justify-center items-center h-full" }, [
  /* @__PURE__ */ T("div", { class: "text-6xl text-[#8C96A1] font-serif text-center" }, [
    /* @__PURE__ */ T("div", { class: "mb-4" }, "✍️"),
    /* @__PURE__ */ T("div", null, "Preview")
  ])
], -1), _0 = /* @__PURE__ */ U({
  __name: "TextKudoBuilderPreview",
  props: {
    message: {},
    senderName: {},
    bgColor: {}
  },
  setup(M) {
    return (e, t) => e.message ? (c(), k(xy, {
      key: 0,
      message: e.message,
      senderName: e.senderName,
      class: V([e.bgColor, "shrink-0 grow-0"])
    }, null, 8, ["message", "senderName", "class"])) : (c(), k(UM, {
      key: 1,
      class: V(["aspect-square shrink-0 grow-0", [e.bgColor, "shrink-0 grow-0"]])
    }, {
      default: O(() => [
        Ey
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), hy = { class: "flex justify-between items-start gap-x-28 max-w-screen-xl mx-auto" }, Cy = { key: 0 }, Oy = { class: "flex" }, py = /* @__PURE__ */ T("span", { class: "input-label" }, "Email(optional)", -1), wy = /* @__PURE__ */ T("div", { class: "w-56 font-semibold" }, " We will never send you any spam. This is just for the confirmation of this kudo post and our anti-spam protection. ", -1), Yy = ["disabled", "textContent"], ix = /* @__PURE__ */ U({
  __name: "TextKudoBuilder",
  props: {
    message: {},
    senderName: {},
    senderEmail: {},
    color: { default: fe[0] },
    isAuthenticated: { type: Boolean }
  },
  emits: ["update:message", "update:senderName", "update:senderEmail", "update:color", "create"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = p(() => te.get(t.color)[0]);
    return (N, l) => (c(), g("div", hy, [
      z(UM, { class: "w-7/12 grow lg:grow-0 shrink-0 space-y-14" }, {
        default: O(() => [
          z(y(me), {
            label: "Kudos here",
            modelValue: N.message,
            onInput: l[0] || (l[0] = (n) => i("update:message", n.target.value)),
            inputClass: "bg-[#F8F9FF] border-none resize-none min-h-[11.25rem]",
            placeholder: "A short message, a long message, you do you. The final Kudo design will match your message’s length."
          }, null, 8, ["modelValue"]),
          z(nM, {
            label: "Your name",
            type: "text",
            modelValue: N.senderName,
            maxlength: "75",
            onInput: l[1] || (l[1] = (n) => i("update:senderName", n.target.value)),
            placeholder: "Or nickname... we are not here to dictate",
            inputClass: "bg-[#F8F9FF] border-none"
          }, null, 8, ["modelValue"]),
          N.isAuthenticated ? A("", !0) : (c(), g("div", Cy, [
            T("div", Oy, [
              py,
              z(y(oe), {
                triggers: ["hover"],
                distance: 20,
                placement: "top",
                popperTriggers: ["hover"],
                delay: { show: 200, hide: 150 }
              }, {
                popper: O(() => [
                  wy
                ]),
                default: O(() => [
                  z(y(Ee), {
                    class: "cursor-pointer h-4 w-4 fill-[#BBC4CD]",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })
            ]),
            z(nM, {
              modelValue: N.senderEmail,
              type: "email",
              "onUpdate:modelValue": l[2] || (l[2] = (n) => i("update:senderEmail", n)),
              placeholder: "Your email",
              inputClass: "bg-[#F8F9FF] border-none"
            }, null, 8, ["modelValue"])
          ])),
          A("", !0),
          z(_0, {
            class: "flex lg:hidden mx-auto mt-24 mb-12",
            message: N.message,
            senderName: N.senderName,
            bgColor: u.value
          }, null, 8, ["message", "senderName", "bgColor"]),
          J(N.$slots, "submit", se(xe(t)), () => [
            T("button", {
              onClick: l[4] || (l[4] = (n) => i("create", t)),
              class: "btn btn--primary self-start",
              disabled: !N.message,
              textContent: w(N.message ? "Post the Kudo!" : "Create your kudo first")
            }, null, 8, Yy)
          ])
        ]),
        _: 3
      }),
      z(_0, {
        class: "hidden lg:flex",
        message: N.message,
        senderName: N.senderName,
        bgColor: u.value
      }, null, 8, ["message", "senderName", "bgColor"])
    ]));
  }
}), Sy = { class: "sidebar bg-[#FFCE21] p-10 rounded-[2.25rem] z-10 overflow-x-hidden overflow-y-auto flex flex-col justify-between" }, Zy = { class: "header" }, ky = /* @__PURE__ */ T("a", { class: "btn-add block mt-10" }, "Create KudosLink", -1), by = { class: "menu" }, Uy = { class: "uppercase text-[#FEF9DF] font-sans mb-4" }, ux = /* @__PURE__ */ U({
  __name: "TheSidebar",
  props: {
    items: {}
  },
  setup(M) {
    return (e, t) => (c(), g("div", Sy, [
      T("div", null, [
        T("div", Zy, [
          J(e.$slots, "header", {}, () => [
            z(y(z1), { class: "w-8 fill-white mx-auto" }),
            ky
          ])
        ]),
        T("div", by, [
          (c(!0), g(K, null, lM(Object.entries(e.items), ([i, u]) => (c(), g("div", {
            key: i,
            class: "sidebar__section mt-14"
          }, [
            T("div", Uy, w(i), 1),
            T("ul", null, [
              (c(!0), g(K, null, lM(u, (N, l) => (c(), g("li", {
                key: l,
                class: "menu__item menu__item--active -mx-10 cursor-pointer relative after:absolute after:scale-0 hover:after:scale-100 after:transition-all after:ease-in after:duration-200 after:top-1/2 after:right-0 after:w-4 after:h-10 after:-translate-y-1/2 after:translate-x-1/2 after:rounded-xl after:bg-white"
              }, [
                typeof N == "function" || typeof N == "object" ? (c(), k(cM(N), { key: 0 })) : (c(), g(K, { key: 1 }, [
                  vM(w(N), 1)
                ], 64))
              ]))), 128))
            ])
          ]))), 128))
        ])
      ]),
      J(e.$slots, "footer")
    ]));
  }
}), Nx = U({
  inheritAttrs: !1,
  props: {
    icon: {
      type: Object,
      required: !1
    },
    tag: {
      type: [String, Object],
      default: "a"
    }
  },
  setup(M, e) {
    const { class: t, ...i } = e.attrs;
    return () => aM(
      M.tag,
      {
        class: iM(
          ["text-white", "hover:text-[#E58312]", "py-4", "px-10", "block"],
          t || []
        ),
        ...i
      },
      [
        aM(
          "div",
          { class: "inline-block align-middle w-5 mr-5" },
          M.icon && aM(M.icon, { class: "w-full max-h-5 fill-current" })
        ),
        aM(
          "div",
          { class: "inline-block align-middle text-[#3F4A55] font-medium" },
          { ...e.slots }
        )
      ]
    );
  }
}), Qy = /* @__PURE__ */ T("span", { class: "sr-only" }, "Use setting", -1), Vy = {
  inheritAttrs: !1
}, lx = /* @__PURE__ */ U({
  ...Vy,
  __name: "ToogleInput",
  props: {
    modelValue: { type: Boolean },
    label: {},
    switchClass: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = e, { labelClass: i, ...u } = yM();
    return (N, l) => (c(), k(cM(N.label ? "label" : "div"), null, {
      default: O(() => [
        N.label ? (c(), g("div", {
          key: 0,
          class: V(y(iM)("input-label", y(i)))
        }, w(N.label), 3)) : A("", !0),
        z(y(NI), DM(N.$attrs, {
          modelValue: N.modelValue,
          "onUpdate:modelValue": l[0] || (l[0] = (n) => t("update:modelValue", n)),
          class: y(iM)(
            N.modelValue ? "bg-[#12DE74] text-[#12DE74]" : "bg-[#E31266] text-[#E31266]",
            "relative flex h-10 aspect-video shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75",
            N.switchClass
          )
        }), {
          default: O(() => [
            Qy,
            T("span", {
              "aria-hidden": "true",
              class: V([
                N.modelValue ? "left-full -translate-x-full" : "left-0 translate-x-0",
                "absolute flex items-center justify-center pointer-events-none h-full border-none aspect-square transform rounded-full bg-white shadow-lg ring-0 transition-all duration-200 ease-in-out"
              ])
            }, [
              J(N.$slots, "icon", {}, () => [
                (c(), k(cM(N.modelValue ? y(Mi) : y(c1)), {
                  class: "fill-current h-2",
                  alt: N.modelValue ? "Checkmark icon" : "Cross icon"
                }, null, 8, ["alt"]))
              ])
            ], 2)
          ]),
          _: 3
        }, 16, ["modelValue", "class"])
      ]),
      _: 3
    }));
  }
});
function Wy(M, e) {
  return c(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    T("path", {
      "fill-rule": "evenodd",
      d: "M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z",
      "clip-rule": "evenodd"
    })
  ]);
}
const fy = { class: "text-right" }, vy = { class: "px-1 py-1" }, Gy = { class: "text-[#FFCE21] text-lg" }, Ry = { class: "mt-2 font-sans text-[#8C96A1] text-sm" }, Fy = { class: "px-1 py-1" }, Xy = { class: "w-7" }, nx = /* @__PURE__ */ U({
  __name: "UserMenuDropdown",
  props: {
    name: {},
    email: {},
    profilePicture: {},
    items: {}
  },
  setup(M) {
    return (e, t) => (c(), g("div", fy, [
      z(y(MI), {
        as: "div",
        class: "relative inline-block text-left"
      }, {
        default: O(({ open: i }) => [
          T("div", null, [
            z(y(eI), { class: "relative w-9 lg:w-14 aspect-square border-2 bg-white border-[#DBDBF9] rounded-full hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75" }, {
              default: O(() => [
                (c(), k(cM(e.profilePicture ? "img" : j1), {
                  src: e.profilePicture,
                  class: V(["w-full h-full rounded-full", [
                    e.profilePicture ? "object-cover" : "object-contain fill-[#BBC4CD]"
                  ]])
                }, null, 8, ["src", "class"])),
                z(y(Wy), {
                  class: V(["absolute left-full -translate-x-1/2 top-1/2 -translate-y-1/2 h-5 w-5 text-[#1212E0] bg-[#DBDBF9] rounded-full transition-all", { "rotate-180": i }]),
                  "aria-hidden": "true"
                }, null, 8, ["class"])
              ]),
              _: 2
            }, 1024)
          ]),
          z(We, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-in",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: O(() => [
              z(y(tI), { class: "absolute right-0 mt-2 w-[18.75rem] p-4 lg:p-8 origin-top-right rounded-2xl bg-white [box-shadow:0px_4px_20px_#E4EDF5] ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                default: O(() => [
                  T("div", vy, [
                    T("p", Gy, w(e.name), 1),
                    T("p", Ry, w(e.email), 1)
                  ]),
                  T("div", Fy, [
                    (c(!0), g(K, null, lM(e.items, (u) => (c(), k(y(iI), {
                      key: u.label
                    }, {
                      default: O(() => [
                        (c(), k(cM(u.tag), DM(u, {
                          class: y(iM)("text-[#3F4A55] group flex w-full items-center rounded-md py-2 mt-6 text-sm font-semibold gap-x-3", u.classListLabel)
                        }), {
                          default: O(() => [
                            T("div", Xy, [
                              (c(), k(cM(Cu[u.icon]), {
                                class: V(y(iM)("mr-2 h-4 mx-auto fill-[#BBC4CD]", u.classListIcon)),
                                "aria-hidden": "true"
                              }, null, 8, ["class"]))
                            ]),
                            T("div", null, w(u.label), 1)
                          ]),
                          _: 2
                        }, 1040, ["class"]))
                      ]),
                      _: 2
                    }, 1024))), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]));
  }
}), Jy = { class: "relative" }, Ky = ["value", "placeholder"], By = /* @__PURE__ */ U({
  __name: "SearchInput",
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ["update:modelValue", "search", "blur"],
  setup(M, { expose: e, emit: t }) {
    const i = t, u = E();
    e({ focus: N });
    function N() {
      var l;
      (l = u.value) == null || l.focus();
    }
    return (l, n) => (c(), g("div", null, [
      T("div", Jy, [
        T("input", {
          ref_key: "inputEl",
          ref: u,
          value: l.modelValue,
          onInput: n[0] || (n[0] = (s) => i("update:modelValue", s.target.value)),
          onBlur: n[1] || (n[1] = (s) => i("blur", s)),
          placeholder: l.placeholder,
          type: "text",
          class: "focus:outline-none bg-white text-xl leading-[64px] py-2 pl-5 pr-16 w-full rounded-2xl font-sans text-[#3F4A55] placeholder:text-[#BBC4CD] [box-shadow:0px_74px_30px_rgba(177,195,213,0.02),0px_42px_25px_rgba(177,195,213,0.08),0px_19px_19px_rgba(177,195,213,0.14),0px_-2px_10px_rgba(177,195,213,0.17),0px_0px_0px_rgba(177,195,213,0.1)]"
        }, null, 40, Ky),
        z(y(Eu), {
          onClick: n[2] || (n[2] = (s) => i("search", l.modelValue)),
          class: "absolute h-5 right-5 top-1/2 -translate-y-1/2 leading-[4rem] fill-[#BBC4CD] cursor-pointer"
        })
      ])
    ]));
  }
}), Hy = { class: "reveal-search-input relative" }, sx = /* @__PURE__ */ U({
  __name: "RevealSearchInput",
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ["update:modelValue", "search"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = E(!1), N = () => u.value = !u.value, l = () => u.value = !1, n = E();
    async function s() {
      var o;
      N(), await zM(), (o = n.value) == null || o.focus();
    }
    function a() {
      !t.modelValue && l();
    }
    return (o, j) => (c(), g("div", Hy, [
      T("div", {
        onClick: s,
        class: "w-10 aspect-square bg-[#DBDBF9] rounded-full text-center flex justify-center align-middle cursor-pointer"
      }, [
        z(y(Eu), { class: "w-5 fill-[#1212E0]" })
      ]),
      z(We, { name: "reveal" }, {
        default: O(() => [
          CM(z(By, {
            ref_key: "inputEl",
            ref: n,
            modelValue: o.modelValue,
            placeholder: o.placeholder,
            "onUpdate:modelValue": j[0] || (j[0] = (D) => i("update:modelValue", D)),
            class: "absolute origin-right right-0 top-1/2 -translate-y-1/2 w-full sm:w-96 opacity-100 overflow-hidden rounded-2xl [box-shadow:0px_74px_30px_rgba(177,195,213,0.02),0px_42px_25px_rgba(177,195,213,0.08),0px_19px_19px_rgba(177,195,213,0.14),0px_-2px_10px_rgba(177,195,213,0.17),0px_0px_0px_rgba(177,195,213,0.1)]",
            onBlur: a,
            onSearch: j[1] || (j[1] = (D) => i("search", D))
          }, null, 8, ["modelValue", "placeholder"]), [
            [WM, u.value]
          ])
        ]),
        _: 1
      })
    ]));
  }
}), Py = {}, _y = { class: "flex justify-between items-center" }, $y = /* @__PURE__ */ T("div", { class: "h-[1px] bg-[#E4EDF5] w-1 grow" }, null, -1), qy = { class: "mx-11 font-semibold font-sans text-sm" }, M5 = /* @__PURE__ */ T("div", { class: "h-[1px] bg-[#E4EDF5] w-1 grow" }, null, -1);
function e5(M, e) {
  return c(), g("div", null, [
    T("div", _y, [
      $y,
      T("div", qy, [
        J(M.$slots, "default")
      ]),
      M5
    ])
  ]);
}
const ox = /* @__PURE__ */ Ou(Py, [["render", e5]]), t5 = ["value"], i5 = {
  inheritAttrs: !1
}, be = /* @__PURE__ */ U({
  ...i5,
  __name: "CheckboxInput",
  props: {
    modelValue: { type: [Array, Set, Boolean] },
    value: {}
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = p({
      get() {
        return t.modelValue;
      },
      set(n) {
        i("update:modelValue", n);
      }
    }), { class: N, ...l } = yM();
    return (n, s) => (c(), g("label", {
      class: V(["checkbox-input", y(iM)("relative w-8 h-8 inline-block", y(N))])
    }, [
      CM(T("input", DM(l, {
        value: n.value,
        "onUpdate:modelValue": s[0] || (s[0] = (a) => u.value = a),
        type: "checkbox",
        class: "appearance-none transition-color duration-300 w-full h-full rounded-lg border border-[hsla(207,35%,94%,1)] bg-white checked:bg-[hsla(240,85%,47%,1)] disabled:bg-[hsla(207,35%,94%,1)]"
      }), null, 16, t5), [
        [bN, u.value]
      ]),
      z(y(Mi), { class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 fill-white" })
    ], 2));
  }
}), u5 = /* @__PURE__ */ T("div", { class: "fixed inset-0 bg-[#F8F9FF] bg-opacity-95" }, null, -1), N5 = { class: "fixed inset-0 overflow-y-auto" }, l5 = { class: "flex min-h-full items-center justify-center p-4 text-center" }, n5 = {
  key: 0,
  class: "mt-8 flex flex-wrap justify-center gap-x-5 gap-y-4"
}, ax = /* @__PURE__ */ U({
  __name: "ModalDialog",
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["update:isOpen"],
  setup(M, { expose: e, emit: t }) {
    const i = t;
    e({ open: u, close: N });
    function u() {
      i("update:isOpen", !0);
    }
    function N() {
      i("update:isOpen", !1);
    }
    return (l, n) => (c(), k(y(jN), {
      appear: "",
      show: l.isOpen,
      as: "template"
    }, {
      default: O(() => [
        z(y(bL), {
          as: "div",
          onClose: N,
          class: "relative z-10"
        }, {
          default: O(() => [
            z(y(Tu), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: O(() => [
                u5
              ]),
              _: 1
            }),
            T("div", N5, [
              T("div", l5, [
                z(y(Tu), {
                  as: "template",
                  enter: "duration-300 ease-out",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "opacity-100 scale-100",
                  leave: "duration-200 ease-in",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "opacity-0 scale-95"
                }, {
                  default: O(() => [
                    z(y(UL), { class: "relative w-full max-w-xl transform rounded-2xl bg-white p-10 text-left align-middle shadow-[0px_4px_20px_#E4EDF5] transition-all" }, {
                      default: O(() => [
                        J(l.$slots, "icon"),
                        z(y(QL), {
                          as: "h3",
                          class: "mt-4 text-2xl font-normal text-center text-[#3F4A55]"
                        }, {
                          default: O(() => [
                            J(l.$slots, "title")
                          ]),
                          _: 3
                        }),
                        J(l.$slots, "default"),
                        l.$slots.actions ? (c(), g("div", n5, [
                          J(l.$slots, "actions")
                        ])) : A("", !0)
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), s5 = { class: "flex text-[#3F4A55] items-center gap-6" }, o5 = ["src"], a5 = { class: "text-xs uppercase font-bold" }, j5 = { key: 0 }, T5 = {
  inheritAttrs: !1
}, c5 = /* @__PURE__ */ U({
  ...T5,
  __name: "SurveyCard",
  props: {
    label: {},
    icon: {},
    canDelete: { type: Boolean, default: !0 },
    canCopy: { type: Boolean, default: !0 },
    collapsed: { type: Boolean, default: void 0 }
  },
  emits: ["copy", "delete", "update:collapsed"],
  setup(M, { emit: e }) {
    const t = M, i = p(() => t.collapsed != null), u = e, { class: N, headerClass: l, ...n } = yM();
    function s() {
      u("update:collapsed", !t.collapsed);
    }
    return (a, o) => (c(), g("div", DM(n, {
      class: y(iM)("border-[#EDEDFC] bg-[#FFFFFF] rounded-2xl p-7 border-2", y(N))
    }), [
      J(a.$slots, "header", {}, () => [
        T("div", {
          onClick: s,
          class: V(y(iM)("flex justify-between", y(l)))
        }, [
          T("div", s5, [
            a.icon && typeof t.icon == "string" ? (c(), g("img", {
              key: 0,
              width: "20",
              height: "20",
              src: a.icon,
              alt: "component icon"
            }, null, 8, o5)) : (c(), k(cM(t.icon), {
              key: 1,
              class: "w-5"
            })),
            T("p", a5, w(a.label), 1)
          ]),
          T("div", {
            class: "flex gap-5",
            onClick: o[2] || (o[2] = M1(() => {
            }, ["stop"]))
          }, [
            a.canCopy ? (c(), k(y(a1), {
              key: 0,
              onClick: o[0] || (o[0] = (j) => u("copy")),
              class: "cursor-pointer h-5 fill-[#BBC4CD]"
            })) : A("", !0),
            a.canDelete ? (c(), k(y(Au), {
              key: 1,
              onClick: o[1] || (o[1] = (j) => u("delete")),
              class: "cursor-pointer h-5 fill-[#BBC4CD]"
            })) : A("", !0),
            i.value ? (c(), k(y(hu), {
              key: 2,
              onClick: s,
              class: V(["cursor-pointer h-5 fill-[#BBC4CD] stroke-1", a.collapsed ? "-rotate-90" : "rotate-90"])
            }, null, 8, ["class"])) : A("", !0)
          ])
        ], 2)
      ]),
      a.collapsed ? A("", !0) : (c(), g("div", j5, [
        J(a.$slots, "default")
      ]))
    ], 16));
  }
}), D5 = { class: "mt-6 space-y-6" }, r5 = {
  key: 0,
  "data-setting": "required",
  class: "flex items-center gap-2"
}, g5 = /* @__PURE__ */ T("p", null, "Required", -1), jx = /* @__PURE__ */ U({
  __name: "TextModuleBuilder",
  props: {
    topic: {},
    description: {},
    required: { type: Boolean },
    placeholderTitle: { default: "Title" },
    placeHolderDescription: { default: "Description (optional)" },
    classListInput: {},
    errors: {}
  },
  emits: ["update:topic", "update:description", "update:required"],
  setup(M, { emit: e }) {
    const t = e;
    return (i, u) => {
      var N, l;
      return c(), g("div", D5, [
        z(nM, {
          inputClass: y(iM)(
            "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
            i.classListInput
          ),
          modelValue: i.topic,
          "onUpdate:modelValue": u[0] || (u[0] = (n) => t("update:topic", n)),
          placeholder: i.placeholderTitle,
          errors: (N = i.errors) != null && N.topic ? [i.errors.topic] : void 0
        }, null, 8, ["inputClass", "modelValue", "placeholder", "errors"]),
        z(nM, {
          inputClass: y(iM)(
            "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
            i.classListInput
          ),
          modelValue: i.description,
          "onUpdate:modelValue": u[1] || (u[1] = (n) => t("update:description", n)),
          placeholder: i.placeHolderDescription,
          errors: (l = i.errors) != null && l.description ? [i.errors.description] : void 0
        }, null, 8, ["inputClass", "modelValue", "placeholder", "errors"]),
        J(i.$slots, "checkbox", {}, () => [
          i.required != null ? (c(), g("div", r5, [
            z(be, {
              value: i.required,
              modelValue: i.required,
              "onUpdate:modelValue": u[2] || (u[2] = (n) => t("update:required", n))
            }, null, 8, ["value", "modelValue"]),
            g5
          ])) : A("", !0)
        ])
      ]);
    };
  }
}), L5 = { class: "mt-6 space-y-6" }, I5 = { class: "flex items-center gap-5 mx-7 h-16" }, d5 = { class: "w-full" }, y5 = { class: "relative" }, z5 = ["onChange"], m5 = {
  key: 0,
  class: "gap-x-2 btn btn--small px-5 py-5 bg-slate-400 cursor-pointer rounded-lg"
}, A5 = {
  key: 1,
  class: "w-16 h-16"
}, x5 = ["src"], E5 = ["onClick"], h5 = /* @__PURE__ */ T("p", { class: "uppercase text-[#3F4A55] font-semibold" }, "add option", -1), C5 = { class: "flex items-center text-[#8C96A1] gap-7 multiple-choice-module-builder__settings" }, O5 = {
  key: 0,
  class: "flex items-center gap-2 multiple-choice-module-builder__setting",
  "data-setting": "required"
}, p5 = /* @__PURE__ */ T("p", null, "Required", -1), w5 = {
  key: 1,
  class: "flex items-center gap-2",
  "data-setting": "multiple-answers"
}, Y5 = /* @__PURE__ */ T("p", null, "Allow multiple answers", -1), S5 = {
  key: 2,
  class: "flex items-center gap-2",
  "data-setting": "own-answers"
}, Z5 = /* @__PURE__ */ T("p", null, "Allow adding own answers", -1), k5 = /* @__PURE__ */ U({
  __name: "MultipleChoiceModuleBuilder",
  props: {
    topic: {},
    description: {},
    choices: { default: () => [{ option: "", image: null }] },
    imgUrl: {},
    required: { type: Boolean },
    multipleChoice: { type: Boolean },
    customAnswers: { type: Boolean },
    classListInput: {},
    errors: {}
  },
  emits: ["update:topic", "update:description", "update:choices", "update:required", "update:multipleChoice", "update:customAnswers"],
  setup(M, { emit: e }) {
    const t = M, i = e;
    function u(o) {
      if (o)
        return o instanceof Blob ? URL.createObjectURL(o) : o;
    }
    function N() {
      i("update:choices", [...t.choices, { option: "", image: null }]);
    }
    function l(o) {
      let j = [...t.choices];
      j.splice(o, 1), i("update:choices", j);
    }
    function n(o, j) {
      let D = [...t.choices];
      D[j].option = o, i("update:choices", D);
    }
    function s(o, j) {
      let D = [...t.choices];
      if (o == null) {
        D[j].image = null, i("update:choices", D);
        return;
      }
      const r = o == null ? void 0 : o.target;
      D[j].image = r.files[0], i("update:choices", D);
    }
    const a = E(!1);
    return (o, j) => {
      var r, I, L;
      const D = AM("PopperTooltip");
      return c(), g("div", L5, [
        z(nM, {
          inputClass: y(iM)(
            "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
            o.classListInput
          ),
          modelValue: o.topic,
          "onUpdate:modelValue": j[0] || (j[0] = (d) => i("update:topic", d)),
          placeholder: "What would you like to ask?",
          errors: (r = o.errors) != null && r.topic ? [o.errors.topic] : void 0
        }, null, 8, ["inputClass", "modelValue", "errors"]),
        z(nM, {
          inputClass: y(iM)(
            "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
            o.classListInput
          ),
          modelValue: o.description,
          "onUpdate:modelValue": j[1] || (j[1] = (d) => i("update:description", d)),
          placeholder: "Description (optional)",
          errors: (I = o.errors) != null && I.desc ? [o.errors.desc] : void 0
        }, null, 8, ["inputClass", "modelValue", "errors"]),
        z(y(Xi), {
          modelValue: o.choices,
          "onUpdate:modelValue": j[4] || (j[4] = (d) => i("update:choices", d)),
          handle: ".handle",
          class: "space-y-5"
        }, {
          item: O(({ element: d, index: m }) => {
            var x, C, Q, S, h, W, eM, NM, v, H, F, $;
            return [
              T("div", null, [
                T("div", I5, [
                  z(y(Zj), {
                    class: V(["w-6 handle", a.value ? "cursor-grabbing" : "cursor-grab"]),
                    onMousedown: j[2] || (j[2] = (X) => a.value = !0),
                    onMouseout: j[3] || (j[3] = (X) => a.value = !1)
                  }, null, 8, ["class"]),
                  T("div", d5, [
                    z(nM, {
                      inputClass: y(iM)(
                        "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
                        o.classListInput
                      ),
                      modelValue: d.option,
                      "onUpdate:modelValue": (X) => n(X, m),
                      placeholder: "Option"
                    }, null, 8, ["inputClass", "modelValue", "onUpdate:modelValue"])
                  ]),
                  T("div", y5, [
                    T("label", null, [
                      T("input", {
                        type: "file",
                        accept: "image/*",
                        class: "hidden",
                        onChange: (X) => s(X, m)
                      }, null, 40, z5),
                      d.image ? A("", !0) : (c(), g("div", m5, [
                        z(y(o1), { class: "w-6" })
                      ])),
                      d.image ? (c(), g("div", A5, [
                        T("img", {
                          class: "object-cover w-16 h-16 cursor-pointer",
                          src: u(d.image),
                          alt: "option image"
                        }, null, 8, x5)
                      ])) : A("", !0)
                    ]),
                    d.image ? (c(), k(D, { key: 0 }, {
                      popper: O(() => [
                        vM("Delete image")
                      ]),
                      default: O(() => [
                        T("div", {
                          onClick: (X) => s(null, m),
                          class: "absolute flex items-center justify-center rounded-full top-0 right-0 cursor-pointer w-6 h-6 bg-[#E31266] before:absolute before:w-1/2 before:h-[2px] before:bg-white before:rotate-45 after:absolute after:w-1/2 after:h-[2px] after:bg-white after:-rotate-45"
                        }, null, 8, E5)
                      ]),
                      _: 2
                    }, 1024)) : A("", !0)
                  ]),
                  o.choices.length > 2 ? (c(), k(y(D1), {
                    key: 0,
                    onClick: (X) => l(m),
                    class: "h-6 fill-[#BBC4CD] cursor-pointer"
                  }, null, 8, ["onClick"])) : A("", !0)
                ]),
                z(Te, {
                  errors: ((Q = (C = (x = o.errors) == null ? void 0 : x.choices) == null ? void 0 : C[m]) == null ? void 0 : Q.option) && [
                    (W = (h = (S = o.errors) == null ? void 0 : S.choices) == null ? void 0 : h[m]) == null ? void 0 : W.option
                  ]
                }, null, 8, ["errors"]),
                z(Te, {
                  errors: ((v = (NM = (eM = o.errors) == null ? void 0 : eM.choices) == null ? void 0 : NM[m]) == null ? void 0 : v.image) && [
                    ($ = (F = (H = o.errors) == null ? void 0 : H.choices) == null ? void 0 : F[m]) == null ? void 0 : $.image
                  ]
                }, null, 8, ["errors"])
              ])
            ];
          }),
          _: 1
        }, 8, ["modelValue"]),
        typeof ((L = o.errors) == null ? void 0 : L.choices) == "string" ? (c(), k(Te, {
          key: 0,
          errors: [o.errors.choices]
        }, null, 8, ["errors"])) : A("", !0),
        T("button", {
          type: "button",
          onClick: N,
          class: "ml-16 py-4 px-5 rounded-[80px] btn--outline flex items-center gap-4"
        }, [
          z(y(I1), { class: "fill-[#1212E0] h-6" }),
          h5
        ]),
        J(o.$slots, "checkbox", {}, () => [
          T("div", C5, [
            o.required != null ? (c(), g("div", O5, [
              z(be, {
                value: o.required,
                modelValue: o.required,
                "onUpdate:modelValue": j[5] || (j[5] = (d) => i("update:required", d))
              }, null, 8, ["value", "modelValue"]),
              p5
            ])) : A("", !0),
            o.multipleChoice != null ? (c(), g("div", w5, [
              z(be, {
                value: o.multipleChoice,
                modelValue: o.multipleChoice,
                "onUpdate:modelValue": j[6] || (j[6] = (d) => i("update:multipleChoice", d))
              }, null, 8, ["value", "modelValue"]),
              Y5
            ])) : A("", !0),
            o.customAnswers != null ? (c(), g("div", S5, [
              z(be, {
                value: o.customAnswers,
                modelValue: o.customAnswers,
                "onUpdate:modelValue": j[7] || (j[7] = (d) => i("update:customAnswers", d))
              }, null, 8, ["value", "modelValue"]),
              Z5
            ])) : A("", !0)
          ])
        ])
      ]);
    };
  }
}), b5 = {
  inheritAttrs: !1
}, Tx = /* @__PURE__ */ U({
  ...b5,
  __name: "RandomModuleBuilder",
  props: {
    topic: {},
    classListInput: {}
  },
  setup(M) {
    const { class: e, ...t } = yM();
    return (i, u) => (c(), g("div", DM(t, {
      class: y(iM)(
        "text-center mt-6 input--small font-sans font-normal text-[#8C96A1] w-full bg-white rounded-xl border-[#DBDBF9] border-[1px]",
        i.classListInput
      )
    }), w(i.topic), 17));
  }
}), U5 = { class: "mt-6 space-y-6" }, Q5 = { class: "flex items-center gap-3" }, V5 = /* @__PURE__ */ T("p", { class: "text-[#8C96A1] ml-5 mr-7" }, "Type", -1), W5 = ["src"], f5 = ["src"], v5 = ["src"], G5 = { class: "space-y-5 ml-5 mr-12" }, R5 = { class: "flex items-center gap-3" }, F5 = { class: "w-full" }, X5 = { class: "flex items-center gap-3" }, J5 = { class: "w-full" }, K5 = {
  key: 0,
  class: "flex items-center gap-2 scale-module-builder__setting",
  "data-setting": "required"
}, B5 = /* @__PURE__ */ T("p", null, "Required", -1), cx = /* @__PURE__ */ U({
  __name: "ScaleModuleBuilder",
  props: {
    topic: {},
    description: {},
    min: {},
    max: {},
    minLabel: {},
    maxLabel: {},
    scaleUnit: {},
    scaleDropdownMin: {},
    scaleDropdownMax: {},
    required: { type: [Array, Set, Boolean] },
    canBeRequired: { type: Boolean },
    classListInput: {},
    classListCard: {},
    errors: {}
  },
  emits: ["update:topic", "update:description", "update:min", "update:max", "update:scaleUnit", "update:minLabel", "update:maxLabel", "update:required"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = ["😧", "😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀", "🥰", "😍"], N = (n) => t.scaleUnit == "numbers" ? (n === "min" ? t.min : t.max) + "." : t.scaleUnit == "stars" ? (n === "min" ? t.min : t.max) + " ⭐️" : n === "min" ? `${t.min} ${u[t.min - 1]}` : `${t.max} ${u[t.max - 1]}`;
    async function l(n) {
      i("update:scaleUnit", n), ["stars", "smiles"].includes(n) && (await zM(), i("update:min", "1"));
    }
    return (n, s) => {
      var a, o, j, D;
      return c(), g("div", U5, [
        z(nM, {
          inputClass: y(iM)(
            "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
            n.classListInput
          ),
          modelValue: n.topic,
          "onUpdate:modelValue": s[0] || (s[0] = (r) => i("update:topic", r)),
          placeholder: "What would you like to ask?",
          errors: (a = n.errors) != null && a.topic ? [n.errors.topic] : void 0
        }, null, 8, ["inputClass", "modelValue", "errors"]),
        z(nM, {
          inputClass: y(iM)(
            "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
            n.classListInput
          ),
          modelValue: n.description,
          "onUpdate:modelValue": s[1] || (s[1] = (r) => i("update:description", r)),
          placeholder: "Description (optional)",
          errors: (o = n.errors) != null && o.description ? [n.errors.description] : void 0
        }, null, 8, ["inputClass", "modelValue", "errors"]),
        T("div", Q5, [
          V5,
          T("button", {
            type: "button",
            onClick: s[2] || (s[2] = (r) => l("numbers")),
            class: V([
              "scale-button",
              n.scaleUnit == "numbers" ? "border-[#12DE74] bg-[#DAF7E8]" : "bg-white border-[#DBDBF9]"
            ])
          }, [
            T("img", {
              class: "h-5",
              src: y(l1),
              alt: "number scale icon"
            }, null, 8, W5)
          ], 2),
          T("button", {
            type: "button",
            onClick: s[3] || (s[3] = (r) => l("stars")),
            class: V([
              "scale-button",
              n.scaleUnit == "stars" ? "border-[#12DE74] bg-[#DAF7E8]" : "bg-white border-[#DBDBF9]"
            ])
          }, [
            T("img", {
              class: "h-5",
              src: y(N1),
              alt: "stars scale icon"
            }, null, 8, f5)
          ], 2),
          T("button", {
            type: "button",
            onClick: s[4] || (s[4] = (r) => l("smiles")),
            class: V([
              "scale-button",
              n.scaleUnit == "smiles" ? "border-[#12DE74] bg-[#DAF7E8]" : "bg-white border-[#DBDBF9]"
            ])
          }, [
            T("img", {
              class: "h-5",
              src: y(n1),
              alt: "🥳"
            }, null, 8, v5)
          ], 2)
        ]),
        T("div", G5, [
          T("div", R5, [
            z(Ve, {
              dropdownItems: n.scaleDropdownMin,
              classListListBoxButton: [
                "text-lg",
                "border-none",
                "px-0",
                "min-w-[4rem]",
                "cursor-pointer"
              ],
              classListListBoxOptions: [
                "z-20",
                "p-1",
                "m-0",
                "min-w-[4rem]",
                "text-center"
              ],
              classListListBoxOption: [
                "text-center",
                "aspect-square",
                "items-center",
                "flex",
                "justify-center",
                "my-0",
                "p-1",
                "mx-0",
                "hover:bg-[#1212E0]",
                "hover:text-white",
                "hover:font-bold"
              ],
              modelValue: N("min"),
              "onUpdate:modelValue": s[5] || (s[5] = (r) => i("update:min", r))
            }, null, 8, ["dropdownItems", "modelValue"]),
            T("div", F5, [
              z(nM, {
                inputClass: y(iM)(
                  "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
                  n.classListInput
                ),
                modelValue: n.minLabel,
                "onUpdate:modelValue": s[6] || (s[6] = (r) => i("update:minLabel", r)),
                placeholder: "Low score label (optional)",
                errors: (j = n.errors) != null && j.minLabel ? [n.errors.minLabel] : void 0
              }, null, 8, ["inputClass", "modelValue", "errors"])
            ])
          ]),
          T("div", X5, [
            z(Ve, {
              dropdownItems: n.scaleDropdownMax,
              classListListBoxButton: [
                "text-lg",
                "border-none",
                "px-0",
                "min-w-[4rem]",
                "cursor-pointer"
              ],
              classListListBoxOptions: [
                "z-20",
                "p-1",
                "m-0",
                "min-w-[4rem]",
                "text-center"
              ],
              classListListBoxOption: [
                "text-center",
                "aspect-square",
                "items-center",
                "flex",
                "justify-center",
                "my-0",
                "p-1",
                "mx-0",
                "hover:bg-[#1212E0]",
                "hover:text-white",
                "hover:font-bold"
              ],
              modelValue: N("max"),
              "onUpdate:modelValue": s[7] || (s[7] = (r) => i("update:max", r))
            }, null, 8, ["dropdownItems", "modelValue"]),
            T("div", J5, [
              z(nM, {
                inputClass: y(iM)(
                  "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
                  n.classListInput
                ),
                modelValue: n.maxLabel,
                "onUpdate:modelValue": s[8] || (s[8] = (r) => i("update:maxLabel", r)),
                placeholder: "High score label (optional)",
                errors: (D = n.errors) != null && D.maxLabel ? [n.errors.maxLabel] : void 0
              }, null, 8, ["inputClass", "modelValue", "errors"])
            ])
          ])
        ]),
        J(n.$slots, "checkbox", {}, () => [
          n.required != null ? (c(), g("div", K5, [
            z(be, {
              value: n.required,
              modelValue: n.required,
              "onUpdate:modelValue": s[9] || (s[9] = (r) => i("update:required", r))
            }, null, 8, ["value", "modelValue"]),
            B5
          ])) : A("", !0)
        ])
      ]);
    };
  }
}), H5 = { class: "mt-6" }, P5 = {
  key: 0,
  class: "text-red-600 mt-2"
}, Dx = /* @__PURE__ */ U({
  __name: "ImageModuleBuilder",
  props: {
    classListInput: {},
    image: {},
    errors: {}
  },
  emits: ["update:image"],
  setup(M, { emit: e }) {
    const t = e;
    return (i, u) => {
      var N;
      return c(), g("div", H5, [
        z(y(TN), {
          class: V(
            y(iM)(
              "input--small font-sans font-normal text-[#3F4A55] w-full bg-[#F8F9FF] rounded-xl border-[#DBDBF9]",
              i.classListInput
            )
          ),
          modelValue: i.image,
          "onUpdate:modelValue": u[0] || (u[0] = (l) => t("update:image", l)),
          errors: (N = i.errors) != null && N.path ? [i.errors.path] : void 0
        }, null, 8, ["class", "modelValue", "errors"]),
        i.image === null ? (c(), g("div", P5, " You don't have an image uploaded ")) : A("", !0)
      ]);
    };
  }
}), _5 = /* @__PURE__ */ T("div", { class: "inline-block" }, "Options to rank", -1), $5 = /* @__PURE__ */ T("p", null, "Set how many options at minimum must the user rank.", -1), rx = /* @__PURE__ */ U({
  __name: "RankingModuleBuilder",
  props: {
    topic: {},
    description: {},
    choices: { default: () => [{ option: "", image: null }] },
    imgUrl: {},
    minNumOfAnswers: {},
    errors: {}
  },
  emits: ["update:topic", "update:description", "update:choices", "update:minNumOfAnswers"],
  setup(M, { emit: e }) {
    const t = M, i = e;
    async function u(N) {
      i("update:choices", N), await zM(), N.length < t.minNumOfAnswers && i(
        "update:minNumOfAnswers",
        Math.min(N.length, t.minNumOfAnswers)
      );
    }
    return (N, l) => (c(), k(y(k5), {
      topic: N.topic,
      description: N.description,
      choices: N.choices,
      "onUpdate:description": l[1] || (l[1] = (n) => i("update:description", n)),
      "onUpdate:topic": l[2] || (l[2] = (n) => i("update:topic", n)),
      "onUpdate:choices": l[3] || (l[3] = (n) => u(n)),
      errors: N.errors
    }, {
      checkbox: O(() => [
        z(y(Ve), {
          classListListBoxButton: ["input--small"],
          dropdownItems: N.choices.map((n, s) => s + 1),
          modelValue: N.minNumOfAnswers || N.choices.length,
          "onUpdate:modelValue": l[0] || (l[0] = (n) => i("update:minNumOfAnswers", n))
        }, {
          label: O(() => [
            _5,
            z(y(oe), {
              triggers: ["hover"],
              class: "inline-block"
            }, {
              popper: O(() => [
                $5
              ]),
              default: O(() => [
                z(y(Cu).InfoIcon, {
                  class: "cursor-pointer h-4 w-4 fill-[#BBC4CD] ml-1",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["dropdownItems", "modelValue"])
      ]),
      _: 1
    }, 8, ["topic", "description", "choices", "errors"]));
  }
}), q5 = /* @__PURE__ */ T("span", null, null, -1), M3 = { class: "font-semibold text-2xl leading-9 text-[#3F4A55]" }, e3 = { class: "font-semibold text-[#8C96A1] leading-7" }, t3 = {
  inheritAttrs: !1
}, gx = /* @__PURE__ */ U({
  ...t3,
  __name: "TextModule",
  props: {
    title: {},
    description: {},
    classListCard: {}
  },
  setup(M) {
    const { class: e, ...t } = yM();
    return (i, u) => (c(), k(c5, DM(t, {
      class: y(iM)("border-[#DBDBF9] border-[1px] py-10 pt-7 pb-8 bg-[#F8F9FF]", y(e))
    }), {
      header: O(() => [
        q5
      ]),
      default: O(() => [
        T("p", M3, w(i.title), 1),
        T("p", e3, w(i.description), 1)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), i3 = { class: "font-semibold text-2xl leading-9 text-[#3F4A55]" }, u3 = { class: "font-semibold text-[#8C96A1] leading-7" }, N3 = { class: "flex items-end relative" }, l3 = {
  key: 0,
  class: "absolute bottom-7 right-3 w-6 aspect-square rounded-full bg-[#EDEDFC] flex items-center justify-center"
}, n3 = {
  inheritAttrs: !1
}, Lx = /* @__PURE__ */ U({
  ...n3,
  __name: "QuestionModule",
  props: {
    title: {},
    description: {},
    answer: {},
    classListInput: {},
    classListCard: {}
  },
  emits: ["update:answer"],
  setup(M, { emit: e }) {
    const t = e, { class: i, ...u } = yM();
    return (N, l) => (c(), g("div", DM(u, {
      tabindex: "0",
      class: y(iM)("border-none px-7 pt-7 pb-8 bg-white rounded-2xl", y(i))
    }), [
      T("p", i3, w(N.title), 1),
      T("p", u3, w(N.description), 1),
      T("div", N3, [
        z(me, {
          class: "w-full",
          inputClass: y(iM)(
            "grow mt-6 px-0 py-1 focus:outline-none border-t-0 border-l-0 border-r-0 border-b-[1px] rounded-none border-[#BBC4CD] focus:border-b-[#6212E5] hover:border-b-[#6212E5]",
            N.classListInput
          ),
          placeholder: "Your short/long answer...",
          modelValue: N.answer,
          classListLabel: "grow",
          "onUpdate:modelValue": l[0] || (l[0] = (n) => t("update:answer", n))
        }, null, 8, ["inputClass", "modelValue"]),
        N.answer ? (c(), g("div", l3, [
          z(y(Mi), { class: "fill-[#1212E0] w-3" })
        ])) : A("", !0)
      ])
    ], 16));
  }
}), s3 = { class: "font-semibold text-2xl leading-9 text-[#3F4A55]" }, o3 = { class: "font-semibold text-[#8C96A1] leading-7" }, a3 = ["src", "alt"], j3 = { class: "my-4 mx-12 flex items-center gap-x-4" }, T3 = {
  key: 0,
  class: "flex items-center gap-5 w-full"
}, c3 = { class: "border gap-x-4 mt-2 border-[#DBDBF9] bg-[#F8F9FF] hover:bg-[#EDEDFC] rounded-[14px] py-4 px-12 w-fit inline-flex items-center" }, D3 = /* @__PURE__ */ T("span", { class: "align-middle mr-8" }, "Other:", -1), r3 = { class: "w-full" }, g3 = {
  inheritAttrs: !1
}, Ix = /* @__PURE__ */ U({
  ...g3,
  __name: "MultipleChoiceModule",
  props: {
    title: {},
    description: {},
    answer: {},
    choices: {},
    allowAddingOwnAnswers: { type: Boolean },
    classListInput: {}
  },
  emits: ["update:answer"],
  setup(M, { emit: e }) {
    const t = M, i = e, { class: u, ...N } = yM(), l = E(""), n = p(() => Array.isArray(t.answer)), s = p(
      () => Array.isArray(t.answer) ? t.answer : [t.answer]
    ), a = p({
      get() {
        return t.answer;
      },
      set(o) {
        i("update:answer", o);
      }
    });
    return xM(l, function(j = "", D) {
      if (!n.value) {
        a.value = j;
        return;
      }
      const r = [...s.value], I = r.indexOf(D);
      I >= 0 && r.splice(I, 1), r.push(j), a.value = r;
    }), (o, j) => (c(), g("div", {
      tabindex: "0",
      class: V(
        y(iM)("border-none px-7 pt-7 pb-8 bg-white rounded-2xl", y(u))
      )
    }, [
      T("p", s3, w(o.title), 1),
      T("p", o3, w(o.description), 1),
      (c(!0), g(K, null, lM(o.choices, (D, r) => (c(), g("label", {
        key: r,
        class: "border gap-x-4 mt-2 border-[#DBDBF9] bg-[#F8F9FF] hover:bg-[#EDEDFC] rounded-[14px] w-full inline-flex items-center"
      }, [
        D.image ? (c(), g("img", {
          key: 0,
          src: D.image,
          class: "rounded-l-[14px] object-cover h-24 aspect-square",
          alt: `${D.option} image`
        }, null, 8, a3)) : A("", !0),
        T("div", j3, [
          (c(), k(cM(n.value ? be : He), {
            modelValue: a.value,
            "onUpdate:modelValue": j[0] || (j[0] = (I) => a.value = I),
            value: D.option,
            class: "shrink-0"
          }, null, 8, ["modelValue", "value"])),
          T("span", {
            class: V([
              s.value.includes(D.option) ? "text-[#3F4A55] font-semibold" : "",
              "align-middle mr-8"
            ])
          }, w(D.option), 3)
        ])
      ]))), 128)),
      o.allowAddingOwnAnswers ? (c(), g("div", T3, [
        T("label", c3, [
          (c(), k(cM(n.value ? be : He), {
            modelValue: a.value,
            "onUpdate:modelValue": j[1] || (j[1] = (D) => a.value = D),
            value: l.value
          }, null, 8, ["modelValue", "value"])),
          D3
        ]),
        T("div", r3, [
          z(nM, {
            inputClass: "mt-6 px-0 py-1 focus:outline-none border-t-0 border-l-0 border-r-0 border-b-[1px] rounded-none border-[#BBC4CD] focus:border-b-[#6212E5] hover:border-b-[#6212E5] disabled:bg-white",
            modelValue: l.value,
            "onUpdate:modelValue": j[2] || (j[2] = (D) => l.value = D),
            placeholder: "Your answer"
          }, null, 8, ["modelValue"])
        ])
      ])) : A("", !0)
    ], 2));
  }
}), L3 = ["src"], I3 = {
  inheritAttrs: !1
}, dx = /* @__PURE__ */ U({
  ...I3,
  __name: "ImageModule",
  props: {
    image: {}
  },
  setup(M) {
    const { class: e, ...t } = yM();
    return (i, u) => i.image ? (c(), g("img", DM({ key: 0 }, t, {
      src: i.image,
      class: y(iM)(
        "mx-auto rounded-2xl scale-100 max-h-[36.625rem] w-[36.625rem]",
        y(e)
      )
    }), null, 16, L3)) : A("", !0);
  }
}), d3 = /* @__PURE__ */ T("div", { class: "bg-white w-6 h-10 absolute left-10 -top-3 opacity-50 shadow-[0_0px_1px__rgba(0,0,0,0.25)]" }, null, -1), y3 = /* @__PURE__ */ T("div", { class: "bg-white w-6 h-10 absolute right-10 -top-3 opacity-50 shadow-[0_0px_1px__rgba(0,0,0,0.25)]" }, null, -1), z3 = { class: "mt-4 text-[#3F4A55] text-[1.75rem] leading-[2.875rem]" }, m3 = {
  inheritAttrs: !1
}, yx = /* @__PURE__ */ U({
  ...m3,
  __name: "RandomModule",
  props: {
    title: {},
    classListCard: {}
  },
  setup(M) {
    const { class: e, ...t } = yM();
    return (i, u) => (c(), g("div", DM(t, {
      class: y(iM)(
        "mx-auto rounded-2xl bg-[#DBDBF9] px-10 py-11 text-center max-w-[36.625rem] relative",
        y(e)
      )
    }), [
      d3,
      y3,
      z(y(d1), { class: "stroke-white fill-[#DBDBF9] stroke-2 w-5 mx-auto" }),
      T("p", z3, w(i.title), 1)
    ], 16));
  }
}), A3 = { class: "flex items-center gap-x-1 md:gap-x-2" }, x3 = /* @__PURE__ */ U({
  __name: "StarScale",
  props: {
    scale: {},
    answer: {}
  },
  emits: ["update:answer"],
  setup(M, { emit: e }) {
    const t = e, i = E(0), { disabled: u = !1 } = yM();
    return (N, l) => (c(), g("div", A3, [
      (c(!0), g(K, null, lM(N.scale, (n) => (c(), k(y(L1), {
        key: n,
        onMouseover: (s) => i.value = n,
        onMouseleave: l[0] || (l[0] = (s) => i.value = 0),
        onClick: (s) => !y(u) && t("update:answer", n),
        class: V(["w-9", [
          y(u) ? "pointer-events-none" : "cursor-pointer",
          n <= i.value || n <= N.answer ? "fill-[#FFCE21] stroke-none" : "stroke-[#C3C3FA] fill-white"
        ]])
      }, null, 8, ["onMouseover", "onClick", "class"]))), 128))
    ]));
  }
}), E3 = {
  key: 0,
  class: "font-semibold text-2xl leading-9 text-[#3F4A55]"
}, h3 = {
  key: 1,
  class: "font-semibold text-[#8C96A1] leading-7"
}, C3 = {
  key: 0,
  class: "flex items-center justify-center w-full"
}, O3 = { key: 1 }, p3 = { class: "sm:hidden block mb-5 text-center" }, w3 = { class: "align-middle" }, Y3 = { class: "sm:hidden block text-center mt-5" }, S3 = { class: "hidden mt-5 sm:flex justify-between" }, Z3 = { class: "font-semibold text-[#3F4A55]" }, k3 = { class: "font-semibold text-[#3F4A55]" }, b3 = ["onClick"], U3 = { class: "align-middle font-serif" }, Q3 = {
  key: 3,
  class: "mt-5 flex justify-between"
}, V3 = { class: "font-semibold text-[#3F4A55]" }, W3 = { class: "font-semibold text-[#3F4A55]" }, f3 = {
  inheritAttrs: !1
}, zx = /* @__PURE__ */ U({
  ...f3,
  __name: "ScaleModule",
  props: {
    title: {},
    description: {},
    answer: {},
    scaleType: {},
    maxScale: {},
    minScale: {},
    textLeft: {},
    textRight: {},
    required: { type: Boolean },
    classListInput: {}
  },
  emits: ["update:answer"],
  setup(M, { emit: e }) {
    const t = M, i = e, { class: u, disabled: N = !1, ...l } = yM(), n = t.minScale == 0 ? t.maxScale + 1 : t.maxScale, s = p(() => t.maxScale >= 7 ? "gap-x-1" : "gap-x-4"), a = {
      2: ["🙁", "🙂"],
      3: ["🙁", "🫤", "🙂"],
      4: ["☹️", "🙁", "🙂", "😀"],
      5: ["☹️", "🙁", "🫤", "🙂", "😀"],
      6: ["☹️", "🙁", "🫤", "🙂", "😉", "😀"],
      7: ["😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀"],
      8: ["😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀", "😍"],
      9: ["😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀", "🥰", "😍"],
      10: ["😧", "😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀", "🥰", "😍"]
    };
    return (o, j) => (c(), g("div", DM(l, {
      tabindex: "0",
      class: y(iM)("border-none px-7 pt-7 pb-8 bg-white rounded-2xl", y(u))
    }), [
      o.title ? (c(), g("p", E3, w(o.title), 1)) : A("", !0),
      o.description ? (c(), g("p", h3, w(o.description), 1)) : A("", !0),
      T("div", {
        class: V(["mx-auto", o.textLeft || o.textRight || o.title || o.description ? "mt-10" : ""])
      }, [
        o.scaleType == "stars" ? (c(), g("div", C3, [
          z(x3, {
            answer: o.answer,
            "onUpdate:answer": j[0] || (j[0] = (D) => i("update:answer", D)),
            scale: o.maxScale,
            disabled: y(N)
          }, null, 8, ["answer", "scale", "disabled"])
        ])) : A("", !0),
        o.scaleType == "numbers" ? (c(), g("div", O3, [
          T("div", {
            class: V(["flex flex-col sm:flex-row justify-between", [s.value, y(N) ? "pointer-events-none" : ""]])
          }, [
            T("div", p3, w(o.textLeft), 1),
            (c(!0), g(K, null, lM(y(n), (D, r) => (c(), g("div", {
              class: "grow",
              key: D
            }, [
              T("label", {
                class: V([
                  "border mt-2 border-[#DBDBF9] bg-[#F8F9FF] hover:bg-[#EDEDFC] rounded-[14px] py-4 items-center flex gap-2",
                  o.maxScale >= 7 ? "sm:flex-col flex-row justify-start sm:justify-center px-12 sm:px-0" : "flex-row justify-start pl-12 sm:pl-5"
                ])
              }, [
                z(He, {
                  value: o.minScale == 0 ? r : D,
                  modelValue: o.answer,
                  disabled: y(N),
                  "onUpdate:modelValue": (I) => i("update:answer", o.minScale == 0 ? r : D)
                }, null, 8, ["value", "modelValue", "disabled", "onUpdate:modelValue"]),
                T("span", w3, w(o.minScale == 0 ? r : D), 1)
              ], 2)
            ]))), 128))
          ], 2),
          T("div", Y3, w(o.textRight), 1),
          T("div", S3, [
            T("p", Z3, w(o.textLeft), 1),
            T("p", k3, w(o.textRight), 1)
          ])
        ])) : A("", !0),
        o.scaleType == "smiles" ? (c(), g("div", {
          key: 2,
          class: V({ "pointer-events-none": y(N) })
        }, [
          T("div", {
            class: V(["flex justify-between overflow-x-scroll", s.value])
          }, [
            (c(!0), g(K, null, lM(a[o.maxScale], (D, r) => (c(), g("div", {
              class: "grow",
              key: r
            }, [
              T("label", {
                onClick: (I) => i("update:answer", r + 1),
                class: V(["cursor-pointer w-full justify-center border mt-2 rounded-[14px] py-4 inline-flex items-center", [
                  r == o.answer - 1 ? "bg-[#1212E0] border-[#1212E0]" : "bg-[#F8F9FF] hover:bg-[#EDEDFC] border-[#DBDBF9]"
                ]])
              }, [
                T("span", U3, w(D), 1)
              ], 10, b3)
            ]))), 128))
          ], 2)
        ], 2)) : A("", !0),
        o.textLeft && o.textRight && o.scaleType != "numbers" ? (c(), g("div", Q3, [
          T("p", V3, w(o.textLeft), 1),
          T("p", W3, w(o.textRight), 1)
        ])) : A("", !0)
      ], 2)
    ], 16));
  }
}), v3 = { class: "space-y-1 mt-9 overflow-y-auto after:[flex-grow:10000] scrollbar scrollbar--stay-visible pr-7" }, mx = /* @__PURE__ */ U({
  __name: "QuestionModuleResponse",
  props: {
    answers: {}
  },
  setup(M) {
    const t = M.answers.filter((i) => i !== null);
    return (i, u) => (c(), g("div", v3, [
      (c(!0), g(K, null, lM(y(t), (N, l) => (c(), g("div", {
        key: l,
        class: "bg-[#F8F9FF] max-w-3xl rounded-[10px] px-5 py-3 font-semibold text-sm"
      }, w(N), 1))), 128))
    ]));
  }
});
function qt(M, e) {
  if (e || (e = 0), !Array.isArray(M))
    throw new Error("percentRound input should be an Array");
  const t = M.slice(), i = M.length, u = new Array(i);
  let N = 0;
  for (let l = i - 1; l >= 0; l--)
    typeof t[l] == "string" && (t[l] = Number.parseFloat(t[l])), N += t[l] * 1;
  if (isNaN(N))
    throw new Error("percentRound invalid input");
  if (N === 0)
    u.fill(0);
  else {
    const l = Math.pow(10, e), n = 100 * l;
    let s = 0;
    for (let a = i - 1; a >= 0; a--)
      t[a] = 100 * t[a] / N, s += u[a] = Math.round(t[a] * l);
    if (s !== n) {
      const a = s - n, o = 1;
      let j = Math.abs(a);
      const D = new Array(i);
      for (let r = 0; r < i; r++)
        D[r] = Math.abs(u[r] - t[r] * l);
      for (; j > 0; ) {
        let r = 0, I = D[0];
        for (let L = 1; L < i; L++)
          if (I < D[L]) {
            if (s > n && u[L] - o < 0)
              continue;
            r = L, I = D[L];
          }
        s > n ? u[r] -= o : u[r] += o, D[r] -= o, j--;
      }
    }
    if (l > 1)
      for (let a = 0; a < i; a++)
        u[a] = u[a] / l;
  }
  return u;
}
qt.default = qt;
const G3 = ["textContent"], R3 = /* @__PURE__ */ T("p", null, "•", -1), F3 = { key: 0 }, X3 = {
  key: 0,
  class: "pt-5 pb-5 uppercase font-semibold text-[0.75em] text-[#3F4A55]"
}, Ax = /* @__PURE__ */ U({
  __name: "MultipleChoiceModuleResponse",
  props: {
    answers: {},
    choices: {},
    resultsListClasses: {}
  },
  setup(M) {
    const e = M, t = p(() => e.answers.flat().filter((s) => s !== null)), i = p(() => t.value.filter(
      (s) => !e.choices.includes(s)
    )), u = p(() => {
      const s = [], a = new Set(t.value);
      for (const D of a) {
        const I = t.value.filter((L) => L === D).length / t.value.length * 100;
        s.push([D, I]);
      }
      const o = qt(
        s.map(([D, r]) => r),
        2
      );
      return new Map(
        s.map(([D, r], I) => {
          const L = o[I];
          return [D, L];
        })
      );
    }), N = p(
      () => [...e.choices].sort((s, a) => l(a) - l(s))
    );
    function l(s) {
      return t.value.filter((a) => a === s).length;
    }
    function n(s) {
      return u.value.get(s) ?? 0;
    }
    return (s, a) => (c(), g("div", {
      class: V(
        y(iM)(
          "flex flex-col gap-y-1 overflow-y-auto after:[flex-grow:10000] scrollbar scrollbar--stay-visible pr-4",
          s.resultsListClasses
        )
      )
    }, [
      (c(!0), g(K, null, lM(N.value, (o, j) => (c(), g("div", {
        class: "flex items-center gap-x-2",
        key: j
      }, [
        z(y(sm), {
          label: o,
          modelValue: n(o)
        }, {
          value: O(() => [
            J(s.$slots, "votes", {
              votes: l(o)
            }, () => [
              T("p", {
                textContent: w(
                  l(o) === 1 ? `${l(o)} vote` : `${l(o)} votes`
                )
              }, null, 8, G3),
              R3
            ]),
            T("p", null, w(t.value.length == 0 ? "0" : n(o)) + " % ", 1)
          ]),
          _: 2
        }, 1032, ["label", "modelValue"]),
        s.$slots.actions ? (c(), g("div", F3, [
          J(s.$slots, "actions", { choice: o })
        ])) : A("", !0)
      ]))), 128)),
      i.value.length > 0 ? (c(), g("div", X3, w(i.value.length) + " other answers ", 1)) : A("", !0),
      (c(!0), g(K, null, lM(i.value, (o, j) => (c(), g("div", {
        key: j,
        class: "bg-[#F8F9FF] rounded-[10px] px-5 py-3 font-semibold text-[0.875em]"
      }, w(o), 1))), 128))
    ], 2));
  }
}), J3 = "data:image/svg+xml;base64,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", K3 = "data:image/svg+xml;base64,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", B3 = "data:image/svg+xml;base64,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", H3 = {
  class: "space-y-14",
  style: { "grid-area": "1 / 1" }
}, P3 = { class: "text-[#8C96A1] text-[0.75em] absolute" }, _3 = /* @__PURE__ */ T("div", { class: "h-[1px] grow bg-[#EDEDFC] translate-x-4 z-10" }, null, -1), $3 = {
  style: { "grid-area": "1 / 1" },
  class: "flex items-center mx-6 z-20"
}, q3 = { class: "item__content-top h-20 py-3 invisible grow-0 shrink-0 group-hover:visible mx-auto font-semibold text-current text-[0.75em] bg-transparent items-center justify-center" }, Mz = { class: "item-bar__content-above grow-0 shrink-0" }, ez = ["src"], tz = ["src"], iz = ["src"], uz = { class: "item__content-bottom h-20 py-3 flex flex-col items-center justify-center text-[0.75em] w-full text-center space-y-2 grow-0 shrink-0 text-[#3F4A55]" }, Nz = { class: "font-bold font-serif" }, lz = { class: "text-[#8C96A1]" }, nz = { class: "flex justify-between font-semibold text-[0.75em] mt-14" }, sz = { key: 0 }, oz = { key: 1 }, $0 = 8, az = /* @__PURE__ */ U({
  __name: "ScaleGraph",
  props: {
    answered: {},
    answers: {},
    maxScale: {},
    minScale: {},
    textLeft: {},
    textRight: {},
    scaleType: { default: "numbers" },
    barColor: { default: "#0687EA" }
  },
  setup(M) {
    const e = M, t = {
      2: ["🙁", "🙂"],
      3: ["🙁", "🫤", "🙂"],
      4: ["☹️", "🙁", "🙂", "😀"],
      5: ["☹️", "🙁", "🫤", "🙂", "😀"],
      6: ["☹️", "🙁", "🫤", "🙂", "😉", "😀"],
      7: ["😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀"],
      8: ["😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀", "😍"],
      9: ["😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀", "🥰", "😍"],
      10: ["😧", "😦", "☹️", "🙁", "🫤", "🙂", "😉", "😀", "🥰", "😍"]
    }, i = p(() => {
      let o = [];
      for (let j = e.minScale == 0 ? 0 : 1; j < (e.minScale == 0, e.maxScale + 1); j++)
        o.push(e.answers.filter((D) => D == String(j)).length);
      return o;
    }), u = p(() => i.value.map((o) => {
      const j = 100 * o / Number(e.answered);
      return isNaN(j) ? 0 : j;
    })), N = p(() => Array.from(new Set(i.value)).sort((o, j) => j - o)), l = p(() => N.value[0] < $0 ? $0 : N.value[0] % 4 == 0 ? N.value[0] : Math.ceil(N.value[0] / 4) * 4);
    function n(o) {
      return e.scaleType == "numbers" ? e.minScale == 0 ? o : o + 1 : e.scaleType == "stars" ? o + 1 + " ⭐️" : e.scaleType == "smiles" ? t[e.maxScale][o] : e.scaleType[o];
    }
    const s = p(() => N.value[0] % 4 == 0 ? 100 * 1 / l.value + "%" : (100 - 100 / l.value * (l.value - N.value[0])) * 1 / N.value[0] + "%"), a = yM();
    return (o, j) => (c(), g(K, null, [
      T("div", DM({ class: "grid" }, y(a)), [
        T("div", H3, [
          (c(!0), g(K, null, lM([
            l.value,
            0.75 * l.value,
            0.5 * l.value,
            0.25 * l.value,
            0
          ], (D, r) => (c(), g("div", {
            key: r,
            class: "flex items-center space-x-2"
          }, [
            T("div", P3, w(Math.floor(D)), 1),
            _3
          ]))), 128))
        ]),
        T("div", $3, [
          (c(!0), g(K, null, lM(i.value, (D, r) => (c(), g("div", {
            key: r,
            class: V(y(iM)("item group h-[calc(100%_+_10rem)] px-[0.75em] bg-transparent transition-all duration-300 ease-in text-transparent hover:text-[#3F4A55] hover:bg-white rounded-[20px] hover:shadow-[0_4px_30px_rgba(195,195,250,0.3)] flex flex-col grow", o.classListItem))
          }, [
            T("div", q3, w(D === 1 ? `${D} vote` : `${D} votes`), 1),
            T("div", {
              style: RM(`
            height: calc(${l.value} * ${s.value});
          `),
              class: "item__bar-wrapper h-full box-border w-full grow flex flex-col justify-end text-[#3F4A55]"
            }, [
              T("div", Mz, [
                o.answers.length >= 20 && N.value[0] && N.value[0] == D ? (c(), g("img", {
                  key: 0,
                  class: "w-5 mb-2 mx-auto",
                  src: y(J3),
                  alt: "bronzemedal"
                }, null, 8, ez)) : A("", !0),
                o.answers.length >= 20 && N.value[1] && N.value[1] == D ? (c(), g("img", {
                  key: 1,
                  class: "w-5 mb-2 mx-auto",
                  src: y(K3),
                  alt: "silvermedal"
                }, null, 8, tz)) : A("", !0),
                o.answers.length >= 20 && N.value[2] && N.value[2] == D ? (c(), g("img", {
                  key: 2,
                  class: "w-5 mb-2 mx-auto",
                  src: y(B3),
                  alt: "goldmedal"
                }, null, 8, iz)) : A("", !0)
              ]),
              T("div", {
                class: "item__bar w-full rounded-t-lg relative grow-0 shrink-0",
                style: RM({
                  height: N.value[0] % 4 == 0 ? 100 * Number(D) / l.value + "%" : (100 - 100 / l.value * (l.value - N.value[0])) * Number(D) / N.value[0] + "%",
                  background: o.barColor
                })
              }, null, 4)
            ], 4),
            T("div", uz, [
              T("div", Nz, w(n(r)), 1),
              T("div", lz, w(Number(o.answered) == 0 ? "0" : y(qt)(u.value, 2)[r]) + "% ", 1)
            ])
          ], 2))), 128))
        ])
      ], 16),
      T("div", nz, [
        o.textLeft ? (c(), g("div", sz, w(o.textLeft), 1)) : A("", !0),
        o.textRight ? (c(), g("div", oz, w(o.textRight), 1)) : A("", !0)
      ])
    ], 64));
  }
}), jz = {
  inheritAttrs: !1
}, xx = /* @__PURE__ */ U({
  ...jz,
  __name: "ScaleModuleResponse",
  props: {
    answered: {},
    answers: {},
    maxScale: {},
    minScale: {},
    textLeft: {},
    textRight: {},
    scaleType: {}
  },
  setup(M) {
    const e = yM();
    return (t, i) => (c(), k(az, DM({
      answered: t.answered,
      answers: t.answers,
      maxScale: t.maxScale,
      minScale: t.minScale,
      scaleType: t.scaleType,
      textLeft: t.textLeft,
      textRight: t.textRight
    }, y(e)), null, 16, ["answered", "answers", "maxScale", "minScale", "scaleType", "textLeft", "textRight"]));
  }
}), Tz = { class: "flex gap-5 items-center uppercase font-bold" }, cz = {
  key: 0,
  class: "flex-grow border-b-[1px] border-[#D9D9D9]"
}, Ex = /* @__PURE__ */ U({
  __name: "NavigationBar",
  props: {
    items: {},
    currentUrl: {},
    tag: { type: [String, Function], default: "a" }
  },
  setup(M) {
    return (e, t) => (c(), g("div", Tz, [
      (c(!0), g(K, null, lM(e.items, (i, u) => (c(), g("div", {
        class: "flex grow items-center gap-x-5",
        key: u
      }, [
        (c(), k(cM(e.tag), {
          href: i.route,
          class: V(["cursor-pointer", e.currentUrl == i.route ? "text-[#3F4A55]" : "text-[#BBC4CD]"])
        }, {
          default: O(() => [
            vM(w(i.name), 1)
          ]),
          _: 2
        }, 1032, ["href", "class"])),
        u + 1 != e.items.length ? (c(), g("span", cz)) : A("", !0)
      ]))), 128))
    ]));
  }
}), Dz = { class: "w-full mt-10 space-y-5" }, rz = { class: "flex justify-between p-5 rounded-xl" }, gz = { class: "flex flex-col" }, Lz = /* @__PURE__ */ T("p", { class: "uppercase" }, "Current plan", -1), Iz = { class: "font-semibold" }, dz = { class: "flex flex-col" }, yz = /* @__PURE__ */ T("p", { class: "uppercase" }, "Billing period", -1), zz = { class: "font-semibold" }, mz = { class: "flex flex-col" }, Az = /* @__PURE__ */ T("p", { class: "uppercase" }, "Renewal date", -1), xz = { class: "font-semibold" }, Ez = { class: "flex flex-col" }, hz = /* @__PURE__ */ T("p", { class: "uppercase" }, "Total", -1), Cz = { class: "font-semibold" }, hx = /* @__PURE__ */ U({
  __name: "OverviewBilling",
  props: {
    currentPlan: {},
    billingPeriod: {},
    renewalDate: {},
    totalPrice: {}
  },
  setup(M) {
    return (e, t) => (c(), g("section", Dz, [
      z(UM, null, {
        default: O(() => [
          T("div", rz, [
            T("div", gz, [
              Lz,
              T("p", Iz, w(e.currentPlan), 1)
            ]),
            T("div", dz, [
              yz,
              T("p", zz, w(e.billingPeriod), 1)
            ]),
            T("div", mz, [
              Az,
              T("p", xz, w(e.renewalDate), 1)
            ]),
            T("div", Ez, [
              hz,
              T("p", Cz, w(e.totalPrice), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]));
  }
}), Oz = { class: "flex w-full gap-x-4 gap-y-10 flex-wrap" }, pz = { class: "w-full grow flex gap-x-4 gap-y-10 flex-wrap" }, Cx = /* @__PURE__ */ U({
  __name: "SettingsBilling",
  props: {
    name: {},
    addressLine1: {},
    addressLine2: {},
    city: {},
    postalCode: {},
    state: {},
    country: {},
    taxRegistratorCode: {},
    taxCountryCode: {},
    taxId: {},
    errors: {}
  },
  emits: ["update:name", "update:addressLine1", "update:addressLine2", "update:city", "update:postalCode", "update:state", "update:country", "update:taxRegistratorCode", "update:taxCountryCode", "update:taxId"],
  setup(M, { emit: e }) {
    const t = e, i = [
      ["au_abn", "au", "Australia"],
      ["au_arn", "au", "Australia"],
      ["eu_vat", "at", "Austria"],
      ["eu_vat", "be", "Belgium"],
      ["br_cnpj", "br", "Brazil"],
      ["br_cpf", "br", "Brazil"],
      ["bg_uic", "bg", "Bulgaria"],
      ["eu_vat", "bg", "Bulgaria"],
      ["ca_bn", "ca", "Canada"],
      ["ca_gst_hst", "ca", "Canada"],
      ["ca_pst_bc", "ca", "Canada"],
      ["ca_pst_mb", "ca", "Canada"],
      ["ca_pst_sk", "ca", "Canada"],
      ["ca_qst", "ca", "Canada"],
      ["cl_tin", "cl", "Chile"],
      ["eu_vat", "hr", "Croatia"],
      ["eu_vat", "cy", "Cyprus"],
      ["eu_vat", "cz", "Czech Republic"],
      ["eu_vat", "dk", "Denmark"],
      ["eg_tin", "eg", "Egypt"],
      ["eu_vat", "ee", "Estonia"],
      ["eu_oss_vat", "", "EU"],
      ["eu_vat", "fi", "Finland"],
      ["eu_vat", "fr", "France"],
      ["ge_vat", "ge", "Georgia"],
      ["eu_vat", "de", "Germany"],
      ["eu_vat", "gr", "Greece"],
      ["hk_br", "hk", "Hong Kong"],
      ["eu_vat", "hu", "Hungary"],
      ["hu_tin", "hu", "Hungary"],
      ["is_vat", "is", "Iceland"],
      ["in_gst", "in", "India"],
      ["id_npwp", "id", "Indonesia"],
      ["eu_vat", "ie", "Ireland"],
      ["il_vat", "il", "Israel"],
      ["eu_vat", "it", "Italy"],
      ["jp_cn", "jp", "Japan"],
      ["jp_rn", "jp", "Japan"],
      ["jp_trn", "jp", "Japan"],
      ["ke_pin", "ke", "Kenya"],
      ["eu_vat", "lv", "Latvia"],
      ["li_uid", "li", "Liechtenstein"],
      ["eu_vat", "lt", "Lithuania"],
      ["eu_vat", "lu", "Luxembourg"],
      ["my_frp", "my", "Malaysia"],
      ["my_itn", "my", "Malaysia"],
      ["my_sst", "my", "Malaysia"],
      ["eu_vat", "mt", "Malta"],
      ["mx_rfc", "mx", "Mexico"],
      ["eu_vat", "nl", "Netherlands"],
      ["nz_gst", "nz", "New Zealand"],
      ["no_vat", "no", "Norway"],
      ["ph_tin", "ph", "Philippines"],
      ["eu_vat", "pl", "Poland"],
      ["eu_vat", "pt", "Portugal"],
      ["eu_vat", "ro", "Romania"],
      ["ru_inn", "ru", "Russia"],
      ["ru_kpp", "ru", "Russia"],
      ["sa_vat", "sa", "Saudi Arabia"],
      ["sg_gst", "sg", "Singapore"],
      ["sg_uen", "sg", "Singapore"],
      ["eu_vat", "sk", "Slovakia"],
      ["eu_vat", "si", "Slovenia"],
      ["si_tin", "si", "Slovenia"],
      ["za_vat", "za", "South Africa"],
      ["kr_brn", "kr", "South Korea"],
      ["es_cif", "es", "Spain"],
      ["eu_vat", "es", "Spain"],
      ["eu_vat", "se", "Sweden"],
      ["ch_vat", "ch", "Switzerland"],
      ["tw_vat", "tw", "Taiwan"],
      ["th_vat", "th", "Thailand"],
      ["tr_tin", "tr", "Turkey"],
      ["ua_vat", "ua", "Ukraine"],
      ["ae_trn", "ae", "United Arab Emirates"],
      ["eu_vat", "gb", "United Kingdom"],
      ["gb_vat", "gb", "United Kingdom"],
      ["us_ein", "us", "United States"]
    ];
    function u([l, n, s]) {
      return aM("div", { class: "flex items-center" }, [
        n ? aM("img", {
          src: `https://country-flags.us-southeast-1.linodeobjects.com/${n}.svg`,
          class: "inline-block w-8 h-8 mr-2"
        }) : aM("div", { class: "inline-block w-8 h-8 mr-2" }),
        aM("span", { class: "mr-3" }, s),
        aM(
          "span",
          { class: "text-gray-300" },
          l.replace("_", " ").toUpperCase()
        )
      ]);
    }
    function N([l, n, s]) {
      t("update:taxRegistratorCode", l), t("update:taxCountryCode", n);
    }
    return (l, n) => (c(), k(UM, { class: "!overflow-visible" }, {
      default: O(() => {
        var s, a, o, j, D, r, I, L, d;
        return [
          T("div", Oz, [
            z(nM, {
              modelValue: l.name,
              "onUpdate:modelValue": n[0] || (n[0] = (m) => t("update:name", m)),
              label: "Name",
              inputClass: "input--small",
              class: "md:w-1/3 grow w-full",
              errors: (s = l.errors) != null && s.name ? [l.errors.name] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(nM, {
              modelValue: l.addressLine1,
              "onUpdate:modelValue": n[1] || (n[1] = (m) => t("update:addressLine1", m)),
              label: "Address line 1",
              placeholder: "Street address",
              inputClass: "input--small",
              class: "md:w-1/3 grow w-full",
              errors: (a = l.errors) != null && a["address.line1"] ? [l.errors["address.line1"]] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(nM, {
              modelValue: l.addressLine2,
              "onUpdate:modelValue": n[2] || (n[2] = (m) => t("update:addressLine2", m)),
              label: "Address line 2",
              placeholder: "Apt., suite, unit number, etc. (optional)",
              inputClass: "input--small",
              class: "md:w-1/3 grow w-full",
              errors: (o = l.errors) != null && o["address.line2"] ? [l.errors["address.line2"]] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(nM, {
              modelValue: l.city,
              "onUpdate:modelValue": n[3] || (n[3] = (m) => t("update:city", m)),
              label: "City",
              inputClass: "input--small",
              class: "md:w-1/3 grow w-full",
              errors: (j = l.errors) != null && j["address.city"] ? [l.errors["address.city"]] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(nM, {
              modelValue: l.postalCode,
              "onUpdate:modelValue": n[4] || (n[4] = (m) => t("update:postalCode", m)),
              label: "Postal Code",
              inputClass: "input--small",
              class: "md:w-1/3 grow w-full",
              errors: (D = l.errors) != null && D["address.postal_code"] ? [l.errors["address.postal_code"]] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(nM, {
              modelValue: l.state,
              "onUpdate:modelValue": n[5] || (n[5] = (m) => t("update:state", m)),
              label: "State",
              inputClass: "input--small",
              class: "md:w-1/3 grow w-full",
              errors: (r = l.errors) != null && r["address.state"] ? [l.errors["address.state"]] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(nM, {
              modelValue: l.country,
              "onUpdate:modelValue": n[6] || (n[6] = (m) => t("update:country", m)),
              label: "Country",
              inputClass: "input--small",
              class: "md:w-1/3 grow w-full",
              errors: (I = l.errors) != null && I["address.country"] ? [l.errors["address.country"]] : void 0
            }, null, 8, ["modelValue", "errors"]),
            T("div", pz, [
              z(Ve, {
                label: "ID type",
                class: "md:w-4/12 grow w-full",
                classListListBoxButton: ["input--small", "min-h-[4rem]"],
                classListListBoxOptions: [
                  "z-20",
                  "absolute",
                  "max-h-96",
                  "overflow-y-scroll"
                ],
                dropdownItems: i,
                getLabel: u,
                getKey: ([m, x]) => `${m}-${x}`,
                modelValue: i.find(
                  ([m, x]) => {
                    var C, Q;
                    return m.toLowerCase() === ((C = l.taxRegistratorCode) == null ? void 0 : C.toLowerCase()) && x.toLowerCase() === ((Q = l.taxCountryCode) == null ? void 0 : Q.toLowerCase());
                  }
                ),
                "onUpdate:modelValue": n[7] || (n[7] = (m) => N(m)),
                errors: (L = l.errors) != null && L["tax.registratorCode"] ? [l.errors["tax.registratorCode"]] : void 0
              }, null, 8, ["getKey", "modelValue", "errors"]),
              z(nM, {
                modelValue: l.taxId,
                "onUpdate:modelValue": n[8] || (n[8] = (m) => t("update:taxId", m)),
                label: "Vat ID",
                inputClass: "input--small",
                class: "md:w-7/12 grow w-full",
                errors: (d = l.errors) != null && d["tax.id"] ? [l.errors["tax.id"]] : void 0
              }, null, 8, ["modelValue", "errors"])
            ])
          ])
        ];
      }),
      _: 1
    }));
  }
}), wz = { class: "w-full mt-10" }, Yz = /* @__PURE__ */ T("p", { class: "font-semibold text-3xl mb-4" }, "Manage billing contacts", -1), Sz = /* @__PURE__ */ T("p", null, " Billing contacts will be notified by email regarding billing changes in your account ", -1), Zz = { class: "flex flex-col mt-5 space-y-5 w-1/3" }, kz = { class: "flex flex-col" }, bz = {
  key: 0,
  class: "font-semibold"
}, Uz = /* @__PURE__ */ T("div", { class: "w-56 font-semibold" }, "Can't remove last contact", -1), Qz = { class: "flex space-x-5 w-full mt-10 items-end" }, Vz = ["disabled"], Ox = /* @__PURE__ */ U({
  __name: "ContactsBilling",
  props: {
    billingContacts: {},
    contacts: {},
    errors: {},
    addUserButton: { type: Function }
  },
  emits: ["addContacts", "deleteContact"],
  setup(M, { emit: e }) {
    const t = e, i = E(), u = E();
    function N(a) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(a);
    }
    const l = p(() => !(i.value || N(u == null ? void 0 : u.value)));
    function n(a) {
      t("deleteContact", a);
    }
    function s() {
      let a = {};
      i.value && (a.listbox = i.value), u.value && N(u.value) && (a.textInput = u.value), t("addContacts", a), i.value = "", u.value = "";
    }
    return (a, o) => {
      var j, D;
      return c(), g("section", wz, [
        Yz,
        Sz,
        T("div", Zz, [
          (c(!0), g(K, null, lM(a.billingContacts, (r, I) => (c(), g("div", {
            class: "flex items-center space-x-5 justify-between",
            key: I
          }, [
            T("div", kz, [
              r.name ? (c(), g("span", bz, w(r.name), 1)) : A("", !0),
              T("span", null, w(r.email), 1)
            ]),
            a.billingContacts.length > 1 ? (c(), k(Ku, {
              key: 0,
              onClick: (L) => n(r.email)
            }, null, 8, ["onClick"])) : (c(), k(y(oe), {
              key: 1,
              triggers: ["hover"],
              distance: 20,
              placement: "right",
              popperTriggers: ["hover"],
              delay: { show: 200, hide: 150 }
            }, {
              popper: O(() => [
                Uz
              ]),
              default: O(() => [
                z(Ku, {
                  class: "cursor-not-allowed bg-[#EAF0F5] hover:bg-[#EAF0F5]",
                  fill: "fill-[#BBC4CD]"
                })
              ]),
              _: 1
            }))
          ]))), 128))
        ]),
        T("div", Qz, [
          z(Ve, {
            label: "Choose from your users",
            dropdownItems: a.contacts.length > 0 ? a.contacts.map((r) => r.email) : [a.addUserButton],
            errors: (j = a.errors) != null && j["contacts.listbox"] ? [a.errors["contacts.listbox"]] : void 0,
            getLabel: () => a.addUserButton,
            class: "w-1/3",
            classListListBoxButton: [
              "input--small",
              "min-h-[4rem]",
              "lowercase",
              "cursor-pointer"
            ],
            classListListBoxOption: a.contacts.length > 0 ? ["lowercase"] : ["hover:bg-white", "p-1", "m-0", "h-full", "cursor-none"],
            modelValue: i.value,
            "onUpdate:modelValue": o[0] || (o[0] = (r) => i.value = r)
          }, null, 8, ["dropdownItems", "errors", "getLabel", "classListListBoxOption", "modelValue"]),
          z(nM, {
            label: "Or add billing contact by email",
            errors: (D = a.errors) != null && D["contacts.textInput"] ? [a.errors["contacts.textInput"]] : void 0,
            modelValue: u.value,
            "onUpdate:modelValue": o[1] || (o[1] = (r) => u.value = r),
            inputClass: "input--small",
            placeholder: "e.g. Your Accountant@email.com"
          }, null, 8, ["errors", "modelValue"]),
          T("button", {
            type: "button",
            onClick: o[2] || (o[2] = (r) => s()),
            class: "btn btn--narrow btn--tertiary",
            disabled: !!l.value
          }, " Add billing contacts ", 8, Vz)
        ])
      ]);
    };
  }
}), Wz = {
  key: 0,
  class: "text-2xl mb-2 font-bold text-[#12DE74]"
}, fz = { class: "relative" }, vz = { class: "flex" }, Gz = { class: "text-[#3F4A55] text-6xl capitalize" }, Rz = {
  key: 0,
  class: "ml-2 pb-3 text-base text-[#8c96a1] mt-2"
}, Fz = { class: "text-[#8C96A1] mt-5" }, Xz = { class: "mt-10 mb-12" }, px = /* @__PURE__ */ U({
  __name: "BillingPlanCard",
  props: {
    heading: { type: Function },
    price: {},
    interval: {},
    priceDescription: {},
    buttonRedirect: { type: [String, Function] },
    checkIconElements: {},
    flashIconElements: {}
  },
  setup(M) {
    return (e, t) => (c(), k(UM, { class: "w-fit" }, {
      default: O(() => [
        T("div", null, [
          typeof e.heading == "string" ? (c(), g("div", Wz, w(e.heading), 1)) : (c(), k(cM(e.heading), {
            key: 1,
            class: "text-2xl mb-2 font-bold"
          })),
          T("div", fz, [
            T("div", vz, [
              T("div", Gz, w(e.price), 1),
              e.interval ? (c(), g("div", Rz, w(e.interval), 1)) : A("", !0)
            ])
          ]),
          T("div", Fz, w(e.priceDescription), 1),
          T("div", Xz, [
            J(e.$slots, "cta"),
            !e.$slots.cta && e.buttonRedirect ? (c(), k(cM(e.buttonRedirect), {
              key: 0,
              class: "btn btn--narrow text-white bg-[#6212E5] px-10"
            })) : A("", !0)
          ]),
          (c(!0), g(K, null, lM(e.checkIconElements, (i, u) => (c(), g("div", {
            class: "mt-1 flex gap-x-5",
            key: u
          }, [
            z(y(T1), { class: "w-3 fill-[#12DE74]" }),
            T("p", null, w(i), 1)
          ]))), 128)),
          (c(!0), g(K, null, lM(e.flashIconElements, (i, u) => (c(), g("div", {
            class: "mt-1 flex gap-x-5",
            key: u
          }, [
            z(y(r1), { class: "w-3 fill-[#FFCE21]" }),
            T("p", null, w(i), 1)
          ]))), 128))
        ])
      ]),
      _: 3
    }));
  }
}), Jz = ["data-test"], Kz = ["data-position"], Bz = { class: "grow flex items-center" }, Hz = ["src", "alt"], Pz = { class: "mr-8 text-gray-800" }, q0 = /* @__PURE__ */ U({
  __name: "RankingModuleInput",
  props: {
    choice: {},
    position: {}
  },
  setup(M) {
    return (e, t) => (c(), g("label", {
      "data-test": e.choice.option,
      class: "border py-4 px-6 border-[#DBDBF9] bg-[#F8F9FF] hover:bg-[#EDEDFC] text-[#6212E5] rounded-[14px] w-full flex items-center"
    }, [
      e.position !== void 0 ? (c(), g("div", {
        key: 0,
        class: "w-10 h-10 rounded-xl bg-[#EDEDFC] flex items-center justify-center text-sm font-semibold",
        "data-position": e.position
      }, w(e.position), 9, Kz)) : A("", !0),
      T("div", Bz, [
        e.choice.image ? (c(), g("img", {
          key: 0,
          src: e.choice.image,
          class: "rounded-l-[14px] object-cover h-24 aspect-square mr-4",
          alt: `${e.choice.option} image`
        }, null, 8, Hz)) : A("", !0),
        T("span", Pz, w(e.choice.option), 1)
      ]),
      J(e.$slots, "default")
    ], 8, Jz));
  }
}), _z = {
  key: 0,
  class: "font-semibold text-2xl leading-9 text-[#3F4A55]"
}, $z = {
  key: 1,
  class: "font-semibold text-[#8C96A1] leading-7 mb-10"
}, qz = /* @__PURE__ */ T("p", { class: "font-semibold mb-2" }, "Your ranking", -1), Mm = {
  key: 2,
  class: "border border-dashed border-[#DBDBF9] text-[#DBDBF9] italic rounded-xl w-full h-24 flex items-center justify-center"
}, em = /* @__PURE__ */ T("p", { class: "font-semibold mt-10 mb-2" }, "Unranked options", -1), tm = {
  inheritAttrs: !1
}, wx = /* @__PURE__ */ U({
  ...tm,
  __name: "RankingModule",
  props: {
    modelValue: { default: () => [] },
    choices: {},
    title: {},
    description: {},
    minNumOfAnswers: {}
  },
  emits: ["update:modelValue"],
  setup(M, { expose: e, emit: t }) {
    const i = M, u = t, N = p(
      () => i.modelValue.length >= (i.minNumOfAnswers ?? i.choices.length)
    );
    e({ completed: N });
    const { class: l } = yM(), n = p({
      get() {
        return i.modelValue.map(
          (r) => i.choices.find((I) => I.option === r)
        );
      },
      set(r) {
        u(
          "update:modelValue",
          r.map((I) => I.option)
        );
      }
    }), s = p(
      () => i.choices.filter((r) => !i.modelValue.includes(r.option))
    );
    function a(r) {
      const I = n.value.indexOf(r);
      if (I <= 0)
        return;
      const L = [...n.value];
      L.splice(I, 1), L.splice(I - 1, 0, r), n.value = L;
    }
    function o(r) {
      const I = n.value.indexOf(r);
      if (I === -1 || I === n.value.length - 1)
        return;
      const L = [...n.value];
      L.splice(I, 1), L.splice(I + 1, 0, r), n.value = L;
    }
    function j(r) {
      const I = n.value.indexOf(r);
      if (I === -1)
        return;
      const L = [...n.value];
      L.splice(I, 1), n.value = L;
    }
    function D(r) {
      const I = [...n.value];
      I.push(r), n.value = I;
    }
    return (r, I) => (c(), g("div", {
      tabindex: "0",
      class: V(
        y(iM)("border-none px-7 pt-7 pb-8 bg-white rounded-2xl", y(l))
      )
    }, [
      r.title ? (c(), g("p", _z, w(r.title), 1)) : A("", !0),
      r.description ? (c(), g("p", $z, w(r.description), 1)) : A("", !0),
      qz,
      r.modelValue.length === 0 ? (c(), g("div", Mm, " Drop options here ")) : A("", !0),
      z(y(Xi), {
        modelValue: n.value,
        "onUpdate:modelValue": I[0] || (I[0] = (L) => n.value = L),
        itemKey: "option",
        group: "answers"
      }, {
        item: O(({ element: L, index: d }) => [
          z(q0, {
            choice: L,
            position: d + 1,
            class: "border gap-x-4 mt-2 border-[#DBDBF9] bg-[#F8F9FF] hover:bg-[#EDEDFC] rounded-[14px] w-full inline-flex items-center"
          }, {
            default: O(() => [
              d > 0 ? (c(), k(y(Sj), {
                key: 0,
                class: "block h-6 cursor-pointer",
                onClick: (m) => a(L)
              }, null, 8, ["onClick"])) : A("", !0),
              d < n.value.length - 1 ? (c(), k(y(Yj), {
                key: 1,
                class: "block h-6 cursor-pointer",
                onClick: (m) => o(L)
              }, null, 8, ["onClick"])) : A("", !0),
              z(y(Au), {
                class: "block h-6 cursor-pointer",
                onClick: (m) => j(L)
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["choice", "position"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      em,
      z(y(Xi), {
        modelValue: s.value,
        itemKey: "option",
        group: "answers"
      }, {
        item: O(({ element: L }) => [
          (c(), k(q0, {
            onClick: (d) => D(L),
            key: L.option,
            choice: L,
            class: "border gap-x-4 mt-2 border-[#DBDBF9] bg-[#F8F9FF] hover:bg-[#EDEDFC] rounded-[14px] w-full inline-flex items-center"
          }, null, 8, ["onClick", "choice"]))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2));
  }
}), im = { class: "flex items-center justify-between" }, um = { class: "flex items-center gap-5 uppercase text-[#3F4A55] font-semibold text-[0.75em]" }, Nm = ["textContent"], lm = { class: "mt-3 bg-[#EDEDFC] rounded-[20px] h-[1.25em] w-full" }, nm = {
  inheritAttrs: !1
}, sm = /* @__PURE__ */ U({
  ...nm,
  __name: "HorizontalLineGraph",
  props: {
    label: {},
    modelValue: {}
  },
  setup(M) {
    const { class: e, ...t } = yM();
    return (i, u) => (c(), g("div", DM(t, {
      class: y(iM)("bg-[#F8F9FF] rounded-[10px] px-5 py-3 font-semibold text-[0.875em] grow", y(e))
    }), [
      T("div", im, [
        T("p", null, w(i.label), 1),
        T("div", um, [
          J(i.$slots, "value", {}, () => [
            T("p", {
              textContent: w(`${i.modelValue} %`)
            }, null, 8, Nm)
          ])
        ])
      ]),
      T("div", lm, [
        T("div", {
          class: "bg-[#1212E0] rounded-[20px] h-full w-full",
          style: RM({ width: `${i.modelValue}%` })
        }, null, 4)
      ])
    ], 16));
  }
}), om = { class: "mb-9" }, am = { class: "flex justify-between" }, jm = {
  key: 0,
  class: "font-semibold text-[#3F4A55] text-xl"
}, Tm = { class: "flex items-center mt-4 text-[#8C96A1] font-semibold text-xs gap-5 uppercase" }, cm = { class: "flex items-center gap-2" }, Dm = ["src"], rm = { key: 1 }, gm = /* @__PURE__ */ T("span", null, "•", -1), Lm = /* @__PURE__ */ T("span", null, "•", -1), Im = {
  inheritAttrs: !1
}, Yx = /* @__PURE__ */ U({
  ...Im,
  __name: "ResponseCard",
  props: {
    title: {},
    type: {},
    icon: {},
    answered: {},
    skipped: {},
    required: { type: Boolean },
    collapsed: { type: Boolean },
    collapsable: { type: Boolean }
  },
  emits: ["update:collapsed"],
  setup(M, { emit: e }) {
    const t = M, i = e, { class: u, ...N } = yM();
    function l() {
      i("update:collapsed", !t.collapsed);
    }
    return (n, s) => (c(), g("div", DM(N, {
      class: y(iM)("border border-[#DBDBF9] rounded-[20px] bg-white pl-10 pt-8 pb-10 pr-16", y(u))
    }), [
      T("header", om, [
        T("div", am, [
          n.title ? (c(), g("div", jm, w(n.title), 1)) : A("", !0),
          n.collapsable ? (c(), k(y(hu), {
            key: 1,
            class: V(["h-5 fill-[#BBC4CD] cursor-pointer", n.collapsed ? "rotate-90" : "-rotate-90"]),
            onClick: l
          }, null, 8, ["class"])) : A("", !0)
        ]),
        T("div", Tm, [
          T("div", cm, [
            n.icon ? (c(), g(K, { key: 0 }, [
              typeof t.icon == "string" ? (c(), g("img", {
                key: 0,
                class: "w-3 h-3",
                src: n.icon,
                alt: "type of response"
              }, null, 8, Dm)) : (c(), k(cM(t.icon), {
                key: 1,
                class: "w-5"
              }))
            ], 64)) : A("", !0),
            n.type ? (c(), g("p", rm, w(n.type), 1)) : A("", !0)
          ]),
          n.answered !== void 0 ? (c(), g(K, { key: 0 }, [
            gm,
            T("p", null, w(n.answered + "x answered"), 1)
          ], 64)) : A("", !0),
          n.required || n.skipped !== void 0 ? (c(), g(K, { key: 1 }, [
            Lm,
            T("p", null, w(n.required ? "required" : n.skipped + "x skipped"), 1)
          ], 64)) : A("", !0)
        ])
      ]),
      T("div", null, [
        J(n.$slots, "default")
      ])
    ], 16));
  }
}), dm = {
  key: 0,
  class: "text-base text-[#3F4A55] font-medium inline-block mb-2"
}, ym = { class: "relative" }, zm = ["type", "value"], mm = ["src"], Am = { class: "text-[#E31266] mt-2" }, xm = {
  key: 0,
  class: "gap-x-2 flex flex-wrap mx-5"
}, Em = {
  key: 0,
  class: "relative inline-block [filter:drop-shadow(0_42px_25px_rgba(177,195,213,0.08))_drop-shadow(0_19px_19px_rgba(177,195,213,0.14))_drop-shadow(0_-2px_10px_rgba(177,195,213,0.17))] bg-white rounded-2xl sm:mr-20 mt-5 px-5 sm:py-10 sm:ml-10 ml-5 py-3 mr-4"
}, hm = ["src"], Cm = /* @__PURE__ */ T("p", { class: "text-[#8C96A1]" }, "Requirements:", -1), Om = { class: "mt-2" }, pm = ["src"], wm = ["textContent"], Ym = {
  inheritAttrs: !1
};
var LN = /* @__PURE__ */ ((M) => (M[M["Too Weak"] = 1] = "Too Weak", M[M.Weak = 2] = "Weak", M[M.Medium = 3] = "Medium", M[M.Strong = 4] = "Strong", M))(LN || {});
const IN = /* @__PURE__ */ U({
  ...Ym,
  __name: "FormPasswordInput",
  props: {
    errors: {},
    modelValue: {},
    label: {},
    constraints: {},
    strength: {}
  },
  emits: ["update:modelValue", "update:strength", "update:constraints"],
  setup(M, { emit: e }) {
    const t = M, i = e, u = E(!1);
    function N(o) {
      i("update:modelValue", o), l(o);
    }
    function l(o) {
      const j = DN.passwordStrength(o, [
        {
          id: 1,
          value: "Too Weak",
          minDiversity: 0,
          minLength: 0
        },
        { id: 2, value: "Weak", minDiversity: 0, minLength: 4 },
        { id: 3, value: "Medium", minDiversity: 1, minLength: 6 },
        { id: 4, value: "Strong", minDiversity: 2, minLength: 8 }
      ]);
      i("update:strength", j.id), i("update:constraints", {
        casing: j.contains.includes("lowercase") && j.contains.includes("uppercase"),
        length: o.length >= 8,
        number: j.contains.includes("number")
      });
    }
    function n(o) {
      return {
        casing: "An uppercase and a lowercase letter",
        number: "At least one number",
        length: "At least 8 characters"
      }[o];
    }
    function s(o) {
      return {
        1: "bg-[#E31266]",
        2: "bg-[#E58312]",
        3: "bg-[#FFCE21]",
        4: "bg-[#12DE74]"
      }[o];
    }
    const a = p(
      () => Object.values(t.constraints ?? {}).some((o) => !o)
    );
    return (o, j) => (c(), g(K, null, [
      T("div", null, [
        T("label", null, [
          o.label ? (c(), g("div", dm, w(o.label), 1)) : A("", !0),
          T("div", ym, [
            T("input", {
              type: u.value ? "text" : "password",
              value: o.modelValue,
              onInput: j[0] || (j[0] = (D) => N(D.target.value)),
              class: V([
                o.errors || a.value ? "input--error" : "border-[#EAF0F5]",
                "rounded-xl bg-white text-base text-[#3F4A55] placeholder:text-[#BBC4CD] placeholder:font-normal border-2 px-5 py-3 w-full focus:border-[#6212E5] outline-none"
              ])
            }, null, 42, zm),
            T("img", {
              onClick: j[1] || (j[1] = (D) => u.value = !u.value),
              class: "absolute right-4 top-1/2 -translate-y-1/2 fill-white",
              src: u.value ? y(gu) : y(Lu),
              alt: "password visibility icon"
            }, null, 8, mm)
          ])
        ]),
        CM(T("ul", Am, [
          (c(!0), g(K, null, lM(o.errors, (D) => (c(), g("li", {
            key: D,
            class: "flex"
          }, w(D), 1))), 128))
        ], 512), [
          [WM, !!o.errors]
        ])
      ]),
      J(o.$slots, "strength", {}, () => [
        o.modelValue ? (c(), g("div", xm, [
          (c(), g(K, null, lM(LN, (D) => T("span", {
            key: D,
            class: V(["w-1/5 flex-grow h-1 mt-2", [
              s(D),
              t.strength && D > t.strength ? "invisible" : ""
            ]])
          }, null, 2)), 64))
        ])) : A("", !0)
      ]),
      J(o.$slots, "constraints", {}, () => [
        o.modelValue && t.constraints ? (c(), g("div", Em, [
          T("img", {
            src: y(Iu),
            class: "absolute left-0 -top-[0.63rem] -z-10",
            alt: "svg for bubble validation styling"
          }, null, 8, hm),
          Cm,
          T("ul", Om, [
            (c(!0), g(K, null, lM(Object.entries(t.constraints), ([D, r]) => (c(), g("li", {
              key: D,
              class: "my-1"
            }, [
              T("img", {
                class: "inline-block align-middle",
                src: r ? y(yu) : y(du),
                alt: "password requirements icon"
              }, null, 8, pm),
              T("span", {
                class: "align-middle ml-2",
                textContent: w(n(D))
              }, null, 8, wm)
            ]))), 128))
          ])
        ])) : A("", !0)
      ])
    ], 64));
  }
}), Sm = { class: "grow block" }, Zm = {
  key: 0,
  class: "text-base text-[#3F4A55] font-medium mb-2 inline-block"
}, km = { class: "relative" }, bm = ["type", "value"], Um = { class: "text-[#E31266] mt-2" }, Qm = {
  inheritAttrs: !1
}, cu = /* @__PURE__ */ U({
  ...Qm,
  __name: "FormTextInput",
  props: {
    errors: {
      type: Array,
      required: !1
    },
    modelValue: {
      type: String,
      required: !1
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      required: !1
    }
  },
  emits: ["update:modelValue"],
  setup(M, { emit: e }) {
    const t = e, { class: i, inputClass: u, ...N } = yM();
    return (l, n) => (c(), g("div", {
      class: V(y(i))
    }, [
      T("label", Sm, [
        J(l.$slots, "label"),
        M.label && !l.$slots.label ? (c(), g("div", Zm, w(M.label), 1)) : A("", !0),
        T("div", km, [
          T("input", DM({
            type: M.type,
            value: M.modelValue
          }, N, {
            onInput: n[0] || (n[0] = (s) => t(
              "update:modelValue",
              s.target.value
            )),
            class: [
              M.errors ? "input--error" : "border-[#EAF0F5]",
              "rounded-xl bg-white text-base text-[#3F4A55] placeholder:text-[#BBC4CD] placeholder:font-normal border-2 px-5 py-3 w-full focus:border-[#6212E5] outline-none"
            ]
          }), null, 16, bm)
        ])
      ]),
      CM(T("ul", Um, [
        (c(!0), g(K, null, lM(M.errors, (s) => (c(), g("li", {
          key: s,
          class: "flex"
        }, w(s), 1))), 128))
      ], 512), [
        [WM, !!M.errors]
      ])
    ], 2));
  }
}), dN = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiPgogIDxwYXRoIGZpbGw9IiNGRkMxMDciIGQ9Ik00My42MTEsMjAuMDgzSDQyVjIwSDI0djhoMTEuMzAzYy0xLjY0OSw0LjY1Ny02LjA4LDgtMTEuMzAzLDhjLTYuNjI3LDAtMTItNS4zNzMtMTItMTJjMC02LjYyNyw1LjM3My0xMiwxMi0xMmMzLjA1OSwwLDUuODQyLDEuMTU0LDcuOTYxLDMuMDM5bDUuNjU3LTUuNjU3QzM0LjA0Niw2LjA1MywyOS4yNjgsNCwyNCw0QzEyLjk1NSw0LDQsMTIuOTU1LDQsMjRjMCwxMS4wNDUsOC45NTUsMjAsMjAsMjBjMTEuMDQ1LDAsMjAtOC45NTUsMjAtMjBDNDQsMjIuNjU5LDQzLjg2MiwyMS4zNSw0My42MTEsMjAuMDgzeiIvPgogIDxwYXRoIGZpbGw9IiNGRjNEMDAiIGQ9Ik02LjMwNiwxNC42OTFsNi41NzEsNC44MTlDMTQuNjU1LDE1LjEwOCwxOC45NjEsMTIsMjQsMTJjMy4wNTksMCw1Ljg0MiwxLjE1NCw3Ljk2MSwzLjAzOWw1LjY1Ny01LjY1N0MzNC4wNDYsNi4wNTMsMjkuMjY4LDQsMjQsNEMxNi4zMTgsNCw5LjY1Niw4LjMzNyw2LjMwNiwxNC42OTF6Ii8+PHBhdGggZmlsbD0iIzRDQUY1MCIgZD0iTTI0LDQ0YzUuMTY2LDAsOS44Ni0xLjk3NywxMy40MDktNS4xOTJsLTYuMTktNS4yMzhDMjkuMjExLDM1LjA5MSwyNi43MTUsMzYsMjQsMzZjLTUuMjAyLDAtOS42MTktMy4zMTctMTEuMjgzLTcuOTQ2bC02LjUyMiw1LjAyNUM5LjUwNSwzOS41NTYsMTYuMjI3LDQ0LDI0LDQ0eiIvPgogIDxwYXRoIGZpbGw9IiMxOTc2RDIiIGQ9Ik00My42MTEsMjAuMDgzSDQyVjIwSDI0djhoMTEuMzAzYy0wLjc5MiwyLjIzNy0yLjIzMSw0LjE2Ni00LjA4Nyw1LjU3MWMwLjAwMS0wLjAwMSwwLjAwMi0wLjAwMSwwLjAwMy0wLjAwMmw2LjE5LDUuMjM4QzM2Ljk3MSwzOS4yMDUsNDQsMzQsNDQsMjRDNDQsMjIuNjU5LDQzLjg2MiwyMS4zNSw0My42MTEsMjAuMDgzeiIvPgo8L3N2Zz4=", yN = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCI+CiAgPHBhdGggZmlsbD0iI2ZmNTcyMiIgZD0iTTYgNkgyMlYyMkg2eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAxNCAxNCkiLz4KICA8cGF0aCBmaWxsPSIjNGNhZjUwIiBkPSJNMjYgNkg0MlYyMkgyNnoiIHRyYW5zZm9ybT0icm90YXRlKC0xODAgMzQgMTQpIi8+CiAgPHBhdGggZmlsbD0iI2ZmYzEwNyIgZD0iTTI2IDI2SDQyVjQySDI2eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAzNCAzNCkiLz4KICA8cGF0aCBmaWxsPSIjMDNhOWY0IiBkPSJNNiAyNkgyMlY0Mkg2eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAxNCAzNCkiLz4KPC9zdmc+", Vm = { class: "lg:w-fit" }, Wm = { class: "flex flex-col lg:w-[32rem] shrink-0 lg:max-w-2xl lg:py-8 lg:px-12 lg:drop-shadow-[0_0px_100px_rgba(195,195,250,0.50)] lg:bg-white lg:rounded-xl" }, fm = /* @__PURE__ */ T("h1", { class: "font-bold text-[#3F4A55] text-2xl text-center lg:text-left" }, " Sign up for free today ", -1), vm = { class: "flex flex-col gap-y-3 mt-5" }, Gm = ["href"], Rm = { class: "w-56 space-x-3 flex" }, Fm = ["src"], Xm = /* @__PURE__ */ T("p", null, "Sign in with Google", -1), Jm = ["href"], Km = { class: "w-56 space-x-3 flex" }, Bm = ["src"], Hm = /* @__PURE__ */ T("p", null, "Sign in with Microsoft", -1), Pm = /* @__PURE__ */ T("p", { class: "mx-auto mt-3 text-[#3F4A55]" }, "or using email", -1), _m = { class: "mt-3 space-y-3 grow" }, $m = /* @__PURE__ */ T("span", null, null, -1), qm = {
  key: 0,
  class: "text-[#3F4A55]"
}, MA = ["disabled"], eA = { class: "mt-3" }, tA = { class: "flex items-center text-sm justify-center grow sm:grow-0" }, iA = ["href"], uA = { class: "mt-2 flex items-center text-sm justify-center grow sm:grow-0" }, NA = ["href"], Sx = /* @__PURE__ */ U({
  __name: "RegisterForm",
  props: {
    name: {},
    email: {},
    password: {},
    googleRedirectRoute: {},
    azureRedirectRoute: {},
    termsRoute: {},
    loginRoute: {},
    processing: { type: Boolean },
    errors: {}
  },
  emits: ["update:name", "update:email", "update:password", "submit"],
  setup(M, { emit: e }) {
    const t = e;
    return (i, u) => {
      var N, l, n, s;
      return c(), g("div", Vm, [
        T("div", Wm, [
          fm,
          T("div", vm, [
            T("a", {
              href: i.googleRedirectRoute,
              class: "text-[#3F4A55] rounded-xl px-7 py-3 gap-x-3 tracking-wider bg-white border border-[#2B333B] flex items-center justify-center"
            }, [
              T("div", Rm, [
                T("img", {
                  src: y(dN),
                  class: "h-7 aspect-square"
                }, null, 8, Fm),
                Xm
              ])
            ], 8, Gm),
            T("a", {
              href: i.azureRedirectRoute,
              class: "text-[#3F4A55] rounded-xl px-7 py-3 gap-x-3 tracking-wider bg-white border border-[#2B333B] flex items-center justify-center"
            }, [
              T("div", Km, [
                T("img", {
                  src: y(yN),
                  class: "h-7 aspect-square"
                }, null, 8, Bm),
                Hm
              ])
            ], 8, Jm)
          ]),
          Pm,
          T("div", _m, [
            z(cu, {
              id: "name",
              label: "First and last name",
              modelValue: i.name,
              "onUpdate:modelValue": u[0] || (u[0] = (a) => t("update:name", a)),
              required: "",
              autofocus: "",
              autocomplete: "username",
              errors: (N = i.errors) != null && N.name ? [i.errors.name] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(cu, {
              id: "email",
              label: "Your work email",
              type: "email",
              modelValue: i.email,
              "onUpdate:modelValue": u[1] || (u[1] = (a) => t("update:email", a)),
              required: "",
              autofocus: "",
              autocomplete: "username",
              errors: (l = i.errors) != null && l.email ? [i.errors.email] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(IN, {
              id: "password",
              label: "Password",
              modelValue: i.password,
              "onUpdate:modelValue": u[2] || (u[2] = (a) => t("update:password", a)),
              required: "",
              autocomplete: "current-password",
              errors: (n = i.errors) != null && n.password ? [i.errors.password] : void 0
            }, {
              strength: O(() => [
                $m
              ]),
              _: 1
            }, 8, ["modelValue", "errors"]),
            (s = i.errors) != null && s.password ? A("", !0) : (c(), g("small", qm, "At least 8 characters")),
            J(i.$slots, "default"),
            T("button", {
              class: V(["w-full btn btn--narrow py-3 px-5 rounded-xl bg-[#6212E5] text-white", { "opacity-25": i.processing }]),
              disabled: i.processing,
              type: "button",
              onClick: u[3] || (u[3] = (a) => t("submit"))
            }, " Create account ", 10, MA)
          ])
        ]),
        T("footer", eA, [
          T("span", tA, [
            vM(" By registering, you agree to our "),
            T("a", {
              class: "underline ml-1",
              href: i.termsRoute
            }, " Terms & Conditions", 8, iA)
          ]),
          T("span", uA, [
            vM(" Already have an account? "),
            T("a", {
              class: "font-bold ml-1",
              href: i.loginRoute
            }, " Log in", 8, NA)
          ])
        ])
      ]);
    };
  }
}), lA = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiPjxwYXRoIGZpbGw9IiMwMzliZTUiIGQ9Ik0yNCA1QTE5IDE5IDAgMSAwIDI0IDQzQTE5IDE5IDAgMSAwIDI0IDVaIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI2LjU3MiwyOS4wMzZoNC45MTdsMC43NzItNC45OTVoLTUuNjl2LTIuNzNjMC0yLjA3NSwwLjY3OC0zLjkxNSwyLjYxOS0zLjkxNWgzLjExOXYtNC4zNTljLTAuNTQ4LTAuMDc0LTEuNzA3LTAuMjM2LTMuODk3LTAuMjM2Yy00LjU3MywwLTcuMjU0LDIuNDE1LTcuMjU0LDcuOTE3djMuMzIzaC00LjcwMXY0Ljk5NWg0LjcwMXYxMy43MjlDMjIuMDg5LDQyLjkwNSwyMy4wMzIsNDMsMjQsNDNjMC44NzUsMCwxLjcyOS0wLjA4LDIuNTcyLTAuMTk0VjI5LjAzNnoiLz48L3N2Zz4=", nA = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiPjxwYXRoIGZpbGw9IiMwMjg4RDEiIGQ9Ik00MiwzN2MwLDIuNzYyLTIuMjM4LDUtNSw1SDExYy0yLjc2MSwwLTUtMi4yMzgtNS01VjExYzAtMi43NjIsMi4yMzktNSw1LTVoMjZjMi43NjIsMCw1LDIuMjM4LDUsNVYzN3oiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTIgMTlIMTdWMzZIMTJ6TTE0LjQ4NSAxN2gtLjAyOEMxMi45NjUgMTcgMTIgMTUuODg4IDEyIDE0LjQ5OSAxMiAxMy4wOCAxMi45OTUgMTIgMTQuNTE0IDEyYzEuNTIxIDAgMi40NTggMS4wOCAyLjQ4NiAyLjQ5OUMxNyAxNS44ODcgMTYuMDM1IDE3IDE0LjQ4NSAxN3pNMzYgMzZoLTV2LTkuMDk5YzAtMi4xOTgtMS4yMjUtMy42OTgtMy4xOTItMy42OTgtMS41MDEgMC0yLjMxMyAxLjAxMi0yLjcwNyAxLjk5QzI0Ljk1NyAyNS41NDMgMjUgMjYuNTExIDI1IDI3djloLTVWMTloNXYyLjYxNkMyNS43MjEgMjAuNSAyNi44NSAxOSAyOS43MzggMTljMy41NzggMCA2LjI2MSAyLjI1IDYuMjYxIDcuMjc0TDM2IDM2IDM2IDM2eiIvPjwvc3ZnPg==", sA = { class: "lg:w-fit" }, oA = { class: "flex flex-col lg:w-[32rem] shrink-0 lg:max-w-2xl lg:py-8 lg:px-12 lg:drop-shadow-[0_0px_100px_rgba(195,195,250,0.50)] lg:bg-white lg:rounded-xl" }, aA = /* @__PURE__ */ T("h1", { class: "font-bold text-[#3F4A55] text-2xl text-center lg:text-left" }, " Log in to your account ", -1), jA = { class: "flex flex-col gap-y-3 mt-5" }, TA = ["href"], cA = { class: "w-56 space-x-3 flex" }, DA = ["src"], rA = /* @__PURE__ */ T("p", null, "Log in with Google", -1), gA = ["href"], LA = { class: "w-56 space-x-3 flex" }, IA = ["src"], dA = /* @__PURE__ */ T("p", null, "Log in with Microsoft", -1), yA = ["href"], zA = { class: "w-56 space-x-3 flex" }, mA = ["src"], AA = /* @__PURE__ */ T("p", null, "Log in with LinkedIn", -1), xA = ["href"], EA = { class: "w-56 space-x-3 flex" }, hA = ["src"], CA = /* @__PURE__ */ T("p", null, "Log in with Facebook", -1), OA = /* @__PURE__ */ T("p", { class: "mx-auto mt-3 text-[#3F4A55]" }, "or using email", -1), pA = { class: "mt-3 space-y-3 grow" }, wA = /* @__PURE__ */ T("span", null, null, -1), YA = {
  key: 0,
  class: "text-[#3F4A55]"
}, SA = ["disabled"], ZA = ["href"], kA = { class: "mt-3" }, bA = { class: "mt-2 flex items-center text-sm justify-center grow sm:grow-0" }, UA = ["href"], Zx = /* @__PURE__ */ U({
  __name: "LoginForm",
  props: {
    email: {},
    password: {},
    googleRedirectRoute: {},
    azureRedirectRoute: {},
    facebookRedirectRoute: {},
    linkedinRedirectRoute: {},
    forgotPasswordRoute: {},
    registerRoute: {},
    processing: { type: Boolean },
    appName: {},
    errors: {}
  },
  emits: ["update:email", "update:password", "submit"],
  setup(M, { emit: e }) {
    const t = e;
    return (i, u) => {
      var N, l, n;
      return c(), g("div", sA, [
        T("div", oA, [
          aA,
          T("div", jA, [
            i.googleRedirectRoute ? (c(), g("a", {
              key: 0,
              href: i.googleRedirectRoute,
              class: "text-[#3F4A55] rounded-xl px-7 py-3 gap-x-3 tracking-wider bg-white border border-[#2B333B] flex items-center justify-center"
            }, [
              T("div", cA, [
                T("img", {
                  src: y(dN),
                  class: "h-7 aspect-square"
                }, null, 8, DA),
                rA
              ])
            ], 8, TA)) : A("", !0),
            i.azureRedirectRoute ? (c(), g("a", {
              key: 1,
              href: i.azureRedirectRoute,
              class: "text-[#3F4A55] rounded-xl px-7 py-3 gap-x-3 tracking-wider bg-white border border-[#2B333B] flex items-center justify-center"
            }, [
              T("div", LA, [
                T("img", {
                  src: y(yN),
                  class: "h-7 aspect-square"
                }, null, 8, IA),
                dA
              ])
            ], 8, gA)) : A("", !0),
            i.linkedinRedirectRoute ? (c(), g("a", {
              key: 2,
              href: i.linkedinRedirectRoute,
              class: "text-[#3F4A55] rounded-xl px-7 py-3 gap-x-3 tracking-wider bg-white border border-[#2B333B] flex items-center justify-center"
            }, [
              T("div", zA, [
                T("img", {
                  src: y(nA),
                  class: "h-7 aspect-square"
                }, null, 8, mA),
                AA
              ])
            ], 8, yA)) : A("", !0),
            i.facebookRedirectRoute ? (c(), g("a", {
              key: 3,
              href: i.facebookRedirectRoute,
              class: "text-[#3F4A55] rounded-xl px-7 py-3 gap-x-3 tracking-wider bg-white border border-[#2B333B] flex items-center justify-center"
            }, [
              T("div", EA, [
                T("img", {
                  src: y(lA),
                  class: "h-7 aspect-square"
                }, null, 8, hA),
                CA
              ])
            ], 8, xA)) : A("", !0)
          ]),
          OA,
          T("div", pA, [
            z(cu, {
              id: "email",
              label: "Your email",
              type: "email",
              modelValue: i.email,
              "onUpdate:modelValue": u[0] || (u[0] = (s) => t("update:email", s)),
              required: "",
              autofocus: "",
              autocomplete: "username",
              errors: (N = i.errors) != null && N.email ? [i.errors.email] : void 0
            }, null, 8, ["modelValue", "errors"]),
            z(IN, {
              id: "password",
              label: "Password",
              modelValue: i.password,
              "onUpdate:modelValue": u[1] || (u[1] = (s) => t("update:password", s)),
              required: "",
              autocomplete: "current-password",
              errors: (l = i.errors) != null && l.password ? [i.errors.password] : void 0
            }, {
              strength: O(() => [
                wA
              ]),
              _: 1
            }, 8, ["modelValue", "errors"]),
            (n = i.errors) != null && n.password ? A("", !0) : (c(), g("small", YA, "At least 8 characters")),
            J(i.$slots, "default"),
            T("button", {
              class: V(["w-full btn btn--narrow py-3 px-5 rounded-xl bg-[#6212E5] text-white", { "opacity-25": i.processing }]),
              disabled: i.processing,
              type: "button",
              onClick: u[2] || (u[2] = (s) => t("submit"))
            }, " Log in ", 10, SA),
            T("a", {
              class: "text-sm mt-2 flex items-center justify-center grow sm:grow-0",
              href: i.forgotPasswordRoute
            }, " Forgot password?", 8, ZA)
          ])
        ]),
        T("footer", kA, [
          T("span", bA, [
            vM(" New to " + w(i.appName) + "? ", 1),
            T("a", {
              class: "font-bold ml-1",
              href: i.registerRoute
            }, "Create account", 8, UA)
          ])
        ])
      ]);
    };
  }
});
export {
  ei as ActionIconButton,
  vA as ActionIconButtonCopy,
  Ku as ActionIconButtonDelete,
  GA as ActionIconButtonEdit,
  RA as ActionIconButtonPreview,
  _A as AiKudoBuilder,
  zj as BackdropModal,
  px as BillingPlanCard,
  Cj as BubbleIcon,
  Et as CharacterCounter,
  be as CheckboxInput,
  m1 as CloseButton,
  FA as ColorPalette,
  Ox as ContactsBilling,
  XA as DataTable,
  TN as FileInput,
  IN as FormPasswordInput,
  cu as FormTextInput,
  JA as GifKudoBuilder,
  sm as HorizontalLineGraph,
  Cu as Icons,
  WA as IconsSvg,
  TN as ImageInput,
  Xt as ImageKudo,
  KA as ImageKudoBuilder,
  dx as ImageModule,
  Dx as ImageModuleBuilder,
  Te as InputError,
  UM as KudoCard,
  VI as LetterNote,
  tx as LineMenu,
  Ve as ListBox,
  Zx as LoginForm,
  HA as MemeKudoBuilder,
  ax as ModalDialog,
  Ix as MultipleChoiceModule,
  k5 as MultipleChoiceModuleBuilder,
  Ax as MultipleChoiceModuleResponse,
  Ex as NavigationBar,
  hx as OverviewBilling,
  $A as PagePagination,
  qA as PasswordInput,
  oe as PopperTooltip,
  Mx as PrependedInput,
  Lx as QuestionModule,
  mx as QuestionModuleResponse,
  ex as RadialMenu,
  He as RadioInput,
  yx as RandomModule,
  Tx as RandomModuleBuilder,
  wx as RankingModule,
  rx as RankingModuleBuilder,
  Sx as RegisterForm,
  Yx as ResponseCard,
  sx as RevealSearchInput,
  az as ScaleGraph,
  zx as ScaleModule,
  cx as ScaleModuleBuilder,
  xx as ScaleModuleResponse,
  By as SearchInput,
  ox as SectionDivider,
  Ri as SectionTitle,
  Cx as SettingsBilling,
  x3 as StarScale,
  c5 as SurveyCard,
  me as TextAreaInput,
  nM as TextInput,
  xy as TextKudo,
  ix as TextKudoBuilder,
  gx as TextModule,
  jx as TextModuleBuilder,
  ux as TheSidebar,
  Nx as TheSidebarItem,
  lx as ToggleInput,
  nx as UserMenuDropdown,
  fA as Utils,
  C0 as VideoKudo,
  PA as VideoKudoBuilder,
  Pt as YtKudo,
  BA as YtKudoBuilder
};
//# sourceMappingURL=kudoslink.mjs.map
